angular.module('app.casos', [
  'ui.router',
  'toastr',
  'app.casosService',
  'app.parametrizacionService'
])
  
.config(
  [          '$stateProvider', '$urlRouterProvider',
    function ($stateProvider,   $urlRouterProvider) {
      $stateProvider
        .state('index.casos', 
        {
          abstract: true,
          url: 'casos',
          params: {
            
          },
          views: 
            {
              '': 
                  {
                    templateUrl: 'app/casos/casos.tpl.html',
                    resolve: {},
                    controller: ['$scope', '$state', 'toastr',
                    function (  $scope,   $state,   toastr) {}]
                  }
            }
        })

        .state( 'index.casos.seguimiento', 
        {
          url: '/seguimiento',
          views: 
            {
              '': 
                  {
                    templateUrl: 'app/casos/casos.seguimiento.tpl.html',
                    resolve: {
                      dataDespacho: ['casosService',
                      function(casosService)
                      {
                      return casosService.getDespacho();
                      }]
                    },
                    controller: ['$scope', '$state', 'toastr', 'authService', 'dataDespacho', 'casosService', 
                    function ($scope, $state, toastr, authService, dataDespacho, casosService) 
                    {
                      //configuracion del enfoque de los elementos
                      $scope.tiempo_focus="500";
                      // $scope.focus_centro = false;
                      $scope.focus_mediador = false;
                      // $scope.focus_caso=false;
                      //se recuperan los valores del centro seleccionado o precargado al iniciar sesion
                      CENTRO = authService.getLocalData('CENTRO');
                      //las cajas de seleccion de centros y mediadores inician deshabilitadas, se habilitaran segun roles
                      $scope.deshabilitar_centros = true;
                      //$scope.mostrar_centros = false;
                      // $scope.deshabilitar_mediadores = true;
                      $scope.mostrar_mediadores = false;
                      // $scope.formulario_revision = false;
                      //se inicializa la variable de columnas
                      $scope.columnas_st_casos=5;

                      //se obtienen los mediadores segun centro
                      getCasos = function(despacho,anio)
                      {
                        casosService.getCasos(despacho,anio).then(
                          function ( response ) 
                          {
                            $scope.casos = [];
                            $scope.casos = response.data;
                            // if (id_caso > 0)
                            // {
                            //   buscarIdCaso(id_caso,$scope.casos);
                            // }
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                      }
                      //se obtienen los centros de mediacion
                      $scope.centros = [];
                      $scope.centros = dataDespacho.data;
                      //se declaran los arreglos para los datos del caso
                      $scope.centro = [];
                      //$scope.centro.ANIO_CASOS = new Date().getFullYear();

                      //se obtienen los anios de los casos segun centro
                      
                      //se selecciona el anio de los casos a desplegar en pantalla
                      $scope.selectedAnioCasos = function (item)
                      {
                        $scope.centro.ANIO = item.ANIO;
                        // if (cambio)
                        // {
                           getCasos($scope.centro.ID_DESPACHO,$scope.centro.ANIO);
                        // }
                      }
                      //se obtienen los mediadores segun centro
                      getAnioCasos = function(despacho,opcion)
                      {
                        casosService.getAnioCasos(despacho,opcion).then(
                          function ( response ) 
                          {
                            $scope.anioCasos = [];
                            $scope.anioCasos = response.data;
                            if ($scope.anioCasos.length > 0)
                            {
                              $scope.selectedAnioCasos(response.data[0],false);
                            }
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          }); 
                      }
                      
                      // $scope.caso = {};
                      //se selecciona el mediador y se obtienen los casos
                      /*$scope.selectedMediador = function (item)
                      {
                        // $scope.formulario_revision = true;
                        $scope.columnas_st_casos=5;
                        $scope.centro.ID_MEDIADOR = item.ID_MEDIADOR;
                        if ($scope.centro.ID_MEDIADOR == $scope.CONSTANTES.REGISTRO_FALSO)
                        {console.log('6 columnas');
                          $scope.columnas_st_casos=6;
                        }
                        getAnioCasos($scope.centro.ID_DESPACHO);
                        //llamar la data para la smarttable
                        // if (cambio)
                        // {
                        //   getCasos($scope.centro.ID_DESPACHO,$scope.centro.ID_MEDIADOR,$scope.centro.ANIO);
                        // }
                      }*/
                      
                      //se obtiene el centro de mediacio del usuario logueado
                      /*buscarMediadorCentro = function(valor, arreglo){
                        for (var i=0; i < arreglo.length; i++) {
                            if (arreglo[i].ID_MEDIADOR === valor) {
                                return true;
                            }
                        }
                        return false;
                      }*/

                      //se obtienen los mediadores segun centro
                      /*getMediadoresCentro = function(despacho,usuario,opcion)
                      {
                        casosService.getMediadoresCentro(despacho,usuario,opcion).then(
                          function ( response ) 
                          {
                            $scope.mediadores = [];
                            $scope.mediadores = response.data;
                            if ($scope.mediadores.length > 0)
                            {
                              // console.log($scope.mediadores, $scope.loginData.ID_USUARIO);
                              if (buscarMediadorCentro($scope.loginData.ID_USUARIO,$scope.mediadores))
                              {
                                $scope.selectedMediador({ID_MEDIADOR:$scope.loginData.ID_USUARIO});
                              }
                              else
                              {
                                $scope.selectedMediador(response.data[0]);
                              }
                            }
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          }); 
                      }*/

                      //se selecciona el centro de mediacion y se obtienen sus mediadores
                      $scope.selectedCentro = function (item,cambio)
                      {
                        $scope.centro.ID_DESPACHO = item.ID_DESPACHO;
                        // if (cambio)
                        // {
                        // getAnioCasos($scope.centro.ID_DESPACHO);
                        //getMediadoresCentro($scope.centro.ID_DESPACHO,$scope.loginData.ID_USUARIO,opcion_responsables);
                        // getMediadoresCentro($scope.centro.ID_DESPACHO,$scope.CONSTANTES.REGISTRO_FALSO,$scope.CONSTANTES.REGISTRO_FALSO);
                        $scope.centro.ANIO="";
                        $scope.casos = [];
                        getAnioCasos($scope.centro.ID_DESPACHO, $scope.CONSTANTES.ANIOS_CASO);
                        // console.log($scope.centro.ID_DESPACHO,$scope.loginData.ID_USUARIO,opcion_responsables);
                        // getCasos($scope.centro.ID_DESPACHO,$scope.centro.ANIO);
                        // }
                        //console.log($scope.centro.ID_DESPACHO,$scope.centro.ID_MEDIADOR,$scope.centro.ANIO);
                      }
                      
                      //se obtiene el centro de mediacio del usuario logueado
                      // buscarCentroMediacion = function(valor, arreglo){
                      //   for (var i=0; i < arreglo.length; i++) {
                      //       if (arreglo[i].ID_DESPACHO === valor) {
                      //           return arreglo[i];
                      //       }
                      //   }
                      // }

                      $scope.consultarCaso = function(item)
                      {
                        itemCaso = {};
                        itemCaso.ID_EXPEDIENTE = item.ID_EXPEDIENTE;
                        itemCaso.rutaEstado = "index.casos.seguimiento";
                        itemCaso.tooltipEstado = "Volver a casos";
                        itemCaso.ID_DESPACHO = $scope.centro.ID_DESPACHO;
                        // itemCaso.ID_REGISTRADOR = item.ID_REGISTRADOR;
                        // itemCaso.NOMBRE_REGISTRADOR = item.NOMBRE_REGISTRADOR;
                        // itemCaso.ID_MEDIADOR_RECEPTOR = item.ID_MEDIADOR_RECEPTOR;
                        // itemCaso.NOMBRE_RECEPTOR = item.NOMBRE_RECEPTOR;
                        // itemCaso.ID_MEDIADOR = item.ID_MEDIADOR;
                        // itemCaso.NOMBRE_MEDIADOR = item.NOMBRE_MEDIADOR;
                        itemCaso.soloConsulta = false;
                        if ((CENTRO.ID_CARGO != $scope.CONSTANTES.CARGO_ASISTENTE) &&
                            (CENTRO.ID_CARGO != $scope.CONSTANTES.CARGO_MEDIADOR))
                        {
                          itemCaso.soloConsulta = true;
                        }
                        $scope.asignaExpedienteGlobal(itemCaso);
                        $state.go('index.casos.caso', {});
                      }   
                      //reestablece el enfoque de la busqueda caso
                      // $scope.cambiar_focus_caso = function()
                      // {
                        // $scope.focus_centro = false;
                        //$scope.focus_mediador = false;
                        // $scope.focus_caso = false;
                      // }
                      //se verifica el rol del usuario y se visualizan y habilitan combos
                      if ((CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_ASISTENTE) || (CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_MEDIADOR))
                      {
                        // opcion_responsables = 0;
                        // $scope.focus_centro = false;
                        //$scope.focus_mediador = false;
                        // $scope.focus_caso =true;
                        // if (CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_ASISTENTE)
                        // {
                          // opcion_responsables = 1;
                          // $scope.deshabilitar_mediadores = false;
                          // $scope.mostrar_mediadores = true;
                          // $scope.focus_centro = false;
                          //$scope.focus_mediador = true;
                          // $scope.focus_caso = false;
                          //getCasos($scope.centro.ID_DESPACHO,0);
                        // }
                        // getAnioCasos(CENTRO.ID_DESPACHO);
                        
                        // getMediadoresCentro(CENTRO.ID_DESPACHO,$scope.CONSTANTES.REGISTRO_FALSO,$scope.CONSTANTES.REGISTRO_FALSO);
                        
                        //itemCentro = buscarCentroMediacion(CENTRO.ID_DESPACHO,$scope.centros);
                        //$scope.selectedCentro(itemCentro);
                        $scope.selectedCentro({ID_DESPACHO:CENTRO.ID_DESPACHO});
                      }
                      else
                      {
                        $scope.mostrar_centros = true;
                        $scope.deshabilitar_centros = false; //seguimiento
                      }

                      //VALUAR CUANDO SEA ROL SUPERVISOR O SUPERIOR
                      //QUITAR ESTE LLAMADO
                      //getCasos($scope.centro.ID_DESPACHO,0);
                    
                    }]
                  }
            }
        })


        .state( 'index.casos.caso', 
        {
          url: '/seguimiento/caso',
          views: 
            {
              '': 
                  {
                    templateUrl: 'app/casos/casos.seguimiento.caso.tpl.html',
                    resolve: {
                      // dataDespacho: ['casosService',
                      // function(casosService)
                      // {
                      // return casosService.getDespacho();
                      // }],
                      dataTipoSujeto: ['casosService',
                      function(casosService)
                      {
                      return casosService.getTipoSujeto();
                      }],
                      dataPrioridadSujeto: ['casosService',
                      function(casosService)
                      {
                      return casosService.getPrioridadSujeto();
                      }],
                      dataTipoContacto: ['casosService',
                      function(casosService)
                      {
                      return casosService.getTipoContacto();
                      }]
                    },
                    controller: ['$scope', '$state', 'toastr', 'authService', 'casosService', '$location', 'ngDialog',
                    'dataTipoSujeto','dataPrioridadSujeto','dataTipoContacto','$document',
                    function ($scope, $state, toastr, authService, casosService, $location, ngDialog, 
                    dataTipoSujeto, dataPrioridadSujeto, dataTipoContacto, $document) 
                    {
                      // itemCaso = authService.getLocalData('CASO');
                      //se inicializa el arreglo de los tipos de sujeto
                      $scope.tipoSujetos = [];
                      $scope.tipoSujetos = dataTipoSujeto.data;
                      //se inicializa el arreglo de la prioridad del sujeto
                      $scope.prioridadSujetos = [];
                      $scope.prioridadSujetos = dataPrioridadSujeto.data;
                      
                      //configuracion de los tiempos en el desplazamiento de elementos
                      duration = 1500;
                      offset = 20;

                      //se recuperan los valores del centro seleccionado o precargado al iniciar sesion
                      CENTRO = authService.getLocalData('CENTRO');
                      //funciones formulario sesion
                      fechaFormatoYYYYMMDD = function (date)
                      {
                        if (date != undefined)
                        {
                          d = new Date(date);
                          month = '' + (d.getMonth() + 1);
                          day = '' + d.getDate();
                          year = d.getFullYear();
                          if (month.length < 2) month = '0' + month;
                          if (day.length < 2) day = '0' + day;
                          return [year, month, day].join('-');
                        }
                        else
                        return "";
                      }
                      //se obtiene la ubicacion del centro 
                      getUbicacionCentro = function (p_id_despacho) 
                      {
                        casosService.getUbicacionCentro(p_id_despacho).then( 
                          function ( response ) 
                          {              
                            $scope.ubicacionCentro = {};     
                            $scope.ubicacionCentro.ID_DEPARTAMENTO = response.data[0].ID_DEPARTAMENTO;
                            $scope.ubicacionCentro.ID_MUNICIPIO = response.data[0].ID_MUNICIPIO;
                          }, 
                          function ( error ) 
                          {
                            toastr.error( error );
                          });
                      }
                      getUbicacionCentro(CENTRO.ID_DESPACHO); 
                      
                      // $scope.formulario_revision = false;
                      //permite el desplazamiento de los elementos
                      $scope.scrollToElement = function(element)
                      {
                        elemento = angular.element(document.getElementById(element));
                        $document.scrollToElement(elemento, offset, duration);
                      }

                      //se obtienen los mediadores segun centro
                      // getCasos = function(despacho,usuario,id_caso)
                      // {
                      //   casosService.getCasos(despacho,usuario).then(
                      //     function ( response ) 
                      //     {
                      //       $scope.casos = [];
                      //       $scope.casos = response.data;
                      //       if (id_caso > 0)
                      //       {
                      //         buscarIdCaso(id_caso,$scope.casos);
                      //       }
                      //     },
                      //     function ( error ) 
                      //     {
                      //         toastr.error( error );
                      //     });
                      // }


                      // //se obtienen los centros de mediacion
                      // $scope.centros = [];
                      // $scope.centros = dataDespacho.data;
                      
                      // //se declaran los arreglos para los datos del caso
                      // $scope.centro = [];
                      // $scope.caso = {};
                      
                      // //se selecciona el mediador y se obtienen los casos
                      // $scope.selectedMediador = function (item)
                      // {
                      //   // $scope.formulario_revision = true;
                      //   $scope.centro.ID_MEDIADOR = item.ID_MEDIADOR;
                      //   //llamar la data para la smarttable
                      //   getCasos($scope.centro.ID_DESPACHO,$scope.centro.ID_MEDIADOR,0);
                      // }

                      // //se obtiene el centro de mediacio del usuario logueado
                      // buscarIdCaso = function(valor, arreglo){
                      //   for (var i=0; i < arreglo.length; i++) {
                      //       if (arreglo[i].ID_EXPEDIENTE === valor) {
                      //           arreglo[i].isSelected = true;
                      //           $scope.isSelectedtemp = true;
                      //       }
                      //   }
                      // }
                      // buscarIdCasoTemp = function(valor, arreglo){
                      //   for (var i=0; i < arreglo.length; i++) {
                      //       if (arreglo[i].ID_EXPEDIENTE === valor) {
                      //           arreglo[i].isSelected = false;
                      //       }
                      //   }
                      // }

                      //se obtiene el centro de mediacio del usuario logueado
                      buscarMediadorSesion = function(valor, arreglo){
                        for (var i=0; i < arreglo.length; i++) {
                            if (arreglo[i].ID_MEDIADOR === valor) {
                                return arreglo[i];
                            }
                        }
                      }
                      
                      // //se obtienen los mediadores segun centro
                      // getMediadoresCentro = function(despacho,usuario,opcion)
                      // {
                      //   casosService.getMediadoresCentro(despacho,usuario,opcion).then(
                      //     function ( response ) 
                      //     {
                      //       $scope.mediadores = [];
                      //       $scope.mediadores = response.data;
                      //       if ($scope.mediadores.length == 1)
                      //       {
                      //         $scope.selectedMediador(response.data[0]);
                      //       }
                      //     },
                      //     function ( error ) 
                      //     {
                      //         toastr.error( error );
                      //     }); 
                      // }

                      // //se selecciona el centro de mediacion y se obtienen sus mediadores
                      // $scope.selectedCentro = function (item)
                      // {
                      //   $scope.centro.ID_DESPACHO = item.ID_DESPACHO;
                      //   getMediadoresCentro($scope.centro.ID_DESPACHO,$scope.loginData.ID_USUARIO,opcion_responsables)
                      // }

                      // //se obtiene el centro de mediacio del usuario logueado
                      // buscarCentroMediacion = function(valor, arreglo){
                      //   for (var i=0; i < arreglo.length; i++) {
                      //       if (arreglo[i].ID_DESPACHO === valor) {
                      //           return arreglo[i];
                      //       }
                      //   }
                      // }

                      //se verifica si existen representates para el sujeto seleccionado
                      $scope.verifica_representantes = function(item)
                      {
                        if ((item != undefined) && (item != '') && (item > 0))
                        {
                          return true;  
                        }
                        else
                        {
                          return false;
                        }
                      }
                      //funciones para recuperar los datos del caso
                      getCasoCompleto = function(p_id_expediente)
                      {
                        casosService.getCasoCompleto(p_id_expediente).then(
                          function ( response ) 
                          { 
                            //formulario_caso
                            //se asignan los datos del caso al arreglo 
                            $scope.caso = response.data.CASO;
                            //se valua si el caso requiere o no la visualizacion del expediente
                            $scope.mostrar_expediente = false;
                            $scope.etiqueta_expediente = "";
                            if ($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO)
                            {
                              $scope.mostrar_expediente = true;
                              $scope.etiqueta_expediente = "Expediente";
                            }
                            //se configuran los formularios segun el tipo de asunto
                            //formularios activos
                            
                            // $scope.formulario_caso = true;
                            
                            $scope.formulario_solicitante = true;
                            $scope.formulario_invitado = false;
                            $scope.formulario_sesion = false;
                            $scope.formulario_homologacion = false;
                            $scope.formulario_seguimiento = false;
                            $scope.color_caso = "bg-green";
                            $scope.color_formulario_caso = "box-success";
                            if ($scope.caso.ID_TIPO_ASUNTO == $scope.CONSTANTES.ASUNTO_NO_MEDIABLE)
                            {
                              $scope.color_caso = "bg-red";
                              $scope.color_formulario_caso = "box-danger";
                            }
                            // if (location)
                            // {
                            //   // $location.hash('caso');
                            //   $scope.scrollToElement('caso');
                            // }
                            //formulario_solicitante

                            $scope.solicitantes = [];
                            $scope.solicitantes = response.data.SOLICITANTES;
                            //formulario_invitado
                            if (response.data.INVITADOS != undefined)
                            {
                              $scope.formulario_invitado = true;
                              $scope.invitados = [];
                              $scope.invitados = response.data.INVITADOS;
                              $scope.caso.NUMERO_INVITADOS = $scope.invitados.length;
                            }
                            //formulario_sesion
                            //valida que la sesion tenga registrado el resultado
                            // verificaResultadoSesion = function(valor,arreglo)
                            // {
                            //   for (var i=0; i < arreglo.length; i++) 
                            //   {
                            //     if (arreglo[i].RESULTADO_PENDIENTE === valor) 
                            //     {
                            //         return true;
                            //     }
                            //   }
                            //   return false;
                            // }
                            
                            if (response.data.SESIONES != undefined)
                            {
                              $scope.formulario_sesion = true;
                              $scope.sesiones = [];
                              if (response.data.SESIONES.length==0)
                              {
                                $scope.deshabilitar_boton_nueva_sesion = false;
                              }
                              else
                              {
                                //recuperar todas las sesiones como en el reporte
                                $scope.sesiones = response.data.SESIONES;
                                $scope.caso.NUMERO_SESIONES = $scope.sesiones.length;
                                //$scope.deshabilitar_boton_nueva_sesion = verificaResultadoSesion($scope.CONSTANTES.REGISTRO_VERDADERO,$scope.sesiones);
                                $scope.deshabilitar_boton_nueva_sesion = true;
                                if ($scope.caso.RESULTADO_ULTIMA_SESION > 0)
                                {
                                  $scope.deshabilitar_boton_nueva_sesion = false;
                                }
                              }
                            }

                            $scope.deshabilitar_datos_caso = false;
                            $scope.deshabilitar_datos_sujeto_general = false;
                            //$scope.deshabilitar_datos_representante = false;
                            $scope.deshabilitar_datos_sesion = false;
                            $scope.deshabilitar_opciones_sesion = false;
                            $scope.deshabilitar_datos_homologacion = false;
                            $scope.mostrar_boton_solicitud_homologacion = false;
                            $scope.deshabilitar_boton_agregar_homologacion=false;
                            $scope.deshabilitar_datos_revision= false;
                            $scope.icon_close = "fa-unlock";

                            if ($scope.caso.CIERRA_CASO == $scope.CONSTANTES.REGISTRO_VERDADERO)
                            {
                              $scope.icon_close = "fa-lock";
                              $scope.deshabilitar_datos_caso = true;
                              $scope.deshabilitar_datos_sujeto_general = true;
                              //$scope.deshabilitar_datos_representante = true;
                              $scope.deshabilitar_datos_sesion = true;
                              $scope.deshabilitar_opciones_sesion = true;
                              $scope.deshabilitar_boton_nueva_sesion = true;
                              //$scope.deshabilitar_datos_homologacion = true;
                              //$scope.deshabilitar_datos_revision= true;
                              if (($scope.caso.CASO_EDITABLE == $scope.CONSTANTES.REGISTRO_VERDADERO) ||
                                  ($scope.caso.SUJETOS_EDITABLES == $scope.CONSTANTES.REGISTRO_VERDADERO))
                              {
                                $scope.deshabilitar_datos_sujeto_general = false;
                              }
                            }
                            if ($scope.caso.CASO_EDITABLE == $scope.CONSTANTES.REGISTRO_FALSO)
                            {
                              $scope.deshabilitar_datos_caso = true;
                            }
                            else
                            {
                              $scope.deshabilitar_datos_caso = false;
                              $scope.deshabilitar_datos_sujeto_general = false;
                              //$scope.deshabilitar_datos_representante = false;
                              $scope.deshabilitar_datos_sesion = false;
                              $scope.deshabilitar_opciones_sesion = false;
                              //$scope.deshabilitar_datos_homologacion = false;
                              //$scope.deshabilitar_datos_revision= false;
                            }
                            // console.log('caso',$scope.caso);
                            if ($scope.caso.ID_ESTADO_EXP == $scope.CONSTANTES.ESTADO_CASO_CON_ACUERDO)
                            {
                              $scope.formulario_homologacion = true;
                              $scope.deshabilitar_datos_homologacion = false;
                              $scope.mostrar_boton_solicitud_homologacion = false;
                              $scope.formulario_seguimiento = true;
                              if ((response.data.HOMOLOGACION != undefined ) && (response.data.HOMOLOGACION.length > 0))
                              {
                                $scope.homologaciones = [];
                                //recuperar todas las sesiones como en el reporte
                                $scope.homologaciones = response.data.HOMOLOGACION;
                                //$scope.caso.NUMERO_SESIONES = $scope.sesiones.length;
                                //$scope.deshabilitar_boton_nueva_sesion = verificaResultadoSesion($scope.CONSTANTES.REGISTRO_VERDADERO,$scope.sesiones);

                                if ($scope.homologaciones.length == 1)
                                {
                                  $scope.deshabilitar_boton_agregar_homologacion=true;
                                  $scope.mostrar_boton_solicitud_homologacion = true;
                                }
                                // $scope.campo_requerido_homologacion = false;
                                // $scope.deshabilitar_datos_homologacion = false;
                                // console.log('$scope.homologaciones[0].HOMOLOGACION_PENDIENTE',$scope.homologaciones[0].HOMOLOGACION_PENDIENTE);
                                // console.log('$scope.homologaciones[0].HOMOLOGACION_EDITABLE',$scope.homologaciones[0].HOMOLOGACION_EDITABLE);
                                // if ($scope.homologaciones[0].HOMOLOGACION_PENDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO)
                                // {
                                //   if ($scope.homologaciones[0].HOMOLOGACION_EDITABLE == $scope.CONSTANTES.REGISTRO_FALSO)
                                //   {
                                //     $scope.campo_requerido_homologacion = true;
                                //   }
                                // }
                                // else if ($scope.homologaciones[0].HOMOLOGACION_EDITABLE == $scope.CONSTANTES.REGISTRO_FALSO)
                                // {
                                //   $scope.campo_requerido_homologacion = true;
                                //   $scope.deshabilitar_datos_homologacion = true;
                                // }
                              }

                              if (response.data.REVISIONES != undefined)
                              {
                                $scope.revisiones = [];
                                if (response.data.REVISIONES.length==0)
                                {
                                  $scope.deshabilitar_boton_nueva_revision = false;
                                }
                                else
                                {
                                  //recuperar todas las sesiones como en el reporte
                                  $scope.revisiones = response.data.REVISIONES;
                                  $scope.caso.NUMERO_SESIONES = $scope.sesiones.length;
                                  //$scope.deshabilitar_boton_nueva_sesion = verificaResultadoSesion($scope.CONSTANTES.REGISTRO_VERDADERO,$scope.sesiones);
                                  $scope.deshabilitar_boton_nueva_revision = true;
                                  
                                  if ($scope.caso.RESULTADO_ULTIMA_SESION > 0) 
                                  {
                                    // ($scope.caso.RESULTADO_ULTIMA_SESION == $scope.CONSTANTES.RS_NO_CUMPLIDO_REVISION)
                                    
                                    if ($scope.caso.RESULTADO_ULTIMA_SESION == $scope.CONSTANTES.RS_CUMPLIDO_REVISION)
                                       {
                                        $scope.deshabilitar_boton_nueva_revision = true;
                                       }
                                       else
                                       {
                                        $scope.deshabilitar_boton_nueva_revision = false;
                                       }
                                  }
                                }


                                //$scope.caso.NUMERO_SESIONES = $scope.sesiones.length;
                                //$scope.deshabilitar_boton_nueva_sesion = verificaResultadoSesion($scope.CONSTANTES.REGISTRO_VERDADERO,$scope.sesiones);

                                /*if ($scope.homologaciones.length == 1)
                                {
                                  $scope.deshabilitar_boton_agregar_homologacion=true;
                                }
                                $scope.campo_requerido_homologacion = false;
                                $scope.deshabilitar_datos_homologacion = false;
                                if ($scope.homologaciones[0].HOMOLOGACION_PENDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO)
                                {
                                  if ($scope.homologaciones[0].HOMOLOGACION_EDITABLE == $scope.CONSTANTES.REGISTRO_FALSO)
                                  {
                                    $scope.campo_requerido_homologacion = true;
                                  }
                                }
                                else if ($scope.homologaciones[0].HOMOLOGACION_EDITABLE == $scope.CONSTANTES.REGISTRO_FALSO)
                                {
                                  $scope.campo_requerido_homologacion = true;
                                  $scope.deshabilitar_datos_homologacion = true;
                                }*/
                              }
                              
                              
                              
                            }
                            // console.log('$scope.expedienteGlobal.soloConsulta',$scope.expedienteGlobal.soloConsulta);
                            // console.log('caso',$scope.caso);
                            if ($scope.expedienteGlobal.soloConsulta)
                            {
                              $scope.deshabilitar_datos_caso = true;
                              $scope.deshabilitar_datos_sujeto_general = true;
                              $scope.deshabilitar_datos_sesion = true;
                              $scope.deshabilitar_opciones_sesion = true;
                              $scope.deshabilitar_boton_nueva_sesion = true;
                              $scope.deshabilitar_datos_homologacion = true;
                              $scope.deshabilitar_boton_agregar_homologacion = true;
                              $scope.deshabilitar_datos_revision= true;
                              $scope.deshabilitar_boton_nueva_revision = true;
                            }
                            // console.log('deshabilitar_datos_caso',$scope.deshabilitar_datos_caso);
                            // console.log('deshabilitar_datos_sujeto_general',$scope.deshabilitar_datos_sujeto_general);
                            // console.log('deshabilitar_datos_sesion',$scope.deshabilitar_datos_sesion);
                            // console.log('deshabilitar_opciones_sesion',$scope.deshabilitar_opciones_sesion);
                            // console.log('deshabilitar_boton_nueva_sesion',$scope.deshabilitar_boton_nueva_sesion);
                            // console.log('deshabilitar_datos_homologacion',$scope.deshabilitar_datos_homologacion);
                            // console.log('deshabilitar_boton_agregar_homologacion',$scope.deshabilitar_boton_agregar_homologacion);
                            // console.log('deshabilitar_datos_revision',$scope.deshabilitar_datos_revision);
                            // console.log('deshabilitar_boton_nueva_revision',$scope.deshabilitar_boton_nueva_revision);



                          },
                          function ( error ) 
                          {
                            toastr.error( error );
                          });
                      }

                      
                              
                              
                            

                      // $scope.reestablece_estado = function()
                      // {
                      //   $location.hash('');
                      // }
                      
                      // $scope.consultarCaso = function(item)
                      // {
                      //   // $scope.reestablece_estado();
                      //   if ($scope.isSelectedtemp)
                      //   {
                      //     $scope.isSelectedtemp = false;
                      //     buscarIdCasoTemp($scope.caso.ID_EXPEDIENTE,$scope.casos);
                      //   }
                      //   if (item.isSelected)
                      //   {
                      //     getCasoCompleto(item.ID_EXPEDIENTE);
                      //   }
                      //   // else
                      //   // {
                      //   //   $scope.caso = [];
                      //   //   $scope.mostrar_casos = false;
                      //   // }
                      // }

                      // //reestablece el enfoque de la busqueda caso
                      // $scope.cambiar_focus_caso = function()
                      // {
                      //   $scope.focus_centro = false;
                      //   $scope.focus_mediador = false;
                      //   $scope.focus_caso = false;
                      // }

                      // //se verifica el rol del usuario y se visualizan y habilitan combos
                      // if ((CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_ASISTENTE) || (CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_MEDIADOR))
                      // {
                      //   opcion_responsables = 0;
                      //   $scope.focus_centro = false;
                      //   $scope.focus_mediador =false;
                      //   $scope.focus_caso =true;
                      //   if (CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_ASISTENTE)
                      //   {
                      //     opcion_responsables = 1;
                      //     $scope.deshabilitar_mediadores = false;
                      //     $scope.mostrar_mediadores = true;
                      //     $scope.focus_centro = false;
                      //     $scope.focus_mediador = true;
                      //     $scope.focus_caso = false;
                      //     //getCasos($scope.centro.ID_DESPACHO,0);
                      //   }
                      //   itemCentro = buscarCentroMediacion(CENTRO.ID_DESPACHO,$scope.centros);
                      //   $scope.selectedCentro(itemCentro);
                      // }

                      //VALUAR CUANDO SEA ROL SUPERVISOR O SUPERIOR
                      //QUITAR ESTE LLAMADO
                      //getCasos($scope.centro.ID_DESPACHO,0);
                      
                      $scope.imprimirArchivo = function(ID_ARCHIVO,ID_TIPO_ARCHIVO)
                      {console.log("dentro de imprimir archivo",ID_ARCHIVO,ID_TIPO_ARCHIVO);
                        authService.getArchivosImprimir(ID_ARCHIVO).then(
                          function ( response ) 
                          {
                            console.log("response getArchivosImprimir",response)
                            $scope.archivosImprimir = [];
                            $scope.archivosImprimir = response.data;
                            for (c=0;c<$scope.archivosImprimir.length;c++)
                            {
                              console.log("c",c,$scope.archivosImprimir[c]);
                              authService.getDocumento($scope.archivosImprimir[c].ID_ARCHIVO,ID_TIPO_ARCHIVO,$scope.CONSTANTES.ARCHIVO_TIPO_INVITACION);
                            }
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                      }

                      //funciones formulario caso
                      $scope.opcion_evolucion = 1;
                      $scope.opcion_registro_invitacion = 2;
                      $scope.opcion_invitacion_revision = 3;
                      $scope.imprimirEvolucion = function(documento)
                      {
                        console.log("$scope.sesion",$scope.sesion)
                        if (documento == $scope.opcion_evolucion)
                        {
                          casosService.getCaratulaCaso($scope.caso.ID_EXPEDIENTE);
                          casosService.getEvolucionCaso($scope.caso.ID_EXPEDIENTE);
                          if ($scope.caso.ID_TIPO_ASUNTO == $scope.CONSTANTES.ASUNTO_NO_MEDIABLE)
                          {
                            casosService.getRegistroCaso($scope.caso.ID_EXPEDIENTE, 0, 0);
                          }
                        }
                        if (documento == $scope.opcion_registro_invitacion)
                        {
                          casosService.getRegistroCaso($scope.caso.ID_EXPEDIENTE, $scope.sesion.ID_SESION, $scope.sesion.NUMERO_SESION);
                          console.log("$scope.sesion.INVITACION_PARA_FIRMA",$scope.sesion.INVITACION_PARA_FIRMA);
                          //verificar y condicionar tambien para los archivos que no tengan que ser firmados
                          if (($scope.loginData.CENTRO.FIRMA_DOCUMENTO == $scope.CONSTANTES.FIRMA_USUARIO_INACTIVA) ||
                              ($scope.sesion.INVITACION_PARA_FIRMA == $scope.CONSTANTES.REGISTRO_FALSO))
                          {
                            casosService.getInvitacionCaso($scope.caso.ID_EXPEDIENTE, $scope.sesion.ID_SESION, $scope.sesion.NUMERO_SESION);  
                          }
                          else if ($scope.sesion.INVITACION_PARA_FIRMA == $scope.CONSTANTES.REGISTRO_VERDADERO)
                          {
                            if ($scope.sesion.ID_ESTADO_ARCHIVO == $scope.CONSTANTES.ESTADO_ARCHIVO_FIRMADO)
                            {
                              $scope.imprimirArchivo($scope.sesion.ID_ARCHIVO,$scope.CONSTANTES.ARCHIVO_TIPO_INVITACION);
                            }
                            else
                            {
                              toastr.info("No se pudieron generar las invitaciones, antes deben firmarse");
                            }
                          }
                        }
                        if (documento == $scope.opcion_invitacion_revision)
                        {
                          casosService.getInvitacionRevisionCaso($scope.caso.ID_EXPEDIENTE, $scope.sesion.ID_SESION, $scope.sesion.NUMERO_SESION);
                        }
                      }
                      $scope.imprimirActa = function(p_opcion_acta)
                      {
                        switch(p_opcion_acta) 
                        {
                          case $scope.CONSTANTES.RS_INCOMPARECIENTE:
                              casosService.getActaCasoIncompareciente($scope.caso.ID_EXPEDIENTE);
                              if ($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO)
                              {
                                casosService.getActaCasoDevolucionExpediente($scope.caso.ID_EXPEDIENTE);  
                              }
                              break;
                          case $scope.CONSTANTES.RS_EXTRAMEDIACION:
                              casosService.getActaCasoExtramediacion($scope.caso.ID_EXPEDIENTE);
                              if ($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO)
                              {
                                casosService.getActaCasoDevolucionExpediente($scope.caso.ID_EXPEDIENTE);  
                              }
                              break;
                          case $scope.CONSTANTES.ESTADO_CASO_SIN_ACUERDO:
                              casosService.getActaCasoSinAcuerdo($scope.caso.ID_EXPEDIENTE);
                              if ($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO)
                              {
                                casosService.getActaCasoDevolucionExpediente($scope.caso.ID_EXPEDIENTE);  
                              }
                              break;
                          case $scope.CONSTANTES.ESTADO_CASO_CON_ACUERDO:
                              // casosService.getActaCasoSinAcuerdo($scope.caso.ID_EXPEDIENTE);
                              if ($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO)
                              {
                                $scope.registro_sesion = true;
                                casosService.getActaCasoDevolucionExpediente($scope.caso.ID_EXPEDIENTE);
                              }
                              break;
                          case $scope.CONSTANTES.RS_DEVOLUCION_EXPEDIENTE:
                              casosService.getActaCasoDevolucionExpediente($scope.caso.ID_EXPEDIENTE);
                              break;
                          // default:
                              // code block
                        }
                      }

                      $scope.imprimirActaRevision = function()
                      {
                        casosService.getActaCasoRevision($scope.caso.ID_EXPEDIENTE, $scope.sesion.ID_SESION);
                      }

                      $scope.imprimirSolicitudHomologacion = function()
                      {
                        casosService.getSolicitudHomologacionCaso($scope.caso.ID_EXPEDIENTE);
                      }
                      //permite verificar la longitud de las observaciones, tanto en caso como en sesion
                      /*$scope.verificar_longitud = function(longitud,formulario)
                      {
                        if (formulario == 'sesion')
                        {
                          if (!$scope.registro_sesion)
                          {
                            $scope.LONGITUD_HOJA_EVOLUCION_SESION = true;
                          }
                          else
                          {
                            $scope.LONGITUD_HOJA_EVOLUCION_SESION = false;
                            if (longitud >= $scope.CONSTANTES.LONGITUD_HOJA_EVOLUCION_SESION)
                            {
                              $scope.LONGITUD_HOJA_EVOLUCION_SESION = true;
                            }
                          }
                        }
                      }*/
                      //vista que permite editar los datos del caso 
                      viewDatosCaso = function()
                      {
                        $scope.dialogShowDatosCaso = ngDialog.open(
                        {
                          template: 'app/casos/casos.seguimiento.datosCaso.view.tpl.html',
                          showClose: true,
                          closeByEscape: true,
                          closeByNavigation: true,
                          preCloseCallback:function()
                          {
                            // getCasos($scope.centro.ID_DESPACHO,$scope.centro.ID_MEDIADOR,$scope.caso.ID_EXPEDIENTE);
                            getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                          },
                          className: 'ngdialog-theme-flat-custom',
                          resolve:
                          {
                            /*dataTipoProcedencia: ['casosService',
                            function(casosService)
                            {
                            return casosService.getTipoProcedencia();
                            }]*/
                          },
                          scope:$scope,
                          controller: ['$scope', 'utilsService', function($scope, utilsService) 
                          {  
                            //se inicializa el arreglo de las materias segun centro                          
                            casosService.getMateriaDespacho(CENTRO.ID_DESPACHO).then(
                              function ( response ) 
                              {
                                $scope.materiasDespacho = [];
                                $scope.materiasDespacho = response.data;
                              },
                              function ( error ) 
                              {
                                  toastr.error( error );
                              });
                            //se inicializa el arreglo de los tipos de procedencias
                            // $scope.tipoProcedencias = [];
                            // $scope.tipoProcedencias = dataTipoProcedencia.data;
                            
                            //se inicializa el arreglo de las materias segun centro
                            getTipoProcedencia = function(p_id_materia)
                            {
                              casosService.getTipoProcedencia(p_id_materia).then(
                                function ( response ) 
                                {
                                  $scope.tipoProcedencias = [];
                                  $scope.tipoProcedencias = response.data;
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }

                            //funciones formulario edicion caso
                            enlistarTipoProcesos = function(p_id_despacho,p_id_materia)
                            {
                              casosService.getTipoProcesoMateriaDespacho(p_id_despacho,p_id_materia).then(
                                function ( response ) 
                                {
                                  $scope.tipoProcesos = [];
                                  $scope.tipoProcesos = response.data;
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }

                            $scope.limpiar_combos_caso = function()
                            {
                              $scope.caso.ID_TIPO_PROCESO = null;
                              $scope.caso.ID_TIPO_PROCEDENCIA = null;
                              $scope.caso.ID_PROCEDENCIA = null;
                              $scope.caso.MASCARA = null;
                              $scope.procedencias = [];
                            }

                            $scope.selectedMateria = function(item)
                            {
                              $scope.caso.ID_MATERIA = item.ID_MATERIA;
                              $scope.caso.MATERIA = item.MATERIA;
                              $scope.caso.ESTADO_CASO = $scope.ESTADO_INICIAL_CASO;
                              $scope.caso.ID_ESTADO_EXP = $scope.ID_ESTADO_INICIAL_CASO;
                              $scope.color_caso = $scope.color_caso_local;
                              $scope.color_formulario_caso = $scope.color_local_formulario_caso;
                              // if (limpiar != false)
                              // {
                              //   $scope.caso.ID_TIPO_PROCESO = "";
                              // }
                              enlistarTipoProcesos(CENTRO.ID_DESPACHO,item.ID_MATERIA);
                              getTipoProcedencia(item.ID_MATERIA);
                            }
                            $scope.selectedTipoProceso = function(item)
                            {
                              $scope.caso.ID_TIPO_PROCESO = item.ID_TIPO_PROCESO;
                              $scope.caso.TIPO_PROCESO = item.TIPO_PROCESO;
                              $scope.caso.ID_CLASIFICACION_JURIDICA = item.ID_CLASIFICACION_JURIDICA;
                              $scope.caso.ID_TIPO_ASUNTO = item.ID_TIPO_ASUNTO;
                              $scope.caso.TIPO_ASUNTO = item.TIPO_ASUNTO;
                              $scope.caso.ESTADO_CASO = $scope.ESTADO_INICIAL_CASO;
                              $scope.caso.ID_ESTADO_EXP = $scope.ID_ESTADO_INICIAL_CASO; 
                              $scope.color_local = "bg-green";
                              $scope.color_formulario_caso = "box-success";
                              if (item.ID_TIPO_ASUNTO == $scope.CONSTANTES.ASUNTO_NO_MEDIABLE)
                              {
                                //evaluar si es edicion de registros, es decir la data viene desde base
                                //condicionar para cambiar las etiquetas y el id de estado
                                $scope.caso.ESTADO_CASO = item.TIPO_ASUNTO;
                                $scope.caso.ID_ESTADO_EXP = $scope.CONSTANTES.ID_ESTADO_NO_MEDIABLE;
                                $scope.color_local = "bg-red";
                                $scope.color_formulario_caso = "box-danger";
                              }
                              else
                              {
                                $scope.caso.ESTADO_CASO = $scope.CONSTANTES.ESTADO_INICIAL_CASO;
                                $scope.caso.ID_ESTADO_EXP = $scope.CONSTANTES.ID_ESTADO_INICIAL_CASO;
                              }
                              
                            } 
                            enlistarProcedencias = function(p_id_tipo_procedencia,p_id_materia,limpiar)
                            {
                              casosService.getProcedenciaTipoProcedencia(p_id_tipo_procedencia,p_id_materia,CENTRO.ID_DESPACHO).then(
                                function ( response ) 
                                {
                                  $scope.procedencias = [];
                                  $scope.procedencias = response.data;
                                  if ($scope.procedencias.length == 1)
                                  {
                                    $scope.selectedProcedencia(response.data[0],limpiar);
                                  }
                                  else
                                  {
                                    if (limpiar != false)
                                    {
                                      $scope.caso.ID_PROCEDENCIA = "";
                                      $scope.caso.REQUIERE_EXPEDIENTE = "";
                                      $scope.caso.MASCARA = "";
                                    }
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }
                            limpiarExpediente = function()
                            {
                              $scope.caso.ANIO = "";
                              $scope.caso.CORRELATIVO = "";
                              $scope.caso.CODIGO_DESPACHO = "";
                              $scope.caso.EXPEDIENTE = "";
                            }
                            $scope.selectedTipoProcedencia = function(item,limpiar)
                            {
                              if (limpiar != false)
                              {
                                $scope.mostrar_expediente = false;
                                $scope.focus_expediente = false;
                                $scope.caso.ID_TIPO_PROCEDENCIA = item.ID_TIPO_PROCEDENCIA;
                                $scope.caso.TIPO_PROCEDENCIA = item.TIPO_PROCEDENCIA;
                                limpiarExpediente();
                              }
                              enlistarProcedencias(item.ID_TIPO_PROCEDENCIA,$scope.caso.ID_MATERIA,limpiar);
                              $scope.campo_requerido_solicitante = true;
                              $scope.place_holder_expediente = "DESPACHO";
                              if (item.ID_TIPO_PROCEDENCIA == $scope.CONSTANTES.TIPO_PROCEDENCIA_REFERIDA)
                              {
                                $scope.place_holder_expediente = "AGENCIA";
                                $scope.mostrar_combo_expediente = false;
                              }
                              if (item.ID_TIPO_PROCEDENCIA == $scope.CONSTANTES.TIPO_PROCEDENCIA_DERIVADA)
                              {
                                //$scope.mostrar_expediente = true;
                                $scope.mostrar_combo_expediente = true;
                                // $scope.campo_requerido_solicitante = false;
                              }
                            }
                            $scope.completarNumeroUnico = function(isValid)
                            {
                              if (isValid)
                              {
                                //$scope.caso.EXPEDIENTE = utilsService.formatNumeroUnicoExp($scope.caso.EXPEDIENTE)
                                EXPEDIENTE = $scope.caso.EXPEDIENTE.split( '-' );
                                $scope.caso.CODIGO_DESPACHO = EXPEDIENTE[0];
                                $scope.caso.ANIO = EXPEDIENTE[1];
                                $scope.caso.CORRELATIVO = EXPEDIENTE[2];
                              } 
                            }
                            $scope.cambiar_focus_expediente = function()
                            {
                              $scope.focus_expediente = false;
                            }
                            $scope.selectedProcedencia = function(item,limpiar)
                            {
                              $scope.mostrar_expediente = false;
                              if (limpiar != false)
                              {
                                $scope.caso.ID_PROCEDENCIA = item.ID_PROCEDENCIA;
                                $scope.caso.PROCEDENCIA = item.PROCEDENCIA;
                                $scope.caso.REQUIERE_EXPEDIENTE = item.REQUIERE_EXPEDIENTE;
                                $scope.caso.MASCARA = item.MASCARA;
                                limpiarExpediente();  
                                $scope.focus_expediente = true;
                              }
                              if (item.REQUIERE_EXPEDIENTE== $scope.CONSTANTES.REGISTRO_VERDADERO)
                              {
                                $scope.mostrar_expediente = true;
                                // $scope.campo_requerido_solicitante = false;
                              } 
                            }
                            //se cargan los datos con el contenido que trae el arreglo de caso 
                            $scope.selectedMateria($scope.caso);
                            $scope.selectedTipoProceso($scope.caso);
                            $scope.selectedTipoProcedencia($scope.caso,false);
                            $scope.selectedProcedencia($scope.caso,false);

                            $scope.actualizarCaso = function()
                            {
                              $scope.caso.FECHA_REGISTRO = fechaFormatoYYYYMMDD($scope.caso.FECHA_REGISTRO)+ ' 00:00:00.0';
                              edtCaso();
                            }
                            edtCaso = function()
                            {
                              casosService.edtCaso($scope.caso).then(
                                function (response)
                                {
                                  if(response.data.result=='OK')
                                  {
                                    toastr.success(response.data.msj);
                                    //getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                                    ngDialog.closeAll();
                                  }
                                  else
                                  {
                                    toastr.error(response.data.msj);
                                  }                      
                                },
                                function (error) 
                                {
                                  toastr.error( error );
                                }); 
                            }
                          }] 
                        });  
                      }
                      $scope.edicion_caso=false;
                      $scope.editarCaso = function()
                      {
                        $scope.ESTADO_INICIAL_CASO = $scope.caso.ESTADO_CASO;
                        $scope.ID_ESTADO_INICIAL_CASO = $scope.caso.ID_ESTADO_EXP;
                        $scope.color_local_formulario_caso = $scope.color_formulario_caso;
                        $scope.color_caso_local = $scope.color_caso;
                        $scope.LONGITUD_OBSERVACIONES_CASO = true;
                        viewDatosCaso();
                        $scope.edicion_caso=true;
                      }
                      
                      //vista que permite editar los datos del caso 
                      viewDatosSujeto = function(edicion,p_id_perfil)
                      {
                        $scope.dialogShowDatosSujeto = ngDialog.open(
                        {
                          template: 'app/casos/casos.seguimiento.datosSujeto.view.tpl.html',
                          showClose: true,
                          closeByEscape: true,
                          closeByNavigation: true,
                          preCloseCallback:function()
                          {
                            // formulario = 'invitados'
                            // if (p_id_perfil==$scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE)
                            // {
                            //   formulario = 'solicitantes'
                            // }
                            // $scope.nuevo_sujeto = false;
                            $scope.nuevo_sujeto = false;
                            $scope.REPRESENTANTES_AGREGADOS = false;
                            getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                          },
                          className: 'ngdialog-theme-flat-custom',
                          resolve:
                          {
                            dataTipoSujeto: ['casosService',
                            function(casosService)
                            {
                            return casosService.getTipoSujeto();
                            }],
                            dataPrioridadSujeto: ['casosService',
                            function(casosService)
                            {
                            return casosService.getPrioridadSujeto();
                            }],
                            dataGenero: ['casosService',
                            function(casosService)
                            {
                            return casosService.getGenero();
                            }],
                            dataNivelEducativo: ['casosService',
                            function(casosService)
                            {
                            return casosService.getNivelEducativo();
                            }],
                            dataDiscapacidad: ['casosService',
                            function(casosService)
                            {
                              return casosService.getDiscapacidad();
                            }]
                          },
                          scope:$scope,
                          controller: ['$scope','dataTipoSujeto','dataPrioridadSujeto','dataGenero',
                                       'dataNivelEducativo', 'dataDiscapacidad',
                          function($scope, dataTipoSujeto, dataPrioridadSujeto, dataGenero,
                                   dataNivelEducativo, dataDiscapacidad) 
                          { 
                            //se inicializa el arreglo de los tipos de sujeto
                            $scope.tipoSujetos = [];
                            $scope.tipoSujetos = dataTipoSujeto.data;
                            //se inicializa el arreglo de la prioridad del sujeto
                            $scope.prioridadSujetos = [];
                            $scope.prioridadSujetos = dataPrioridadSujeto.data;
                            //se inicializa el arreglo del sexo del sujeto
                            $scope.generos = [];
                            $scope.generos = dataGenero.data;
                            //se inicializa el arreglo del nivel educativo del sujeto
                            $scope.nivelesEducativos = [];
                            $scope.nivelesEducativos = dataNivelEducativo.data;
                            //se inicializa el arreglo de las discapacidades
                            $scope.discapacidades = [];
                            $scope.discapacidades = dataDiscapacidad.data;
                            
                            //se inicializa el arreglo representante
                            $scope.representante = {};
                            $scope.representante.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                            //se inicializa el arreglo de datos de contacto del representante
                            $scope.datosContactoRepresentante = [];
                            $scope.datosContactoRepresentante.seleccion = [];
                            $scope.datosContactoRepresentante.eliminacion = [];
                            //se inicializa el arreglo de representantes
                            // $scope.representantes = [];
                            // $scope.representantes.seleccion = [];
                            // $scope.representantes.eliminacion = [];
                            //se inicializa la variable para el enfoque en la identificacion del sujeto
                            $scope.focus_identificacion_sujeto = false;
                            //se inicializa el combo de tipo de identificacion
                            $scope.combo_tipo_identificacion = true;
                            // //se valida si el sujeto requiere de representante      
                            // validaRepresentante = function()
                            // {
                            //   ID_TIPO_SUJETO = $scope.sujeto.ID_TIPO_SUJETO;
                            //   $scope.REPRESENTANTES_AGREGADOS = false;
                            //   if ((ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL) ||
                            //     ($scope.representantes.seleccion | $scope.representantes.seleccion.length > 0) || (!$scope.campo_requerido))
                            //   {
                            //     $scope.REPRESENTANTES_AGREGADOS = true;
                            //   }
                            // }
                            $scope.limpiar_combo = true;
                            //funcion para limpiar los datos del sujeto, solo para casos nuevos
                            $scope.limpiarSujeto = function()
                            {
                              //ID_PRIORIDAD_SUJETO = $scope.sujeto.ID_PRIORIDAD_SUJETO;
                              // PRIORIDAD_SUJETO = $scope.sujeto.PRIORIDAD_SUJETO;
                              $scope.sujeto = {};
                              $scope.sujeto.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                              $scope.sujeto.ID_PRIORIDAD_SUJETO = ID_PRIORIDAD_SUJETO;
                              //se inicializan los verificadores de direcciones en falso
                              $scope.sujeto.DIRECCION = false;
                              // $scope.sujeto.PRIORIDAD_SUJETO = PRIORIDAD_SUJETO;
                              $scope.datosContacto = [];
                              $scope.datosContacto.seleccion = [];
                              $scope.datosContacto.eliminacion = [];
                              //se inicializa el arreglo representante
                              $scope.representante = {};
                              $scope.representante.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                              //se inicializa el arreglo de representantes
                              $scope.representantes = [];
                              $scope.representantes.seleccion = [];
                              $scope.representantes.eliminacion = [];
                              //validaRepresentante();
                              $scope.SUJETO_BD = false;
                              // $scope.REPRESENTANTE_BD = false;
                              $scope.focus_identificacion_sujeto = false;
                              // $scope.focus_identificacion_invitado = false;
                              $scope.UBICACION_CORRECTA = true;
                              // $scope.index = -1;
                              cambioSexoEstadoCivil = false;
                              cambioSexoProfesion = false;
                              ID_ESTADO_CIVIL = "";
                              ID_PROFESION = "";
                              descripciones_generales();
                            }
                            $scope.habilitar_datos_identificacion = function()
                            {
                              $scope.deshabilitar_identificacion = false;
                              $scope.deshabilitar_datos_sujeto = false;

                              if (edicion)
                              {
                                $scope.deshabilitar_identificacion = false;  
                                if (($scope.sujeto.IDENTIFICACION != undefined) && ($scope.sujeto.IDENTIFICACION != ""))
                                {  
                                  $scope.deshabilitar_identificacion = true;  
                                }
                              }
                              //   $scope.deshabilitar_identificacion = true;
                              //   $scope.deshabilitar_datos_sujeto = false;
                              //   if (($scope.sujeto.IDENTIFICACION != undefined) && ($scope.sujeto.IDENTIFICACION != ""))
                              //   {
                              //     $scope.deshabilitar_identificacion = false;
                              //     $scope.deshabilitar_datos_sujeto = true;
                              //     $scope.focus_identificacion_sujeto = false;
                              //   }
                              // }
                              // else if (!$scope.campo_requerido_sujeto)
                              // {
                              //   $scope.deshabilitar_identificacion = false;
                              //   $scope.deshabilitar_datos_sujeto = false;  
                              //   $scope.focus_identificacion_sujeto = true;
                              // }
                              limpiarEstadoCivilProfesion();
                            }

                        /*if ($scope.formulario_solicitante)
                        {
                          if ($scope.editar_solicitante)
                          {
                            $scope.deshabilitar_identificacion = true;
                            $scope.deshabilitar_datos_sujeto = false;
                            if (($scope.solicitante.IDENTIFICACION == undefined) || ($scope.solicitante.IDENTIFICACION == ""))
                            {
                              $scope.deshabilitar_identificacion = false;
                              $scope.deshabilitar_datos_sujeto = false;    
                            }
                          }
                          else if ((!$scope.campo_requerido_solicitante) || ($scope.caso.REQUIERE_EXPEDIENTE== $scope.CONSTANTES.REGISTRO_VERDADERO))
                          {
                            $scope.deshabilitar_identificacion = false;
                            $scope.deshabilitar_datos_sujeto = false;  
                            if ($scope.caso.REQUIERE_EXPEDIENTE== $scope.CONSTANTES.REGISTRO_VERDADERO)
                            {
                              $scope.campo_requerido_solicitante = false; 
                            }
                          }
                        }
                        else if ($scope.formulario_invitado)
                        {console.log('$scope.editar_invitado',$scope.editar_invitado, '$scope.invitado.IDENTIFICACION', $scope.invitado.IDENTIFICACION,'$scope.campo_requerido_invitado',$scope.campo_requerido_invitado);
                          if ($scope.editar_invitado)
                          {console.log('edicion'); 
                            $scope.deshabilitar_identificacion = true;
                            $scope.deshabilitar_datos_sujeto = false;
                            if (($scope.invitado.IDENTIFICACION == undefined) || ($scope.invitado.IDENTIFICACION == ""))
                            {console.log('identificacion indefinida o vacia'); 
                              $scope.deshabilitar_identificacion = false;
                              $scope.deshabilitar_datos_sujeto = false;    
                            }
                          }
                          else 
                          // if (!$scope.campo_requerido_invitado)
                          {console.log('else campo requerido');
                            $scope.deshabilitar_identificacion = false;
                            $scope.deshabilitar_datos_sujeto = false;  
                            $scope.campo_requerido_invitado = false;
                          }
                        }*/

                            $scope.habilitar_datos_identificacion_representante = function()
                            {
                              $scope.deshabilitar_identificacion_representante = false;
                              $scope.deshabilitar_datos_sujeto_representante = false;
                              if ((!$scope.editar_representante) && 
                                  (p_id_perfil==$scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE) &&
                                  ($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_FALSO))
                              {
                                // console.log('habilitar datos identificacion',p_id_perfil);
                                $scope.deshabilitar_datos_sujeto_representante = true;
                              }
                          
                              if ($scope.editar_representante)
                              {
                                $scope.deshabilitar_identificacion_representante = false;  
                                if (($scope.representante.IDENTIFICACION != undefined) && ($scope.representante.IDENTIFICACION != ""))
                                {  
                                  $scope.deshabilitar_identificacion_representante = true;  
                                }
                              }
                              
                              /*if ($scope.editar_representante)
                              {
                                $scope.deshabilitar_identificacion_representante = true;
                                $scope.deshabilitar_datos_sujeto_representante = false;
                                if (($scope.representante.IDENTIFICACION == undefined) || ($scope.representante.IDENTIFICACION == ""))
                                {
                                  $scope.deshabilitar_identificacion_representante = false;
                                  $scope.deshabilitar_datos_sujeto_representante = true;    
                                  $scope.focus_identificacion_representante = true; 
                                }
                              }
                              else if (!$scope.campo_requerido)
                              {
                                $scope.deshabilitar_identificacion_representante = false;
                                $scope.deshabilitar_datos_sujeto_representante = false; 
                                $scope.focus_identificacion_representante = true; 
                              }*/
                              limpiarEstadoCivilProfesion();
                            }

                            $scope.selectedTipoSujeto = function (item)
                            {
                              cambiar_focus_identificacion_valida();
                              $scope.habilitar_datos_identificacion();
                              $scope.limpiarSujeto();
                              if ((!edicion) && 
                                  (p_id_perfil==$scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE) &&
                                  ($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_FALSO))
                              {
                                $scope.deshabilitar_datos_sujeto = true;
                              }
                              $scope.sujeto.SUJETO_NATURAL = false;
                              if (item.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                              {
                                $scope.sujeto.SUJETO_NATURAL = true;
                                $scope.campo_identificacion_requerido = $scope.campo_requerido_sujeto; 
                              }
                              else
                              {
                                // descripciones_generales();
                                $scope.campo_identificacion_requerido = false;                             
                                $scope.deshabilitar_datos_sujeto = false;
                              }

                              // if ((!edicion) && (p_id_perfil==$scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE))
                              // {
                              //   console.log('habilitar datos identificacion',p_id_perfil);
                              //   $scope.deshabilitar_datos_sujeto = true;
                              // }

                              $scope.sujeto.ID_TIPO_SUJETO = item.ID_TIPO_SUJETO;
                              $scope.LOCAL_ID_TIPO_SUJETO = item.ID_TIPO_SUJETO;
                              getTipoIdentificacion(item.ID_TIPO_SUJETO);
                            }
                            $scope.selectedPrioridadSujeto = function (item)
                            {
                              $scope.LOCAL_ID_PRIORIDAD_SUJETO = item.ID_PRIORIDAD_SUJETO;
                              $scope.sujeto.ID_PRIORIDAD_SUJETO = item.ID_PRIORIDAD_SUJETO;
                              if ($scope.sujeto.IDENTIFICACION == "")
                              {
                                $scope.focus_identificacion_sujeto = true;
                              }
                            }
                            //se obtiene el arreglo inicial para el tipo de sujeto natural
                            buscarTipoSujeto = function(valor, arreglo){
                              for (var i=0; i < arreglo.length; i++) {
                                  if (arreglo[i].ID_TIPO_SUJETO === valor) {
                                      return arreglo[i];
                                  }
                              }
                            }
                            //se obtiene el arreglo inicial para la prioridad del sujeto natural
                            buscarPrioridadSujeto = function(valor, arreglo){
                              for (var i=0; i < arreglo.length; i++) {
                                  if (arreglo[i].ID_PRIORIDAD_SUJETO === valor) {
                                      return arreglo[i];
                                  }
                              }
                            }
                            //se obtiene el arreglo inicial para el tipo de identificacion de los sujetos
                            buscarTipoIdentificacionSujeto = function(valor, arreglo){
                              for (var i=0; i < arreglo.length; i++) {
                                  if (arreglo[i].ID_TIPO_IDENTIFICACION === valor) {
                                      return arreglo[i];
                                  }
                              }
                            }
                            $scope.cambiar_focus_identificacion = function()
                            {
                              $scope.focus_identificacion_sujeto = false;
                            }
                            cambiar_tipo_identificacion = function()
                            {
                              $scope.combo_tipo_identificacion = !$scope.combo_tipo_identificacion;
                            }
                            cambiar_focus_identificacion_valida = function()
                            {
                              $scope.focus_identificacion_valida = false;
                              $scope.focus_identificacion_valida_representante = false;
                            }
                            $scope.selectedIdioma = function (item)
                            {
                              if ($scope.formularioRepresentante)
                              {
                                $scope.representante.ID_IDIOMA = item.ID_IDIOMA;
                                $scope.representante.ID_CLASIFICACION_IDIOMA = item.ID_CLASIFICACION_IDIOMA;
                              }
                              else
                              {
                                $scope.sujeto.ID_IDIOMA = item.ID_IDIOMA;
                                $scope.sujeto.ID_CLASIFICACION_IDIOMA = item.ID_CLASIFICACION_IDIOMA;
                              }
                            } 
                            limpiarIdioma = function(limpiar)
                            {
                              if ($scope.formularioRepresentante)
                              {
                                if ((!$scope.editar_representante) || ($scope.representante.IDENTIFICACION == "") || (limpiar))
                                {
                                  $scope.representante.ID_IDIOMA = "";
                                  $scope.representante.ID_CLASIFICACION_IDIOMA = "";
                                  $scope.idiomas = [];
                                }
                              }
                              else if ((!edicion) || ($scope.sujeto.IDENTIFICACION == "") || (limpiar))
                              {
                                $scope.sujeto.ID_IDIOMA = "";
                                $scope.sujeto.ID_CLASIFICACION_IDIOMA = "";                              
                                $scope.idiomas = [];
                              }
                            }     
                            getIdioma = function (p_id_nacionalidad,p_id_tipo_poblacion,p_id_tipo_clasificacion_idioma,limpiar)
                            {
                              casosService.getIdioma(p_id_nacionalidad,p_id_tipo_poblacion,p_id_tipo_clasificacion_idioma).then(
                                function ( response ) 
                                {
                                  limpiarIdioma(limpiar);
                                  $scope.idiomas = [];
                                  $scope.idiomas = response.data;
                                  if ($scope.idiomas.length == 1)
                                  {
                                    $scope.selectedIdioma(response.data[0]);
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }
                            $scope.selectedTipoPoblacion = function (item,limpiar)
                            {
                              $scope.limpiarTipoPoblacion = limpiar
                              ID_NACIONALIDAD = "";
                              if ($scope.formularioRepresentante)
                              {
                                $scope.representante.ID_TIPO_POBLACION = item.ID_TIPO_POBLACION;
                                ID_NACIONALIDAD = $scope.representante.ID_NACIONALIDAD;
                              }
                              else
                              {
                                $scope.sujeto.ID_TIPO_POBLACION = item.ID_TIPO_POBLACION;
                                ID_NACIONALIDAD = $scope.sujeto.ID_NACIONALIDAD;  
                              }
                              getIdioma(ID_NACIONALIDAD,item.ID_TIPO_POBLACION,$scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO,limpiar);
                            }
                            limpiarTipoPoblacion = function()
                            {
                              if ((($scope.formularioRepresentante) && (!$scope.editar_representante)) ||
                                  (($scope.formularioRepresentante) && ($scope.representante.IDENTIFICACION == "")))
                              {
                                $scope.representante.ID_TIPO_POBLACION = "";
                              }
                              else if ((!edicion) || ($scope.sujeto.IDENTIFICACION == ""))
                              {
                                $scope.sujeto.ID_TIPO_POBLACION = "";
                              }
                              limpiarIdioma(!$scope.limpiar_combo); 
                            }
                            getTipoPoblacion = function (p_id_nacionalidad,p_id_tipo_clasificacion_idioma,limpiar)
                            {
                              casosService.getTipoPoblacion(p_id_nacionalidad,p_id_tipo_clasificacion_idioma).then(
                                function ( response ) 
                                { 
                                  if (limpiar)
                                  {
                                    limpiarTipoPoblacion();   
                                  }
                                  $scope.tipoPoblacion = [];
                                  $scope.tipoPoblacion = response.data;
                                  if ($scope.tipoPoblacion.length == 1)
                                  {
                                    $scope.selectedTipoPoblacion(response.data[0],!$scope.limpiar_combo);
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }
                            $scope.selectedNacionalidad = function (item,limpiar)
                            {      
                              if ($scope.formularioRepresentante)
                              {
                                $scope.representante.ID_NACIONALIDAD = item.ID_NACIONALIDAD;
                              }
                              else
                              {
                                $scope.sujeto.ID_NACIONALIDAD = item.ID_NACIONALIDAD;
                              }
                              getTipoPoblacion(item.ID_NACIONALIDAD,$scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO,limpiar);
                            }
                            limpiarNacionalidad = function()
                            {
                              if ($scope.formularioRepresentante)
                              {
                                $scope.representante.ID_NACIONALIDAD = "";
                              }
                              else
                              {
                                $scope.sujeto.ID_NACIONALIDAD = "";
                              }
                              limpiarTipoPoblacion();
                            }
                            //se obtiene el arreglo inicial para las nacionalidades
                            buscarNacionalidad = function(valor, arreglo){
                              for (var i=0; i < arreglo.length; i++) {
                                  if (arreglo[i].ID_NACIONALIDAD === valor) {
                                      return arreglo[i];
                                  }
                              }
                            }
                            getNacionalidad = function(p_id_tipo_clasificacion_idioma,p_id_tipo_identificacion,limpiar)
                            {
                              casosService.getNacionalidad(p_id_tipo_clasificacion_idioma,p_id_tipo_identificacion).then(
                                function ( response ) 
                                {
                                  if (limpiar)
                                  {
                                    limpiarNacionalidad();
                                  }
                                  $scope.nacionalidades = [];   
                                  $scope.nacionalidades = response.data;
                                  if ($scope.nacionalidades.length == 1)
                                  {
                                    $scope.selectedNacionalidad(response.data[0],limpiar);
                                  }
                                  else if ($scope.sujeto.ID_NACIONALIDAD != "")
                                  {
                                    itemNacionalidad = buscarNacionalidad($scope.sujeto.ID_NACIONALIDAD,$scope.nacionalidades);
                                    $scope.selectedNacionalidad(itemNacionalidad,limpiar);
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }
                            $scope.selectedTipoIdentificacion = function (item,limpiarTipoIdentificacion)
                            {
                              cambiar_tipo_identificacion();
                              $scope.sujeto.ID_TIPO_IDENTIFICACION = item.ID_TIPO_IDENTIFICACION;
                              $scope.sujeto.MASCARA_IDENTIFICACION = item.MASCARA;
                              if (limpiarTipoIdentificacion)
                              {
                                $scope.sujeto.IDENTIFICACION="";
                                $scope.focus_identificacion_sujeto = true;
                              }
                              if ((item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_PASAPORTE) || 
                                  (item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI) ||
                                  (item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI_EXT))
                              { 
                                getNacionalidad($scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO,item.ID_TIPO_IDENTIFICACION,limpiarTipoIdentificacion);
                              }
                              $scope.UBICACION_CORRECTA = false;
                              if ((($scope.sujeto.IDENTIFICACION != undefined) && 
                                   ($scope.sujeto.IDENTIFICACION != "")) || 
                                   (item.ID_TIPO_IDENTIFICACION != $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI) ||
                                   (p_id_perfil == $scope.CONSTANTES.PERFIL_SUJETO_INVITADO) || 
                                   ($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO)) 
                              {
                                $scope.UBICACION_CORRECTA = true;
                              }
                            }
                            // selectedTipoIdentificacion = function (item,limpiarTipoIdentificacion)
                            // {
                            //   cambiar_tipo_identificacion();
                            //   $scope.sujeto.ID_TIPO_IDENTIFICACION = item.ID_TIPO_IDENTIFICACION;
                            //   $scope.sujeto.MASCARA_IDENTIFICACION = item.MASCARA;
                            //   if (limpiarTipoIdentificacion)
                            //   {
                            //     $scope.sujeto.IDENTIFICACION="";
                            //     $scope.focus_identificacion_sujeto = true;
                            //   }
                            //   // if ((item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_PASAPORTE) || 
                            //   //     (item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI))
                            //   // { 
                            //   $scope.UBICACION_CORRECTA = false;
                            //   if ((($scope.sujeto.IDENTIFICACION != undefined) && 
                            //        ($scope.sujeto.IDENTIFICACION != "")) || 
                            //       (item.ID_TIPO_IDENTIFICACION != $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI)) 
                            //   {
                            //     $scope.UBICACION_CORRECTA = true;
                            //   }
                            //     //getNacionalidad($scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO,item.ID_TIPO_IDENTIFICACION);
                            //   // }
                            // }
                            getTipoIdentificacion = function (p_id_tipo_sujeto)
                            {
                              casosService.getTipoIdentificacion(p_id_tipo_sujeto).then(
                                function ( response ) 
                                {
                                  $scope.tipoIdentificacion = [];
                                  $scope.tipoIdentificacion = response.data;
                                  if ($scope.tipoIdentificacion.length == 1)
                                  {
                                    $scope.selectedTipoIdentificacion(response.data[0],true);
                                  }
                                  else if (p_id_tipo_sujeto == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                                  { 
                                    itemTipoIdentificacion = buscarTipoIdentificacionSujeto($scope.CONSTANTES.TIPO_IDENTIFICACION_DPI, response.data);
                                    $scope.selectedTipoIdentificacion(itemTipoIdentificacion,true);
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }
                            $scope.selectedEstadoCivil = function (item)
                            {
                              ID_ESTADO_CIVIL = item.ID_ESTADO_CIVIL;
                              if ($scope.formularioRepresentante)
                              {
                                $scope.representante.ID_ESTADO_CIVIL = item.ID_ESTADO_CIVIL;
                              }
                              else
                              {
                                $scope.sujeto.ID_ESTADO_CIVIL = item.ID_ESTADO_CIVIL;
                              }
                            }
                            selectedEstadoCivilTemporal = function (item)
                            {
                              if ($scope.formularioRepresentante)
                              {
                                $scope.representante.ID_ESTADO_CIVIL = item.ID_ESTADO_CIVIL;
                              }
                              else
                              {
                                $scope.sujeto.ID_ESTADO_CIVIL = item.ID_ESTADO_CIVIL;
                              }
                            }
                            $scope.selectedNivelEducativo = function (item)
                            {
                              $scope.representante.ID_NIVEL_EDUCATIVO = item.ID_NIVEL_EDUCATIVO;
                            }
                            $scope.selectedProfesion = function (item)
                            {
                              ID_PROFESION = item.ID_PROFESION;
                              if ($scope.formularioRepresentante)
                              {
                                $scope.representante.ID_PROFESION = item.ID_PROFESION;
                              }
                              else
                              {
                                $scope.sujeto.ID_PROFESION = item.ID_PROFESION;
                              }
                            }
                            selectedProfesionTemporal = function (item)
                            {
                              if ($scope.formularioRepresentante)
                              {
                                $scope.representante.ID_PROFESION = item.ID_PROFESION;
                              }
                              else
                              {
                                $scope.sujeto.ID_PROFESION = item.ID_PROFESION;
                              }
                            }
                            //descripciones iniciales para los formularios
                            descripciones_generales = function()
                            {
                              if ($scope.formularioRepresentante)
                              {
                                $scope.descripcion_datos_representante = "Representante";
                                $scope.tooltip_boton_editar_representante = "Actualizar datos";
                                if (!$scope.editar_representante)
                                {
                                  // $scope.descripcion_datos_representante = "Representante";
                                  $scope.tooltip_boton_editar_representante = "Guardar representante";
                                }
                              }
                              else 
                              {
                                $scope.tooltip_boton_guardar_sujeto = "Guardar cambios";
                                if (p_id_perfil == $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE)
                                {
                                  $scope.descripcion_datos_sujeto = "Solicitante";
                                  $scope.tooltip_boton_eliminar_sujeto = "Eliminar solicitante";
                                  if (!edicion)
                                  {
                                    // $scope.descripcion_datos_sujeto = "Solicitante";
                                    $scope.tooltip_boton_guardar_sujeto = "Guardar solicitante";
                                    // $scope.tooltip_boton_eliminar_sujeto = "Limpiar datos";
                                  }
                                }
                                else if (p_id_perfil == $scope.CONSTANTES.PERFIL_SUJETO_INVITADO)
                                {
                                  $scope.descripcion_datos_sujeto = "Invitado";
                                  $scope.tooltip_boton_eliminar_sujeto = "Eliminar invitado";
                                  if (!edicion)
                                  {
                                    // $scope.descripcion_datos_sujeto = "Invitado";
                                    $scope.tooltip_boton_guardar_sujeto = "Guardar invitado";
                                    // $scope.tooltip_boton_eliminar_sujeto = "Limpiar datos";
                                  }
                                }  
                              }
                              
                            }
                            descripciones_generales();
                            descripciones_mujer = function()
                            {
                              if ($scope.formularioRepresentante)
                              {
                                $scope.descripcion_datos_representante = "Representante";
                                //$scope.tooltip_boton_editar_representante = "Actualizar datos";
                                if (!$scope.editar_representante)
                                {
                                  // $scope.descripcion_datos_representante = "Representante";
                                  $scope.tooltip_boton_editar_representante = "Guardar representante";
                                }
                              }
                              else 
                              {
                                if (p_id_perfil == $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE)
                                {
                                  $scope.descripcion_datos_sujeto = "Solicitante";
                                  // if (!edicion)
                                  // {
                                  //   $scope.descripcion_datos_sujeto = "Solicitante";
                                  // }
                                }
                                else if (p_id_perfil == $scope.CONSTANTES.PERFIL_SUJETO_INVITADO)
                                {
                                  $scope.descripcion_datos_sujeto = "Invitada";
                                  $scope.tooltip_boton_eliminar_sujeto = "Eliminar invitada";
                                  if (!edicion)
                                  {
                                    // $scope.descripcion_datos_sujeto = "Invitada";
                                    $scope.tooltip_boton_guardar_sujeto = "Guardar invitada";
                                    // $scope.tooltip_boton_eliminar_sujeto = "Limpiar datos";
                                  }
                                }
                              }
                            }
                            //funciones solicitante invitado representante
                            buscarEstadoCivil = function(valor, arreglo){
                              for (var i=0; i < arreglo.length; i++) {
                                  if (arreglo[i].ID_ESTADO_CIVIL === valor) {
                                      return arreglo[i];
                                  }
                              }
                            }
                            buscarProfesion = function(valor, arreglo){
                              for (var i=0; i < arreglo.length; i++) {
                                  if (arreglo[i].ID_PROFESION === valor) {
                                      return arreglo[i];
                                  }
                              }
                            }
                            limpiarEstadoCivilProfesion = function()
                            {
                              cambioSexoEstadoCivil = false;
                              cambioSexoProfesion = false;
                              ID_ESTADO_CIVIL = "";
                              ID_PROFESION = "";
                              $scope.estadosCiviles = [];
                              $scope.profesiones = [];
                            }
                            limpiarEstadoCivilProfesion();
                            $scope.cambiaSexo = function()
                            {
                              cambioSexoEstadoCivil=false;
                              cambioSexoProfesion = false;
                              if (ID_ESTADO_CIVIL != "")
                              {
                                id_estado_civil_temporal = "0";
                                BreakException = {};
                                try 
                                {
                                  $scope.estadosCiviles.forEach(function(estado_civil) 
                                  {
                                    id_estado_civil_temporal = estado_civil.ID_ESTADO_CIVIL;
                                    if (estado_civil.ID_ESTADO_CIVIL != ID_ESTADO_CIVIL)                  
                                    {
                                      throw BreakException;
                                    }
                                  });
                                } catch (e) 
                                {
                                  true;
                                }  
                                itemEstadoCivil=buscarEstadoCivil(id_estado_civil_temporal,$scope.estadosCiviles)
                                selectedEstadoCivilTemporal(itemEstadoCivil);
                                cambioSexoEstadoCivil=true;
                              }
                              if (ID_PROFESION != "")
                              {
                                id_profesion_temporal = "0";
                                BreakException = {};
                                try 
                                {
                                  $scope.profesiones.forEach(function(profesion) 
                                  {
                                    id_profesion_temporal = profesion.ID_PROFESION;
                                    if (profesion.ID_PROFESION != ID_PROFESION)                  
                                    {
                                      throw BreakException;
                                    }
                                  });
                                } catch (e) 
                                {
                                  true;
                                }  
                                itemProfesion=buscarProfesion(id_profesion_temporal,$scope.profesiones)
                                selectedProfesionTemporal(itemProfesion);
                                cambioSexoProfesion=true;
                              }
                            }
                            getEstadoCivil = function(p_id_sexo, estado_civil)
                            {
                              casosService.getEstadoCivil(p_id_sexo).then(
                                function ( response ) 
                                { 
                                  //limpiarEstadoCivilProfesion();
                                  $scope.estadosCiviles = [];
                                  $scope.estadosCiviles = response.data;
                                  if ((cambioSexoEstadoCivil) || ((estado_civil != undefined) && (estado_civil != "")))
                                  {
                                    if (estado_civil != undefined)
                                    {
                                      ID_ESTADO_CIVIL = estado_civil
                                    }
                                    if ((ID_ESTADO_CIVIL != undefined) && (ID_ESTADO_CIVIL != ""))
                                    {
                                      itemEstadoCivil=buscarEstadoCivil(ID_ESTADO_CIVIL,$scope.estadosCiviles)
                                      $scope.selectedEstadoCivil(itemEstadoCivil);
                                    }
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }
                            getProfesion = function(p_id_sexo, profesion)
                            {
                              casosService.getProfesion(p_id_sexo).then(
                                function ( response ) 
                                {
                                  //limpiarProfesion();
                                  $scope.profesiones = [];
                                  $scope.profesiones = response.data;
                                  if ((cambioSexoProfesion) || ((profesion != undefined) && (profesion != "")))
                                  { 
                                    if (profesion != undefined)
                                    {
                                      ID_PROFESION = profesion
                                    }
                                    if ((ID_PROFESION != undefined) && (ID_PROFESION != ""))
                                    {
                                      itemProfesion=buscarProfesion(ID_PROFESION,$scope.profesiones)
                                      $scope.selectedProfesion(itemProfesion);
                                    }
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }
                            $scope.selectedGenero = function (item)
                            { 
                              if ($scope.formularioRepresentante)
                              {
                                descripciones_generales();
                                $scope.representante.ID_GENERO = item.ID_GENERO;
                                // $scope.representante.GENERO = item.GENERO;
                                $scope.representante.SEXO_MUJER = false;
                                if (item.ID_GENERO == $scope.CONSTANTES.SEXO_MUJER)
                                {
                                  descripciones_mujer();
                                  $scope.representante.SEXO_MUJER = true;
                                }
                                else
                                {
                                  $scope.representante.APELLIDO_CASADA="";
                                }
                              }
                              else
                              {
                                descripciones_generales();
                                $scope.sujeto.ID_GENERO = item.ID_GENERO;
                                $scope.sujeto.SEXO_MUJER = false;
                                if (item.ID_GENERO == $scope.CONSTANTES.SEXO_MUJER)
                                {
                                  descripciones_mujer();
                                  $scope.sujeto.SEXO_MUJER = true;
                                }
                                else
                                {
                                  $scope.sujeto.APELLIDO_CASADA="";
                                }  
                              }
                              getEstadoCivil(item.ID_GENERO,item.ID_ESTADO_CIVIL);
                              getProfesion(item.ID_GENERO,item.ID_PROFESION);
                            }
                            getPoblacionIdioma = function(item)
                            {
                              if ((item.ID_NACIONALIDAD != undefined) && (item.ID_NACIONALIDAD != ""))
                              {
                                $scope.tipoPoblacion = [];
                                casosService.getTipoPoblacion(item.ID_NACIONALIDAD,$scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO).then(
                                  function ( response ) 
                                  {    
                                    $scope.tipoPoblacion = response.data;
                                  },
                                  function ( error ) 
                                  {
                                      toastr.error( error );
                                  });
                                if ((item.ID_TIPO_POBLACION != undefined) && (item.ID_TIPO_POBLACION != ""))
                                {
                                  $scope.idiomas = [];
                                  casosService.getIdioma(item.ID_NACIONALIDAD,item.ID_TIPO_POBLACION,$scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO).then(
                                  function ( response ) 
                                  {
                                    $scope.idiomas = response.data;
                                  },
                                  function ( error ) 
                                  {
                                      toastr.error( error );
                                  });
                                }
                              }
                            }
                            $scope.reinicio_contado_mensajes_invalidos = function()
                            {
                              contador_mensajes_invalidos = 0;
                              $scope.cambiar_focus_identificacion();
                            }

                            $scope.verificar_identificacion_sujeto = function()
                            {
                              // if ((($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO) ||
                              //     (p_id_perfil == $scope.CONSTANTES.PERFIL_SUJETO_INVITADO)) &&
                              //     ($scope.IDENTIFICACION_BD != $scope.sujeto.IDENTIFICACION))
                              // {
                                if (($scope.sujeto.IDENTIFICACION != "") && ($scope.sujeto.IDENTIFICACION != undefined))
                                {
                                  if ($scope.sujeto.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI)
                                  {
                                    $scope.valida_identificacion($scope.sujeto.IDENTIFICACION);
                                  }
                                  if ($scope.UBICACION_CORRECTA)
                                  {
                                    $scope.campo_requerido_sujeto = true;
                                    $scope.deshabilitar_datos_sujeto = true;
                                  }
                                }
                                else
                                {
                                  $scope.UBICACION_CORRECTA = true;
                                }  
                              // }
                              // else
                              // {
                              //   if (p_id_perfil == $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE)
                              //   {
                                  
                              //   }
                              //   else if (p_id_perfil == $scope.CONSTANTES.PERFIL_SUJETO_INVITADO)
                              //   {
                                // agregarSujeto = 
                              //   }
                              // } 
                            }
                            
                            $scope.verificar_identificacion_representante = function()
                            {
                              // if (($scope.caso.REQUIERE_EXPEDIENTE== $scope.CONSTANTES.REGISTRO_VERDADERO)&&
                              //     ($scope.IDENTIFICACION_BD != $scope.representante.IDENTIFICACION))
                              // {
                                if (($scope.representante.IDENTIFICACION != "") && ($scope.representante.IDENTIFICACION != undefined))
                                {
                                  if ($scope.representante.ID_TIPO_IDENTIFICACION == $scope.constantes.TIPO_IDENTIFICACION_DPI)
                                  {
                                    $scope.valida_identificacion($scope.representante.IDENTIFICACION);
                                  }
                                  if ($scope.UBICACION_CORRECTA)
                                  {
                                    $scope.campo_requerido = true;
                                    $scope.deshabilitar_datos_sujeto_representante = true;
                                  }
                                }
                                else
                                {
                                  $scope.UBICACION_CORRECTA = true;
                                }  
                              // } 
                            }

                            $scope.reinicio_contado_mensajes_invalidos();
                            $scope.valida_identificacion = function(IDENTIFICACION)
                            {
                              if (IDENTIFICACION != undefined)
                              {
                                if (contador_mensajes_invalidos < 100) 
                                {
                                  validaUbicacionNacimiento();
                                }
                                contador_mensajes_invalidos++;
                              }
                            }
                            //verificar si se usa para obtener el lugar de nacimiento de los sujetos o se obtiene desde la base
                            getUbicacionNacimiento = function(IDENTIFICACION)
                            {
                              IDENTIFICACION = IDENTIFICACION.replace(/\s/g, "");
                              IDENTIFICACION = IDENTIFICACION.substring(IDENTIFICACION.length-4, IDENTIFICACION.length);                      
                              casosService.getUbicacionNacimiento(IDENTIFICACION).then(
                                function ( response ) 
                                { 
                                  if (response.data.id == 0)
                                  {
                                    toastr.warning(response.data.msj);
                                    $scope.mensaje_ubicacion_incorrecta = response.data.msj
                                    $scope.UBICACION_CORRECTA = false;
                                  }
                                  else
                                  {
                                    $scope.UBICACION_CORRECTA = true;
                                  }
                                },
                                function ( error ) 
                                {
                                  toastr.error( error );
                                });  
                            }
                            validaUbicacionNacimiento = function()
                            {
                              if (($scope.formularioRepresentante) &&
                                  ($scope.representante.IDENTIFICACION != undefined) && 
                                  ($scope.representante.IDENTIFICACION != "") &&
                                  ($scope.representante.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI))
                                {
                                  getUbicacionNacimiento($scope.representante.IDENTIFICACION);
                                }
                              else if (($scope.sujeto.IDENTIFICACION != undefined) && 
                                       ($scope.sujeto.IDENTIFICACION != "") &&
                                       ($scope.sujeto.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI))
                                {
                                  getUbicacionNacimiento($scope.sujeto.IDENTIFICACION);
                                }
                            }
                            desplegar_mensaje_fecha_invalida = true;
                            $scope.valida_fecha_nacimiento = function(FECHA_NACIMIENTO)
                            {
                              if (FECHA_NACIMIENTO != undefined) 
                              {
                                contador_mensajes_invalidos++;
                                if (FECHA_NACIMIENTO >= $scope.dateOptions.minDate)
                                {
                                  if (FECHA_NACIMIENTO <= $scope.dateOptions.maxDate)
                                  {
                                    $scope.FECHA_NACIMIENTO_VALIDA = true;
                                    contador_mensajes_invalidos = 0;
                                  }
                                  else
                                  {
                                    if ((desplegar_mensaje_fecha_invalida) && (contador_mensajes_invalidos < 2))
                                    {
                                      toastr.warning('Fecha de nacimiento invalida, no se pueden registrar menores de edad');
                                    }
                                    desplegar_mensaje_fecha_invalida = !desplegar_mensaje_fecha_invalida;
                                    $scope.FECHA_NACIMIENTO_VALIDA = false;
                                  }
                                }
                                else
                                { 
                                  if ((desplegar_mensaje_fecha_invalida) && (contador_mensajes_invalidos < 2))
                                  {
                                    toastr.warning('Fecha de nacimiento invalida');
                                  }
                                  desplegar_mensaje_fecha_invalida = !desplegar_mensaje_fecha_invalida;
                                  $scope.FECHA_NACIMIENTO_VALIDA = false;
                                }
                              }
                              else
                              {
                                contador_mensajes_invalidos = 0;
                              }
                            }
                            validaDireccion = function()
                            {  
                              $scope.sujeto.DIRECCION = false;
                              var BreakException = {};
                              try 
                              {
                                $scope.datosContacto.seleccion.forEach(function(contacto) 
                                {
                                  if (contacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION) throw BreakException;
                                });
                              } catch (e) 
                              {
                                $scope.sujeto.DIRECCION = true;
                              } 
                            }

                            //se obtiene el arreglo inicial para el tipo de identificacion de los sujetos
                            buscarContactoSujeto = function(valor, arreglo){
                              valor = valor.replace(/ /g,"");
                              valor = valor.replace(/,/g,"");
                              valor = valor.replace(/Á/g,"A");
                              valor = valor.replace(/É/g,"E");
                              valor = valor.replace(/Í/g,"I");
                              valor = valor.replace(/Ó/g,"O");
                              valor = valor.replace(/Ú/g,"U");
                              valor = valor.replace(/-/g,"");
                              valor = valor.replace(/_/g,"");
                              for (var i=0; i < arreglo.length; i++) 
                              {
                                contacto = arreglo[i].CONTACTO_TEMPORAL;
                                contacto = contacto.replace(/ /g,"");
                                contacto = contacto.replace(/,/g,"");
                                contacto = contacto.replace(/Á/g,"A");
                                contacto = contacto.replace(/É/g,"E");
                                contacto = contacto.replace(/Í/g,"I");
                                contacto = contacto.replace(/Ó/g,"O");
                                contacto = contacto.replace(/Ú/g,"U");
                                contacto = contacto.replace(/-/g,"");
                                contacto = contacto.replace(/_/g,"");
                                if (contacto === valor) 
                                {
                                      return true;
                                }
                                else
                                {
                                  return false;
                                }
                              }
                            }
                            ordenarContacto = function()
                            {
                              if ($scope.formularioRepresentante)
                              {
                                var filtered = [];
                                angular.forEach($scope.datosContactoRepresentante.seleccion, function(item) {
                                  filtered.push(item);
                                });
                                filtered.sort(function (a, b) {
                                  return (a['ID_TIPO_CONTACTO'] > b['ID_TIPO_CONTACTO'] ? 1 : -1);
                                });
                                $scope.datosContactoRepresentante.seleccion =  filtered;
                              }
                              else
                              {
                                var filtered = [];
                                angular.forEach($scope.datosContacto.seleccion, function(item) {
                                  filtered.push(item);
                                });
                                filtered.sort(function (a, b) {
                                  return (a['ID_TIPO_CONTACTO'] > b['ID_TIPO_CONTACTO'] ? 1 : -1);
                                });
                                $scope.datosContacto.seleccion =  filtered;
                              }
                            }
                            getDatosSujetoIdentificacion = function(p_id_tipo_sujeto,p_id_tipo_identificacion,p_identificacion)
                            {
                              casosService.getDatosSujetoIdentificacion(p_id_tipo_sujeto,p_id_tipo_identificacion,p_identificacion).then(
                                function ( response ) 
                                {
                                  if (response.data.ID_SUJETO == undefined)
                                  {
                                    toastr.warning('No se encontraron coincidencias para el número de identificación ingresado');
                                    if ($scope.formularioRepresentante)
                                    {
                                      $scope.deshabilitar_identificacion_representante = true;
                                      $scope.deshabilitar_datos_sujeto_representante = false;
                                      if ($scope.representante.FECHA_NACIMIENTO == "")
                                      {
                                        $scope.focus_identificacion_valida_representante = true;
                                      }
                                    }
                                    else
                                    {
                                      $scope.deshabilitar_identificacion = true;
                                      $scope.deshabilitar_datos_sujeto = false;
                                      if ($scope.sujeto.FECHA_NACIMIENTO == "")
                                      {
                                        $scope.focus_identificacion_valida = true;
                                      } 
                                    }
                                  }
                                  else
                                  {
                                    if (p_id_tipo_sujeto == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                                    {
                                      getPoblacionIdioma(response.data);
                                      ID_ESTADO_CIVIL = response.data.ID_ESTADO_CIVIL;
                                      ID_PROFESION = response.data.ID_PROFESION;
                                      $scope.selectedGenero(response.data);
                                    }
                                    if ($scope.formularioRepresentante)
                                    {
                                      $scope.deshabilitar_identificacion_representante = true;
                                      $scope.deshabilitar_datos_sujeto_representante = false;
                                      if ($scope.editar_representante)
                                      {
                                        temp = {};
                                        temp.ID_SUJETO_EXPEDIENTE = $scope.representante.ID_SUJETO_EXPEDIENTE;
                                        temp.ID_REPRESENTANTE_ELIMINACION = $scope.representante.ID_REPRESENTANTE;
                                        temp.ICONO_TIPO_SUJETO = $scope.representante.ICONO_TIPO_SUJETO;
                                        temp.ID_PERFIL_SUJETO = $scope.representante.ID_PERFIL_SUJETO;
                                        temp.ID_PRIORIDAD_SUJETO = $scope.representante.ID_PRIORIDAD_SUJETO;
                                        temp.ID_TIPO_SUJETO = $scope.representante.ID_TIPO_SUJETO;
                                        temp.PERFIL_SUJETO = $scope.representante.PERFIL_SUJETO;
                                        temp.PRIORIDAD_SUJETO = $scope.representante.PRIORIDAD_SUJETO;
                                        temp.SEXO_MUJER = $scope.representante.SEXO_MUJER;
                                        temp.SUJETO_NATURAL = $scope.representante.SUJETO_NATURAL;
                                        temp.TIPO_SUJETO = $scope.representante.TIPO_SUJETO;
                                        angular.extend(temp,response.data);
                                        for (var i=0; i < $scope.representante.contactos.length; i++) 
                                        {
                                          contactoExistente = buscarContactoSujeto($scope.representante.contactos[i].CONTACTO_TEMPORAL,temp.contactos);
                                          if (!contactoExistente)
                                          {
                                            $scope.representante.contactos[i].ID_CONTACTO_SUJETO_ELIMINACION = $scope.representante.contactos[i].ID_CONTACTO_SUJETO;
                                            temp.contactos.push($scope.representante.contactos[i]);
                                          }                                      
                                        }
                                        $scope.representante = {};
                                        $scope.representante = temp;
                                        if (temp.SUJETO_NATURAL)
                                        {
                                          $scope.cambiaSexo(); 
                                          $scope.selectedGenero($scope.representante);
                                        }
                                        $scope.datosContactoRepresentante.seleccion = [];
                                        $scope.datosContactoRepresentante.seleccion = temp.contactos;
                                        ordenarContacto();
                                      }
                                      else
                                      {
                                        angular.extend($scope.representante,response.data);
                                        $scope.datosContactoRepresentante.seleccion = $scope.representante.contactos;
                                      }
                                      if (($scope.representante.FECHA_NACIMIENTO != undefined) && ($scope.representante.FECHA_NACIMIENTO != ""))
                                      {
                                        $scope.FECHA_NACIMIENTO_VALIDA = true;
                                      }
                                      validaDireccion();
                                    }
                                    else 
                                    {
                                      $scope.deshabilitar_identificacion = true;
                                      $scope.deshabilitar_datos_sujeto = false;
                                      if (edicion)
                                      {
                                        temp = {};
                                        temp.ID_SUJETO_EXPEDIENTE_ELIMINACION = $scope.sujeto.ID_SUJETO_EXPEDIENTE;
                                        temp.ID_SUJETO_ELIMINACION = $scope.sujeto.ID_SUJETO;
                                        temp.ICONO_TIPO_SUJETO = $scope.sujeto.ICONO_TIPO_SUJETO;
                                        temp.ID_PERFIL_SUJETO = $scope.sujeto.ID_PERFIL_SUJETO;
                                        temp.ID_PRIORIDAD_SUJETO = $scope.sujeto.ID_PRIORIDAD_SUJETO;
                                        temp.ID_TIPO_SUJETO = $scope.sujeto.ID_TIPO_SUJETO;
                                        temp.PERFIL_SUJETO = $scope.sujeto.PERFIL_SUJETO;
                                        temp.PRIORIDAD_SUJETO = $scope.sujeto.PRIORIDAD_SUJETO;
                                        temp.SEXO_MUJER = $scope.sujeto.SEXO_MUJER;
                                        temp.SUJETO_NATURAL = $scope.sujeto.SUJETO_NATURAL;
                                        temp.TIPO_SUJETO = $scope.sujeto.TIPO_SUJETO;
                                        angular.extend(temp,response.data);
                                        for (var i=0; i < $scope.sujeto.contactos.length; i++) 
                                        {
                                          contactoExistente = buscarContactoSujeto($scope.sujeto.contactos[i].CONTACTO_TEMPORAL,temp.contactos);
                                          if (!contactoExistente)
                                          {
                                            $scope.sujeto.contactos[i].ID_CONTACTO_SUJETO_ELIMINACION = $scope.sujeto.contactos[i].ID_CONTACTO_SUJETO;
                                            temp.contactos.push($scope.sujeto.contactos[i]);
                                          }                                      
                                        }
                                        $scope.sujeto = {};
                                        $scope.sujeto.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                                        $scope.sujeto = temp;
                                        if (temp.SUJETO_NATURAL)
                                        {
                                          $scope.cambiaSexo(); 
                                          $scope.selectedGenero($scope.sujeto);
                                        }
                                        $scope.datosContacto.seleccion = [];
                                        $scope.datosContacto.seleccion = temp.contactos;
                                        ordenarContacto();
                                      }
                                      else
                                      {
                                        angular.extend($scope.sujeto,response.data);
                                        $scope.datosContacto.seleccion = $scope.sujeto.contactos;
                                      }
                                      if (($scope.sujeto.FECHA_NACIMIENTO != undefined) && ($scope.sujeto.FECHA_NACIMIENTO != ""))
                                      {
                                        $scope.FECHA_NACIMIENTO_VALIDA = true;
                                      }
                                      validaDireccion();
                                    }
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }
                            $scope.buscarSujeto = function(ubicacion,isValid,item)
                            {
                              if ((ubicacion) && (isValid) && (item.IDENTIFICACION != ""))
                              {
                                if ($scope.formularioRepresentante)
                                {
                                  ID_TIPO_SUJETO = $scope.CONSTANTES.TIPO_SUJETO_NATURAL;
                                }
                                else
                                {
                                  ID_TIPO_SUJETO = item.ID_TIPO_SUJETO;
                                }
                                getDatosSujetoIdentificacion(ID_TIPO_SUJETO,item.ID_TIPO_IDENTIFICACION,item.IDENTIFICACION);  
                              }
                              else
                              {
                                mensaje = 'Ingrese un número de identificación para realizar la búsqueda ';
                                if (!ubicacion)
                                {
                                  mensaje = $scope.mensaje_ubicacion_incorrecta;
                                }
                                toastr.warning(mensaje);
                              }


                              // if ((ubicacion) && (isValid) && (item.IDENTIFICACION != ""))
                              // {
                              //   getDatosSujetoIdentificacion(item.ID_TIPO_SUJETO,item.ID_TIPO_IDENTIFICACION,item.IDENTIFICACION);  
                              // }
                              // else
                              // {
                              //   mensaje = 'Ingrese un número de identificación para realizar la búsqueda ';
                              //   if (!ubicacion)
                              //   {
                              //     mensaje = $scope.mensaje_ubicacion_incorrecta;
                              //   }
                              //   toastr.warning(mensaje);
                              // }
                            }
                            // validaSujetos = function()
                            // {
                            //   $scope.SUJETO_PRINCIPAL_AGREGADO = false;
                            //   BreakException = {};
                            //   try 
                            //   {
                            //     $scope.sujetos.forEach(function(sujeto) 
                            //     {
                            //       if (sujeto.ID_PRIORIDAD_SUJETO == $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL)                  
                            //       {
                            //         throw BreakException;
                            //       }
                            //     });
                            //   } catch (e) 
                            //   {
                            //     $scope.SUJETO_PRINCIPAL_AGREGADO = true;
                            //   }
                            // }
                            restaurarValoresSujeto = function()
                            {
                              // validaSujetos();
                              itemTipoSujeto = buscarTipoSujeto($scope.LOCAL_ID_TIPO_SUJETO, $scope.tipoSujetos);
                              $scope.selectedTipoSujeto(itemTipoSujeto);
                              // if ($scope.SUJETO_PRINCIPAL_AGREGADO)
                              // {
                              //   $scope.deshabilitar_prioridad_sujeto = false;
                              //   $scope.LOCAL_ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_SECUNDARIO;  
                              // }
                              // else
                              // {
                              //   $scope.deshabilitar_prioridad_sujeto = true;
                              //   $scope.LOCAL_ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL;  
                              // }
                              itemPrioridadSujeto = buscarPrioridadSujeto($scope.LOCAL_ID_PRIORIDAD_SUJETO, $scope.prioridadSujetos);
                              $scope.selectedPrioridadSujeto(itemPrioridadSujeto);
                            }

                            $scope.limpiarSujetoNuevo = function()
                            {
                              $scope.campo_requerido_sujeto = true;
                              if ((p_id_perfil == $scope.CONSTANTES.PERFIL_SUJETO_INVITADO) || 
                                  ($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO)) 
                              {
                                $scope.campo_requerido_sujeto = false;
                              }
                              if (edicion)
                              {
                                $scope.sujeto = {};
                                $scope.sujeto.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                                angular.extend($scope.sujeto,$scope.sujetoTemp);
                                $scope.datosContacto.seleccion = [];
                                angular.extend($scope.datosContacto.seleccion,$scope.sujetoTemp.contactos);
                                $scope.representantes.seleccion = [];
                                angular.extend($scope.representantes.seleccion,$scope.sujetoTemp.representantes);
                                itemTipoIdentificacion = buscarTipoIdentificacionSujeto($scope.sujeto.ID_TIPO_IDENTIFICACION, $scope.tipoIdentificacion);
                                $scope.selectedTipoIdentificacion(itemTipoIdentificacion);
                                validaDireccion();
                                $scope.habilitar_datos_identificacion();
                              }
                              else
                              {
                                restaurarValoresSujeto();
                                $scope.habilitar_datos_identificacion();
                              }
                            }
                            getDatosSujeto = function(item,p_sujeto_natural,representante)
                            {
                              casosService.getDatosSujeto($scope.caso.ID_EXPEDIENTE,item.ID_SUJETO,item.ID_TIPO_SUJETO,p_sujeto_natural).then(
                                function ( response ) 
                                {
                                  if (representante)
                                  {
                                    $scope.IDENTIFICACION_BD = response.data.IDENTIFICACION;
                                    angular.extend(item,response.data);
                                    $scope.representanteTemp = {};
                                    angular.extend($scope.representanteTemp,item);
                                    editarRepresentanteLocal(item);  
                                  }
                                  else
                                  {
                                    $scope.IDENTIFICACION_BD = response.data.IDENTIFICACION;
                                    angular.extend($scope.sujeto,response.data);
                                    $scope.datosContacto.seleccion = $scope.sujeto.contactos;
                                    $scope.representantes.seleccion = $scope.sujeto.representantes;
                                    $scope.LOCAL_ID_TIPO_SUJETO = $scope.sujeto.ID_TIPO_SUJETO;
                                    $scope.LOCAL_ID_PRIORIDAD_SUJETO = $scope.sujeto.ID_PRIORIDAD_SUJETO;
                                    casosService.getTipoIdentificacion($scope.sujeto.ID_TIPO_SUJETO).then(
                                      function ( response ) 
                                      {
                                        $scope.tipoIdentificacion = [];
                                        $scope.tipoIdentificacion = response.data;
                                        // if (!$scope.seleccionTipoIdentificacion)
                                        // {
                                          itemTipoIdentificacion = buscarTipoIdentificacionSujeto($scope.sujeto.ID_TIPO_IDENTIFICACION, $scope.tipoIdentificacion);
                                          $scope.selectedTipoIdentificacion(itemTipoIdentificacion,false);
                                        // }
                                      },
                                      function ( error ) 
                                      {
                                          toastr.error( error );
                                      });
                                      $scope.sujeto.SUJETO_NATURAL = false;
                                      //$scope.solicitante.REQUIERE_REPRESENTANTE = false;
                                      if ($scope.sujeto.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                                      {
                                        $scope.sujeto.SUJETO_NATURAL = true;
                                      }
                                      else
                                      {
                                        descripciones_generales();
                                      }
                                      //$scope.deshabilitar_prioridad_solicitante = false;
                                      // if ($scope.sujeto.ID_PRIORIDAD_SUJETO == $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL)
                                      // {
                                      //   $scope.deshabilitar_prioridad_solicitante = true;
                                      // }
                                      if ($scope.sujeto.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                                      {
                                        $scope.estadosCiviles = [];
                                        $scope.profesiones = [];
                                        ID_ESTADO_CIVIL = $scope.sujeto.ID_ESTADO_CIVIL;
                                        ID_PROFESION = $scope.sujeto.ID_PROFESION;
                                        $scope.selectedGenero($scope.sujeto);
                                        getPoblacionIdioma($scope.sujeto);
                                      }
                                      $scope.seleccionTipoIdentificacion = false;
                                      validaDireccion();
                                      validaRepresentante();
                                      $scope.habilitar_datos_identificacion();
                                      $scope.UBICACION_CORRECTA = false;
                                      if ((($scope.sujeto.IDENTIFICACION != undefined) && 
                                          ($scope.sujeto.IDENTIFICACION != "")) || 
                                          ($scope.sujeto.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_JURIDICO) ||
                                          ($scope.sujeto.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_PASAPORTE)) 
                                      {
                                        $scope.UBICACION_CORRECTA = true;
                                      }
                                      if (($scope.sujeto.FECHA_NACIMIENTO != undefined) && ($scope.sujeto.FECHA_NACIMIENTO != ""))
                                      {
                                        $scope.FECHA_NACIMIENTO_VALIDA = true;
                                      }
                                      $scope.deshabilitar_prioridad_sujeto = false;
                                      if ($scope.sujeto.ID_PRIORIDAD_SUJETO == $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL)
                                      {
                                        $scope.deshabilitar_prioridad_sujeto = true;
                                      }
                                      $scope.sujetoTemp = {};
                                      angular.extend($scope.sujetoTemp,$scope.sujeto);
                                  } 
                                },
                                function ( error ) 
                                {
                                  toastr.error( error );
                                });
                            }
                            $scope.getHeight = function(selector)
                            {
                              var element = $(selector);
                              return element.css("height");
                            }
                            if (($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_FALSO) && (p_id_perfil == $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE))
                            {
                              $scope.campo_requerido_sujeto = true;
                            }
                            else
                            {
                              $scope.UBICACION_CORRECTA = true;
                              $scope.FECHA_NACIMIENTO_VALIDA = true;
                            }
                            
                            $scope.campo_requerido = $scope.campo_requerido_sujeto;
                            if (!edicion)
                            {
                              descripciones_generales(); 
                              //$scope.icono_boton_guardar_sujeto = "fa fa-lg fa-save";
                              // $scope.icono_boton_eliminar_sujeto = "fa fa-lg fa-trash-o";
                              $scope.editar_sujeto = false;
                              itemTipoSujeto = buscarTipoSujeto($scope.CONSTANTES.TIPO_SUJETO_NATURAL, $scope.tipoSujetos);
                              $scope.selectedTipoSujeto(itemTipoSujeto);
                              itemPrioridadSujeto = buscarPrioridadSujeto(ID_PRIORIDAD_SUJETO, $scope.prioridadSujetos);
                              $scope.selectedPrioridadSujeto(itemPrioridadSujeto);
                              //restaurarValoresSujeto();
                            }
                            else
                            {
                              //$scope.icono_boton_guardar_sujeto = "fa fa-lg fa-refresh";
                              // $scope.icono_boton_eliminar_sujeto = "fa fa-lg fa-user-times";
                              $scope.SUJETO_BD = true;
                              $scope.editar_sujeto = true;
                              getDatosSujeto($scope.sujeto,$scope.CONSTANTES.TIPO_SUJETO_NATURAL,false);
                            }

                            insSujeto =  function(item)
                            {
                              casosService.insSujeto(item).then(
                                function (response)
                                {
                                  if(response.data.result=='OK')
                                  {
                                    accion = "agregado";
                                    if ($scope.sujeto.SEXO_MUJER)
                                    {
                                      accion = "agregada";
                                    }
                                    if (edicion)
                                    {
                                      accion = "actualizado";
                                      if ($scope.sujeto.SEXO_MUJER)
                                      {
                                        accion = "actualizada";
                                      }  
                                    }
                                    mensaje_operacion = "Invitado "+accion+" correctamente";
                                    if ($scope.sujeto.SEXO_MUJER)
                                    {
                                      mensaje_operacion = "Invitada "+accion+" correctamente";
                                    }
                                    if ($scope.sujeto.ID_PERFIL_SUJETO == $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE)
                                    {
                                      mensaje_operacion = "Solicitante "+accion+" correctamente";
                                      if ($scope.sujeto.SEXO_MUJER)
                                      {
                                        mensaje_operacion = "Solicitante "+accion+" correctamente";
                                      }
                                    }
                                    toastr.success(mensaje_operacion);
                                    // getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                                    ngDialog.closeAll();
                                  }
                                  else
                                  {
                                    toastr.error(response.data.msj);
                                  }                      
                                },
                                function (error) 
                                {
                                  toastr.error( error );
                                }); 
                            }
                            delSujeto =  function(item)
                            {
                              casosService.delSujeto(item).then(
                                function (response)
                                {
                                  if(response.data.result=='OK')
                                  {
                                    accion = "eliminado";
                                    if ($scope.sujeto.SEXO_MUJER)
                                    {
                                      accion = "eliminada";
                                    }
                                    mensaje_operacion = "Invitado "+accion+" correctamente";
                                    if ($scope.sujeto.SEXO_MUJER)
                                    {
                                      mensaje_operacion = "Invitada "+accion+" correctamente";
                                    }
                                    if ($scope.sujeto.ID_PERFIL_SUJETO == $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE)
                                    {
                                      mensaje_operacion = "Solicitante "+accion+" correctamente";
                                      if ($scope.sujeto.SEXO_MUJER)
                                      {
                                        mensaje_operacion = "Solicitante "+accion+" correctamente";
                                      }
                                    }
                                    toastr.success(mensaje_operacion);
                                    // getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                                    ngDialog.closeAll();
                                    //limpiarCaso();
                                    //getCasoCompleto(response.data.id);
                                  }
                                  else
                                  {
                                    toastr.error(response.data.msj);
                                  }                      
                                },
                                function (error) 
                                {
                                  toastr.error( error );
                                }); 
                            }
                            $scope.viewSwalEliminarSujeto = function(item)
                            {
                              $scope.dialogShowSwalEliminarSujeto = ngDialog.open(
                              {
                                template: 'app/casos/casos.seguimiento.swalContainer.view.tpl.html',
                                showClose: false,
                                closeByEscape: false,
                                closeByNavigation: true,
                                preCloseCallback:function()
                                {
                                  // $scope.sesion = {};
                                  // getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                                  // $scope.habilitar_datos_identificacion();
                                  // $scope.nuevo_sujeto = false;
                                },
                                className: 'ngdialog-theme-flat-custom',
                                // resolve:
                                // {
                                // },
                                scope:$scope,
                                controller: ['$scope',
                                function($scope) 
                                { 
                                  swal({
                                    title:'¿Eliminar '+item.PERFIL_SUJETO+'?', 
                                    html: ',',
                                    text: '<i class="'+item.ICONO_TIPO_SUJETO+'"></i>'+' '+item.SUJETO,
                                    type: "error",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "Continuar",
                                    cancelButtonClass: "btn-default",
                                    cancelButtonText: "Cancelar",
                                    closeOnConfirm: false,
                                    closeOnCancel: false }, 
                                    function(isConfirm){ 
                                    if (isConfirm) 
                                    {
                                      swal.close();
                                      $scope.$apply();
                                      delSujeto($scope.sujeto);
                                    } 
                                    else 
                                    {
                                      swal.close();
                                      $scope.$apply();
                                      ngDialog.close($scope.dialogShowSwalEliminarSujeto.id);
                                    }
                                  });
                                  
                                }]
                              })
                            }
                            
                            nombreSujeto = function()
                            {
                              nombre_sujeto = "";
                              espacio_nombre=" ";
                              if ($scope.sujeto.SUJETO_NATURAL)
                              {
                                nombre_sujeto = $scope.sujeto.PRIMER_NOMBRE;
                                if ($scope.sujeto.SEGUNDO_NOMBRE != undefined && $scope.sujeto.SEGUNDO_NOMBRE != "")
                                {
                                  nombre_sujeto = nombre_sujeto+espacio_nombre+$scope.sujeto.SEGUNDO_NOMBRE;
                                }
                                if ($scope.sujeto.TERCER_NOMBRE != undefined && $scope.sujeto.TERCER_NOMBRE != "")
                                {
                                  nombre_sujeto = nombre_sujeto+espacio_nombre+$scope.sujeto.TERCER_NOMBRE;
                                }
                                nombre_sujeto = nombre_sujeto+espacio_nombre+$scope.sujeto.PRIMER_APELLIDO;
                                if ($scope.sujeto.SEGUNDO_APELLIDO != undefined && $scope.sujeto.SEGUNDO_APELLIDO != "")
                                {
                                  nombre_sujeto = nombre_sujeto+espacio_nombre+$scope.sujeto.SEGUNDO_APELLIDO;
                                }
                                if ($scope.sujeto.APELLIDO_CASADA != undefined && $scope.sujeto.APELLIDO_CASADA != "")
                                {
                                  nombre_sujeto = nombre_sujeto+espacio_nombre+'DE'+espacio_nombre+$scope.sujeto.APELLIDO_CASADA;
                                }
                              }
                              else
                              {
                                nombre_sujeto = $scope.sujeto.SUJETO_JURIDICO;
                                if ($scope.sujeto.MARCA_COMERCIAL != undefined && $scope.sujeto.MARCA_COMERCIAL != "")
                                {
                                  nombre_sujeto = nombre_sujeto+espacio_nombre+"("+$scope.sujeto.MARCA_COMERCIAL+")";
                                }
                              }
                              $scope.sujeto.SUJETO=nombre_sujeto;  
                            }
                            $scope.guardarSujeto = function(isValid)
                            {
                              validaRepresentante();
                              if((isValid) &&
                                 ($scope.sujeto.DIRECCION) &&
                                 ($scope.UBICACION_CORRECTA) &&
                                 ($scope.REPRESENTANTES_AGREGADOS))
                              {
                                $scope.sujeto.ID_EXPEDIENTE = $scope.caso.ID_EXPEDIENTE;
                                $scope.sujeto.ID_PERFIL_SUJETO = p_id_perfil;
                                $scope.sujeto.IDENTIFICACION_DPI = $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI;
                                $scope.sujeto.TIPO_CONTACTO_DIRECCION = $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION;
                                $scope.sujeto.TIPO_SUJETO_NATURAL = $scope.CONSTANTES.TIPO_SUJETO_NATURAL;
                                $scope.sujeto.TIPO_SUJETO_JURIDICO = $scope.CONSTANTES.TIPO_SUJETO_JURIDICO;
                                if (($scope.sujeto.SUJETO == undefined) || ($scope.sujeto.SUJETO == "") || (edicion)) 
                                {
                                  nombreSujeto();
                                }
                                $scope.sujeto.contactos = $scope.datosContacto.seleccion;
                                $scope.sujeto.contactoseliminacion = $scope.datosContacto.eliminacion;
                                if (!$scope.sujeto.SUJETO_NATURAL)
                                {
                                  $scope.sujeto.representantes = $scope.representantes.seleccion;
                                  $scope.sujeto.representanteseliminacion = $scope.representantes.eliminacion;
                                }
                                insSujeto($scope.sujeto);
                              }
                              else
                              {
                                toastr.warning("Faltan datos por ingresar");
                              }
                            }


                            //vista que permite editar los datos de contacto
/*-------------------viewContacto------------------*/
                            //longitud minima para la caja de direccion
                            longitud_minima_caja_contacto = 15;
                            $scope.editar_contacto = false;
                            $scope.boton_agregar_contacto = "Guardar";
                            $scope.seccion_datos = false;
                            $scope.seccion_datos_tipo = false;
                            $scope.icono_boton_editar_contacto = "fa fa-plus";
                            //se inicializa el arreglo de los tipos de contacto del sujeto
                            $scope.tipoContacto = [];
                            $scope.tipoContacto = dataTipoContacto.data;
                            $scope.editarContacto = function(item)
                            {
                              if ($scope.formularioRepresentante)
                              {
                                $scope.index_contacto = $scope.datosContactoRepresentante.seleccion.indexOf(item);
                              }
                              else
                              {
                                $scope.index_contacto = $scope.datosContacto.seleccion.indexOf(item); 
                              }
                              $scope.editar_contacto = true;
                              $scope.boton_agregar_contacto = "Actualizar";
                              $scope.icono_boton_editar_contacto = "fa fa-refresh";
                              $scope.focus_contacto = true;
                              cambiar_tipo_dato();
                              $scope.viewContacto(item,$scope.editar_contacto);
                            }
                            validaDireccion = function()
                            {
                              if ($scope.formularioRepresentante)
                              {
                                $scope.representante.DIRECCION=false;
                                var BreakException = {};
                                try 
                                {
                                  $scope.datosContactoRepresentante.seleccion.forEach(function(contacto) 
                                  {
                                    if (contacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION) throw BreakException;
                                  });
                                } catch (e) 
                                {
                                  $scope.representante.DIRECCION=true;
                                }
                              }
                              else
                              {
                                $scope.sujeto.DIRECCION = false;
                                var BreakException = {};
                                try 
                                {
                                  $scope.datosContacto.seleccion.forEach(function(contacto) 
                                  {
                                    if (contacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION) throw BreakException;
                                  });
                                } catch (e) 
                                {
                                  $scope.sujeto.DIRECCION = true;
                                }
                              }  
                            }
                            $scope.eliminarContacto = function(item)
                            {
                              /*if (($scope.formularioRepresentante) &&
                                  ($scope.editar_representante) &&
                                  (!$scope.representante.DIRECCION))
                              {                        
                                $scope.datosContactoRepresentante.seleccion.push(item);
                                validaDireccion();
                                ordenarContacto();
                                toastr.warning("No se puede realizar la eliminación, Debe registrar como mínimo una dirección en los datos de contacto");  
                              }
                              else if ((edicion) && (!$scope.sujeto.DIRECCION))
                              {                        
                                $scope.datosContacto.seleccion.push(item);
                                validaDireccion();
                                ordenarContacto();
                                toastr.warning("No se puede realizar la eliminación, Debe registrar como mínimo una dirección en los datos de contacto");  
                              }
                              else
                              {*/
                                swal({                            
                                  title:'¿Eliminar contacto?', 
                                  html: ',',
                                  text: '<i class="'+item.ICONO+'"></i>'+' '+item.CONTACTO_TEMPORAL,
                                  type: "error",
                                  showCancelButton: true,
                                  confirmButtonClass: "btn-danger",
                                  confirmButtonText: "Continuar",
                                  cancelButtonClass: "btn-default",
                                  cancelButtonText: "Cancelar",
                                  closeOnConfirm: false,
                                  closeOnCancel: false }, 
                                  function(isConfirm){ 
                                  if (isConfirm) 
                                  {
                                    if ($scope.formularioRepresentante)
                                    {
                                      // $scope.representantes.seleccion[$scope.index_representante].contactos = $scope.datosContactoRepresentante.seleccion;
                                      if ((item.ID_CONTACTO_SUJETO != undefined) && (item.ID_CONTACTO_SUJETO != ""))
                                      {
                                        $scope.datosContactoRepresentante.eliminacion.push(item);
                                      }
                                    }
                                    else
                                    {
                                      // $scope.sujeto.contactos = $scope.datosContacto.seleccion;
                                      if ((item.ID_CONTACTO_SUJETO != undefined) && (item.ID_CONTACTO_SUJETO != ""))
                                      {
                                        $scope.datosContacto.eliminacion.push(item);
                                      }
                                    } 
                                    validaDireccion();
                                    ordenarContacto();
                                    $scope.$apply();
                                    swal.close();
                                  } 
                                  else 
                                  {
                                    if ($scope.formularioRepresentante)
                                    {
                                      $scope.datosContactoRepresentante.seleccion.push(item);
                                    }
                                    else
                                    {
                                      $scope.datosContacto.seleccion.push(item);  
                                    }
                                    validaDireccion();
                                    ordenarContacto();
                                    $scope.$apply();
                                    swal.close();
                                  }
                              });
                              // }
                            }
                            cambiar_tipo_dato = function()
                            {
                              if (($scope.seccion_datos == false) && ($scope.seccion_datos_tipo == false))
                              {
                                $scope.seccion_datos = true;
                              }
                              else if (($scope.seccion_datos == true) && ($scope.seccion_datos_tipo == false))
                              {
                                $scope.seccion_datos = false;
                                $scope.seccion_datos_tipo = true;
                              }
                              else
                              {
                                $scope.seccion_datos = true;
                                $scope.seccion_datos_tipo = false;
                              }       
                            }
                            limpiarContacto = function()
                            {
                              $scope.datosContacto.CONTACTO = "";
                              //$scope.datosContacto.ICONO = "";
                              $scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE = "";
                              $scope.datosContacto.ID_UBICACION_GEOGRAFICA = "";
                              $scope.datosContacto.UBICACION_GEOGRAFICA = "";
                              $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE = "";
                            }
                            limpiardatosContacto = function()
                            {
                              $scope.datoContactoDireccion = [];
                              $scope.datoContactoTelefono = [];
                              $scope.datoContactoCorreo = [];
                            }
                            $scope.viewContacto = function(item,edicion)
                            {
                              $scope.dialogShowContacto = ngDialog.open(
                              {
                                template: 'app/casos/casos.registro.contacto.view.tpl.html',
                                showClose:true,
                                closeByEscape: true,
                                preCloseCallback:function()
                                {
                                  $scope.editar_contacto = false;
                                  $scope.boton_agregar_contacto = "Guardar";
                                  $scope.icono_boton_editar_contacto = "fa fa-plus";
                                  $scope.datosContacto.ID_TIPO_CONTACTO="";
                                  $scope.datosContacto.TIPO_CONTACTO = "";
                                  $scope.focus_contacto = false;
                                  $scope.seccion_datos = false;
                                  $scope.seccion_datos_tipo = false;
                                },
                                className: 'ngdialog-theme-flat-custom custom-width',
                                scope:$scope,
                                controller: ['$scope', '$filter', function($scope, $filter) 
                                {
                                  $scope.datosContacto.ICONO = ""; 
                                  limpiardatosContacto();
                                  //se obtiene el arreglo inicial para el tipo de contacto de los sujetos
                                  buscarTipoContacto = function(valor, arreglo){
                                    for (var i=0; i < arreglo.length; i++) {
                                        if (arreglo[i].ID_TIPO_CONTACTO === valor) {
                                            return arreglo[i];
                                        }
                                    }
                                  }
                                  $scope.ingreso_inicial_contacto = false;
                                  $scope.tituloFormContacto = "Contacto";
                                  if (($scope.datosContacto.seleccion.length == 0) || 
                                      (($scope.formularioRepresentante) && 
                                      ($scope.datosContactoRepresentante.seleccion.length == 0)))
                                  {
                                    $scope.longitud_minima_caja_contacto = longitud_minima_caja_contacto;
                                    $scope.focus_contacto = true;
                                    itemTipocontacto = buscarTipoContacto($scope.CONSTANTES.TIPO_CONTACTO_DIRECCION, $scope.tipoContacto);
                                    $scope.datoContactoDireccion.ID_TIPO_CONTACTO = itemTipocontacto.ID_TIPO_CONTACTO;
                                    $scope.datoContactoDireccion.TIPO_CONTACTO = itemTipocontacto.TIPO_CONTACTO;
                                    $scope.datoContactoDireccion.ICONO = itemTipocontacto.ICONO;
                                    $scope.datoContactoDireccion.MASCARA = itemTipocontacto.MASCARA;
                                    $scope.datoContactoDireccion.TIPO_DATO = itemTipocontacto.TIPO_DATO;
                                    itemTipocontacto = buscarTipoContacto($scope.CONSTANTES.TIPO_CONTACTO_TELEFONO, $scope.tipoContacto);
                                    $scope.datoContactoTelefono.ID_TIPO_CONTACTO = itemTipocontacto.ID_TIPO_CONTACTO;
                                    $scope.datoContactoTelefono.TIPO_CONTACTO = itemTipocontacto.TIPO_CONTACTO;
                                    $scope.datoContactoTelefono.ICONO = itemTipocontacto.ICONO;
                                    $scope.datoContactoTelefono.MASCARA = itemTipocontacto.MASCARA;
                                    $scope.datoContactoTelefono.TIPO_DATO = itemTipocontacto.TIPO_DATO;
                                    itemTipocontacto = buscarTipoContacto($scope.CONSTANTES.TIPO_CONTACTO_CORREO, $scope.tipoContacto);
                                    $scope.datoContactoCorreo.ID_TIPO_CONTACTO = itemTipocontacto.ID_TIPO_CONTACTO;
                                    $scope.datoContactoCorreo.TIPO_CONTACTO = itemTipocontacto.TIPO_CONTACTO;
                                    $scope.datoContactoCorreo.ICONO = itemTipocontacto.ICONO;
                                    $scope.datoContactoCorreo.MASCARA = itemTipocontacto.MASCARA;
                                    $scope.datoContactoCorreo.TIPO_DATO = itemTipocontacto.TIPO_DATO;
                                    $scope.ingreso_inicial_contacto = true;
                                    $scope.tituloFormContacto = "Contacto";
                                  }
                                  //limpiarContacto();
                                  //funciones formulario contacto
                                  $scope.cambiar_focus_contacto = function()
                                  {
                                    $scope.focus_contacto = false;
                                  }
                                  buscarDepartamentoMunicipio = function(valor, arreglo)
                                  {
                                      for (var i=0; i < arreglo.length; i++) 
                                      {
                                        if (arreglo[i].ID_UBICACION_GEOGRAFICA === valor) 
                                        {
                                            return arreglo[i];
                                        }
                                      } 
                                  }
                                  selectDepto = false;
                                  enlistarUbicacionesGeograficas = function(p_id_tipo_ubicacion,p_id_ubicacion_padre)
                                  {
                                    casosService.getUbicacionGeografica(p_id_tipo_ubicacion,p_id_ubicacion_padre).then(
                                      function ( response ) 
                                      {
                                        if (p_id_tipo_ubicacion > 0)
                                        {
                                          $scope.departamentos = [];
                                          $scope.departamentos = response.data;
                                          if ($scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA_PADRE == undefined)
                                          {
                                            selectDepto = true;
                                            itemDepartamento = buscarDepartamentoMunicipio($scope.ubicacionCentro.ID_DEPARTAMENTO, $scope.departamentos);
                                            $scope.selectedUbicacionGeografica(itemDepartamento,$scope.CONSTANTES.TIPO_UB_GEOGRAFICA_DEPTO);
                                          }
                                        }
                                        else
                                        {
                                          $scope.municipios = [];
                                          $scope.municipios = response.data;
                                          if (selectDepto)
                                          {
                                            selectDepto = false;
                                            itemMunicipio = buscarDepartamentoMunicipio($scope.ubicacionCentro.ID_MUNICIPIO, $scope.municipios);
                                            $scope.selectedUbicacionGeografica(itemMunicipio);
                                          }
                                        }
                                      },
                                      function ( error ) 
                                      {
                                          toastr.error( error );
                                      });
                                  }

                                  enlistarUbicacionesGeograficas($scope.CONSTANTES.TIPO_UB_GEOGRAFICA_DEPTO,0);
                                  $scope.selectedUbicacionGeografica = function (item,ubicacion_padre)
                                  {
                                    if (ubicacion_padre != undefined)
                                    {
                                      $scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE = item.ID_UBICACION_GEOGRAFICA;   
                                      $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE = item.UBICACION_GEOGRAFICA;
                                      $scope.datosContacto.ID_UBICACION_GEOGRAFICA = "";
                                      $scope.datosContacto.UBICACION_GEOGRAFICA = "";
                                      $scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA_PADRE = item.ID_UBICACION_GEOGRAFICA;   
                                      $scope.datoContactoDireccion.UBICACION_GEOGRAFICA_PADRE = item.UBICACION_GEOGRAFICA;
                                      $scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA = "";
                                      $scope.datoContactoDireccion.UBICACION_GEOGRAFICA = "";
                                      enlistarUbicacionesGeograficas(0,item.ID_UBICACION_GEOGRAFICA);
                                    }
                                    else
                                    {
                                      $scope.datosContacto.ID_UBICACION_GEOGRAFICA = item.ID_UBICACION_GEOGRAFICA;
                                      $scope.datosContacto.UBICACION_GEOGRAFICA = item.UBICACION_GEOGRAFICA;
                                      $scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA = item.ID_UBICACION_GEOGRAFICA;
                                      $scope.datoContactoDireccion.UBICACION_GEOGRAFICA = item.UBICACION_GEOGRAFICA;
                                    }
                                  }
                                  $scope.selectedTipoContacto = function (item)
                                  {
                                    limpiarContacto();
                                    $scope.focus_contacto = true;
                                    $scope.contacto_tipo_direccion = false;
                                    $scope.datosContacto.ID_TIPO_CONTACTO = item.ID_TIPO_CONTACTO;
                                    $scope.datosContacto.TIPO_CONTACTO = item.TIPO_CONTACTO;
                                    $scope.datosContacto.ICONO = item.ICONO;
                                    $scope.datosContacto.MASCARA = item.MASCARA;
                                    $scope.datosContacto.TIPO_DATO = item.TIPO_DATO;
                                    cambiar_tipo_dato();
                                    $scope.longitud_minima_caja_contacto = 0;
                                    if (edicion == true)
                                    {
                                      $scope.datosContacto.ICONO = item.ICONO;
                                      $scope.datosContacto.MASCARA = item.MASCARA;
                                      $scope.datosContacto.TIPO_DATO = item.TIPO_DATO;
                                      $scope.datosContacto.CONTACTO = item.CONTACTO;
                                      $scope.datosContacto.CONTACTO_TEMPORAL = item.CONTACTO_TEMPORAL;
                                      if (item.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                                      {
                                        $scope.longitud_minima_caja_contacto = longitud_minima_caja_contacto;
                                        $scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE = item.ID_UBICACION_GEOGRAFICA_PADRE;
                                        $scope.datosContacto.ID_UBICACION_GEOGRAFICA = item.ID_UBICACION_GEOGRAFICA;
                                        $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE = item.UBICACION_GEOGRAFICA_PADRE;
                                        $scope.datosContacto.UBICACION_GEOGRAFICA = item.UBICACION_GEOGRAFICA;
                                        enlistarUbicacionesGeograficas(0,item.ID_UBICACION_GEOGRAFICA_PADRE);
                                      }
                                    }
                                    else if ($scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA_PADRE != undefined)
                                    {
                                      selectDepto = true;
                                      itemDepartamento = buscarDepartamentoMunicipio($scope.ubicacionCentro.ID_DEPARTAMENTO, $scope.departamentos);
                                      $scope.selectedUbicacionGeografica(itemDepartamento,$scope.CONSTANTES.TIPO_UB_GEOGRAFICA_DEPTO);
                                    }
                                    if (item.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                                    {
                                      $scope.longitud_minima_caja_contacto = longitud_minima_caja_contacto;
                                      $scope.contacto_tipo_direccion = true;
                                    }
                                  }
                                  if (edicion)
                                  {
                                    $scope.selectedTipoContacto(item);
                                  }
                                  $scope.formularioContacto = function(isValid)
                                  {
                                    if(isValid)
                                    {
                                      tipo_dato = $filter('lowercase')($scope.datosContacto.TIPO_CONTACTO) ;
                                      mensaje_operacion="Contacto "+tipo_dato+" agregado correctamente";
                                      espacio = " ";
                                      if ($scope.datosContacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                                      {
                                        coma = ", ";
                                      }
                                      if (edicion)
                                      {
                                        if ($scope.formularioRepresentante)
                                        {
                                          if ($scope.datosContacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                                          {
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].ID_TIPO_CONTACTO = $scope.datosContacto.ID_TIPO_CONTACTO;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].TIPO_CONTACTO = $scope.datosContacto.TIPO_CONTACTO;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].ICONO = $scope.datosContacto.ICONO;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].MASCARA = $scope.datosContacto.MASCARA;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].TIPO_DATO = $scope.datosContacto.TIPO_DATO;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].CONTACTO = $scope.datosContacto.CONTACTO;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].ID_UBICACION_GEOGRAFICA = $scope.datosContacto.ID_UBICACION_GEOGRAFICA;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].ID_UBICACION_GEOGRAFICA_PADRE = $scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].UBICACION_GEOGRAFICA = $scope.datosContacto.UBICACION_GEOGRAFICA;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].UBICACION_GEOGRAFICA_PADRE = $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].CONTACTO_TEMPORAL = $scope.datosContacto.CONTACTO+espacio+$scope.datosContacto.UBICACION_GEOGRAFICA+coma+$scope.datosContacto.UBICACION_GEOGRAFICA_PADRE;    
                                          }
                                          else
                                          {
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].ID_TIPO_CONTACTO = $scope.datosContacto.ID_TIPO_CONTACTO;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].TIPO_CONTACTO = $scope.datosContacto.TIPO_CONTACTO;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].ICONO = $scope.datosContacto.ICONO;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].MASCARA = $scope.datosContacto.MASCARA;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].TIPO_DATO = $scope.datosContacto.TIPO_DATO;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].CONTACTO = $scope.datosContacto.CONTACTO;
                                            $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].CONTACTO_TEMPORAL = $scope.datosContacto.CONTACTO;  
                                          }
                                        }
                                        else
                                        {
                                          if ($scope.datosContacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                                          {
                                            $scope.datosContacto.seleccion[$scope.index_contacto].ID_TIPO_CONTACTO = $scope.datosContacto.ID_TIPO_CONTACTO;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].TIPO_CONTACTO = $scope.datosContacto.TIPO_CONTACTO;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].ICONO = $scope.datosContacto.ICONO;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].MASCARA = $scope.datosContacto.MASCARA;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].TIPO_DATO = $scope.datosContacto.TIPO_DATO;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].CONTACTO = $scope.datosContacto.CONTACTO;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].ID_UBICACION_GEOGRAFICA = $scope.datosContacto.ID_UBICACION_GEOGRAFICA;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].ID_UBICACION_GEOGRAFICA_PADRE = $scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].UBICACION_GEOGRAFICA = $scope.datosContacto.UBICACION_GEOGRAFICA;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].UBICACION_GEOGRAFICA_PADRE = $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].CONTACTO_TEMPORAL = $scope.datosContacto.CONTACTO+espacio+$scope.datosContacto.UBICACION_GEOGRAFICA+coma+$scope.datosContacto.UBICACION_GEOGRAFICA_PADRE;
                                          }
                                          else
                                          {
                                            $scope.datosContacto.seleccion[$scope.index_contacto].ID_TIPO_CONTACTO = $scope.datosContacto.ID_TIPO_CONTACTO;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].TIPO_CONTACTO = $scope.datosContacto.TIPO_CONTACTO;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].ICONO = $scope.datosContacto.ICONO;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].MASCARA = $scope.datosContacto.MASCARA;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].TIPO_DATO = $scope.datosContacto.TIPO_DATO;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].CONTACTO = $scope.datosContacto.CONTACTO;
                                            $scope.datosContacto.seleccion[$scope.index_contacto].CONTACTO_TEMPORAL = $scope.datosContacto.CONTACTO;
                                          }
                                          
                                        }
                                        mensaje_operacion="Contacto "+tipo_dato+" actualizado correctamente";
                                        ngDialog.close($scope.dialogShowContacto.id);
                                      }
                                      else
                                      {
                                        if ($scope.formularioRepresentante)
                                        {
                                          if ($scope.datosContacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                                          {
                                            $scope.datosContactoRepresentante.seleccion.push(
                                            {
                                              ID_TIPO_CONTACTO:$scope.datosContacto.ID_TIPO_CONTACTO,
                                              TIPO_CONTACTO:$scope.datosContacto.TIPO_CONTACTO,
                                              ICONO:$scope.datosContacto.ICONO,
                                              MASCARA:$scope.datosContacto.MASCARA,
                                              TIPO_DATO:$scope.datosContacto.TIPO_DATO,
                                              CONTACTO:$scope.datosContacto.CONTACTO,
                                              ID_UBICACION_GEOGRAFICA:$scope.datosContacto.ID_UBICACION_GEOGRAFICA,
                                              ID_UBICACION_GEOGRAFICA_PADRE:$scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE,
                                              UBICACION_GEOGRAFICA:$scope.datosContacto.UBICACION_GEOGRAFICA,
                                              UBICACION_GEOGRAFICA_PADRE:$scope.datosContacto.UBICACION_GEOGRAFICA_PADRE,
                                              CONTACTO_TEMPORAL:$scope.datosContacto.CONTACTO+espacio+
                                                                $scope.datosContacto.UBICACION_GEOGRAFICA+coma+
                                                                $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE
                                            });
                                          }
                                          else
                                          {
                                            $scope.datosContactoRepresentante.seleccion.push(
                                            {
                                              ID_TIPO_CONTACTO:$scope.datosContacto.ID_TIPO_CONTACTO,
                                              TIPO_CONTACTO:$scope.datosContacto.TIPO_CONTACTO,
                                              ICONO:$scope.datosContacto.ICONO,
                                              MASCARA:$scope.datosContacto.MASCARA,
                                              TIPO_DATO:$scope.datosContacto.TIPO_DATO,
                                              CONTACTO:$scope.datosContacto.CONTACTO,
                                              CONTACTO_TEMPORAL:$scope.datosContacto.CONTACTO
                                            });
                                          } 
                                        }
                                        else
                                        {
                                          if ($scope.datosContacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                                          {
                                            $scope.datosContacto.seleccion.push(
                                            {
                                              ID_TIPO_CONTACTO:$scope.datosContacto.ID_TIPO_CONTACTO,
                                              TIPO_CONTACTO:$scope.datosContacto.TIPO_CONTACTO,
                                              ICONO:$scope.datosContacto.ICONO,
                                              MASCARA:$scope.datosContacto.MASCARA,
                                              TIPO_DATO:$scope.datosContacto.TIPO_DATO,
                                              CONTACTO:$scope.datosContacto.CONTACTO,
                                              ID_UBICACION_GEOGRAFICA:$scope.datosContacto.ID_UBICACION_GEOGRAFICA,
                                              ID_UBICACION_GEOGRAFICA_PADRE:$scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE,
                                              UBICACION_GEOGRAFICA:$scope.datosContacto.UBICACION_GEOGRAFICA,
                                              UBICACION_GEOGRAFICA_PADRE:$scope.datosContacto.UBICACION_GEOGRAFICA_PADRE,
                                              CONTACTO_TEMPORAL:$scope.datosContacto.CONTACTO+espacio+
                                                                $scope.datosContacto.UBICACION_GEOGRAFICA+coma+
                                                                $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE
                                            });
                                          }
                                          else
                                          {
                                            $scope.datosContacto.seleccion.push(
                                            {
                                              ID_TIPO_CONTACTO:$scope.datosContacto.ID_TIPO_CONTACTO,
                                              TIPO_CONTACTO:$scope.datosContacto.TIPO_CONTACTO,
                                              ICONO:$scope.datosContacto.ICONO,
                                              MASCARA:$scope.datosContacto.MASCARA,
                                              TIPO_DATO:$scope.datosContacto.TIPO_DATO,
                                              CONTACTO:$scope.datosContacto.CONTACTO,
                                              CONTACTO_TEMPORAL:$scope.datosContacto.CONTACTO
                                            });
                                          }
                                        }
                                      }
                                      limpiarContacto();
                                      ordenarContacto();
                                      validaDireccion();
                                      toastr.success(mensaje_operacion);
                                    }
                                    else
                                    {
                                      toastr.warning("Faltan datos por ingresar");
                                    }
                                  }
                                  $scope.guardarContactosInicial = function(isValid)
                                  {
                                    if (isValid)
                                    {
                                      $scope.datosContacto.CONTACTO = $scope.datoContactoDireccion.CONTACTO
                                      $scope.datosContacto.ICONO = $scope.datoContactoDireccion.ICONO
                                      $scope.datosContacto.ID_TIPO_CONTACTO = $scope.datoContactoDireccion.ID_TIPO_CONTACTO
                                      $scope.datosContacto.ID_UBICACION_GEOGRAFICA = $scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA
                                      $scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE = $scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA_PADRE
                                      $scope.datosContacto.MASCARA = $scope.datoContactoDireccion.MASCARA
                                      $scope.datosContacto.TIPO_CONTACTO = $scope.datoContactoDireccion.TIPO_CONTACTO
                                      $scope.datosContacto.TIPO_DATO = $scope.datoContactoDireccion.TIPO_DATO
                                      $scope.datosContacto.UBICACION_GEOGRAFICA = $scope.datoContactoDireccion.UBICACION_GEOGRAFICA
                                      $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE = $scope.datoContactoDireccion.UBICACION_GEOGRAFICA_PADRE
                                      $scope.formularioContacto(true);
                                      if (($scope.datoContactoTelefono.CONTACTO != undefined) && 
                                          ($scope.datoContactoTelefono.CONTACTO != ""))
                                      {
                                        $scope.datosContacto.CONTACTO = $scope.datoContactoTelefono.CONTACTO
                                        $scope.datosContacto.ICONO = $scope.datoContactoTelefono.ICONO
                                        $scope.datosContacto.ID_TIPO_CONTACTO = $scope.datoContactoTelefono.ID_TIPO_CONTACTO
                                        $scope.datosContacto.MASCARA = $scope.datoContactoTelefono.MASCARA
                                        $scope.datosContacto.TIPO_CONTACTO = $scope.datoContactoTelefono.TIPO_CONTACTO
                                        $scope.datosContacto.TIPO_DATO = $scope.datoContactoTelefono.TIPO_DATO
                                        $scope.formularioContacto(true);
                                      }
                                      if (($scope.datoContactoCorreo.CONTACTO != undefined) && 
                                          ($scope.datoContactoCorreo.CONTACTO != ""))
                                      {
                                        $scope.datosContacto.CONTACTO = $scope.datoContactoCorreo.CONTACTO
                                        $scope.datosContacto.ICONO = $scope.datoContactoCorreo.ICONO
                                        $scope.datosContacto.ID_TIPO_CONTACTO = $scope.datoContactoCorreo.ID_TIPO_CONTACTO
                                        $scope.datosContacto.MASCARA = $scope.datoContactoCorreo.MASCARA
                                        $scope.datosContacto.TIPO_CONTACTO = $scope.datoContactoCorreo.TIPO_CONTACTO
                                        $scope.datosContacto.TIPO_DATO = $scope.datoContactoCorreo.TIPO_DATO
                                        $scope.formularioContacto(true);
                                      }
                                      ngDialog.close($scope.dialogShowContacto.id);  
                                    }
                                    else
                                    {
                                      mensaje = "Faltan datos por ingresar";
                                      if (($scope.datoContactoDireccion.CONTACTO != undefined) && 
                                          ($scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA != "") && 
                                          ($scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA_PADRE != ""))
                                      {
                                        mensaje = "Formato inválido en el contacto correo electrónico";
                                      }
                                      toastr.warning(mensaje);  
                                    }
                                  }
                                }] 
                              });
                            }                      
                            /*-------------------viewContacto------------------*/

                            /*----------------viewRepresentante----------------*/
                            // $scope.deshabilitar_datos_representante = false;
                            $scope.tipoIdentificacionRepresentante = [];
                            // $scope.tooltip_boton_guardar_representante = "Guardar representante";
                            // $scope.cerrarDialog = false;
                            $scope.cambiar_focus_identificacion_representante = function()
                            {
                              $scope.focus_identificacion_representante = false;
                              //$scope.UBICACION_NACIMIENTO = true;
                            }
                            $scope.combo_tipo_identificacion_representante = true;
                            cambiar_tipo_identificacion_representante = function()
                            {
                              $scope.combo_tipo_identificacion_representante = !$scope.combo_tipo_identificacion_representante;
                            }
                            $scope.selectedTipoIdentificacionRepresentante = function (item,limpiar)
                            {
                              cambiar_tipo_identificacion_representante();
                              $scope.representante.ID_TIPO_IDENTIFICACION = item.ID_TIPO_IDENTIFICACION;
                              // $scope.representante.TIPO_IDENTIFICACION = item.TIPO_IDENTIFICACION;
                              $scope.representante.MASCARA_IDENTIFICACION = item.MASCARA;
                              $scope.representante.IDENTIFICACION=""; 
                              $scope.focus_identificacion_representante = true;
                              if ((item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_PASAPORTE) ||
                                  (item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI) ||
                                  (item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI_EXT))
                              {
                                getNacionalidad($scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO,item.ID_TIPO_IDENTIFICACION,limpiar);
                              }
                            }
                            casosService.getTipoIdentificacion($scope.CONSTANTES.TIPO_SUJETO_NATURAL).then(
                              function ( response ) 
                              {
                                $scope.tipoIdentificacionRepresentante = response.data;
                              },
                              function ( error ) 
                              {
                                  toastr.error( error );
                              });
                            $scope.cambiarBotones = function()
                            {
                              // if ($scope.formularioRepresentante)
                              // { 
                                $scope.icono_boton_editar_representante = "fa fa-plus";
                                $scope.editar_representante = false;
                                $scope.tooltip_boton_editar_representante = "Guardar representante";
                              // }
                            }
                            $scope.limpiarRepresentante = function()
                            {
                              if ($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO)
                              {
                                $scope.campo_requerido = false;
                              }
                              if ($scope.editar_representante)
                              {
                                $scope.representante = {};
                                $scope.representante.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                                angular.extend($scope.representante,$scope.representanteTemp);
                                $scope.datosContactoRepresentante.seleccion = [];
                                angular.extend($scope.datosContactoRepresentante.seleccion,$scope.representanteTemp.contactos);
                                itemTipoIdentificacion = buscarTipoIdentificacionSujeto($scope.representante.ID_TIPO_IDENTIFICACION, $scope.tipoIdentificacionRepresentante);
                                $scope.selectedTipoIdentificacionRepresentante(itemTipoIdentificacion,true);
                                validaDireccion();
                              }
                              else
                              {
                                $scope.editar_representante_registro = false;
                                $scope.cambiarBotones();
                                $scope.representante = {};
                                $scope.representante.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                                $scope.datosContactoRepresentante = [];
                                $scope.datosContactoRepresentante.seleccion = [];
                                $scope.datosContactoRepresentante.eliminacion = [];
                                $scope.focus_identificacion_representante = false;
                                $scope.UBICACION_CORRECTA = true;
                                descripciones_generales();
                                itemTipoIdentificacion = buscarTipoIdentificacionSujeto($scope.CONSTANTES.TIPO_IDENTIFICACION_DPI, $scope.tipoIdentificacionRepresentante);
                                $scope.selectedTipoIdentificacionRepresentante(itemTipoIdentificacion,false);
                              }
                            }
                            $scope.limpiarSeleccionRepresentante = function()
                            {
                              $scope.representante = {};
                              $scope.representante.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                              $scope.representantes.seleccion = [];
                            }
                            validaRepresentante = function()
                            {
                              $scope.REPRESENTANTES_AGREGADOS = false;
                              if (($scope.sujeto.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL) ||
                                  ($scope.representantes.seleccion.length > 0) ||
                                  (PERFIL_SUJETO == $scope.CONSTANTES.PERFIL_SUJETO_INVITADO) ||
                                  ($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO))
                              {
                                $scope.REPRESENTANTES_AGREGADOS = true;
                              }
                            }
                            $scope.agregarRepresentante = function(isValid)
                            {
                              validaDireccion();
                              validaSexo();
                              if((isValid) && 
                                ($scope.representante.DIRECCION) && 
                                ($scope.UBICACION_CORRECTA) &&
                                ($scope.validacionSexoSujeto))
                              {
                                nombre_representante = "";
                                espacio_nombre=" ";
                                mensaje_operacion = "Representante agregado correctamente";
                                nombre_representante = $scope.representante.PRIMER_NOMBRE;
                                if ($scope.representante.SEGUNDO_NOMBRE != undefined && $scope.representante.SEGUNDO_NOMBRE != "")
                                {
                                  nombre_representante = nombre_representante+espacio_nombre+$scope.representante.SEGUNDO_NOMBRE;
                                }
                                if ($scope.representante.TERCER_NOMBRE != undefined && $scope.representante.TERCER_NOMBRE != "")
                                {
                                  nombre_representante = nombre_representante+espacio_nombre+$scope.representante.TERCER_NOMBRE;
                                }
                                nombre_representante = nombre_representante+espacio_nombre+$scope.representante.PRIMER_APELLIDO;
                                if ($scope.representante.SEGUNDO_APELLIDO != undefined && $scope.representante.SEGUNDO_APELLIDO != "")
                                {
                                  nombre_representante = nombre_representante+espacio_nombre+$scope.representante.SEGUNDO_APELLIDO;
                                }
                                if ($scope.representante.APELLIDO_CASADA != undefined && $scope.representante.APELLIDO_CASADA != "")
                                {
                                  nombre_representante = nombre_representante+espacio_nombre+'DE'+espacio_nombre+$scope.representante.APELLIDO_CASADA;
                                }
                                $scope.representante.SUJETO=nombre_representante;  

                                if ($scope.editar_representante)
                                {
                                  $scope.representantes.seleccion[$scope.index_representante].APELLIDO_CASADA = $scope.representante.APELLIDO_CASADA;
                                  $scope.representantes.seleccion[$scope.index_representante].contactos = $scope.datosContactoRepresentante.seleccion;
                                  $scope.representantes.seleccion[$scope.index_representante].contactoseliminacion = $scope.datosContactoRepresentante.eliminacion;
                                  //$scope.representantes.seleccion[$scope.index_representante].FECHA_NACIMIENTO = fechaFormatoYYYYMMDD($scope.representante.FECHA_NACIMIENTO);
                                  $scope.representantes.seleccion[$scope.index_representante].FECHA_NACIMIENTO = $scope.representante.FECHA_NACIMIENTO;
                                  $scope.representantes.seleccion[$scope.index_representante].IDENTIFICACION = $scope.representante.IDENTIFICACION;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_CLASIFICACION_IDIOMA = $scope.representante.ID_CLASIFICACION_IDIOMA;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_ESTADO_CIVIL = $scope.representante.ID_ESTADO_CIVIL;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_GENERO = $scope.representante.ID_GENERO;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_IDIOMA = $scope.representante.ID_IDIOMA;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_NACIONALIDAD = $scope.representante.ID_NACIONALIDAD;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_NIVEL_EDUCATIVO = $scope.representante.ID_NIVEL_EDUCATIVO;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_PROFESION = $scope.representante.ID_PROFESION;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_SUJETO = $scope.representante.ID_SUJETO;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_SUJETO_NATURAL = $scope.representante.ID_SUJETO_NATURAL;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_SUJETO_NAT_IDENTIFICACION = $scope.representante.ID_SUJETO_NAT_IDENTIFICACION;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_REPRESENTANTE_ELIMINACION = $scope.representante.ID_REPRESENTANTE_ELIMINACION;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_SUJETO_EXPEDIENTE = $scope.representante.ID_SUJETO_EXPEDIENTE;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_TIPO_IDENTIFICACION = $scope.representante.ID_TIPO_IDENTIFICACION;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_TIPO_SUJETO = $scope.representante.ID_TIPO_SUJETO;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_TIPO_POBLACION = $scope.representante.ID_TIPO_POBLACION;
                                  $scope.representantes.seleccion[$scope.index_representante].MASCARA_IDENTIFICACION = $scope.representante.MASCARA_IDENTIFICACION;
                                  $scope.representantes.seleccion[$scope.index_representante].PRIMER_APELLIDO = $scope.representante.PRIMER_APELLIDO;
                                  $scope.representantes.seleccion[$scope.index_representante].PRIMER_NOMBRE = $scope.representante.PRIMER_NOMBRE;
                                  $scope.representantes.seleccion[$scope.index_representante].SEGUNDO_APELLIDO = $scope.representante.SEGUNDO_APELLIDO;
                                  $scope.representantes.seleccion[$scope.index_representante].SEGUNDO_NOMBRE = $scope.representante.SEGUNDO_NOMBRE;
                                  $scope.representantes.seleccion[$scope.index_representante].SUJETO = $scope.representante.SUJETO;
                                  $scope.representantes.seleccion[$scope.index_representante].TERCER_NOMBRE = $scope.representante.TERCER_NOMBRE;
                                  $scope.representantes.seleccion[$scope.index_representante].ACTUALIZACION_PENDIENTE = true;
                                  $scope.representantes.seleccion[$scope.index_representante].ID_DISCAPACIDAD = $scope.representante.ID_DISCAPACIDAD;
                                  mensaje_operacion = "Representante actualizado correctamente";
                                }
                                else
                                {
                                  $scope.representantes.seleccion.push(
                                  {
                                    APELLIDO_CASADA:$scope.representante.APELLIDO_CASADA,
                                    contactos:$scope.datosContactoRepresentante.seleccion,
                                    contactoseliminacion:$scope.datosContactoRepresentante.eliminacion,
                                    //FECHA_NACIMIENTO:fechaFormatoYYYYMMDD($scope.representante.FECHA_NACIMIENTO),
                                    FECHA_NACIMIENTO:$scope.representante.FECHA_NACIMIENTO,
                                    IDENTIFICACION:$scope.representante.IDENTIFICACION,
                                    ID_CLASIFICACION_IDIOMA:$scope.representante.ID_CLASIFICACION_IDIOMA,
                                    ID_ESTADO_CIVIL:$scope.representante.ID_ESTADO_CIVIL,
                                    ID_GENERO:$scope.representante.ID_GENERO,
                                    ID_IDIOMA:$scope.representante.ID_IDIOMA,
                                    ID_NACIONALIDAD:$scope.representante.ID_NACIONALIDAD,
                                    ID_NIVEL_EDUCATIVO:$scope.representante.ID_NIVEL_EDUCATIVO,
                                    ID_PROFESION:$scope.representante.ID_PROFESION,
                                    ID_SUJETO:$scope.representante.ID_SUJETO,
                                    ID_SUJETO_NATURAL:$scope.representante.ID_SUJETO_NATURAL,
                                    ID_SUJETO_NAT_IDENTIFICACION:$scope.representante.ID_SUJETO_NAT_IDENTIFICACION,
                                    ID_REPRESENTANTE_ELIMINACION:$scope.representante.ID_REPRESENTANTE_ELIMINACION,
                                    ID_SUJETO_EXPEDIENTE:$scope.representante.ID_SUJETO_EXPEDIENTE,
                                    ID_TIPO_IDENTIFICACION:$scope.representante.ID_TIPO_IDENTIFICACION,
                                    ID_TIPO_POBLACION:$scope.representante.ID_TIPO_POBLACION,
                                    ID_TIPO_SUJETO:$scope.representante.ID_TIPO_SUJETO,
                                    MASCARA_IDENTIFICACION:$scope.representante.MASCARA_IDENTIFICACION,
                                    PRIMER_APELLIDO:$scope.representante.PRIMER_APELLIDO,
                                    PRIMER_NOMBRE:$scope.representante.PRIMER_NOMBRE,
                                    SEGUNDO_APELLIDO:$scope.representante.SEGUNDO_APELLIDO,
                                    SEGUNDO_NOMBRE:$scope.representante.SEGUNDO_NOMBRE,
                                    SUJETO:$scope.representante.SUJETO,
                                    TERCER_NOMBRE:$scope.representante.TERCER_NOMBRE,
                                    ID_DISCAPACIDAD:$scope.representante.ID_DISCAPACIDAD
                                  });
                                }
                                if ($scope.icono_boton_editar_representante == "fa fa-plus")
                                {
                                  $scope.cambiarBotones();
                                  validaRepresentante();
                                  $scope.limpiarRepresentante();
                                }
                                toastr.success(mensaje_operacion);
                                $scope.habilitar_datos_identificacion_representante();
                              }
                              else
                              {
                                mensaje="Faltan datos por ingresar";
                                if(isValid)
                                {
                                  if (!$scope.representante.DIRECCION)
                                  {
                                    mensaje="Debe agregar como mínimo una dirección en los datos de contacto";
                                  }
                                  else if (!$scope.UBICACION_CORRECTA)
                                  {
                                    mensaje = $scope.mensaje_ubicacion_incorrecta;
                                  }
                                }
                                toastr.warning(mensaje);
                              }
                            }
                            $scope.editarRepresentante = function(item)
                            {
                              $scope.index_representante = $scope.representantes.seleccion.indexOf(item);
                              if ((item.ID_SUJETO != undefined) && (item.ID_SUJETO != "") && (item.ACTUALIZACION_PENDIENTE == undefined))
                              {
                                $scope.REPRESENTANTE_BD = true;
                                item.ID_TIPO_SUJETO = $scope.CONSTANTES.TIPO_SUJETO_NATURAL;
                                getDatosSujeto(item,$scope.CONSTANTES.TIPO_SUJETO_NATURAL,true);  
                              }
                              else
                              {
                                $scope.REPRESENTANTE_BD = false;
                                editarRepresentanteLocal(item);
                              }
                            }

                            editarRepresentanteLocal = function(item)
                            {
                              $scope.activarFormularioRepresentante();
                              $scope.editar_representante = true;
                              $scope.editar_representante_registro = true;
                              itemTipoIdentificacion = buscarTipoIdentificacionSujeto(item.ID_TIPO_IDENTIFICACION, $scope.tipoIdentificacionRepresentante);
                              $scope.selectedTipoIdentificacionRepresentante(itemTipoIdentificacion);
                              getPoblacionIdioma(item);
                              angular.extend($scope.representante,item);
                              $scope.selectedGenero(item);
                              $scope.datosContactoRepresentante.seleccion=$scope.representante.contactos;
                              $scope.icono_boton_editar_representante = "fa fa-refresh";
                              $scope.icono_boton_limpiar_representante = "fa fa-close";
                              $scope.tooltip_boton_editar_representante = "Actualizar datos";
                              $scope.tooltip_boton_limpiar_representante = "Cancelar actualización de datos";
                              $scope.formularioRepresentante = true;

                              $scope.focus_identificacion_representante = false;
                              validaDireccion();
                              $scope.habilitar_datos_identificacion_representante();
                            }
                            viewSwalEliminarRepresentante = function(item)
                            {
                              $scope.dialogShowSwalEliminarRepresentante = ngDialog.open(
                              {
                                template: 'app/casos/casos.seguimiento.swalContainer.view.tpl.html',
                                showClose: false,
                                closeByEscape: false,
                                closeByNavigation: true,
                                preCloseCallback:function()
                                {
                                  // $scope.sesion = {};
                                  // getCasoCompleto($scope.caso.ID_EXPEDIENTE);
                                  // $scope.habilitar_datos_identificacion();
                                  // $scope.nuevo_sujeto = false;
                                },
                                className: 'ngdialog-theme-flat-custom',
                                // resolve:
                                // {
                                // },
                                scope:$scope,
                                controller: ['$scope',
                                function($scope) 
                                { 
                                  swal({                            
                                    title:'¿Eliminar representante?', 
                                    text: item.SUJETO,
                                    type: "error",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-danger",
                                    confirmButtonText: "Continuar",
                                    cancelButtonClass: "btn-default",
                                    cancelButtonText: "Cancelar",
                                    closeOnConfirm: false,
                                    closeOnCancel: false }, 
                                    function(isConfirm){ 
                                    if (isConfirm) 
                                    {  
                                      if (edicion)
                                      {
                                        $scope.sujeto.representantes = $scope.representantes.seleccion;
                                        if ((item.ID_REPRESENTANTE != undefined) && (item.ID_REPRESENTANTE != ""))
                                        {
                                          $scope.representantes.eliminacion.push(item);
                                        }
                                      }
                                      $scope.$apply();
                                      swal.close();
                                      ngDialog.close($scope.dialogShowSwalEliminarRepresentante.id);
                                    } 
                                    else 
                                    {
                                      $scope.representantes.seleccion.push(item);
                                      $scope.$apply();
                                      swal.close();
                                      ngDialog.close($scope.dialogShowSwalEliminarRepresentante.id);
                                    }
                                  });
                                }]
                              })
                            }

                            $scope.eliminarRepresentante = function(item)
                            {
                              // if (($scope.representantes.seleccion.length == 0) && 
                              //     // ($scope.index >= 0) && 
                              //     ($scope.campo_requerido))
                              // {
                              //   $scope.representantes.seleccion.push(item);
                              //   toastr.warning("No se puede realizar la eliminación, debe asignar como mínimo un representante");
                              // }
                              // else
                              // {
                              viewSwalEliminarRepresentante(item); 
                              validaRepresentante();
                              // }
                            }
                            $scope.viewRepresentante = function()
                            {
                              $scope.dialogShowRepresentante = ngDialog.open(
                              {
                                template: 'app/casos/casos.registro.representante.view.tpl.html',
                                showClose: true,
                                closeByEscape: true,
                                closeByNavigation: true,
                                preCloseCallback:function()
                                {
                                $scope.limpiarRepresentante();
                                $scope.formularioRepresentante = false;
                                $scope.focus_identificacion_valida_representante = false;   
                                $scope.editar_representante = false;
                                // if (!$scope.REPRESENTANTE_BD)
                                // {
                                  // if ($scope.editar_solicitante)
                                  // {
                                  //   $scope.solicitantes.seleccion[$scope.index].representantes = $scope.representantes.seleccion;
                                  // }
                                  // else if ($scope.editar_invitado)
                                  // {
                                  //   $scope.invitados.seleccion[$scope.index].representantes = $scope.representantes.seleccion;
                                  // }
                                // }
                                },
                                className: 'ngdialog-theme-flat-custom',
                                scope:$scope,
                                controller: ['$scope', function($scope) 
                                {
                                  if (!$scope.editar_representante)
                                  {
                                    $scope.limpiarRepresentante();
                                    itemTipoIdentificacion = buscarTipoIdentificacionSujeto($scope.CONSTANTES.TIPO_IDENTIFICACION_DPI, $scope.tipoIdentificacionRepresentante);
                                    $scope.selectedTipoIdentificacionRepresentante(itemTipoIdentificacion);
                                  } 
                                }] 
                              });  
                            }
                            $scope.activarFormularioRepresentante = function(edicion_representante)
                            {
                              //se activa el indicador que las operaciones son en el formulario de representantes
                              $scope.formularioRepresentante = true;
                              //se deshabilita la seccion para visualizar los representantes del sujeto
                              //$scope.mostrar_representantes = false;
                              //se inicializa el indicador de representante guardado en base de datos
                              $scope.habilitar_datos_identificacion_representante();
                              $scope.REPRESENTANTE_BD = false;
                              $scope.FECHA_NACIMIENTO_VALIDA = true;
                              // $scope.limpiarRepresentante();
                              $scope.viewRepresentante();
                            }
                /*----------------viewRepresentante----------------*/        
                          }] 
                        });  
                      }
                      $scope.edicion = true;
                      limpiarSujetoInicial = function()
                      {
                        //se inicializa el arreglo de los datos de contacto
                        $scope.datosContacto = [];
                        $scope.datosContacto.seleccion = [];
                        $scope.datosContacto.eliminacion = [];
                        // $scope.datosContactoRepresentante = [];
                        // $scope.datosContactoRepresentante.seleccion = [];
                        // $scope.datosContactoRepresentante.eliminacion = [];
                        $scope.representantes = [];
                        $scope.representantes.seleccion = [];
                        $scope.representantes.eliminacion = [];
                        $scope.sujeto = {};
                        $scope.sujeto.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                      }
                      $scope.editarSujeto = function(item,perfil)
                      {
                        PERFIL_SUJETO = perfil;
                        if (item.isSelected)
                        {
                          limpiarSujetoInicial();
                          angular.copy(item,$scope.sujeto);
                          if (perfil == $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE)
                          {
                            $scope.box_ngDdialog = "box-primary";
                            $scope.btn_sujeto = "btn-primary";
                            $scope.color_formulario_sujeto = "box-primary";
                            $scope.color_boton_sujeto = "btn-primary";
                          }
                          else
                          {
                            $scope.box_ngDdialog = "box-warning";
                            $scope.btn_sujeto = "btn-warning";
                            $scope.color_formulario_sujeto = "box-warning";
                            $scope.color_boton_sujeto = "btn-warning";
                          }
                          $scope.deshabilitar_boton_eliminar_sujeto = true;
                          if ((perfil == $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE) && 
                              ($scope.solicitantes.length > 1) && 
                              ($scope.sujeto.ID_PRIORIDAD_SUJETO == $scope.CONSTANTES.PRIORIDAD_SUJETO_SECUNDARIO))
                            {
                              $scope.deshabilitar_boton_eliminar_sujeto = false;
                            }
                          
                          else if ((perfil == $scope.CONSTANTES.PERFIL_SUJETO_INVITADO) &&
                                   ($scope.invitados.length > 1) && 
                                   ($scope.sujeto.ID_PRIORIDAD_SUJETO == $scope.CONSTANTES.PRIORIDAD_SUJETO_SECUNDARIO))
                            {
                              $scope.deshabilitar_boton_eliminar_sujeto = false;
                            }
                          viewDatosSujeto($scope.edicion,perfil);
                        }
                        else
                        {
                          $scope.sujeto = {};
                          $scope.sujeto.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                        }
                      }
                      validaSexo = function()
                      { 
                        $scope.validacionSexoSujeto = false;
                        if ($scope.formularioRepresentante)
                        {
                          if (($scope.representante.ID_GENERO != undefined) && ($scope.representante.ID_GENERO != ""))
                          {
                            $scope.validacionSexoSujeto = true;
                          }
                        }
                        else if (($scope.sujeto.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL))
                        {
                          if (($scope.sujeto.ID_GENERO != undefined) && ($scope.sujeto.ID_GENERO != ""))
                          {
                            $scope.validacionSexoSujeto = true;
                          }
                        }
                        else
                        {
                          $scope.validacionSexoSujeto = true;
                        }
                      }
                      $scope.nuevo_sujeto = false;
                      PERFIL_SUJETO = null;
                      $scope.agregarSujeto = function(perfil)
                      {
                        PERFIL_SUJETO = perfil;
                        if (perfil == $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE)
                          {
                            $scope.box_ngDdialog = "box-primary";
                            $scope.btn_sujeto = "btn-primary";
                            $scope.color_formulario_sujeto = "box-primary";
                            $scope.color_boton_sujeto = "btn-primary";
                            if ($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO)
                            {
                              $scope.REPRESENTANTES_AGREGADOS = true;  
                            }
                          }
                          else
                          {
                            $scope.box_ngDdialog = "box-warning";
                            $scope.btn_sujeto = "btn-warning";
                            $scope.color_formulario_sujeto = "box-warning";
                            $scope.color_boton_sujeto = "btn-warning";
                            // console.log('agregar sujeto');
                            // console.log('$scope.REPRESENTANTES_AGREGADOS',$scope.REPRESENTANTES_AGREGADOS);
                            $scope.REPRESENTANTES_AGREGADOS = true;
                          }
                          $scope.UBICACION_CORRECTA = true;
                          ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_SECUNDARIO;
                          //se inicializa el arreglo de los datos de contacto
                          $scope.nuevo_sujeto = true;
                          limpiarSujetoInicial();
                          viewDatosSujeto(!$scope.edicion,perfil);
                      }
                      
                      viewDatosSesion = function(edicion,formulario)
                      {
                        $scope.dialogShowDatosSesion = ngDialog.open(
                        {
                          template: 'app/casos/casos.seguimiento.datosSesion.view.tpl.html',
                          showClose: true,
                          closeByEscape: true,
                          closeByNavigation: true,
                          preCloseCallback:function()
                          {
                            $scope.sesion = {};
                            // editar_solo_sesion = false;
                            getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                            // $scope.habilitar_datos_identificacion();
                            // $scope.nuevo_sujeto = false;
                            //quitar_seleccion('sesiones');
                          },
                          className: 'ngdialog-theme-flat-custom',
                          resolve:
                          {
                            dataEstadoSesion: ['casosService',
                            function(casosService)
                            {
                            return casosService.getEstadoSesion();
                            }],
                            dataFechaAgenda: ['casosService',
                            function(casosService)
                            {
                            return casosService.getFechaAgenda(CENTRO.ID_DESPACHO);
                            }]
                          },
                          scope:$scope,
                          controller: ['$scope', 'casosService','dataEstadoSesion', 'calendarConfig','$filter', 'dataFechaAgenda',
                          function($scope, casosService, dataEstadoSesion, calendarConfig, $filter, dataFechaAgenda) 
                          { 
                            //se obtiene la opcion a realizar, nuevas sesion o resultado
                            if (!editar_solo_sesion)
                            {
                              $scope.edicion_sesion = edicion;
                            }
                            //se obtienen los idiomas
                            getIdioma = function()
                            {
                              casosService.getIdioma(0,0,$scope.CONSTANTES.TIPO_CLS_IDIOMA_SESION).then(
                                function ( response ) 
                                {
                                  $scope.idiomasSesion = [];
                                  $scope.idiomasSesion = response.data;
                                  if ($scope.idiomasSesion.length == 1)
                                  {
                                    $scope.selectedIdiomaSesion(response.data[0]);    
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }
                            //permite seleccionar el estado de la sesion
                            ID_ESTADO_SESION = "";
                            limpiarParticipantes = function()
                            {
                              solicitantes = 0;
                              invitados = 0;
                              if ($scope.participantes != undefined)
                              {
                                for (var i=0; i < $scope.participantes.length; i++) 
                                {
                                  $scope.participantes[i].isSelected = false;
                                }
                              }
                            }
                            // $scope.columna_resultado = 6;
                            $scope.selectedEstadoSesion = function (item)
                            {
                              $scope.sesion.ESTADO_CASO = $scope.caso.ESTADO_CASO;
                              
                              /*$scope.deshabilitar_opciones_sesion = false;
                              registroIncompleto = verificaParticipantes($scope.CONSTANTES.REGISTRO_FALSO,$scope.solicitantes)
                              if ((registroIncompleto) && (item.ID_ESTADO_SESION==$scope.CONSTANTES.ESTADO_SESION_CELEBRADA))
                              {
                                toastr.warning('Faltan datos por ingresar en solicitantes, por favor verifique');
                                $scope.deshabilitar_opciones_sesion = true;
                                //item.isSelected = false;
                                // $location.hash('solicitantes');
                                //$scope.scrollToElement('solicitantes');
                              }
                              else
                              {
                                registroIncompleto = verificaParticipantes($scope.CONSTANTES.REGISTRO_FALSO,$scope.invitados)
                                if ((registroIncompleto) && (item.ID_ESTADO_SESION==$scope.CONSTANTES.ESTADO_SESION_CELEBRADA))
                                {
                                  toastr.warning('Faltan datos por ingresar en invitados, por favor verifique');
                                  $scope.deshabilitar_opciones_sesion = true;
                                  //item.isSelected = false;
                                  // $location.hash('invitados');
                                  //$scope.scrollToElement('invitados');
                                }
                                else
                                {*/
                                  if (ID_ESTADO_SESION != item.ID_ESTADO_SESION)
                                  {
                                    $scope.deshabilitar_opciones_sesion = false;
                                    $scope.sesion.ID_ESTADO_SESION = item.ID_ESTADO_SESION;
                                    ID_ESTADO_SESION = item.ID_ESTADO_SESION;
                                    $scope.sesion.ID_RESULTADO_SESION = "";
                                    $scope.sesion.REQUIERE_IDIOMA = "0";
                                    $scope.sesion.HORA_ATENCION = "";
                                    $scope.sesion.HORA_ATENCION_MOMENT = "";
                                    $scope.sesion.DURACION_ATENCION = "";
                                    $scope.sesion.DURACION_ATENCION_MOMENT = "";
                                    $scope.mostrar_participantes = false;
                                    $scope.sesion.PARTICIPANTES_SELECCIONADOS = false;
                                    // $scope.columna_resultado = 6;
                                    limpiarParticipantes();
                                    getResultado(item.ID_ESTADO_SESION,$scope.caso.REQUIERE_EXPEDIENTE,$scope.sesion.ID_TIPO_SESION);
                                    //se obtienen los idiomas
                                    if ($scope.sesion.ID_ESTADO_SESION == $scope.CONSTANTES.ESTADO_SESION_CELEBRADA)
                                    {
                                      getIdioma();
                                    }
                                  }
                                // }
                              // }
                            }
                            selectedEstadoSesionLocal = function (item)
                            {
                              getResultado(item.ID_ESTADO_SESION,$scope.caso.REQUIERE_EXPEDIENTE,$scope.sesion.ID_TIPO_SESION);
                              //se obtienen los idiomas
                              if ($scope.sesion.ID_ESTADO_SESION == $scope.CONSTANTES.ESTADO_SESION_CELEBRADA)
                              {
                                getIdioma();
                              }
                            }
                            //se obtienen los resultados de la sesion
                            getResultado = function(p_id_estado_sesion,p_requiere_expediente,p_id_tipo_sesion)
                            {
                              casosService.getResultadoSesion(p_id_estado_sesion,p_requiere_expediente,p_id_tipo_sesion).then(
                                function ( response ) 
                                {
                                  $scope.resultadosSesion = [];
                                  $scope.resultadosSesion = response.data;
                                  if ($scope.sesion.ID_RESULTADO_SESION != "")
                                  {
                                    //$scope.selectedEstadoSesion($scope.sesion);
                                    $scope.selectedResultadoSesion($scope.sesion);
                                  }
                                  else if ($scope.resultadosSesion.length == 1)
                                  {
                                    $scope.selectedResultadoSesion(response.data[0]);
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }
                            //permite seleccionar el idioma
                            $scope.selectedIdiomaSesion = function (item)
                            {
                              $scope.sesion.ID_IDIOMA = item.ID_IDIOMA;
                              $scope.sesion.ID_CLASIFICACION_IDIOMA = item.ID_CLASIFICACION_IDIOMA;
                            }
                            //permite seleccionar el resultado de la sesion
                            $scope.selectedResultadoSesion = function (item)
                            {
                              if (!edicion)
                              {
                                $scope.sesion.PARTICIPANTES_SELECCIONADOS = false;
                              }
                              $scope.mostrar_participantes = true;
                              mostrar_todos = 0;
                              if ($scope.sesion.RESULTADO_INCOMPARECIENTE)
                              {
                                $scope.descripcion_participantes = "Comparecientes";
                                $scope.sesion.RESULTADO_SESION = item.RESULTADO_SESION;
                                $scope.sesion.ID_IDIOMA = "";
                                $scope.sesion.ID_CLASIFICACION_IDIOMA = "";   
                                $scope.sesion.CAMBIAR_ESTADO = $scope.CONSTANTES.REGISTRO_FALSO;
                                $scope.sesion.RESULTADO_INCOMPARECIENTE = false;
                                // $scope.columna_resultado = 4;
                                if (($scope.sesion.ID_RESULTADO_SESION == $scope.CONSTANTES.RS_INCOMPARECIENTE) &&
                                    ($scope.caso.CIERRA_CASO == $scope.CONSTANTES.REGISTRO_VERDADERO))
                                {
                                  $scope.sesion.CAMBIAR_ESTADO = $scope.CONSTANTES.REGISTRO_VERDADERO;
                                }
                              }
                              else
                              {
                                $scope.sesion.RESULTADO_SESION = item.RESULTADO_SESION;
                                $scope.sesion.ID_RESULTADO_SESION = item.ID_RESULTADO_SESION;
                                $scope.sesion.REQUIERE_IDIOMA = item.REQUIERE_IDIOMA;
                                $scope.sesion.CAMBIAR_ESTADO = $scope.CONSTANTES.REGISTRO_VERDADERO;
                                if (formulario == 'revisiones')
                                {
                                  $scope.sesion.CAMBIAR_ESTADO = $scope.CONSTANTES.REGISTRO_FALSO;
                                }
                                $scope.descripcion_participantes = "Participantes";
                                // $scope.columna_resultado = 6;
                                if ((item.ID_RESULTADO_SESION == $scope.CONSTANTES.RS_INCOMPARECIENTE) ||
                                    (item.ID_RESULTADO_SESION == $scope.CONSTANTES.RS_EXTRAMEDIACION) ||
                                    (item.ID_RESULTADO_SESION == $scope.CONSTANTES.RS_DEVOLUCION_EXPEDIENTE))
                                {
                                  $scope.descripcion_participantes = "Solicitantes";
                                  $scope.sesion.ID_IDIOMA = "";
                                  $scope.sesion.ID_CLASIFICACION_IDIOMA = "";
                                  limpiarParticipantes();
                                  if (item.ID_RESULTADO_SESION == $scope.CONSTANTES.RS_INCOMPARECIENTE)
                                  {
                                    $scope.descripcion_participantes = "Comparecientes";
                                    $scope.sesion.CAMBIAR_ESTADO = "";
                                    $scope.sesion.ESTADO_CASO = $scope.caso.ESTADO_CASO;
                                    // $scope.columna_resultado = 4;
                                  }
                                  if (item.ID_RESULTADO_SESION == $scope.CONSTANTES.RS_EXTRAMEDIACION)
                                  {
                                    mostrar_todos = $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE;
                                  }
                                }
                                if (item.ID_RESULTADO_SESION != $scope.CONSTANTES.RS_INCOMPARECIENTE)
                                {
                                  $scope.sesion.ESTADO_CASO = item.RESULTADO_SESION;
                                }
                                if (item.ID_RESULTADO_SESION == $scope.CONSTANTES.RS_INCOMPARECIENTE_REVISION)
                                {
                                    $scope.descripcion_participantes = "Comparecientes";
                                    $scope.sesion.PARTICIPANTES_SELECCIONADOS = true;
                                }
                              }
                              $scope.getSujetosSesion($scope.caso.ID_EXPEDIENTE,mostrar_todos,$scope.CONSTANTES.TIPO_SUJETO_JURIDICO,$scope.sesion.ID_SESION);
                            }
                            $scope.selectedCerrarCaso = function(item)
                            {
                              // console.log('item',$scope.participantes);
                              if (item.ID_CERRAR_CASO==$scope.CONSTANTES.REGISTRO_VERDADERO)
                              {
                                $scope.sesion.ESTADO_CASO = $scope.sesion.RESULTADO_SESION;
                                $scope.sesion.PARTICIPANTES_SELECCIONADOS = true;
                              }
                              else if ($scope.caso.REQUIERE_EXPEDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO)
                              {
                                $scope.sesion.PARTICIPANTES_SELECCIONADOS = true;
                              }
                              else if (solicitantes+invitados == 0)
                              {
                                $scope.sesion.ESTADO_CASO = $scope.caso.ESTADO_CASO;
                                // if ($scope.participantes.length > 0)
                                // {
                                  $scope.sesion.PARTICIPANTES_SELECCIONADOS = false;
                                // }
                              }
                            }
                            $scope.seleccionarParticipante = function(item)
                            {
                              // console.log('seleccion_parcicipante');
                              if (item.REGISTRO_COMPLETO == $scope.CONSTANTES.REGISTRO_VERDADERO)
                              {
                                if (item.isSelected)
                                {
                                  // console.log('registro completo - solicitante isSelected');
                                  if (item.ID_PERFIL_SUJETO == $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE)
                                  {
                                    solicitantes++;
                                  }
                                  else if (item.ID_PERFIL_SUJETO == $scope.CONSTANTES.PERFIL_SUJETO_INVITADO)
                                  {
                                    invitados++;
                                  } 
                                }
                                else
                                {
                                  // console.log('registro completo - invitado isSelected');
                                  if (item.ID_PERFIL_SUJETO == $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE)
                                  {
                                    solicitantes--;
                                  }
                                  else if (item.ID_PERFIL_SUJETO == $scope.CONSTANTES.PERFIL_SUJETO_INVITADO)
                                  {
                                    invitados--;
                                  }
                                }
                                $scope.sesion.PARTICIPANTES_SELECCIONADOS = false;
                                if ((solicitantes > 0) && (invitados > 0))
                                {
                                  $scope.sesion.PARTICIPANTES_SELECCIONADOS = true;          
                                }
                                else if (($scope.sesion.ID_ESTADO_SESION == $scope.CONSTANTES.ESTADO_SESION_NO_CELEBRADA && 
                                        ((solicitantes > 0) || (invitados > 0))))
                                {
                                  $scope.sesion.PARTICIPANTES_SELECCIONADOS = true;
                                }
                                else if (($scope.sesion.CAMBIAR_ESTADO == $scope.CONSTANTES.REGISTRO_VERDADERO) &&
                                    ($scope.sesion.ID_RESULTADO_SESION == $scope.CONSTANTES.RS_INCOMPARECIENTE))
                                {
                                  $scope.sesion.PARTICIPANTES_SELECCIONADOS = true;
                                }
                                if ($scope.sesion.ID_RESULTADO_SESION == $scope.CONSTANTES.RS_INCOMPARECIENTE_REVISION)
                                {
                                    $scope.sesion.PARTICIPANTES_SELECCIONADOS = true;
                                }
                              }
                              else
                              {  
                                item.isSelected = false;
                                toastr.warning('Faltan datos por ingresar en '+item.PERFIL_SUJETO.toLowerCase()+', por favor verifique');
                              }
                            }
                            
        /*formulario sesion*/
                            //se cambia la configuracion predeterminada para que al seleccionar semana salga en español el texto
                            calendarConfig.allDateFormats.angular.title.week = "Semana {week} de {year}"
                            //se utiliza para que el calendario inicie en lunes como primer dia de la semana
                            //moment.locale('en_gb', {week : {dow : 1 }});
                            $scope.btn_select_agenda = "btn-default";
                            //se inicializa la bandera para mantener oculto el calendario
                            $scope.colapsado = false;
                            //se declara el arreglo para el calendario
                            $scope.vm = {};
                            //unidad con la que el calendario se visualizara incialmente, pueden ser dia, semana, mes y año                      
                            $scope.vm.calendarView = 'week';
                            
                            if (formulario == 'sesiones')
                            {
                              $scope.descripcion_sesion = "Sesión"; 
                              $scope.descricpcion_observaciones = "Hoja de evolución";
                              $scope.color_formulario_sesion = "box-info";
                              $scope.color_boton_agenda = "btn-info";
                              $scope.descripcion_acuerdo = "caso";
                            }
                            else if (formulario == 'revisiones')
                            {
                              $scope.descripcion_sesion = "Revisión de acuerdo"; 
                              $scope.descricpcion_observaciones = "Observaciones";
                              $scope.color_formulario_sesion = "box-maroon";
                              $scope.color_boton_agenda = "bg-maroon";
                              $scope.descripcion_acuerdo = "acuerdo";
                            }
                            if ((dataFechaAgenda.data.FECHA_AGENDA == "") || (dataFechaAgenda.data.FECHA_AGENDA == undefined))
                            {
                              $scope.vm.viewDate = new Date();
                            }
                            else
                            {
                              $scope.vm.viewDate = new Date(dataFechaAgenda.data.FECHA_AGENDA);
                              $scope.btn_select_agenda = $scope.color_boton_agenda;
                            }
                            //se inicializa oculta la etiqueta de fecha y hora
                            $scope.mostrar_fecha_hora = false;
                            
                            //se obtiene el dia actual para poder enviarla como fecha actual al llenar el calendario
                            p_fecha_actual = fechaFormatoYYYYMMDD(new Date(new Date().setDate($scope.vm.viewDate.getDate())));
                            meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
                            dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
                            fechaDiaInicialFinalSemana = function (date)
                            {
                              d = new Date(date);
                              day = d.getDay();
                              diff = d.getDate() - day + (day == 0 ? -6 : 1);
                              lunes = new Date(d.setDate(diff));
                              p_fecha_inicial = fechaFormatoYYYYMMDD(lunes);

                              d = new Date(date);
                              day = d.getDay(),
                              diff = d.getDate() - day + (day == 0 ? -6 : 5);
                              viernes = new Date(d.setDate(diff));
                              p_fecha_final = fechaFormatoYYYYMMDD(viernes);
                            }
                            fechaTituloRangoDiasSemana = function(date)
                            {
                              d = new Date(date);
                              day = d.getDay(),
                              diff = d.getDate() - day;
                              domingo = new Date(d.setDate(diff));            
                              d = new Date(date);
                              day = d.getDay(),
                              diff = d.getDate() - day + (day == 0 ? -6 : 6);
                              sabado = new Date(d.setDate(diff));
                              diaInicial = domingo.getDate();
                              mesInicial = meses[domingo.getMonth()];
                              anioInicial= domingo.getFullYear();
                              diaFinal = sabado.getDate();
                              mesFinal = meses[sabado.getMonth()];
                              anioFinal= sabado.getFullYear();
                              tituloCalendario = diaInicial;
                              if (mesInicial != mesFinal)
                              {
                                tituloCalendario = tituloCalendario +' '+ mesInicial;
                              }
                              if (anioInicial != anioFinal)
                              {
                                tituloCalendario = tituloCalendario +' '+ anioInicial;
                              }
                              tituloCalendario = tituloCalendario +' - '+diaFinal+' '+mesFinal+', '+anioFinal;
                              return tituloCalendario;
                            }
                            fechaEtiquetaDiaMes = function(date)
                            {
                              today = new Date(date);
                              dd = today.getDate();
                              mm = today.getMonth()+1;
                              yyyy = today.getFullYear();
                              if(dd<10)
                              {
                                dd='0'+dd;
                              } 
                              if(mm<10)
                              {
                                mm='0'+mm;
                              }   
                              d = new Date(date);
                              return $filter('uppercase')(dias[d.getDay()])+', '+dd+' DE '+$filter('uppercase')(meses[today.getMonth()])+' DE '+yyyy;
                            }
                            $scope.fijarAgenda = function(item)
                            {
                              casosService.edtFijarAgenda({ID_DESPACHO:CENTRO.ID_DESPACHO,FECHA_AGENDA:fechaFormatoYYYYMMDD(item)}).then(
                                function (response)
                                {
                                  if(response.data.result=='OK')
                                  {
                                    toastr.success(response.data.msj);
                                    $scope.btn_select_agenda = $scope.color_boton_agenda;
                                  }
                                  else
                                  {
                                    toastr.error(response.data.msj);
                                  }                      
                                },
                                function (error) 
                                {
                                  toastr.error( error );
                                });
                            }
                            $scope.colapsar = function()
                            {
                              $scope.colapsado = !$scope.colapsado;
                              if ((edicion) || (activarSeleccionReceptor))
                              {
                                if (edicion)
                                {
                                  $scope.edicion_sesion = $scope.colapsado;
                                }
                                if (activarSeleccionReceptor)
                                {
                                  $scope.cargarEventos(false);
                                  activarSeleccionReceptor = false;
                                }
                              }
                            }
                            limpiarEventoSeleccionado = function()
                            {
                              $scope.sesion.calendarEventId = undefined;
                              $scope.mostrar_fecha_hora = false;
                              if (formulario == 'sesiones')
                              {
                                $scope.sesion.FECHA_LARGA_HORA_SESION = "SESIÓN NO AGENDADA"; 
                              }
                              else if (formulario == 'revisiones')
                              {
                                $scope.sesion.FECHA_LARGA_HORA_SESION = "REVISIÓN NO AGENDADA"; 
                              }
                              $scope.sesion.SESION_AGENDADA = false;
                              $scope.sesion.ID_HORA = "";
                              $scope.sesion.FECHA_SESION = "";
                            }
                            armaCalendario = function(eventos){
                            $scope.vm.events=[];
                            eventos.forEach(function(evento) {
                                  var evt ={
                                    title: evento.HORA_INICIO+' - '+evento.ESTADO_SESION,
                                    color: angular.fromJson(evento.COLORES),
                                    startsAt: new Date(fechaFormatoYYYYMMDD(evento.FECHA_CALENDARIO)+' '+evento.HORA_INICIO),
                                    endsAt: new Date(fechaFormatoYYYYMMDD(evento.FECHA_CALENDARIO)+' '+evento.HORA_FIN),
                                    draggable: false,
                                    resizable: false,
                                    FECHA_CALENDARIO: evento.FECHA_CALENDARIO,
                                    ID_HORA: evento.ID_HORA,
                                    HORA_INICIO: evento.HORA_INICIO,
                                    HORA_FIN: evento.HORA_FIN,
                                    ID_SESION:evento.ID_SESION,
                                    ESTADO_SESION: evento.ESTADO_SESION,
                                    SESION_EDITABLE: evento.SESION_EDITABLE,
                                    PROGRAMACION_FUTURA: evento.PROGRAMACION_FUTURA,
                                    MEDIADORES_CENTRO: evento.MEDIADORES_CENTRO,
                                    SESIONES_CENTRO: evento.SESIONES_CENTRO
                                  };
                                  /*if ((evento.ID_SESION > 0) && (evento.SESION_EDITABLE > 0))
                                  {
                                    $scope.sesion.ID_SESION = evento.ID_SESION;
                                    $scope.sesion.SESION_EDITABLE = evento.SESION_EDITABLE;
                                    $scope.mostrar_fecha_hora = true;
                                    $scope.sesion.FECHA_LARGA_HORA_SESION = fechaEtiquetaDiaMes(evento.FECHA_CALENDARIO)+', '+evento.HORA_INICIO+' HORAS';
                                    $scope.colapsado = true;
                                  }*/
                                  $scope.vm.events.push(evt);
                              });      
                              
                            };
                            
                            $scope.cargarEventos = function(colapsar)
                            {
                              if ($scope.sesion.ID_SESION == "0")
                              {
                                limpiarEventoSeleccionado();
                              }
                              fechaDiaInicialFinalSemana($scope.vm.viewDate);
                              if ($scope.vm.calendarView == 'week')
                              {
                                $scope.tituloCalendario = fechaTituloRangoDiasSemana($scope.vm.viewDate);  
                              }
                              else
                              {
                                $scope.tituloCalendario = $scope.vm.calendarTitle;
                              }
                              casosService.getAgendaSesionesMediador(CENTRO.ID_DESPACHO,$scope.sesion.ID_SESION,p_fecha_inicial,p_fecha_final,p_fecha_actual).then(
                                function ( response ) 
                                { 
                                  $scope.colapsado = colapsar;
                                  armaCalendario(response.data);
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                                $scope.btn_select_agenda = "btn-default";
                                if (fechaFormatoYYYYMMDD(dataFechaAgenda.data.FECHA_AGENDA) == fechaFormatoYYYYMMDD($scope.vm.viewDate))
                                {
                                  $scope.btn_select_agenda = $scope.color_boton_agenda;
                                }
                            }
                            $scope.selectedMediadorReceptorSesion = function (item)
                            {
                              $scope.sesion.ID_MEDIADOR_RECEPTOR = item.ID_MEDIADOR;
                              $scope.sesion.NOMBRE_RECEPTOR = item.MEDIADOR;
                              //$scope.sesion.FIRMA_DOCUMENTO = item.ESTADO_FIRMA;
                              //$scope.sesion.FIRMA_USUARIO_INACTIVA = $scope.CONSTANTES.FIRMA_USUARIO_INACTIVA;
                              if (!$scope.sesion.SESION_AGENDADA)
                              {
                                $scope.cargarEventos(false);
                              }
                            }
                            selectedMediadorReceptorSesion = function (item)
                            {
                              activarSeleccionReceptor = false;
                              if ((item != undefined) && (!$scope.edicion_sesion))
                              {
                                $scope.sesion.ID_MEDIADOR_RECEPTOR = item.ID_MEDIADOR;
                                $scope.sesion.NOMBRE_RECEPTOR = item.MEDIADOR;
                                activarSeleccionReceptor = true;
                              }
                              if ($scope.edicion_sesion)
                              {
                                $scope.mostrar_combo_repector = false;
                              }
                            }
                            selectedMediadorSesion = function (item)
                            {
                              if (item != undefined)
                              {
                                $scope.sesion.ID_MEDIADOR = item.ID_MEDIADOR;
                                $scope.sesion.NOMBRE_MEDIADOR = item.MEDIADOR;
                              }
                              else
                              {
                                $scope.mostrar_combo_mediador = false;
                              }
                            }
                            getMediadoresSesion = function(despacho,usuario,opcion)
                            {
                              casosService.getMediadoresCentro(despacho,usuario,opcion).then(
                                function ( response ) 
                                {
                                  $scope.mediadoresSesion = [];
                                  $scope.mediadoresSesion = response.data;
                                  $scope.mostrar_combo_mediador = false;
                                  if (edicion)
                                  {
                                    $scope.mostrar_combo_mediador = true;
                                    if ($scope.mediadoresSesion.length == 1)
                                    {
                                      selectedMediadorReceptorSesion(response.data[0]);
                                      selectedMediadorSesion(response.data[0]);
                                    }
                                    else
                                    {
                                      itemMediadorReceptorSesion = buscarMediadorSesion($scope.sesion.ID_MEDIADOR_RECEPTOR,$scope.mediadoresSesion); 
                                      selectedMediadorReceptorSesion(itemMediadorReceptorSesion); 
                                    }
                                    if ($scope.sesion.ID_MEDIADOR != "")
                                    {
                                      itemMediadorSesion = buscarMediadorSesion($scope.sesion.ID_MEDIADOR,$scope.mediadoresSesion); 
                                      selectedMediadorSesion(itemMediadorSesion); 
                                    }
                                    /*console.log('dentro edicion',edicion)
                                    if (($scope.mediadoresSesion.length == 1) && ($scope.expedienteGlobal.ID_MEDIADOR == $scope.sesion.ID_MEDIADOR_BASE))
                                    {
                                      selectedMediadorReceptorSesion(response.data[0]);
                                    }
                                    else if ($scope.expedienteGlobal.ID_MEDIADOR == $scope.sesion.ID_MEDIADOR_BASE)
                                    {
                                      itemMediadorSesion = buscarMediadorSesion($scope.sesion.ID_MEDIADOR,$scope.mediadoresSesion);
                                      selectedMediadorReceptorSesion(itemMediadorSesion);
                                    }
                                    else
                                    {
                                      $scope.mostrar_combo_repector = false;
                                      if (($scope.sesion.SESION_EDITABLE == $scope.sesion.SESION_EDITABLE_DIA) && ($scope.sesion.ID_RESULTADO_SESION == "")) 
                                      {
                                        if ($scope.mediadoresSesion.length == 1)
                                        {
                                          selectedMediadorReceptorSesion($scope.mediadoresSesion[0]);
                                        }
                                      }
                                      if (editar_solo_sesion)
                                      {
                                        if ($scope.mediadoresSesion.length == 1)
                                        {
                                          selectedMediadorReceptorSesion($scope.mediadoresSesion[0]);
                                        }
                                        else if ($scope.sesion.ID_MEDIADOR != "")
                                        {
                                          itemMediadorSesion = buscarMediadorSesion($scope.sesion.ID_MEDIADOR,$scope.mediadoresSesion);
                                          $scope.selectedMediadorReceptorSesion(itemMediadorSesion);
                                        }
                                        // $scope.edicion_sesion = false;
                                        // edicion=false;
                                        // $scope.sesion.PARTICIPANTES_SELECCIONADOS = true;
                                      }
                                      // console.log('$scope.sesion.ID_MEDIADOR_BASE',$scope.sesion.ID_MEDIADOR_BASE);
                                      // if ($scope.expedienteGlobal.ID_MEDIADOR != $scope.sesion.ID_MEDIADOR_BASE)
                                      // {
                                      //   $scope.deshabilitar_datos_sesion = true;
                                      //   $scope.deshabilitar_opciones_sesion = true;
                                      //   console.log('mediador base','$scope.deshabilitar_opciones_sesion = true;');
                                      // }
                                    }*/
                                  }
                                  else
                                  {
                                    if ($scope.mediadoresSesion.length == 1)
                                    {
                                      selectedMediadorReceptorSesion(response.data[0]);
                                    }
                                    else
                                    {
                                      itemMediadorSesion = buscarMediadorSesion($scope.sesion.ID_MEDIADOR_RECEPTOR,$scope.mediadoresSesion); 
                                      selectedMediadorReceptorSesion(itemMediadorSesion);
                                    }
                                    if ($scope.sesion.ID_SESION == 0)
                                    {
                                      $scope.colapsar();
                                    }
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }
                            $scope.vm.cellIsOpen = true;
                            $scope.vm.eventClicked = function(event) 
                            {
                              // if ((($scope.sesion.ID_SESION > 0) && ($scope.sesion.SESION_EDITABLE > 0)) && !edicion)
                              // {
                              //   $scope.sesion.ID_HORA = event.ID_HORA;
                              //   $scope.sesion.SESION_AGENDADA = true;
                              //   $scope.colapsado = true;
                              //   console.log('dentro');
                              // }
                              // else
                              // {
                                if (event.SESION_EDITABLE == 0)
                                {
                                  mensaje = 'Otra sesión ya ha sido agendada en este horario, por favor seleccione uno diferente';
                                  if (event.MEDIADORES_CENTRO > 1)
                                  {
                                    mensaje = 'Otras sesiones ya han sido agendadas en este horario, por favor seleccione uno diferente';
                                  }
                                  toastr.warning(mensaje);
                                }
                                else
                                {
                                  if (!agregar_sesion)
                                  {
                                    reprogramacion = true;
                                  }
                                  edicion = false;
                                  $scope.sesion.PARTICIPANTES_SELECCIONADOS = true;
                                  $scope.mostrar_fecha_hora = true;
                                  $scope.sesion.FECHA_LARGA_HORA_SESION = fechaEtiquetaDiaMes(event.FECHA_CALENDARIO)+', '+event.HORA_INICIO+' HORAS';  
                                  $scope.sesion.ID_HORA = event.ID_HORA;
                                  $scope.sesion.FECHA_SESION = event.FECHA_CALENDARIO;
                                  eventTemp = $scope.vm.events[event.calendarEventId];
                                  $scope.sesion.SESION_AGENDADA = true;
                                  if (formulario == 'sesiones')
                                  {
                                    complemento_titulo = ' - Sesión agendada';
                                  }
                                  else if (formulario == 'revisiones')
                                  {
                                    complemento_titulo = ' - Revisión agendada';
                                  }
                                  if (event.MEDIADORES_CENTRO > 1)
                                  {
                                    if (formulario == 'sesiones')
                                    {
                                      complemento_titulo = ' - ('+(parseInt(event.SESIONES_CENTRO)+1)+'/'+event.MEDIADORES_CENTRO+') Sesión agendada';
                                    }
                                    else if (formulario == 'revisiones')
                                    {
                                      complemento_titulo = ' - ('+(parseInt(event.SESIONES_CENTRO)+1)+'/'+event.MEDIADORES_CENTRO+') Revisión agendada';
                                    }
                                  }
                                  if ($scope.sesion.calendarEventId == undefined)
                                  {
                                    // if (formulario == 'sesiones')
                                    // {
                                    //   eventTemp.title = event.HORA_INICIO+' - Sesión agendada';  
                                    // }
                                    // else if (formulario == 'revisiones')
                                    // {
                                    //   eventTemp.title = event.HORA_INICIO+' - Revisión agendada';
                                    // }
                                    eventTemp.title = event.HORA_INICIO+complemento_titulo;
                                    eventTemp.color.primary = '#ad2121';
                                    eventTemp.color.secondary = '#fae3e3';
                                    $scope.sesion.calendarEventId = event.calendarEventId;
                                  }
                                  else
                                  {
                                    if ($scope.sesion.calendarEventId != event.calendarEventId)
                                    {
                                      eventRestore = $scope.vm.events[$scope.sesion.calendarEventId];
                                      eventRestore.title = eventRestore.HORA_INICIO+' - '+eventRestore.ESTADO_SESION;
                                      if (eventRestore.PROGRAMACION_FUTURA == $scope.CONSTANTES.REGISTRO_VERDADERO)
                                      {
                                        eventRestore.color.primary = '#006400';
                                        eventRestore.color.secondary = '#caffca';
                                      }
                                      else if (eventRestore.PROGRAMACION_FUTURA == $scope.CONSTANTES.REGISTRO_FALSO)
                                      {
                                        eventRestore.color.primary = '#e3bc08';
                                        eventRestore.color.secondary = '#fdf1ba';
                                      }
                                      else
                                      {
                                        eventRestore.color.primary = '#1e90ff';
                                        eventRestore.color.secondary = '#d1e8ff';
                                      }
                                      eventTemp.title = event.HORA_INICIO+complemento_titulo;
                                      eventTemp.color.primary = '#ad2121';
                                      eventTemp.color.secondary = '#fae3e3';
                                      $scope.sesion.calendarEventId = event.calendarEventId;
                                      // if (formulario == 'sesiones')
                                      // {
                                      //   eventTemp.title = event.HORA_INICIO+' - Sesión agendada';  
                                      // }
                                      // else if (formulario == 'revisiones')
                                      // {
                                      //   eventTemp.title = event.HORA_INICIO+' - Revisión agendada';
                                      // }
                                      // eventTemp.color.primary = '#ad2121';
                                      // eventTemp.color.secondary = '#fae3e3';
                                      // $scope.sesion.calendarEventId = event.calendarEventId;
                                    }
                                  }
                                  // toastr.success('Sesión agendada correctamente');
                                  $scope.colapsado = true;
                                }
                              // }
                            }; 
        /*formulario sesion*/

                            $scope.getSujetosSesion = function(p_id_expediente,p_id_perfil_sujeto,p_tipo_juridico,p_id_sesion)
                            {
                              casosService.getSujetosSesion(p_id_expediente,p_id_perfil_sujeto,p_tipo_juridico,p_id_sesion).then(
                                function ( response ) 
                                {
                                  $scope.participantes = [];
                                  $scope.participantes = response.data;
                                  // console.log('$scope.participantes',$scope.participantes);
                                  if ($scope.sesion.ID_RESULTADO_SESION != "")
                                  {
                                    for (var i=0; i < $scope.participantes.length; i++) 
                                    {
                                      if ($scope.participantes[i].ID_SUJETO_SESION != "")
                                      {
                                        if ($scope.participantes[i].ID_PERFIL_SUJETO == $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE)
                                        {
                                          solicitantes++;
                                        }
                                        else if ($scope.participantes[i].ID_PERFIL_SUJETO == $scope.CONSTANTES.PERFIL_SUJETO_INVITADO)
                                        {
                                          invitados++;
                                        } 
                                        $scope.participantes[i].isSelected = true;
                                      }
                                    }
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });  
                            }
                            
                            getMediadoresSesion($scope.expedienteGlobal.ID_DESPACHO,$scope.loginData.ID_USUARIO,$scope.CONSTANTES.CARGO_MEDIADOR);

                            
                            if (edicion)
                            {
                              // console.log('if');
                              $scope.sesion.SESION_AGENDADA = true;
                              $scope.tooltip_boton_guardar_sesion ="Guardar cambios";
                              $scope.icono_boton_guardar_sesion = "fa fa-lg fa-refresh";
                              $scope.descripcion_fecha_hora_sesion = "Fecha y hora agendada";
                              $scope.colapsado = true;
                              $scope.mostrar_combo_estado = false;
                              $scope.estadosSesion = [];
                              $scope.estadosSesion = dataEstadoSesion.data;
                              $scope.cerrarCaso = [{ID_CERRAR_CASO:"1",CERRAR_CASO:"SÍ"},{ID_CERRAR_CASO:"0",CERRAR_CASO:"NO"}]
                              //se obtienen los participantes
                              //$scope.getSujetosSesion ($scope.caso.ID_EXPEDIENTE,0,$scope.CONSTANTES.TIPO_SUJETO_JURIDICO,$scope.sesion.ID_SESION);
                              if ($scope.sesion.ID_RESULTADO_SESION != "")
                              {
                                // console.log('con resultado');
                                selectedEstadoSesionLocal($scope.sesion);
                                $scope.mostrar_combo_estado = true;
                                $scope.deshabilitar_datos_sesion = true;
                                $scope.deshabilitar_opciones_sesion = true;
                                if (($scope.sesion.SESION_EDITABLE_DIA == $scope.CONSTANTES.REGISTRO_VERDADERO) && 
                                    ($scope.sesion.NUEVA_SESION_AGENDADA == $scope.CONSTANTES.REGISTRO_VERDADERO))
                                    // &&
                                    // ((!$scope.deshabilitar_boton_nueva_sesion) || (!$scope.deshabilitar_boton_nueva_revision))) 
                                {
                                  $scope.deshabilitar_datos_sesion = false;
                                  $scope.deshabilitar_opciones_sesion = false;
                                }
                                // else if (($scope.deshabilitar_boton_nueva_revision) &&
                                //          ($scope.sesion.SESION_EDITABLE == $scope.sesion.SESION_EDITABLE_DIA))
                                // {
                                //   $scope.deshabilitar_datos_sesion = false;
                                //   $scope.deshabilitar_opciones_sesion = false;
                                // }
                                
                                if (formulario == 'revisiones')
                                {
                                  $scope.caso.CIERRA_CASO = $scope.CONSTANTES.REGISTRO_VERDADERO;
                                }
                                /*else if (($scope.caso.CIERRA_CASO==$scope.CONSTANTES.REGISTRO_VERDADERO) &&
                                         ($scope.caso.REQUIERE_EXPEDIENTE==$scope.CONSTANTES.REGISTRO_VERDADERO))
                                {console.log('registro sesion');
                                  $scope.registro_sesion = true;
                                }*/
                                $scope.sesion.PARTICIPANTES_SELECCIONADOS = true;
                              }
                              else
                              {
                                $scope.caso.CIERRA_CASO = $scope.CONSTANTES.REGISTRO_FALSO;
                                if ((formulario == 'revisiones') && ($scope.sesion.SESION_EDITABLE == $scope.CONSTANTES.REGISTRO_VERDADERO))
                                {
                                  $scope.deshabilitar_opciones_sesion = false;
                                  $scope.deshabilitar_datos_sesion = false;
                                }
                              }
                              $scope.mostrar_combo_repector = false;
                              if (($scope.sesion.SESION_EDITABLE == $scope.sesion.SESION_EDITABLE_DIA) && ($scope.sesion.ID_RESULTADO_SESION == "")) 
                              {
                                $scope.mostrar_combo_repector = true;
                              }
                              if (editar_solo_sesion)
                              {
                                $scope.mostrar_combo_repector = true;
                                if (formulario == 'revisiones')
                                {
                                  $scope.deshabilitar_opciones_sesion = false;
                                  $scope.deshabilitar_datos_sesion = false;
                                }
                                $scope.edicion_sesion = false;
                                edicion=false;
                                $scope.sesion.PARTICIPANTES_SELECCIONADOS = true;
                              }
                            }
                            else
                            {
                              // console.log('else');
                              $scope.mostrar_combo_repector = true;
                              $scope.deshabilitar_datos_sesion = false;
                              $scope.deshabilitar_opciones_sesion = false;

                              $scope.sesion.PARTICIPANTES_SELECCIONADOS = true;
                              $scope.tooltip_boton_guardar_sesion ="Guardar sesión";
                              $scope.icono_boton_guardar_sesion = "fa fa-lg fa-save";
                              $scope.descripcion_fecha_hora_sesion = "Fecha y hora";

                              // se inicializa el id de la sesion en 0 para ser cambiado segun la sesion seleccionada en la seccion de sesiones
                              // cambiar el 0 por el id que se seleccione en la seccion sesiones
                              $scope.sesion.ID_SESION = "0";
                              //se inicializa la etiqueta de la fecha y hora de la sesion
                              if (formulario == 'sesiones')
                              {
                                $scope.sesion.FECHA_LARGA_HORA_SESION = "SESIÓN NO AGENDADA"; 
                              }
                              else if (formulario == 'revisiones')
                              {
                                $scope.sesion.FECHA_LARGA_HORA_SESION = "REVISIÓN NO AGENDADA"; 
                              }
                              $scope.sesion.SESION_AGENDADA = false;
                              // if ($scope.mediadoresSesion.length == 1)
                              // {
                              //   $scope.selectedMediadorReceptorSesion($scope.mediadoresSesion[0]);
                              // }
                            }
                            
                            $scope.firmarArchivo = function(item)
                            {
                              authService.getArchivo(item.ID_EXPEDIENTE,item.ID_SESION,item.ID_TIPO_DOCUMENTO).then(
                                function ( response ) 
                                {console.log("RESPONSE DE GETARCHIVO", response);
                                  if (response.data.ID_ARCHIVO > 0)
                                  {
                                    //enviar nombre de archivo y numero de caso para formar bien el nombre del documento
                                    item.ID_ARCHIVO = response.data.ID_ARCHIVO;
                                    item.ID_ARCHIVO_PADRE = response.data.ID_ARCHIVO;
                                    item.INVITACION_PARA_FIRMA = response.data.INVITACION_PARA_FIRMA;
                                    $scope.sesion.INVITACION_PARA_FIRMA = response.data.INVITACION_PARA_FIRMA;
                                    item.ID_TIPO_SESION = $scope.sesion.ID_TIPO_SESION;
                                    item.TIPO_SESION_MEDIACION = $scope.CONSTANTES.TIPO_SESION_MEDIACION;
                                    item.TIPO_SESION_REVISION = $scope.CONSTANTES.TIPO_SESION_REVISION;
                                    item.NUMERO_CASO = response.data.NUMERO_CASO
                                    item.ARCHIVO = response.data.ARCHIVO;
                                    authService.firmarArchivo(item).then(
                                      function (response)
                                      {console.log("response de firmar Archivo",response);
                                        if(response.data.result=='OK')
                                        {console.log("response OK de firmar Archivo",response);
                                          $scope.sesion.ID_ESTADO_ARCHIVO = $scope.CONSTANTES.ESTADO_ARCHIVO_FIRMADO;
                                          item.ID_ESTADO_ARCHIVO = $scope.CONSTANTES.ESTADO_ARCHIVO_FIRMADO;
                                          if ($scope.loginData.CENTRO.BUZON_ACHIVOS == $scope.CONSTANTES.MOSTRAR_BUZON_ARCHIO)
                                          {
                                            $scope.cantidadArchivosFirma($scope.loginData.ID_USUARIO,$scope.loginData.CENTRO.ID_DESPACHO,$scope.CONSTANTES.ESTADO_ARCHIVO_SOLICITUD,$scope.CONSTANTES.ARCHIVO_TIPO_INVITACION);
                                          }
                                          //$scope.imprimirArchivo(item.ID_ARCHIVO,$scope.CONSTANTES.ARCHIVO_TIPO_INVITACION);
                                          if (formulario == 'sesiones')
                                          {
                                            $scope.imprimirEvolucion($scope.opcion_registro_invitacion);
                                          }
                                          else if (formulario == 'revisiones')
                                          {
                                            $scope.imprimirEvolucion($scope.opcion_invitacion_revision);
                                          }
                                          toastr.success(response.data.msj);
                                        }
                                        else
                                        {
                                          toastr.error(response.data.msj);
                                        }                    
                                      },
                                      function (error) 
                                      {
                                        toastr.error( error );
                                      });
                                    //bloque de firma
                                  }
                                  else
                                  {
                                    if (formulario == 'sesiones')
                                    {
                                      $scope.imprimirEvolucion($scope.opcion_registro_invitacion);
                                    }
                                    else if (formulario == 'revisiones')
                                    {
                                      $scope.imprimirEvolucion($scope.opcion_invitacion_revision);
                                    }
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }

                            //$scope.firmarArchivo($scope.caso.ID_EXPEDIENTE,$scope.sesion.ID_SESION,$scope.CONSTANTES.ARCHIVO_TIPO_INVITACION); 

                            insSesion =  function(item,firmarArchivo,firma)
                            {
                              casosService.insSesion(item).then(
                                function (response)
                                {
                                  if(response.data.result=='OK')
                                  {
                                    toastr.success(response.data.msj);  
                                    $scope.sesion.NUMERO_SESION = $scope.caso.NUMERO_SESIONES+1;
                                    $scope.sesion.ID_SESION = response.data.id;
                                    item.ID_SESION = response.data.id;
                                    //getCasoCompleto($scope.sesion.ID_EXPEDIENTE);
                                    console.log("dentro de insSesion");
                                    if ((firmarArchivo) && 
                                        ($scope.loginData.CENTRO.FIRMA_DOCUMENTO == $scope.CONSTANTES.USUARIO_CON_FIRMA))
                                    {
                                      console.log("firma archivo y usuario con firma");
                                      item.FIRMA = firma;              
                                      item.ID_ESTADO_ARCHIVO = $scope.CONSTANTES.ESTADO_ARCHIVO_FIRMADO;
                                      item.ID_TIPO_DOCUMENTO = $scope.CONSTANTES.ARCHIVO_TIPO_INVITACION;
                                      item.ARCHIVO_TIPO_INVITACION = $scope.CONSTANTES.ARCHIVO_TIPO_INVITACION;
                                      $scope.firmarArchivo(item);
                                      //ngDialog.close($scope.dialogShowDatosSesion.id);
                                    }
                                    else
                                    {
                                      if (formulario == 'sesiones')
                                      {
                                        $scope.imprimirEvolucion($scope.opcion_registro_invitacion);
                                      }
                                      else if (formulario == 'revisiones')
                                      {
                                        $scope.imprimirEvolucion($scope.opcion_invitacion_revision);
                                      }
                                      //ngDialog.close($scope.dialogShowDatosSesion.id);
                                    }
                                    //limpiarCaso();
                                    //getCasoCompleto(response.data.id);
                                  }
                                  else
                                  {
                                    toastr.error(response.data.msj);
                                  }                      
                                },
                                function (error) 
                                {
                                  toastr.error( error );
                                }); 
                            }

                            edtSesion =  function(item)
                            {
                              casosService.edtSesion(item).then(
                                function (response)
                                {
                                  if(response.data.result=='OK')
                                  {
                                    toastr.success(response.data.msj);
                                    // getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                                    ngDialog.close($scope.dialogShowDatosSesion.id);
                                    //limpiarCaso();
                                    //getCasoCompleto(response.data.id);
                                  }
                                  else
                                  {
                                    toastr.error(response.data.msj);
                                  }                      
                                },
                                function (error) 
                                {
                                  toastr.error( error );
                                }); 
                            }

                            edtResultadoSesion =  function(item)
                            {
                              casosService.edtResultadoSesion(item).then(
                                function (response)
                                {
                                  if(response.data.result=='OK')
                                  {
                                    toastr.success(response.data.msj);
                                    if (($scope.sesion.CAMBIAR_ESTADO == $scope.CONSTANTES.REGISTRO_VERDADERO)&&
                                        ($scope.sesion.ID_RESULTADO_SESION != $scope.CONSTANTES.RS_SESION_PENDIENTE))
                                    {
                                      $scope.deshabilitar_datos_sesion = true;
                                      $scope.deshabilitar_opciones_sesion = true;
                                      $scope.caso.CIERRA_CASO = $scope.CONSTANTES.REGISTRO_VERDADERO;
                                      $scope.caso.ID_RESULTADO_SESION = $scope.sesion.ID_RESULTADO_SESION;
                                      $scope.imprimirActa($scope.sesion.ID_RESULTADO_SESION);
                                      toastr.success('Caso cerrado correctamente');
                                    }
                                    else
                                    {
                                      if (formulario == 'sesiones')
                                      {
                                        ngDialog.close($scope.dialogShowDatosSesion.id);  
                                      }
                                      else
                                      {
                                        $scope.deshabilitar_datos_sesion = true;
                                        $scope.deshabilitar_opciones_sesion = true;
                                        $scope.registro_sesion = false;
                                        $scope.caso.ID_RESULTADO_SESION = $scope.sesion.ID_RESULTADO_SESION;
                                        $scope.imprimirActaRevision();
                                      }
                                    }
                                    getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                                  }
                                  else
                                  {
                                    toastr.error(response.data.msj);
                                  }                      
                                },
                                function (error) 
                                {
                                  toastr.error( error );
                                }); 
                            }

                            viewSwalCerrarCaso = function(item)
                            {
                              $scope.dialogShowSwalCerrarCaso = ngDialog.open(
                              {
                                template: 'app/casos/casos.seguimiento.swalContainer.view.tpl.html',
                                showClose: false,
                                closeByEscape: false,
                                closeByNavigation: true,
                                preCloseCallback:function()
                                {
                                  // $scope.sesion = {};
                                  // getCasoCompleto($scope.caso.ID_EXPEDIENTE);
                                  // $scope.habilitar_datos_identificacion();
                                  // $scope.nuevo_sujeto = false;
                                },
                                className: 'ngdialog-theme-flat-custom',
                                // resolve:
                                // {
                                // },
                                scope:$scope,
                                controller: ['$scope',
                                function($scope) 
                                { 
                                  swal({                            
                                    title:'¿Cerrar caso?', 
                                    // html: ',',
                                    text: 'El caso se cerrará con estado '+$scope.sesion.RESULTADO_SESION,
                                    type: "warning",
                                    showCancelButton: true,
                                    confirmButtonClass: "btn-warning",
                                    confirmButtonText: "Continuar",
                                    cancelButtonClass: "btn-default",
                                    cancelButtonText: "Cancelar",
                                    closeOnConfirm: false,
                                    closeOnCancel: false
                                   }, 
                                    function(isConfirm){ 
                                    if (isConfirm) 
                                    {
                                      $scope.$apply();
                                      swal.close();
                                      ngDialog.close($scope.dialogShowSwalCerrarCaso.id);
                                      edtResultadoSesion(item);
                                    } 
                                    else 
                                    {
                                      $scope.$apply();
                                      swal.close();
                                      ngDialog.close($scope.dialogShowSwalCerrarCaso.id);
                                    }
                                  });
                                }]
                              })
                            }

                            viewValidarPin = function (item) {
                              $scope.dialogShowPin = ngDialog.open({
                                template: 'app/archivos.pin.view.tpl.html',
                                showClose: true,
                                className: "ngdialog-theme-flat-custom custom-width",
                                closeByEscape: true,
                                preCloseCallback:function()
                                {
                                  //archivosFirma();  
                                  //if ($scope.datosPin.pinValido == false)    
                                  //{
                                  //  limpiarDatosPin();
                                  //}
                                },
                                scope: $scope,
                                controller: ['$scope', 'authService', '$cryptoOJ', '$base64',
                                  function ($scope,  authService, $cryptoOJ, $base64) {
                                    firma = {};
                                    firmantes = {};
                                    
                                    //$scope.datosPin.USUARIO = $scope.loginData.USUARIO;
                                    //$scope.datosPin.TIPO_ARCHIVO = item.TIPO_ARCHIVO;
                                    console.log("item en viewValidarPin",item,$scope.datosPin);
                                    $scope.validarPin = function (isValid) 
                                    {
                                      if (isValid) 
                                      {
                                    
                                          $scope.datosPin.usuario = $scope.loginData.USUARIO;
                                    
                                          $scope.datosPin.sistema = appSettings.sistemaIdRRHH;
                                          $scope.datosPin.contrasenia = $base64.encode($scope.datosPin.PIN);
        
                                    
                                          $scope.datosPin.cadena = 'SIGMA=>Generar invitación: '
                                          + item.ID_ARCHIVO
                                          + '=>Fecha:' + moment(new Date()).format('DD/MM/YYYY HH:mm:ss')
                                          + '=>Usuario:'+ $scope.loginData.USUARIO;
                                    
                                        console.log('$scope.loginData',$scope.datosPin);
                                        authService.validarPin($scope.datosPin)
                                          .then(function (response) {
                                            console.log('response validar PIN',response);
                                            if (response.data.status == "OK") 
                                            {console.log("response pasa", response);
                                              $scope.datosPin.pinValido = true;  
                                              firmantes.FIRMA_INTERNA = response.data.data[0].contrasenia;
                                              console.log("response validar PIN",response);
                                              authService.usuarioInterno($scope.datosPin.usuario)
                                                .then(function (response) {
                                                  console.log("response usuarioInterno",response);
                                                  if ((response.data.TIENE_FIRMA == $scope.CONSTANTES.REGISTRO_VERDADERO)
                                                   &&(response.data.TIENE_RUBRICA == $scope.CONSTANTES.REGISTRO_VERDADERO))
                                                  {
                                                    $scope.datosPin.firmaInterna = true;

                                                    firmantes.CARNET = response.data.EMPLEADO_ID;  
                                                    firmantes.LLEVA_SELLO = "0";
                                                    firmantes.NOMBRE_CARGO = response.data.CARGO.toUpperCase();
                                                    firmantes.NOMBRE_DEPENDENCIA = $scope.loginData.CENTRO.DESPACHO.toUpperCase();
                                    
                                                    firmantes.NOMBRE_FIRMANTE = response.data.NOMBRE_COMPLETO.toUpperCase();
                                                    firmantes.PRIORIDAD = "1";
                                                    firmantes.PROFESION = $scope.loginData.CENTRO.PROFESION.toUpperCase();
                                                    firmantes.VISTO_BUENO = "0";
                                                    
                                                    firma.USUARIO = response.data.SAU_CUENTA;
                                                    firma.ID_DEPENDENCIA = response.data.DEPENDENCIA_ID;
                                                    firma.UBICACION = "";
                                                    firma.OBSERVACIONES = "";
                                                    firma.CODIGO = "";
                                                    
                                                    firma.ID_TIPO_DOCUMENTO = item.ID_TIPO_ARCHIVO;
                                                    
                                                    
                                                    firma.FIRMANTES = [];
                                                    firma.FIRMANTES.push(firmantes);
                                                    

                                                    insSesion(item,true,firma)
                                                    
                                                    ngDialog.close($scope.dialogShowPin.id);

                                                    //item.FIRMA = firma;
                                                    
                                                    /*
                                                    //se cierra el dialogo de verificacion de pin
                                                    
        
                                                    console.log(firma);
                                                    //se solicita la firma electronica
                                                    firmarArchivo(item);
                                                    
                                                    item.ID_ESTADO_ARCHIVO = $scope.CONSTANTES.ESTADO_ARCHIVO_FIRMADO;
                                                    */
                                                  }  
                                                  else
                                                  {
                                                    limpiarDatosPin();
                                                    toastr.warning("Usuario sin firma registrada");
                                                  }
                                                }
                                                , function (error) {
                                                  toastr.error(error);
                                                });
                                              
                                              
                                            } 
                                            else 
                                            {
                                              //$scope.datosPin.pinValido = false;
                                              toastr.error(response.data.message);
                                            }
        
                                          }, function (error) {
                                            toastr.error(error);
                                          });
                                      } 
                                      else 
                                      {
                                        toastr.warning("Faltan datos por ingresar");
                                      }
                                    }
        
                                  }]
                                  
                              });
                            }

                            $scope.guardarSesion = function(isValid)
                            {
                              // && $scope.LONGITUD_HOJA_EVOLUCION_SESION
                              if (isValid && $scope.sesion.PARTICIPANTES_SELECCIONADOS && 
                                 ($scope.sesion.CAMBIAR_ESTADO != "")&&($scope.sesion.SESION_AGENDADA))
                              {
                                if (edicion)
                                {console.log("edicion");
                                  $scope.sesion.ID_EXPEDIENTE = $scope.caso.ID_EXPEDIENTE;
                                  $scope.sesion.ID_ESTADO_EXPEDIENTE = $scope.caso.ID_ESTADO_EXPEDIENTE;
                                  $scope.sesion.ID_ESTADO_EXP = $scope.sesion.ID_RESULTADO_SESION;
                                  $scope.sesion.REGISTRO_VERDADERO = $scope.CONSTANTES.REGISTRO_VERDADERO;
                                  $scope.sesion.participantes = [];
                                  $scope.sesion.participanteseliminacion = [];
                                  for (var i=0; i < $scope.participantes.length; i++) 
                                  {
                                    if ($scope.participantes[i].isSelected)
                                    {
                                      $scope.sesion.participantes.push({ID_SUJETO_EXPEDIENTE:$scope.participantes[i].ID_SUJETO_EXPEDIENTE});
                                    }
                                    else if(($scope.participantes[i].ID_SUJETO_SESION != "") && 
                                            ($scope.participantes[i].ID_SUJETO_SESION != undefined))
                                    {
                                      $scope.sesion.participanteseliminacion.push({ID_SUJETO_EXPEDIENTE:$scope.participantes[i].ID_SUJETO_EXPEDIENTE,
                                                                                   ID_SUJETO_SESION:$scope.participantes[i].ID_SUJETO_SESION});
                                    }
                                  }
                                  // if (($scope.sesion.ID_RESULTADO_SESION == $scope.CONSTANTES.RS_INCOMPARECIENTE) &&
                                  
                                  if(($scope.sesion.CAMBIAR_ESTADO == $scope.CONSTANTES.REGISTRO_VERDADERO)&&
                                     ($scope.sesion.ID_RESULTADO_SESION != $scope.CONSTANTES.RS_SESION_PENDIENTE))
                                  {
                                    viewSwalCerrarCaso($scope.sesion);
                                  }
                                  else
                                  {
                                    edtResultadoSesion($scope.sesion);
                                  }
                                }
                                else if(reprogramacion)
                                {console.log("reprogramacion");
                                  $scope.sesion.ID_ESTADO_SESION = $scope.CONSTANTES.ESTADO_SESION_REAGENDADA;
                                  $scope.sesion.ID_TIPO_ARCHIVO = $scope.constantes.ARCHIVO_TIPO_INVITACION;
                                  edtSesion($scope.sesion);
                                }
                                else if (editar_solo_sesion)
                                {console.log("editar solo sesion");
                                  $scope.sesion.ID_TIPO_ARCHIVO = $scope.constantes.ARCHIVO_TIPO_INVITACION;
                                  edtSesion($scope.sesion);
                                }
                                else
                                {console.log("else?");
                                    $scope.sesion.ID_EXPEDIENTE = $scope.caso.ID_EXPEDIENTE;
                                    if (formulario == 'sesiones')
                                    {
                                      $scope.sesion.ID_TIPO_SESION = $scope.CONSTANTES.TIPO_SESION_MEDIACION;
                                      $scope.sesion.NUMERO_SESION = $scope.sesiones.length+1;  
                                    }
                                    else if (formulario == 'revisiones')
                                    {
                                      $scope.sesion.ID_TIPO_SESION = $scope.CONSTANTES.TIPO_SESION_REVISION;
                                      $scope.sesion.NUMERO_SESION = $scope.revisiones.length+1;
                                    }
                                    $scope.sesion.ID_TIPO_ARCHIVO = $scope.constantes.ARCHIVO_TIPO_INVITACION;
                                    $scope.sesion.ID_ESTADO_ARCHIVO = $scope.constantes.ESTADO_ARCHIVO_SOLICITUD;
                                    $scope.sesion.ID_ARCHIVO_PADRE = "0";
                                    $scope.sesion.ARCHIVO = "";
                                    $scope.sesion.RUTA = "";
                                    $scope.sesion.DATO_COMPLEMENTARIO = "";
                                    if ($scope.loginData.CENTRO.FIRMA_DOCUMENTO == $scope.CONSTANTES.USUARIO_CON_FIRMA)
                                    {
                                      //item.ID_ARCHIVO_PADRE = item.ID_ARCHIVO;
                                      $scope.datosPin = {};
                                      //$scope.datosPin.pinValido = false;
                                      $scope.datosPin.firmaInterna = false;
                                      viewValidarPin($scope.sesion);
                                    }
                                    else
                                    {
                                      insSesion($scope.sesion,false,null);
                                    }
                                }
                              }
                              else
                              {
                                toastr.warning("Faltan datos por ingresar");
                              }
                              
                            }
                          }]
                        })
                      }
                      //valida que los datos de participantes esten completos
                      verificaParticipantes = function(valor,arreglo)
                      {
                        for (var i=0; i < arreglo.length; i++) 
                        {
                          if (arreglo[i].REGISTRO_COMPLETO === valor) 
                          {
                              return true;
                          }
                        }
                        return false;
                      }
                      $scope.editarSesion = function(item,formulario)
                      {
                        item.ID_MEDIADOR_RECEPTOR_INICIAL = item.ID_MEDIADOR_RECEPTOR;
                        item.RUTA = "";
                        item.ARCHIVO = "";
                        item.ID_TIPO_ARCHIVO = $scope.CONSTANTES.ARCHIVO_TIPO_INVITACION;
                        item.ID_ARCHIVO_PADRE = "0";
                        //item.ID_ESTADO_ARCHIVO = $scope.CONSTANTES.ESTADO_ARCHIVO_SOLICITUD;
                        item.USUARIO_CON_FIRMA = $scope.CONSTANTES.USUARIO_CON_FIRMA;
                        console.log("item",item);
                        agregar_sesion = false;
                        reprogramacion = false;
                        editar_solo_sesion = false;
                        // $scope.mostrar_boton_acta = false;
                        $scope.mostrar_boton_imprimir = false;
                        $scope.mostrar_boton_imprimir_revision = false;
                        $scope.caso.ID_RESULTADO_SESION = item.ID_RESULTADO_SESION;
                        if ((item.SESION_EDITABLE == $scope.CONSTANTES.REGISTRO_VERDADERO) && (item.SESION_EDITABLE_DIA == $scope.CONSTANTES.REGISTRO_VERDADERO))
                        {
                          // registroIncompleto = verificaParticipantes($scope.CONSTANTES.REGISTRO_FALSO,$scope.solicitantes)
                          // if (registroIncompleto)
                          // {
                          //   toastr.warning('Faltan datos por ingresar en solicitantes, por favor verifique');
                          //   item.isSelected = false;
                          //   // $location.hash('solicitantes');
                          //   $scope.scrollToElement('solicitantes');
                          // }
                          // else
                          // {
                            // registroIncompleto = verificaParticipantes($scope.CONSTANTES.REGISTRO_FALSO,$scope.invitados)
                            // if (registroIncompleto)
                            // {
                            //   toastr.warning('Faltan datos por ingresar en invitados, por favor verifique');
                            //   item.isSelected = false;
                            //   // $location.hash('invitados');
                            //   $scope.scrollToElement('invitados');
                            // }
                            // else
                            // {
                              if (item.isSelected)
                              {
                                $scope.sesion = {};
                                angular.extend($scope.sesion,item);
                                // $scope.LONGITUD_HOJA_EVOLUCION_SESION = true;
                                if (($scope.sesion.ID_ESTADO_SESION == $scope.CONSTANTES.ESTADO_SESION_AGENDADA) ||
                                    ($scope.sesion.ID_ESTADO_SESION == $scope.CONSTANTES.ESTADO_SESION_REAGENDADA))
                                {
                                  $scope.sesion.ID_ESTADO_SESION = "";
                                }
                                if (($scope.sesion.ID_RESULTADO_SESION != "") && ($scope.sesion.ID_RESULTADO_SESION == $scope.CONSTANTES.RS_INCOMPARECIENTE))
                                {
                                  $scope.sesion.RESULTADO_INCOMPARECIENTE = true;
                                }
                                $scope.sesion.ESTADO_CASO = $scope.caso.ESTADO_CASO;
                                if (formulario == 'sesiones')
                                {
                                  $scope.sesion.ID_TIPO_SESION = $scope.CONSTANTES.TIPO_SESION_MEDIACION;
                                  $scope.registro_sesion = true;
                                  $scope.mostrar_boton_imprimir = true;
                                }
                                else if (formulario == 'revisiones')
                                {
                                  $scope.sesion.ID_TIPO_SESION = $scope.CONSTANTES.TIPO_SESION_REVISION;
                                  $scope.registro_sesion = false;
                                  $scope.mostrar_boton_imprimir_revision = true;
                                }
                                viewDatosSesion(true,formulario);
                              }
                              else
                              {
                                $scope.sesion = {};
                              }
                            // }
                          // }
                          $scope.descripcion_participantes = "Participantes";
                        }
                        else if (item.SESION_EDITABLE_DIA == $scope.CONSTANTES.REGISTRO_VERDADERO)
                        {
                          if (item.isSelected)
                              {
                                $scope.sesion = {};
                                angular.extend($scope.sesion,item);
                                // $scope.LONGITUD_HOJA_EVOLUCION_SESION = true;
                                editar_solo_sesion = true;
                                $scope.sesion.ESTADO_CASO = $scope.caso.ESTADO_CASO;
                                if (formulario == 'sesiones')
                                {
                                  $scope.sesion.ID_TIPO_SESION = $scope.CONSTANTES.TIPO_SESION_MEDIACION;
                                  $scope.registro_sesion = true;
                                  $scope.mostrar_boton_imprimir = true;
                                }
                                else if (formulario == 'revisiones')
                                {
                                  $scope.sesion.ID_TIPO_SESION = $scope.CONSTANTES.TIPO_SESION_REVISION;
                                  $scope.registro_sesion = false;
                                  $scope.mostrar_boton_imprimir_revision = true;
                                }
                                viewDatosSesion(true,formulario);
                              }
                              else
                              {
                                $scope.sesion = {};
                              }
                        }
                        else
                        {
                          if (item.isSelected)
                              {
                                $scope.sesion = {};
                                angular.extend($scope.sesion,item);
                                // $scope.LONGITUD_HOJA_EVOLUCION_SESION = true;
                                if (($scope.sesion.ID_ESTADO_SESION == $scope.CONSTANTES.ESTADO_SESION_AGENDADA) ||
                                    ($scope.sesion.ID_ESTADO_SESION == $scope.CONSTANTES.ESTADO_SESION_REAGENDADA))
                                {
                                  $scope.sesion.ID_ESTADO_SESION = "";
                                }
                                if (($scope.sesion.ID_RESULTADO_SESION != "") && ($scope.sesion.ID_RESULTADO_SESION == $scope.CONSTANTES.RS_INCOMPARECIENTE))
                                {
                                  $scope.sesion.RESULTADO_INCOMPARECIENTE = true;
                                }
                                $scope.sesion.ESTADO_CASO = $scope.caso.ESTADO_CASO;
                                if (formulario == 'sesiones')
                                {
                                  $scope.sesion.ID_TIPO_SESION = $scope.CONSTANTES.TIPO_SESION_MEDIACION;
                                  $scope.registro_sesion = true;
                                  $scope.mostrar_boton_imprimir = true;
                                }
                                else if (formulario == 'revisiones')
                                {
                                  $scope.sesion.ID_TIPO_SESION = $scope.CONSTANTES.TIPO_SESION_REVISION;
                                  $scope.registro_sesion = false;
                                  $scope.mostrar_boton_imprimir_revision = true;
                                }
                                viewDatosSesion(true,formulario);
                              }
                              else
                              {
                                $scope.sesion = {};
                              }
                          // if (formulario == 'sesiones')
                          // {
                          //   etiqueta_sesion = 'Sesión';  
                          // }
                          // else if (formulario == 'revisiones')
                          // {
                          //   etiqueta_sesion = 'Revisión';  
                          // }
                          // toastr.warning(etiqueta_sesion+" agendada para el día "+item.FECHA_LARGA_HORA_SESION.toLowerCase()+", aún no se permiten realizar cambios");
                          // item.isSelected = false;
                          
                        }
                        // item.isSelected = false;
                      }

                      $scope.agregarSesion = function(formulario)
                      {
                        reprogramacion = false;
                        editar_solo_sesion = false;
                        agregar_sesion = true;
                        $scope.sesion = {}
                        $scope.sesion.FIRMA_DOCUMENTO = $scope.loginData.CENTRO.FIRMA_DOCUMENTO;
                        $scope.sesion.FIRMA_USUARIO_INACTIVA = $scope.CONSTANTES.FIRMA_USUARIO_INACTIVA;
                        $scope.sesion.INVITACION_PARA_FIRMA = "0";
                        $scope.mostrar_boton_imprimir = false;
                        $scope.mostrar_boton_imprimir_revision = false;
                        $scope.sesion.ESTADO_CASO = $scope.caso.ESTADO_CASO;
                        if (formulario == 'sesiones')
                        {
                          $scope.sesion.ID_TIPO_SESION = $scope.CONSTANTES.TIPO_SESION_MEDIACION;
                          $scope.registro_sesion = true;
                        }
                        else if (formulario == 'revisiones')
                        {
                          $scope.sesion.ID_TIPO_SESION = $scope.CONSTANTES.TIPO_SESION_REVISION;
                          $scope.registro_sesion = false;
                          // $scope.LONGITUD_HOJA_EVOLUCION_SESION = true;
                          $scope.caso.CIERRA_CASO = $scope.CONSTANTES.REGISTRO_FALSO;
                          $scope.caso.ID_RESULTADO_SESION = 0;
                        }
                        viewDatosSesion(false,formulario);
                      }

                      

                      viewDatosHomologacion = function(edicion)
                      {
                        $scope.dialogShowDatosHomologacion = ngDialog.open(
                        {
                          template: 'app/casos/casos.seguimiento.datosHomologacion.view.tpl.html',
                          showClose: true,
                          closeByEscape: true,
                          closeByNavigation: true,
                          preCloseCallback:function()
                          {
                            $scope.homologacion = {};
                            // editar_solo_sesion = false;
                            getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                            // $scope.habilitar_datos_identificacion();
                            // $scope.nuevo_sujeto = false;
                          },
                          className: 'ngdialog-theme-flat-custom',
                          resolve:
                          {
                            dataDepartamentos: ['parametrizacionService',
                            function( parametrizacionService){
                            return parametrizacionService.getDepartamentos();
                            }],
                            dataDocumentosHomologacion: ['casosService',
                            function( casosService){
                            return casosService.getDocumentosHomologacion();
                            }]
                          },
                          scope:$scope,
                          controller: ['$scope', 'casosService', 'parametrizacionService', 'dataDepartamentos',
                                       'dataDocumentosHomologacion',
                          function($scope, casosService, parametrizacionService, dataDepartamentos,
                                       dataDocumentosHomologacion) 
                          { 
                            $scope.dataDepartamentos = {};
                            $scope.dataDepartamentos = dataDepartamentos.data;

                            $scope.dataDocumentosHomologacion = {};
                            $scope.dataDocumentosHomologacion = dataDocumentosHomologacion.data;
                            
                            $scope.tiempo_focus="500";

                            $scope.selectedDepartamento = function () 
                            {
                              if($scope.homologacion.ID_DEPARTAMENTO>0)
                              {
                                if (!$scope.editarTemp)
                                {
                                  $scope.homologacion.ID_DESPACHO=null;
                                  $scope.homologacion.ID_MUNICIPIO=null;
                                }
                                parametrizacionService.getMunicipios($scope.homologacion.ID_DEPARTAMENTO,-1).then(
                                  function ( response ) 
                                  {
                                    $scope.dataMunicipios = {};
                                    $scope.dataMunicipios = response.data;
                                  }, 
                                  function ( error ) 
                                  {
                                    toastr.error( error );
                                  });
                              }
                            }

                            $scope.selectedMunicipio = function () 
                            {
                              if($scope.homologacion.ID_MUNICIPIO>0)
                              {
                                if ($scope.editarTemp)
                                {
                                  $scope.editarTemp=false;
                                }
                                else
                                {
                                  $scope.homologacion.ID_DESPACHO=null;
                                }
                                parametrizacionService.getDespachos($scope.homologacion.ID_DEPARTAMENTO,$scope.homologacion.ID_MUNICIPIO,0).then( 
                                  function ( response ) 
                                  {   
                                    $scope.dataDespachos = {};
                                    $scope.dataDespachos = response.data;
                                  }, 
                                  function ( error ) 
                                  {
                                    toastr.error( error );
                                  });
                              }
                            }


                            getUbicacionCentro = function (p_id_despacho) 
                            {
                              casosService.getUbicacionCentro(p_id_despacho).then( 
                                function ( response ) 
                                {                   
                                  $scope.homologacion.ID_DEPARTAMENTO = response.data[0].ID_DEPARTAMENTO;
                                  $scope.selectedDepartamento();
                                  $scope.homologacion.ID_MUNICIPIO = response.data[0].ID_MUNICIPIO;
                                  $scope.selectedMunicipio();
                                }, 
                                function ( error ) 
                                {
                                  toastr.error( error );
                                });
                            }
                            
                            $scope.focus_homologacion = false;
                            if (edicion)
                            {
                              $scope.tooltip_boton_guardar_homologacion ="Guardar cambios";
                              $scope.editarTemp=true;
                              $scope.focus_despachos = false;
                              $scope.selectedDepartamento();
                              $scope.selectedMunicipio();
                              if ($scope.homologacion.HOMOLOGACION_PENDIENTE == $scope.CONSTANTES.REGISTRO_VERDADERO)
                              {
                                $scope.focus_homologacion = true;
                              }
                            }
                            else
                            {
                              $scope.tooltip_boton_guardar_homologacion ="Guardar homologación";
                              $scope.focus_despachos = true;
                              getUbicacionCentro($scope.expedienteGlobal.ID_DESPACHO);
                            }
                            
                            insHomologacion =  function(item)
                            {
                              casosService.insHomologacion(item).then(
                                function (response)
                                {
                                  if(response.data.result=='OK')
                                  {
                                    toastr.success(response.data.msj);
                                    // getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                                    $scope.mostrar_boton_solicitud_homologacion = true;
                                    $scope.imprimirSolicitudHomologacion();
                                    ngDialog.close($scope.dialogShowDatosHomologacion.id);
                                  }
                                  else
                                  {
                                    toastr.error(response.data.msj);
                                  }                      
                                },
                                function (error) 
                                {
                                  toastr.error( error );
                                }); 
                            }

                            edtHomologacion =  function(item)
                            {
                              casosService.edtHomologacion(item).then(
                                function (response)
                                {
                                  if(response.data.result=='OK')
                                  {
                                    toastr.success(response.data.msj);
                                    // getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                                    ngDialog.close($scope.dialogShowDatosHomologacion.id);
                                  }
                                  else
                                  {
                                    toastr.error(response.data.msj);
                                  }                      
                                },
                                function (error) 
                                {
                                  toastr.error( error );
                                }); 
                            }

                            buscarDocumentoHomologacion = function(valor, arreglo){
                              for (var i=0; i < arreglo.length; i++) 
                              {
                                if (arreglo[i].ID_DOCUMENTO_HOMOLOGACION === valor) 
                                {
                                  return true;
                                }
                              }
                            }

                            $scope.guardarHomologacion = function(isValid)
                            {
                              if (isValid)
                              {
                                if (edicion)
                                {
                                  $scope.homologacion.ID_EXPEDIENTE = $scope.caso.ID_EXPEDIENTE;
                                  $scope.homologacion.ENVIO_ACUERDO = fechaFormatoYYYYMMDD($scope.homologacion.ENVIO_ACUERDO)+ ' 00:00:00.0';
                                  if (($scope.homologacion.HOMOLOGACION != "") && 
                                      ($scope.homologacion.HOMOLOGACION != undefined)&&
                                      ($scope.homologacion.HOMOLOGACION != null))
                                  {
                                    $scope.homologacion.HOMOLOGACION = fechaFormatoYYYYMMDD($scope.homologacion.HOMOLOGACION)+ ' 00:00:00.0';
                                  }

                                  $scope.homologacion.documentos = [];
                                  $scope.homologacion.documentoseliminacion = [];
                                  for (var i=0; i < $scope.homologacion.DOCUMENTOSADJUNTOS.length; i++) 
                                  {
                                    $scope.homologacion.documentos.push({ID_DOCUMENTO_HOMOLOGACION:$scope.homologacion.DOCUMENTOSADJUNTOS[i]});
                                  }
                                  for (var i=0; i < $scope.homologacion.docs_adjuntos_homologacion.length; i++) 
                                  { 
                                    if (buscarDocumentoHomologacion($scope.homologacion.docs_adjuntos_homologacion[i].ID_DOCUMENTO_HOMOLOGACION, $scope.homologacion.documentos) == undefined)
                                    {
                                      $scope.homologacion.documentoseliminacion.push({ID_HOMOLOGACION_DOCUMENTO:$scope.homologacion.docs_adjuntos_homologacion[i].ID_HOMOLOGACION_DOCUMENTO});
                                    }
                                  }
                                  edtHomologacion($scope.homologacion);
                                }
                                else
                                {
                                  $scope.homologacion.ID_EXPEDIENTE = $scope.caso.ID_EXPEDIENTE;
                                  $scope.homologacion.ENVIO_ACUERDO = fechaFormatoYYYYMMDD($scope.homologacion.ENVIO_ACUERDO)+ ' 00:00:00.0';
                                  if (($scope.homologacion.HOMOLOGACION != "") && 
                                      ($scope.homologacion.HOMOLOGACION != undefined)&&
                                      ($scope.homologacion.HOMOLOGACION != null))
                                  {
                                    $scope.homologacion.HOMOLOGACION = fechaFormatoYYYYMMDD($scope.homologacion.HOMOLOGACION)+ ' 00:00:00.0';
                                  }
                                  
                                  $scope.homologacion.documentos = [];
                                  for (var i=0; i < $scope.homologacion.DOCUMENTOSADJUNTOS.length; i++) 
                                  {
                                    $scope.homologacion.documentos.push({ID_DOCUMENTO_HOMOLOGACION:$scope.homologacion.DOCUMENTOSADJUNTOS[i]});
                                    
                                  }
                                  insHomologacion($scope.homologacion);
                                }
                              }
                              else
                              {
                                toastr.warning("Faltan datos por ingresar");
                              }
                            }
                          }]
                        })
                      }


                      $scope.editarHomologacion = function(item)
                      {
                        if (item.isSelected)
                          {
                            $scope.homologacion = {};
                            angular.extend($scope.homologacion,item);
                            $scope.homologacion.DOCUMENTOSADJUNTOS = [];
                            for (var i=0; i < $scope.homologacion.docs_adjuntos_homologacion.length; i++) 
                            {
                              $scope.homologacion.DOCUMENTOSADJUNTOS.push($scope.homologacion.docs_adjuntos_homologacion[i].ID_DOCUMENTO_HOMOLOGACION);
                            }
                            viewDatosHomologacion(true);
                          }
                          else
                          {
                            $scope.homologacion = {};
                          }
                      }
                      
                      $scope.agregarHomologacion = function()
                      {
                        $scope.homologacion = {};
                        viewDatosHomologacion(false);
                      }



                      // console.log($scope.expedienteGlobal);
                      
                      /*$scope.expedienteGlobal.ID_EXPEDIENTE = "1400";
                      $scope.expedienteGlobal.rutaEstado = "index.casos.seguimiento";
                      $scope.expedienteGlobal.tooltipEstado = "Volver a casos";
                      $scope.expedienteGlobal.ID_DESPACHO = "100068";
                      $scope.expedienteGlobal.soloConsulta = false;*/

                      // $scope.expedienteGlobal.ID_REGISTRADOR ="-2";
                      // $scope.expedienteGlobal.NOMBRE_REGISTRADOR ="-2";
                      // $scope.expedienteGlobal.ID_MEDIADOR_RECEPTOR ="50769";
                      // $scope.expedienteGlobal.NOMBRE_RECEPTOR ="50769";
                      // $scope.expedienteGlobal.ID_MEDIADOR ="";
                      // $scope.expedienteGlobal.NOMBRE_MEDIADOR ="";
                      

                      if ($scope.expedienteGlobal.ID_EXPEDIENTE != undefined)
                      {
                        getCasoCompleto($scope.expedienteGlobal.ID_EXPEDIENTE);
                      }
                      else
                      {
                        $state.go('index.home', {});
                      }
                      $scope.volverEstado = function()
                      {
                        $state.go($scope.expedienteGlobal.rutaEstado, {});
                      }


                    }]
                  }
            }
        })

        .state( 'index.casos.registro', 
        {
          url: '/registro',
          views: 
            {
              '': 
                  {
                    templateUrl: 'app/casos/casos.registro.tpl.html',
                    resolve: 
                    {
                      /*dataTipoProcedencia: ['casosService',
                      function(casosService)
                      {
                      return casosService.getTipoProcedencia();
                      }],*/
                      dataTipoSujeto: ['casosService',
                      function(casosService)
                      {
                      return casosService.getTipoSujeto();
                      }],
                      dataPrioridadSujeto: ['casosService',
                      function(casosService)
                      {
                      return casosService.getPrioridadSujeto();
                      }],
                      dataGenero: ['casosService',
                      function(casosService)
                      {
                      return casosService.getGenero();
                      }],
                      // dataEstadoCivil: ['casosService',
                      // function(casosService)
                      // {
                      // return casosService.getEstadoCivil();
                      // }],
                      dataNivelEducativo: ['casosService',
                      function(casosService)
                      {
                      return casosService.getNivelEducativo();
                      }],
                      // dataProfesion: ['casosService',
                      // function(casosService)
                      // {
                      // return casosService.getProfesion();
                      // }],
                      dataTipoContacto: ['casosService',
                      function(casosService)
                      {
                        return casosService.getTipoContacto();
                      }],
                      dataDiscapacidad: ['casosService',
                      function(casosService)
                      {
                        return casosService.getDiscapacidad();
                      }]
                    },
                    controller: ['$scope', '$state', 'toastr', 'casosService', 'authService', 'dataTipoSujeto', 
                                 'dataPrioridadSujeto', 'dataGenero', 'ngDialog', 'dataNivelEducativo', 'dataTipoContacto', 
                                 '$filter', 'calendarConfig', 'utilsService', 'dataDiscapacidad', '$base64',
                    function (  $scope,   $state,   toastr, casosService, authService, dataTipoSujeto, 
                                dataPrioridadSujeto, dataGenero, ngDialog, dataNivelEducativo, dataTipoContacto, 
                                $filter, calendarConfig, utilsService, dataDiscapacidad, $base64) 
                    {
                      //se recuperan los valores del centro seleccionado o precargado al iniciar sesion
                      CENTRO = authService.getLocalData('CENTRO');
                      //funciones formulario sesion
                      fechaFormatoYYYYMMDD = function (date)
                      {
                        if (date != undefined)
                        {
                          d = new Date(date);
                          month = '' + (d.getMonth() + 1);
                          day = '' + d.getDate();
                          year = d.getFullYear();
                          if (month.length < 2) month = '0' + month;
                          if (day.length < 2) day = '0' + day;
                          return [year, month, day].join('-');
                        }
                        else
                        return "";
                      }
                      //se obtiene la ubicacion del centro 
                      getUbicacionCentro = function (p_id_despacho) 
                      {
                        casosService.getUbicacionCentro(p_id_despacho).then( 
                          function ( response ) 
                          {              
                            $scope.ubicacionCentro = {};     
                            $scope.ubicacionCentro.ID_DEPARTAMENTO = response.data[0].ID_DEPARTAMENTO;
                            $scope.ubicacionCentro.ID_MUNICIPIO = response.data[0].ID_MUNICIPIO;
                          }, 
                          function ( error ) 
                          {
                            toastr.error( error );
                          });
                      }
                      getUbicacionCentro(CENTRO.ID_DESPACHO);

                      //etiqueta asunto inicia oculta
                      $scope.etiqueta_asunto = false;
                      $scope.etiqueta_estado = true;
                      //numero de columnas que se muestran segun los items
                      numerocolumnasbase = 12;
                      divisioncolumnasitems = function(items)
                      {
                        $scope.numerocolumnas = numerocolumnasbase/items;
                      }
                      divisioncolumnasitems(1);
                      //se inicializa deshabilitado el boton para ver formulario solicitante
                      $scope.ir_solicitante = true;
                      //items timeline
                      $scope.item_caso = true;
                      $scope.item_caso_no_mediable = false;
                      $scope.item_solicitante = false;
                      $scope.item_invitado = false;
                      $scope.item_sesion = false;
                      $scope.item_homologacion = false;
                      $scope.item_seguimiento = false;
                      //tooltip items timeline
                      $scope.tooltip_item_caso = false;
                      $scope.tooltip_item_solicitante = false;
                      $scope.tooltip_item_invitado = false;
                      $scope.tooltip_item_sesion = false;
                      $scope.tooltip_item_homologacion = false;
                      $scope.tooltip_item_seguimiento = false;
                      //items deshabilitados
                      $scope.deshabilitar_item_solicitante = true;
                      $scope.deshabilitar_item_invitado = true;
                      $scope.deshabilitar_item_sesion = true;
                      $scope.deshabilitar_item_homologacion = true;
                      $scope.deshabilitar_item_seguimiento = true;
                      //edicion de datos deshabilitada
                      $scope.deshabilitar_datos_caso = false;
                      $scope.deshabilitar_datos_solicitante = false;
                      $scope.deshabilitar_datos_invitado = false;
                      $scope.deshabilitar_datos_sesion = false;
                      $scope.deshabilitar_datos_homologacion = false;
                      $scope.deshabilitar_datos_revision= false;
                      //formulario activo
                      $scope.formulario_caso = true;
                      $scope.formulario_solicitante = false;
                      $scope.formulario_invitado = false;
                      $scope.formulario_sesion = false;
                      $scope.formulario_homologacion = false;
                      $scope.formulario_seguimiento = false;
                      //formularios completos
                      // $scope.formulario_caso_completo = false;
                      // $scope.formulario_solicitante_completo = false;
                      // $scope.formulario_invitado_completo = false;
                      // $scope.formulario_sesion_completo = false;
                      // $scope.formulario_homologacion_completo = false;
                      // $scope.formulario_seguimiento_completo = false;
                      //efectos form
                      entrada_izquiera = "animated fadeInLeftBig";  
                      entrada_derecha = "animated fadeInRightBig";
                      $scope.animacion_formulario_caso="";
                      $scope.animacion_formulario_solicitante=entrada_derecha;
                      $scope.animacion_formulario_invitado=entrada_derecha;
                      $scope.animacion_formulario_sesion=entrada_derecha;
                      $scope.animacion_formulario_homologacion=entrada_derecha;
                      $scope.animacion_formulario_seguimiento=entrada_derecha;
                      //tiempo focus
                      $scope.tiempo_focus="500";
                      //deshabilitar boton guardado
                      $scope.deshabilitar_boton_guardar_caso_no_mediable = true;
                      $scope.deshabilitar_boton_guardar_caso_mediable = true;
                      //deshabilitar_boton_imprimir_invitacion
                      $scope.deshabilitar_imprimir_invitacion = true;
                      //se inicializa la bandera que indica si el contacto es de un representante o un sujeto
                      $scope.formularioRepresentante = false;
                      //campos requeridos formularios solicitante, invitado y representante
                      $scope.campo_requerido = true;
                      $scope.campo_requerido_solicitante = true;
                      $scope.campo_requerido_invitado = false;
                      $scope.campo_identificacion_requerido = true;
                      //longitud minima para la caja de direccion
                      longitud_minima_caja_contacto = 15;
                      //variable indicativa para limpiar desde la presentacion los combos
                      $scope.limpiar_combo = true;
                      //funciones comunes
                      tooltipItems = function(formulario)
                      {
                        $scope.tooltip_item_caso = false;
                        $scope.tooltip_item_solicitante = false;
                        $scope.tooltip_item_invitado = false;
                        $scope.tooltip_item_sesion = false;
                        $scope.tooltip_item_homologacion = false;
                        $scope.tooltip_item_seguimiento = false;
                        if ((($scope.item_caso == true)||($scope.item_caso_no_mediable == true)) && (formulario !="formulario_caso"))  
                        {
                          $scope.tooltip_item_caso = true;
                        }
                        if (($scope.item_solicitante == true) && (formulario != "formulario_solicitante"))
                        {
                          $scope.tooltip_item_solicitante = true;
                        }
                        if (($scope.item_invitado == true) && (formulario != "formulario_invitado"))
                        {
                          $scope.tooltip_item_invitado = true;
                        }
                        if (($scope.item_sesion == true) && (formulario != "formulario_sesion"))
                        {
                          $scope.tooltip_item_sesion = true;
                        }
                        if (($scope.item_homologacion == true) && (formulario != "formulario_homologacion"))
                        {
                          $scope.tooltip_item_homologacion = true;
                        }
                        if (($scope.item_seguimiento == true) && (formulario != "formulario_seguimiento"))
                        {
                          $scope.tooltip_item_seguimiento = true;
                        }
                      }
                      formulariocompleto = function ()
                      {
                        validaSujetos();
                        $scope.deshabilitar_item_solicitante = true;
                        $scope.deshabilitar_item_invitado = true;
                        $scope.deshabilitar_item_sesion = true;
                        $scope.deshabilitar_item_homologacion = true;
                        $scope.deshabilitar_item_seguimiento = true;
                        if ($scope.SOLICITANTES_AGREGADOS)
                        {
                          $scope.deshabilitar_item_solicitante = false;
                        }
                        if ($scope.INVITADOS_AGREGADOS)
                        {
                          $scope.deshabilitar_item_invitado = false;
                        }
                        if ($scope.sesion.SESION_AGENDADA == true)
                        {
                          $scope.deshabilitar_item_sesion = false;
                        }
                        if ($scope.formulario_homologacion_completo == true)
                        {
                          $scope.deshabilitar_item_homologacion = false;
                        }
                        if ($scope.formulario_seguimiento_completo == true)
                        {
                          $scope.deshabilitar_item_seguimiento = false;
                        }
                      }
/*formulario caso*/                      
                      //se inicializa el arreglo de las materias segun centro
                      casosService.getMateriaDespacho(CENTRO.ID_DESPACHO).then(
                        function ( response ) 
                        {
                          $scope.materiasDespacho = [];
                          $scope.materiasDespacho = response.data;
                        },
                        function ( error ) 
                        {
                            toastr.error( error );
                        });
                      
                      //se inicializa el arreglo de los tipos de procedencias
                      // $scope.tipoProcedencias = [];
                      // $scope.tipoProcedencias = dataTipoProcedencia.data;

                      //se inicializa el arreglo de las materias segun centro
                      getTipoProcedencia = function(p_id_materia)
                      {
                        casosService.getTipoProcedencia(p_id_materia).then(
                          function ( response ) 
                          {
                            $scope.tipoProcedencias = [];
                            $scope.tipoProcedencias = response.data;
                            // console.log('registro');
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                      }

                      $scope.nuevoCaso = function () {
                        //$state.go($state.current, {}, {reload: true});
                        $state.reload();
                      };
                      //se limpian los arreglos de caso, solicitantes, invitados y sesion
                      limpiarCaso = function()
                      {
                        //se inicializan variables y arreglos del caso
                        //color form caso
                        $scope.color_formulario_caso = "box-gray";
                        $scope.color_item_caso = "bg-gray";
                        //opciones inician ocultas
                        $scope.mostrar_expediente = false;
                        //enfoque del expediente
                        $scope.focus_expediente = false;
                        //se inicializan las variables para deshabilitar los formularios
                        $scope.deshabilitar_nuevo_caso = true;
                        $scope.deshabilitar_datos_caso = false;
                        $scope.deshabilitar_datos_solicitante = false;
                        //se declara el arreglo para datos del caso
                        $scope.caso = {};
                        //etiqueta encabezado caso
                        $scope.caso.ENCABEZADO_CASO = "NUEVO CASO";
                        //se inicializa el id, estado y asunto del caso
                        $scope.caso.ID_ESTADO_EXP = $scope.CONSTANTES.ID_ESTADO_INICIAL_CASO;
                        $scope.caso.ESTADO_CASO = $scope.CONSTANTES.ESTADO_INICIAL_CASO;
                        $scope.caso.ASUNTO_CASO = "";
                        $scope.caso.ASUNTO_NO_MEDIABLE_CASO = "";
                        //se inicializan las variables con el id y codigo del centro que tendra asignado el caso
                        $scope.caso.ID_DESPACHO = CENTRO.ID_DESPACHO;
                        $scope.caso.CODIGO_CENTRO = CENTRO.CODIGO_DESPACHO;
                        //se asignan indicadores segun constantes para tipo de identificacion dpi, perfiles, tipos de sujetos y contacto direccion
                        $scope.caso.IDENTIFICACION_DPI = $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI;
                        $scope.caso.PERFIL_SUJETO_SOLICITANTE = $scope.CONSTANTES.PERFIL_SUJETO_SOLICITANTE;
                        $scope.caso.PERFIL_SUJETO_INVITADO = $scope.CONSTANTES.PERFIL_SUJETO_INVITADO;
                        $scope.caso.TIPO_SUJETO_NATURAL = $scope.CONSTANTES.TIPO_SUJETO_NATURAL;
                        $scope.caso.TIPO_SUJETO_JURIDICO = $scope.CONSTANTES.TIPO_SUJETO_JURIDICO;
                        $scope.caso.TIPO_CONTACTO_DIRECCION = $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION;
                        $scope.caso.ASUNTO_MEDIABLE = $scope.CONSTANTES.ASUNTO_MEDIABLE;
                        $scope.caso.ASUNTO_NO_MEDIABLE = $scope.CONSTANTES.ASUNTO_NO_MEDIABLE;
                        //se obtiene la fecha actual para desplegarla en los formularios
                        $scope.caso.FECHA_REGISTRO = new Date();
                        //se declara el arreglo para contener los solicitantes del caso
                        $scope.solicitantes = [];
                        $scope.solicitantes.seleccion = [];
                        //se declara el arreglo para contener los solicitantes del caso
                        $scope.invitados = [];
                        $scope.invitados.seleccion = [];
                        //se declara el arreglo para contener los solicitantes del caso
                        $scope.representantes = [];
                        $scope.representantes.seleccion = [];
                        $scope.representantes.eliminacion = [];
                        //se declara el arreglo para contener las sesiones del caso
                        $scope.sesiones = [];
                        $scope.sesiones.seleccion = [];
                        $scope.sesion = {};
                        $scope.sesion.ID_TIPO_SESION = $scope.CONSTANTES.TIPO_SESION_MEDIACION;
                        //se inicializan variables y arreglos del sujeto
                        //se declara el arreglo para datos del sujeto
                        $scope.solicitante = [];
                        $scope.solicitante.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                        $scope.invitado = [];
                        $scope.invitado.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                        //se declara el arreglo para datos del representante
                        $scope.representante = {};
                        $scope.representante.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                        //seccion apellido casada inicia oculta
                        $scope.solicitante.SEXO_MUJER = false;
                        $scope.invitado.SEXO_MUJER = false;
                        $scope.representante.SEXO_MUJER = false;
                        //se inicializan los verificadores de direcciones en falso
                        $scope.solicitante.DIRECCION = false;
                        $scope.invitado.DIRECCION = false;
                        $scope.representante.DIRECCION = false;
                        //arreglo de contactos sujeto
                        $scope.datosContacto = [];
                        $scope.datosContacto.seleccion = [];
                        $scope.datosContacto.eliminacion = [];
                        //arreglo de contactos representates
                        $scope.datosContactoRepresentante = [];
                        $scope.datosContactoRepresentante.seleccion = [];
                        $scope.datosContactoRepresentante.eliminacion = [];
                        //se inicializan las verificaciones de ubicacion y fechas de nacimiento valida
                        $scope.UBICACION_CORRECTA = true;
                        $scope.FECHA_NACIMIENTO_VALIDA = true;
                        //se inicializa el index de los sujetos en negativo para verificar las ediciones de representantes
                        $scope.index = -1;
                        //se inicializan las banderas de prioridad principal
                        $scope.SOLICITANTE_PRINCIPAL_AGREGADO = false;
                        $scope.INVITADO_PRINCIPAL_AGREGADO = false;
                        $scope.SOLICITANTES_AGREGADOS = false;
                        $scope.INVITADOS_AGREGADOS = false;
                      }
                      limpiarCaso();
                      //funciones caso
                      $scope.formularioCaso = function()
                      {
                        if ($scope.formulario_caso == false)
                        {
                          formulariocompleto();
                          tooltipItems("formulario_caso");
                          $scope.animacion_formulario_caso = entrada_izquiera;
                          $scope.formulario_caso = true;    
                          $scope.formulario_solicitante = false;
                          $scope.formulario_invitado = false;
                          $scope.formulario_sesion = false;
                          $scope.formulario_homologacion = false;
                          $scope.formulario_seguimiento = false;
                        }
                      }
                      enlistarTipoProcesos = function(p_id_despacho,p_id_materia)
                      {
                        casosService.getTipoProcesoMateriaDespacho(p_id_despacho,p_id_materia).then(
                          function ( response ) 
                          {
                            $scope.tipoProcesos = [];
                            $scope.tipoProcesos = response.data;
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                      }

                      $scope.limpiar_combos_caso = function()
                      {
                        $scope.caso.ID_TIPO_PROCESO = null;
                        $scope.caso.ID_TIPO_PROCEDENCIA = null;
                        $scope.caso.ID_PROCEDENCIA = null;
                        $scope.caso.MASCARA = null;
                        $scope.procedencias = [];
                      }

                      $scope.selectedMateria = function(item)
                      {
                        $scope.caso.ID_MATERIA = item.ID_MATERIA;
                        $scope.caso.MATERIA = item.MATERIA;
                        // if (limpiar != false)
                        // {
                        //   $scope.caso.ID_TIPO_PROCESO = "";
                        // }
                        $scope.animacion_etiqueta_asunto = "fadeOut";
                        // $scope.animacion_etiqueta_estado = "";
                        //$scope.etiqueta_estado = true;
                        if ($scope.animacion_etiqueta_estado != "")
                          {
                            if ($scope.animacion_etiqueta_estado =="fadeOut")
                            {
                              $scope.animacion_etiqueta_estado = "fadeIn";  
                            }
                          }

                        //evaluar si es edicion de registros, es decir la data viene desde base
                        //condicionar para cambiar las etiquetas y el id de estado
                        $scope.caso.ESTADO_CASO = $scope.CONSTANTES.ESTADO_INICIAL_CASO;
                        $scope.caso.ID_ESTADO_EXP = $scope.CONSTANTES.ID_ESTADO_INICIAL_CASO;

                        $scope.item_caso = true;
                        $scope.item_caso_no_mediable = false;
                        $scope.item_solicitante = false;
                        $scope.item_invitado = false;
                        $scope.item_sesion = false;
                        tooltipItems("formulario_caso");
                        $scope.color_formulario_caso = "box-gray";
                        $scope.color_item_caso = "bg-gray";
                        enlistarTipoProcesos(CENTRO.ID_DESPACHO,item.ID_MATERIA);
                        divisioncolumnasitems(1);
                        $scope.ir_solicitante = true;
                        $scope.etiqueta_estado = true;
                        $scope.deshabilitar_boton_guardar_caso_no_mediable = true;
                        $scope.deshabilitar_boton_guardar_caso_mediable = true;
                        getTipoProcedencia(item.ID_MATERIA);
                      }
                      $scope.selectedTipoProceso = function(item)
                      {
                        $scope.caso.ID_TIPO_PROCESO = item.ID_TIPO_PROCESO;
                        $scope.caso.TIPO_PROCESO = item.TIPO_PROCESO;
                        $scope.caso.ID_CLASIFICACION_JURIDICA = item.ID_CLASIFICACION_JURIDICA;
                        $scope.caso.ID_TIPO_ASUNTO = item.ID_TIPO_ASUNTO;
                        //$scope.animacion_etiqueta_estado = "";
                        $scope.animacion_etiqueta_asunto = "fadeIn";
                        $scope.animacion_etiqueta_asunto_no_mediable = "fadeOut";
                        $scope.deshabilitar_boton_guardar_caso_no_mediable = true;
                        $scope.deshabilitar_boton_guardar_caso_mediable = false;
                        if (item.ID_TIPO_ASUNTO == $scope.CONSTANTES.ASUNTO_NO_MEDIABLE)
                        {
                          //evaluar si es edicion de registros, es decir la data viene desde base
                          //condicionar para cambiar las etiquetas y el id de estado
                          $scope.caso.ASUNTO_NO_MEDIABLE_CASO = item.TIPO_ASUNTO;
                          $scope.caso.ID_ESTADO_EXP = $scope.CONSTANTES.ID_ESTADO_NO_MEDIABLE;
                          divisioncolumnasitems(2);
                          $scope.animacion_etiqueta_estado = "fadeOut";
                          $scope.animacion_etiqueta_asunto = "fadeOut";
                          $scope.animacion_etiqueta_asunto_no_mediable = "fadeIn";
                          $scope.item_solicitante = true;
                          $scope.item_invitado = false;
                          $scope.item_sesion = false;
                          $scope.item_caso = false;
                          $scope.item_caso_no_mediable = true;
                          $scope.color_formulario_caso = "box-danger";
                          $scope.etiqueta_asunto = false;
                          $scope.etiqueta_estado = false;
                          $scope.deshabilitar_boton_guardar_caso_no_mediable = false;
                          $scope.deshabilitar_boton_guardar_caso_mediable = true;
                        }
                        else
                        {
                          //evaluar si es edicion de registros, es decir la data viene desde base
                          //condicionar para cambiar las etiquetas y el id de estado
                          $scope.caso.ESTADO_CASO = $scope.CONSTANTES.ESTADO_INICIAL_CASO;
                          $scope.caso.ID_ESTADO_EXP = $scope.CONSTANTES.ID_ESTADO_INICIAL_CASO;
                          $scope.caso.ASUNTO_CASO = item.TIPO_ASUNTO;
                          divisioncolumnasitems(4);
                          if ($scope.animacion_etiqueta_estado != "")
                          {
                            if ($scope.animacion_etiqueta_estado =="fadeOut")
                            {
                              $scope.animacion_etiqueta_estado = "fadeIn";  
                            }
                          }
                          $scope.item_solicitante = true;
                          $scope.item_invitado = true;
                          $scope.item_sesion = true;
                          $scope.item_caso = true;
                          $scope.item_caso_no_mediable = false;
                          $scope.color_formulario_caso = "box-success";
                          $scope.color_item_caso = "bg-green";
                          $scope.etiqueta_asunto = true;
                          $scope.etiqueta_estado = true;
                          $scope.deshabilitar_boton_guardar_caso_no_mediable = true;
                          $scope.deshabilitar_boton_guardar_caso_mediable = false;
                        }
                        tooltipItems("formulario_caso");
                        $scope.ir_solicitante = false;
                      }
                      enlistarProcedencias = function(p_id_tipo_procedencia,p_id_materia,limpiar)
                      {
                        casosService.getProcedenciaTipoProcedencia(p_id_tipo_procedencia,p_id_materia,CENTRO.ID_DESPACHO).then(
                          function ( response ) 
                          {
                            $scope.procedencias = [];
                            $scope.procedencias = response.data;
                            if ($scope.procedencias.length == 1)
                            {
                              $scope.selectedProcedencia(response.data[0]);
                            }
                            else
                            {
                              if (limpiar != false)
                              {
                                $scope.caso.ID_PROCEDENCIA = "";
                                $scope.caso.REQUIERE_EXPEDIENTE = "";
                                $scope.caso.MASCARA = "";
                              }
                            }
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                      }
                      limpiarExpediente = function()
                      {
                        $scope.caso.ANIO = "";
                        $scope.caso.CORRELATIVO = "";
                        $scope.caso.CODIGO_DESPACHO = "";
                        $scope.caso.EXPEDIENTE = "";
                      }
                      $scope.selectedTipoProcedencia = function(item,limpiar)
                      {
                        if (limpiar != false)
                        {
                          $scope.mostrar_expediente = false;
                          $scope.focus_expediente = false;
                          $scope.caso.ID_TIPO_PROCEDENCIA = item.ID_TIPO_PROCEDENCIA;
                          $scope.caso.TIPO_PROCEDENCIA = item.TIPO_PROCEDENCIA;
                          limpiarExpediente();
                        }
                        enlistarProcedencias(item.ID_TIPO_PROCEDENCIA,$scope.caso.ID_MATERIA,limpiar);
                        $scope.campo_requerido_solicitante = true;
                        $scope.place_holder_expediente = "DESPACHO";
                        if (item.ID_TIPO_PROCEDENCIA == $scope.CONSTANTES.TIPO_PROCEDENCIA_REFERIDA)
                        {
                          // $scope.EXPRESION_EXPEDIENTE = $scope.CONSTANTES.EXPRESION_PROCEDENCIA_REFERIDA;
                          $scope.place_holder_expediente = "AGENCIA";
                          $scope.mostrar_combo_expediente = false;
                        }
                        // else 
                        if (item.ID_TIPO_PROCEDENCIA == $scope.CONSTANTES.TIPO_PROCEDENCIA_DERIVADA)
                        {
                          // $scope.EXPRESION_EXPEDIENTE = $scope.CONSTANTES.EXPRESION_PROCEDENCIA_DERIVADA;
                          $scope.mostrar_combo_expediente = true;
                          //$scope.mostrar_expediente = true;
                          // $scope.campo_requerido_solicitante = false;
                        }
                      }
                      $scope.completarNumeroUnico = function(isValid)
                      {
                        if (isValid)
                        {
                          //$scope.caso.EXPEDIENTE=utilsService.formatNumeroUnicoExp($scope.caso.EXPEDIENTE)
                          EXPEDIENTE = $scope.caso.EXPEDIENTE.split( '-' );
                          $scope.caso.CODIGO_DESPACHO = EXPEDIENTE[0];
                          $scope.caso.ANIO = EXPEDIENTE[1];
                          $scope.caso.CORRELATIVO = EXPEDIENTE[2];
                        } 
                      }
                      $scope.cambiar_focus_expediente = function()
                      {
                        $scope.focus_expediente = false;
                      }
                      $scope.selectedProcedencia = function(item,limpiar)
                      {
                        $scope.mostrar_expediente = false;
                        if (limpiar != false)
                        {
                          $scope.caso.ID_PROCEDENCIA = item.ID_PROCEDENCIA;
                          $scope.caso.PROCEDENCIA = item.PROCEDENCIA;
                          $scope.caso.REQUIERE_EXPEDIENTE = item.REQUIERE_EXPEDIENTE;
                          $scope.caso.MASCARA = item.MASCARA;
                          limpiarExpediente();  
                          $scope.focus_expediente = true;
                        }
                        if (item.REQUIERE_EXPEDIENTE== $scope.CONSTANTES.REGISTRO_VERDADERO)
                        {
                          $scope.mostrar_expediente = true;
                          $scope.campo_requerido_solicitante = false;
                        } 
                      }

                      /*$scope.verificar_longitud = function(longitud)
                      {
                        $scope.LONGITUD_HOJA_EVOLUCION_SESION = false;
                        if (longitud >= $scope.CONSTANTES.LONGITUD_HOJA_EVOLUCION_SESION)
                        {
                          $scope.LONGITUD_HOJA_EVOLUCION_SESION = true;
                        }
                      }*/
/*formulario caso*/
/*datos comunes solicitantes invitados representantes contactos*/
                      //se inicializa el arreglo de los tipos de sujeto
                      $scope.tipoSujetos = [];
                      $scope.tipoSujetos = dataTipoSujeto.data;
                      //se inicializa el arreglo de la prioridad del sujeto
                      $scope.prioridadSujetos = [];
                      $scope.prioridadSujetos = dataPrioridadSujeto.data;
                      //se inicializa el arreglo del sexo del sujeto
                      $scope.generos = [];
                      $scope.generos = dataGenero.data;
                      //se inicializa el arreglo del nivel educativo del sujeto
                      $scope.nivelesEducativos = [];
                      $scope.nivelesEducativos = dataNivelEducativo.data;
                      //se inicializa el arreglo de discapacidad
                      $scope.discapacidades = [];
                      $scope.discapacidades = dataDiscapacidad.data;
                      //descripciones iniciales para los formularios
                      descripciones_generales = function()
                      {
                        if ($scope.formularioRepresentante)
                        {
                          $scope.descripcion_datos_representante = "Representantes";
                        }
                        else 
                        {
                          $scope.descripcion_datos_solicitante = "Solicitantes";
                          $scope.descripcion_datos_invitado = "Invitados";
                        }
                      }
                      descripciones_generales();
                      descripciones_hombre = function()
                      {
                        if ($scope.formularioRepresentante)
                        {
                          $scope.descripcion_datos_representante = "Representante";
                        }
                        else if ($scope.formulario_solicitante)
                        {
                          $scope.descripcion_datos_solicitante = "Solicitante";
                        }
                        else if ($scope.formulario_invitado)
                        {
                          $scope.descripcion_datos_invitado = "Invitado";
                        }
                      }
                      descripciones_mujer = function()
                      {
                        if ($scope.formularioRepresentante)
                        {
                          $scope.descripcion_datos_representante = "Representante";
                        }
                        else if ($scope.formulario_solicitante)
                        {
                          $scope.descripcion_datos_solicitante = "Solicitante";
                        }
                        else if ($scope.formulario_invitado)
                        {
                          $scope.descripcion_datos_invitado = "Invitada";
                        }
                      }
                      //funciones solicitante invitado representante
                      buscarEstadoCivil = function(valor, arreglo){
                        for (var i=0; i < arreglo.length; i++) {
                            if (arreglo[i].ID_ESTADO_CIVIL === valor) {
                                return arreglo[i];
                            }
                        }
                      }
                      buscarProfesion = function(valor, arreglo){
                        for (var i=0; i < arreglo.length; i++) {
                            if (arreglo[i].ID_PROFESION === valor) {
                                return arreglo[i];
                            }
                        }
                      }
                      // limpiarEstadoCivil = function()
                      // {
                      //   if (($scope.formularioRepresentante) && (!$scope.editar_representante))
                      //   {
                      //     $scope.representante.ID_ESTADO_CIVIL = "";
                      //   }
                      //   else if (($scope.formulario_solicitante) && (!$scope.editar_solicitante))
                      //   {
                      //     $scope.solicitante.ID_ESTADO_CIVIL = "";
                      //   }
                      //   else if (($scope.formulario_invitado) && (!$scope.editar_invitado))
                      //   {
                      //     $scope.invitado.ID_ESTADO_CIVIL = "";
                      //   }
                      // }
                      limpiarEstadoCivilProfesion = function()
                      {
                        cambioSexoEstadoCivil = false;
                        cambioSexoProfesion = false;
                        ID_ESTADO_CIVIL = "";
                        ID_PROFESION = "";
                        $scope.estadosCiviles = [];
                        $scope.profesiones = [];
                      }
                      limpiarEstadoCivilProfesion();
                      // cambioSexoEstadoCivil = false;
                      // cambioSexoProfesion = false;
                      $scope.cambiaSexo = function()
                      {
                        cambioSexoEstadoCivil=false;
                        cambioSexoProfesion = false;
                        if (ID_ESTADO_CIVIL != "")
                        {
                          id_estado_civil_temporal = "0";
                          BreakException = {};
                          try 
                          {
                            $scope.estadosCiviles.forEach(function(estado_civil) 
                            {
                              id_estado_civil_temporal = estado_civil.ID_ESTADO_CIVIL;
                              if (estado_civil.ID_ESTADO_CIVIL != ID_ESTADO_CIVIL)                  
                              {
                                throw BreakException;
                              }
                            });
                          } catch (e) 
                          {
                            true;
                          }  
                          itemEstadoCivil=buscarEstadoCivil(id_estado_civil_temporal,$scope.estadosCiviles)
                          selectedEstadoCivilTemporal(itemEstadoCivil);
                          cambioSexoEstadoCivil=true;
                        }
                        if (ID_PROFESION != "")
                        {
                          id_profesion_temporal = "0";
                          BreakException = {};
                          try 
                          {
                            $scope.profesiones.forEach(function(profesion) 
                            {
                              id_profesion_temporal = profesion.ID_PROFESION;
                              if (profesion.ID_PROFESION != ID_PROFESION)                  
                              {
                                throw BreakException;
                              }
                            });
                          } catch (e) 
                          {
                            true;
                          }  
                          itemProfesion=buscarProfesion(id_profesion_temporal,$scope.profesiones)
                          selectedProfesionTemporal(itemProfesion);
                          cambioSexoProfesion=true;
                        }
                      }
                      getEstadoCivil = function(p_id_sexo, estado_civil)
                      {
                        casosService.getEstadoCivil(p_id_sexo).then(
                          function ( response ) 
                          { 
                            //limpiarEstadoCivilProfesion();
                            $scope.estadosCiviles = [];
                            $scope.estadosCiviles = response.data;
                            if ((cambioSexoEstadoCivil) || ((estado_civil != undefined) && (estado_civil != "")))
                            {
                              if (estado_civil != undefined)
                              {
                                ID_ESTADO_CIVIL = estado_civil
                              }
                              if ((ID_ESTADO_CIVIL != undefined) && (ID_ESTADO_CIVIL != ""))
                              {
                                itemEstadoCivil=buscarEstadoCivil(ID_ESTADO_CIVIL,$scope.estadosCiviles)
                                $scope.selectedEstadoCivil(itemEstadoCivil);
                              }
                            }
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                      }
                      // limpiarProfesion = function()
                      // {
                      //   if (($scope.formularioRepresentante) && (!$scope.editar_representante))
                      //   {
                      //     $scope.representante.ID_PROFESION = "";
                      //   }
                      //   else if (($scope.formulario_solicitante) && (!$scope.editar_solicitante))
                      //   {
                      //     $scope.solicitante.ID_PROFESION = "";
                      //   }
                      //   else if (($scope.formulario_invitado) && (!$scope.editar_invitado))
                      //   {
                      //     $scope.invitado.ID_PROFESION = "";
                      //   }
                      // }
                      getProfesion = function(p_id_sexo, profesion)
                      {
                        casosService.getProfesion(p_id_sexo).then(
                          function ( response ) 
                          {
                            //limpiarProfesion();
                            $scope.profesiones = [];
                            $scope.profesiones = response.data;
                            if ((cambioSexoProfesion) || ((profesion != undefined) && (profesion != "")))
                            { 
                              if (profesion != undefined)
                              {
                                ID_PROFESION = profesion
                              }
                              if ((ID_PROFESION != undefined) && (ID_PROFESION != ""))
                              {
                                itemProfesion=buscarProfesion(ID_PROFESION,$scope.profesiones)
                                $scope.selectedProfesion(itemProfesion);
                              }
                            }
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                      }
                      limpiarComunes = function()
                      {
                        $scope.datosContacto = [];
                        $scope.datosContacto.seleccion = [];
                        $scope.datosContacto.eliminacion = [];
                        $scope.representantes = [];
                        $scope.representantes.seleccion = [];
                        $scope.representantes.eliminacion = [];
                        $scope.tipoIdentificacion = [];
                        validaRepresentante();
                        $scope.SUJETO_BD = false;
                        $scope.REPRESENTANTE_BD = false;
                        $scope.focus_identificacion_solicitante = false;
                        $scope.focus_identificacion_invitado = false;
                        $scope.UBICACION_CORRECTA = true;
                        $scope.index = -1;
                        cambioSexoEstadoCivil = false;
                        cambioSexoProfesion = false;
                        ID_ESTADO_CIVIL = "";
                        ID_PROFESION = "";
                        descripciones_generales();
                        // limpiarEstadoCivil();
                        // $scope.tooltip_ver_representante = "Guardar representante";
                        // if ($scope.nacionalidades != undefined)
                        // {
                        //   if ($scope.nacionalidades.length = 1)
                        //   { 
                        //     $scope.selectedNacionalidad($scope.nacionalidades[0]);
                        //   }
                        //   else
                        //   {
                        //     $scope.tipoPoblacion = [];
                        //     $scope.idiomas = [];
                        //   }
                        // }
                      }
                      $scope.limpiarSujeto = function()
                      {
                        if ($scope.formulario_solicitante)
                        {
                          ID_PRIORIDAD_SUJETO = $scope.solicitante.ID_PRIORIDAD_SUJETO;
                          PRIORIDAD_SUJETO = $scope.solicitante.PRIORIDAD_SUJETO;
                          $scope.solicitante = [];
                          $scope.solicitante.ID_PRIORIDAD_SUJETO = ID_PRIORIDAD_SUJETO;
                          $scope.solicitante.PRIORIDAD_SUJETO = PRIORIDAD_SUJETO;
                          $scope.solicitante.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                        }
                        else if ($scope.formulario_invitado)
                        {
                          ID_PRIORIDAD_SUJETO = $scope.invitado.ID_PRIORIDAD_SUJETO;
                          PRIORIDAD_SUJETO = $scope.invitado.PRIORIDAD_SUJETO;
                          $scope.invitado = [];
                          $scope.invitado.ID_PRIORIDAD_SUJETO = ID_PRIORIDAD_SUJETO;
                          $scope.invitado.PRIORIDAD_SUJETO = PRIORIDAD_SUJETO;
                          $scope.invitado.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                        }
                        limpiarComunes();
                      }
                      //se obtiene el arreglo inicial para el tipo de sujeto natural
                      buscarTipoSujeto = function(valor, arreglo){
                        for (var i=0; i < arreglo.length; i++) {
                            if (arreglo[i].ID_TIPO_SUJETO === valor) {
                                return arreglo[i];
                            }
                        }
                      }
                      //se obtiene el arreglo inicial para la prioridad del sujeto natural
                      buscarPrioridadSujeto = function(valor, arreglo){
                        for (var i=0; i < arreglo.length; i++) {
                            if (arreglo[i].ID_PRIORIDAD_SUJETO === valor) {
                                return arreglo[i];
                            }
                        }
                      }
                      $scope.restaurarValoresSujeto = function()
                      {
                        validaSujetos();
                        itemTipoSujeto = buscarTipoSujeto($scope.LOCAL_ID_TIPO_SUJETO, $scope.tipoSujetos);
                        $scope.selectedTipoSujeto(itemTipoSujeto);
                        if ($scope.formulario_solicitante)
                        {
                          if ($scope.SOLICITANTE_PRINCIPAL_AGREGADO)
                          {
                            $scope.deshabilitar_prioridad_solicitante = false;
                            $scope.LOCAL_ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_SECUNDARIO;  
                          }
                          else
                          {
                            $scope.deshabilitar_prioridad_solicitante = true;
                            $scope.LOCAL_ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL;  
                          }
                        }
                        else if ($scope.formulario_invitado)
                        {
                          if ($scope.INVITADO_PRINCIPAL_AGREGADO)
                          {
                            $scope.deshabilitar_prioridad_invitado = false;
                            $scope.LOCAL_ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_SECUNDARIO;  
                          }
                          else
                          {
                            $scope.deshabilitar_prioridad_invitado = true;
                            $scope.LOCAL_ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL;  
                          }
                        }
                        itemPrioridadSujeto = buscarPrioridadSujeto($scope.LOCAL_ID_PRIORIDAD_SUJETO, $scope.prioridadSujetos);
                        $scope.selectedPrioridadSujeto(itemPrioridadSujeto);
                      }
                      $scope.cambiarBotones = function()
                      {
                        if ($scope.formularioRepresentante)
                        { 
                          $scope.icono_boton_editar_representante = "fa fa-plus";
                          // $scope.icono_boton_limpiar_representante = "fa fa-trash-o";
                          $scope.editar_representante = false;
                          $scope.editar_representante_registro = false;
                          $scope.tooltip_boton_editar_representante = "Guardar representante";
                          // $scope.tooltip_boton_limpiar_representante = "Limpiar datos";
                          // if ($scope.representantes.seleccion.length >= 1)
                          // {
                          //     $scope.mostrar_representantes = true; 
                          // }
                          // else
                          // {
                          //   $scope.mostrar_representantes = false;
                          // }   
                        }
                        else if ($scope.formulario_solicitante)
                        {
                          $scope.icono_boton_editar_solicitante = "fa fa-user-plus";
                          $scope.icono_boton_limpiar_solicitante = "fa fa-trash-o";
                          $scope.editar_solicitante = false;
                          $scope.tooltip_boton_editar_solicitante = "Guardar solicitante";
                          $scope.tooltip_boton_limpiar_solicitante = "Limpiar datos";  
                          if ($scope.solicitantes.seleccion.length >= 1)
                          {
                              $scope.mostrar_solicitantes = true; 
                          }
                          else
                          {
                            $scope.mostrar_solicitantes = false;
                          }          
                        }
                        else
                        {
                          $scope.icono_boton_editar_invitado = "fa fa-user-plus";
                          $scope.icono_boton_limpiar_invitado = "fa fa-trash-o";
                          $scope.editar_invitado = false;
                          $scope.tooltip_boton_editar_invitado = "Guardar invitado";
                          $scope.tooltip_boton_limpiar_invitado = "Limpiar datos del invitado";
                          if ($scope.invitados.seleccion.length >= 1)
                          {
                              $scope.mostrar_invitados = true; 
                          }
                          else
                          {
                            $scope.mostrar_invitados = false;
                          }
                        }
                      }
                      $scope.cambiar_focus_identificacion = function()
                      {
                        $scope.focus_identificacion_solicitante = false;
                        $scope.focus_identificacion_invitado = false;
                      }
                      $scope.combo_tipo_identificacion = true;
                      cambiar_tipo_identificacion = function()
                      {
                        $scope.combo_tipo_identificacion = !$scope.combo_tipo_identificacion;
                      }
                      cambiar_focus_identificacion_valida = function()
                      {
                        $scope.focus_identificacion_valida = false;
                      }
                      $scope.selectedTipoIdentificacion = function (item,limpiarTipoIdentificacion)
                      {
                        cambiar_tipo_identificacion();
                        if ($scope.formulario_solicitante)
                        {
                          $scope.solicitante.ID_TIPO_IDENTIFICACION = item.ID_TIPO_IDENTIFICACION;
                          $scope.solicitante.MASCARA_IDENTIFICACION = item.MASCARA;
                          if (limpiarTipoIdentificacion)
                          {
                            $scope.solicitante.IDENTIFICACION="";
                            $scope.focus_identificacion_solicitante = true;
                          }
                        }
                        else if ($scope.formulario_invitado)
                        {
                          $scope.invitado.ID_TIPO_IDENTIFICACION = item.ID_TIPO_IDENTIFICACION;
                          // $scope.invitado.TIPO_IDENTIFICACION = item.TIPO_IDENTIFICACION;
                          $scope.invitado.MASCARA_IDENTIFICACION = item.MASCARA;
                          if (limpiarTipoIdentificacion)
                          {
                            $scope.invitado.IDENTIFICACION="";  
                            $scope.focus_identificacion_invitado = true;
                          }
                        }
                        if (item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_PASAPORTE)
                        { 
                          getNacionalidad($scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO,item.ID_TIPO_IDENTIFICACION);
                        }
                        else if (item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI)
                        { 
                          getNacionalidad($scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO,item.ID_TIPO_IDENTIFICACION);
                        }
                        else if (item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI_EXT)
                        { 
                          getNacionalidad($scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO,item.ID_TIPO_IDENTIFICACION);
                        }
                      }
                      //se obtiene el arreglo inicial para el tipo de identificacion de los sujetos
                      buscarTipoIdentificacionSujeto = function(valor, arreglo){
                        for (var i=0; i < arreglo.length; i++) {
                            if (arreglo[i].ID_TIPO_IDENTIFICACION === valor) {
                                return arreglo[i];
                            }
                        }
                      }
                      getTipoIdentificacion = function (p_id_tipo_sujeto)
                      {
                        casosService.getTipoIdentificacion(p_id_tipo_sujeto).then(
                          function ( response ) 
                          {
                            $scope.tipoIdentificacion = response.data;
                            if ($scope.tipoIdentificacion.length == 1)
                            {
                              $scope.selectedTipoIdentificacion(response.data[0],true);
                            }
                            else if (p_id_tipo_sujeto == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                            { 
                              itemTipoIdentificacion = buscarTipoIdentificacionSujeto($scope.CONSTANTES.TIPO_IDENTIFICACION_DPI, response.data);
                              $scope.selectedTipoIdentificacion(itemTipoIdentificacion,true);
                            }
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                      }
                      //se obtiene el arreglo inicial para el tipo de identificacion de los sujetos
                      buscarContactoSujeto = function(valor, arreglo){
                        valor = valor.replace(/ /g,"");
                        valor = valor.replace(/,/g,"");
                        valor = valor.replace(/Á/g,"A");
                        valor = valor.replace(/É/g,"E");
                        valor = valor.replace(/Í/g,"I");
                        valor = valor.replace(/Ó/g,"O");
                        valor = valor.replace(/Ú/g,"U");
                        valor = valor.replace(/-/g,"");
                        valor = valor.replace(/_/g,"");
                        for (var i=0; i < arreglo.length; i++) 
                        {
                          contacto = arreglo[i].CONTACTO_TEMPORAL;
                          contacto = contacto.replace(/ /g,"");
                          contacto = contacto.replace(/,/g,"");
                          contacto = contacto.replace(/Á/g,"A");
                          contacto = contacto.replace(/É/g,"E");
                          contacto = contacto.replace(/Í/g,"I");
                          contacto = contacto.replace(/Ó/g,"O");
                          contacto = contacto.replace(/Ú/g,"U");
                          contacto = contacto.replace(/-/g,"");
                          contacto = contacto.replace(/_/g,"");
                          if (contacto === valor) 
                          {
                                return true;
                          }
                          else
                          {
                            return false;
                          }
                        }
                      }
                      ordenarContacto = function()
                      {
                        if ($scope.formularioRepresentante)
                        {
                          var filtered = [];
                          angular.forEach($scope.datosContactoRepresentante.seleccion, function(item) {
                            filtered.push(item);
                          });
                          filtered.sort(function (a, b) {
                            return (a['ID_TIPO_CONTACTO'] > b['ID_TIPO_CONTACTO'] ? 1 : -1);
                          });
                          $scope.datosContactoRepresentante.seleccion =  filtered;
                        }
                        else
                        {
                          var filtered = [];
                          angular.forEach($scope.datosContacto.seleccion, function(item) {
                            filtered.push(item);
                          });
                          filtered.sort(function (a, b) {
                            return (a['ID_TIPO_CONTACTO'] > b['ID_TIPO_CONTACTO'] ? 1 : -1);
                          });
                          $scope.datosContacto.seleccion =  filtered;
                        }
                      }

                      getDatosSujetoIdentificacion = function(p_id_tipo_sujeto,p_id_tipo_identificacion,p_identificacion)
                      {
                        casosService.getDatosSujetoIdentificacion(p_id_tipo_sujeto,p_id_tipo_identificacion,p_identificacion).then(
                          function ( response ) 
                          {
                            if (response.data.ID_SUJETO == undefined)
                            {
                              toastr.warning('No se encontraron coincidencias para el número de identificación ingresado');
                              if ($scope.formularioRepresentante)
                              {
                                $scope.deshabilitar_identificacion_representante = true;
                                $scope.deshabilitar_datos_sujeto_representante = false;
                                $scope.focus_identificacion_valida_representante = true;
                              }
                              else
                              {
                                $scope.deshabilitar_identificacion = true;
                                $scope.deshabilitar_datos_sujeto = false;
                                $scope.focus_identificacion_valida = true;
                              }
                            }
                            else
                            {
                              if (p_id_tipo_sujeto == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                              {
                                getPoblacionIdioma(response.data);
                                //getEstadoCivil(response.data.ID_GENERO);
                                //getProfesion(response.data.ID_GENERO);
                                ID_ESTADO_CIVIL = response.data.ID_ESTADO_CIVIL;
                                ID_PROFESION = response.data.ID_PROFESION;
                                $scope.selectedGenero(response.data);
                              }
                              if ($scope.formularioRepresentante)
                              {
                                $scope.deshabilitar_identificacion_representante = true;
                                $scope.deshabilitar_datos_sujeto_representante = false;
                                /*if ($scope.editar_representante)
                                {
                                  temp = [];
                                  temp.ID_SUJETO_EXPEDIENTE_ELIMINACION = $scope.representante.ID_SUJETO_EXPEDIENTE;
                                  temp.ID_REPRESENTANTE_ELIMINACION = $scope.representante.ID_REPRESENTANTE;
                                  temp.ICONO_TIPO_SUJETO = $scope.representante.ICONO_TIPO_SUJETO;
                                  temp.ID_PERFIL_SUJETO = $scope.representante.ID_PERFIL_SUJETO;
                                  temp.ID_PRIORIDAD_SUJETO = $scope.representante.ID_PRIORIDAD_SUJETO;
                                  temp.ID_TIPO_SUJETO = $scope.representante.ID_TIPO_SUJETO;
                                  temp.PERFIL_SUJETO = $scope.representante.PERFIL_SUJETO;
                                  temp.PRIORIDAD_SUJETO = $scope.representante.PRIORIDAD_SUJETO;
                                  temp.SEXO_MUJER = $scope.representante.SEXO_MUJER;
                                  temp.SUJETO_NATURAL = $scope.representante.SUJETO_NATURAL;
                                  temp.TIPO_SUJETO = $scope.representante.TIPO_SUJETO;
                                  angular.extend(temp,response.data);
                                  for (var i=0; i < $scope.representante.contactos.length; i++) 
                                  {
                                    contactoExistente = buscarContactoSujeto($scope.representante.contactos[i].CONTACTO_TEMPORAL,temp.contactos);
                                    if (!contactoExistente)
                                    {
                                      temp.contactos.push($scope.representante.contactos[i]);
                                    }                                      
                                  }
                                  $scope.representante = {};
                                  $scope.representante = temp;
                                  if (temp.SUJETO_NATURAL)
                                  {
                                    $scope.cambiaSexo(); 
                                    $scope.selectedGenero($scope.representante);
                                  }
                                  $scope.datosContactoRepresentante.seleccion = [];
                                  $scope.datosContactoRepresentante.seleccion = temp.contactos;
                                  ordenarContacto();
                                }
                                else
                                {*/
                                  angular.extend($scope.representante,response.data);
                                  $scope.datosContactoRepresentante.seleccion = $scope.representante.contactos;
                                  validaDireccion();
                                // }
                              }
                              else 
                              {
                                $scope.deshabilitar_identificacion = true;
                                $scope.deshabilitar_datos_sujeto = false;
                                if ($scope.formulario_solicitante)
                                {
                                  /*if ($scope.editar_solicitante)
                                  {
                                    temp = [];
                                    temp.ID_SUJETO_EXPEDIENTE_ELIMINACION = $scope.solicitante.ID_SUJETO_EXPEDIENTE;
                                    temp.ID_SUJETO_ELIMINACION = $scope.solicitante.ID_SUJETO;
                                    temp.ICONO_TIPO_SUJETO = $scope.solicitante.ICONO_TIPO_SUJETO;
                                    temp.ID_PERFIL_SUJETO = $scope.solicitante.ID_PERFIL_SUJETO;
                                    temp.ID_PRIORIDAD_SUJETO = $scope.solicitante.ID_PRIORIDAD_SUJETO;
                                    temp.ID_TIPO_SUJETO = $scope.solicitante.ID_TIPO_SUJETO;
                                    temp.PERFIL_SUJETO = $scope.solicitante.PERFIL_SUJETO;
                                    temp.PRIORIDAD_SUJETO = $scope.solicitante.PRIORIDAD_SUJETO;
                                    temp.SEXO_MUJER = $scope.solicitante.SEXO_MUJER;
                                    temp.SUJETO_NATURAL = $scope.solicitante.SUJETO_NATURAL;
                                    temp.TIPO_SUJETO = $scope.solicitante.TIPO_SUJETO;
                                    angular.extend(temp,response.data);
                                    for (var i=0; i < $scope.solicitante.contactos.length; i++) 
                                    {
                                      contactoExistente = buscarContactoSujeto($scope.solicitante.contactos[i].CONTACTO_TEMPORAL,temp.contactos);
                                      if (!contactoExistente)
                                      {
                                        temp.contactos.push($scope.solicitante.contactos[i]);
                                      }                                      
                                    }
                                    $scope.solicitante = [];
                                    $scope.solicitante = temp;
                                    if (temp.SUJETO_NATURAL)
                                    {
                                      $scope.cambiaSexo(); 
                                      $scope.selectedGenero($scope.solicitante);
                                    }
                                    $scope.datosContacto.seleccion = [];
                                    $scope.datosContacto.seleccion = temp.contactos;
                                    ordenarContacto();
                                  }
                                  else
                                  {*/
                                    angular.extend($scope.solicitante,response.data);
                                    $scope.datosContacto.seleccion = $scope.solicitante.contactos;
                                  //}
                                }
                                else if ($scope.formulario_invitado)
                                {
                                  /*if ($scope.editar_invitado)
                                  {
                                    temp = [];
                                    temp.ID_SUJETO_EXPEDIENTE_ELIMINACION = $scope.invitado.ID_SUJETO_EXPEDIENTE;
                                    temp.ID_SUJETO_ELIMINACION = $scope.invitado.ID_SUJETO;
                                    temp.ICONO_TIPO_SUJETO = $scope.invitado.ICONO_TIPO_SUJETO;
                                    temp.ID_PERFIL_SUJETO = $scope.invitado.ID_PERFIL_SUJETO;
                                    temp.ID_PRIORIDAD_SUJETO = $scope.invitado.ID_PRIORIDAD_SUJETO;
                                    temp.ID_TIPO_SUJETO = $scope.invitado.ID_TIPO_SUJETO;
                                    temp.PERFIL_SUJETO = $scope.invitado.PERFIL_SUJETO;
                                    temp.PRIORIDAD_SUJETO = $scope.invitado.PRIORIDAD_SUJETO;
                                    temp.SEXO_MUJER = $scope.invitado.SEXO_MUJER;
                                    temp.SUJETO_NATURAL = $scope.invitado.SUJETO_NATURAL;
                                    temp.TIPO_SUJETO = $scope.invitado.TIPO_SUJETO;
                                    angular.extend(temp,response.data);
                                    for (var i=0; i < $scope.invitado.contactos.length; i++) 
                                    {
                                      contactoExistente = buscarContactoSujeto($scope.invitado.contactos[i].CONTACTO_TEMPORAL,temp.contactos);
                                      if (!contactoExistente)
                                      {
                                        temp.contactos.push($scope.invitado.contactos[i]);
                                      }                                      
                                    }
                                    $scope.invitado = [];
                                    $scope.invitado = temp;
                                    if (temp.SUJETO_NATURAL)
                                    {
                                      $scope.cambiaSexo(); 
                                      $scope.selectedGenero($scope.invitado);
                                    }
                                    $scope.datosContacto.seleccion = [];
                                    $scope.datosContacto.seleccion = temp.contactos;
                                    ordenarContacto();
                                  }
                                  else
                                  {*/
                                    angular.extend($scope.invitado,response.data);
                                    $scope.datosContacto.seleccion = $scope.invitado.contactos;
                                    // $scope.representantes.seleccion = $scope.invitado.representantes;
                                  //}
                                }  
                                validaDireccion();
                              }
                            }
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                      }
                      $scope.habilitar_datos_identificacion = function()
                      {
                        $scope.deshabilitar_identificacion = false;
                        $scope.deshabilitar_datos_sujeto = true;
                        if ($scope.formulario_solicitante)
                        {
                          if ($scope.editar_solicitante)
                          {
                            $scope.deshabilitar_identificacion = true;
                            $scope.deshabilitar_datos_sujeto = false;
                            if (($scope.solicitante.IDENTIFICACION == undefined) || ($scope.solicitante.IDENTIFICACION == ""))
                            {
                              $scope.deshabilitar_identificacion = false;
                              $scope.deshabilitar_datos_sujeto = false;    
                            }
                          }
                          else if ((!$scope.campo_requerido_solicitante) || ($scope.caso.REQUIERE_EXPEDIENTE== $scope.CONSTANTES.REGISTRO_VERDADERO))
                          {
                            $scope.deshabilitar_identificacion = false;
                            $scope.deshabilitar_datos_sujeto = false;  
                            if ($scope.caso.REQUIERE_EXPEDIENTE== $scope.CONSTANTES.REGISTRO_VERDADERO)
                            {
                              $scope.campo_requerido_solicitante = false; 
                            }
                          }
                        }
                        else if ($scope.formulario_invitado)
                        {
                          if ($scope.editar_invitado)
                          {
                            $scope.deshabilitar_identificacion = true;
                            $scope.deshabilitar_datos_sujeto = false;
                            if (($scope.invitado.IDENTIFICACION == undefined) || ($scope.invitado.IDENTIFICACION == ""))
                            {
                              $scope.deshabilitar_identificacion = false;
                              $scope.deshabilitar_datos_sujeto = false;    
                            }
                          }
                          else 
                          // if (!$scope.campo_requerido_invitado)
                          {
                            $scope.deshabilitar_identificacion = false;
                            $scope.deshabilitar_datos_sujeto = false;  
                            $scope.campo_requerido_invitado = false;
                          }
                        }
                        
                        
                        // ) ||
                        //     (($scope.formulario_invitado) && (!$scope.campo_requerido_invitado)))
                        // {
                          
                        // }

                        limpiarEstadoCivilProfesion();
                      }
                      $scope.habilitar_datos_identificacion_representante = function()
                      {
                        $scope.deshabilitar_identificacion_representante = false;
                        $scope.deshabilitar_datos_sujeto_representante = true;
                        if ($scope.editar_representante)
                        {
                          $scope.deshabilitar_identificacion_representante = true;
                          $scope.deshabilitar_datos_sujeto_representante = false;
                          if (($scope.representante.IDENTIFICACION == undefined) || ($scope.representante.IDENTIFICACION == ""))
                          {
                            $scope.deshabilitar_identificacion_representante = false;
                            $scope.deshabilitar_datos_sujeto_representante = false;    
                          }
                        }
                        else if ((!$scope.campo_requerido) || ($scope.caso.REQUIERE_EXPEDIENTE== $scope.CONSTANTES.REGISTRO_VERDADERO))
                        {
                          $scope.deshabilitar_identificacion_representante = false;
                          $scope.deshabilitar_datos_sujeto_representante = false;  
                          if ($scope.caso.REQUIERE_EXPEDIENTE== $scope.CONSTANTES.REGISTRO_VERDADERO)
                          {
                            $scope.campo_requerido = false; 
                          }
                        }
                        limpiarEstadoCivilProfesion();
                      }

                      $scope.buscarSujeto = function(ubicacion,isValid,item)
                      {
                        if ((ubicacion) && (isValid) && (item.IDENTIFICACION != ""))
                        {
                          if ($scope.formularioRepresentante)
                          {
                            ID_TIPO_SUJETO = $scope.CONSTANTES.TIPO_SUJETO_NATURAL;
                          }
                          else
                          {
                            ID_TIPO_SUJETO = item.ID_TIPO_SUJETO;
                          }
                          getDatosSujetoIdentificacion(ID_TIPO_SUJETO,item.ID_TIPO_IDENTIFICACION,item.IDENTIFICACION);  
                        }
                        else
                        {
                          mensaje = 'Ingrese un número de identificación para realizar la búsqueda ';
                          if (!ubicacion)
                          {
                            mensaje = $scope.mensaje_ubicacion_incorrecta;
                          }
                          toastr.warning(mensaje);
                        }
                      }
                      $scope.selectedTipoSujeto = function (item)
                      {
                        $scope.habilitar_datos_identificacion();
                        cambiar_focus_identificacion_valida();
                        $scope.limpiarSujeto();
                        // $scope.mostrar_representantes = true;
                        if ($scope.formulario_solicitante)
                        {
                          $scope.solicitante.SUJETO_NATURAL = false;
                          // $scope.solicitante.REQUIERE_REPRESENTANTE = true;
                          if (item.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                          {
                            $scope.solicitante.SUJETO_NATURAL = true;
                            // itemNacionalidad = buscarNacionalidad($scope.CONSTANTES.NACIONALIDAD_GUATEMALTECA,$scope.nacionalidades);
                            // $scope.selectedNacionalidad(itemNacionalidad);  
                            $scope.campo_identificacion_requerido = $scope.campo_requerido_solicitante;
                          }
                          else
                          {
                            descripciones_hombre();
                            $scope.campo_identificacion_requerido = false;
                            $scope.deshabilitar_datos_sujeto = false;
                          }
                          $scope.solicitante.ID_TIPO_SUJETO = item.ID_TIPO_SUJETO;
                          // $scope.solicitante.TIPO_SUJETO = item.TIPO_SUJETO;
                          $scope.solicitante.ICONO_TIPO_SUJETO = item.ICONO;
                          $scope.LOCAL_ID_TIPO_SUJETO = item.ID_TIPO_SUJETO; 
                          validaRepresentante();
                        }
                        else if ($scope.formulario_invitado)
                        {
                          $scope.invitado.SUJETO_NATURAL = false;
                          // $scope.invitado.REQUIERE_REPRESENTANTE = true;
                          if (item.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                          {
                            $scope.invitado.SUJETO_NATURAL = true;
                            //$scope.mostrar_representantes = false;
                            // itemNacionalidad = buscarNacionalidad($scope.CONSTANTES.NACIONALIDAD_GUATEMALTECA,$scope.nacionalidades);
                            // $scope.selectedNacionalidad(itemNacionalidad);  
                            $scope.campo_identificacion_requerido = $scope.campo_requerido_invitado;
                          }
                          else
                          {
                            descripciones_hombre();
                            $scope.campo_identificacion_requerido = false;
                            $scope.deshabilitar_datos_sujeto = false;
                          }
                          $scope.invitado.ID_TIPO_SUJETO = item.ID_TIPO_SUJETO;
                          // $scope.invitado.TIPO_SUJETO = item.TIPO_SUJETO;
                          $scope.invitado.ICONO_TIPO_SUJETO = item.ICONO;
                          $scope.LOCAL_ID_TIPO_SUJETO = item.ID_TIPO_SUJETO;
                        }
                        getTipoIdentificacion(item.ID_TIPO_SUJETO);
                      }
                      $scope.selectedPrioridadSujeto = function (item)
                      {
                        $scope.LOCAL_ID_PRIORIDAD_SUJETO = item.ID_PRIORIDAD_SUJETO;  
                        if ($scope.formulario_solicitante)
                        {
                          $scope.solicitante.ID_PRIORIDAD_SUJETO = item.ID_PRIORIDAD_SUJETO;
                          $scope.solicitante.PRIORIDAD_SUJETO = item.PRIORIDAD_SUJETO;
                          if ($scope.solicitante.IDENTIFICACION == "")
                          {
                            $scope.focus_identificacion_solicitante = true;
                          }
                        }
                        else if ($scope.formulario_invitado)
                        {
                          $scope.invitado.ID_PRIORIDAD_SUJETO = item.ID_PRIORIDAD_SUJETO;
                          $scope.invitado.PRIORIDAD_SUJETO = item.PRIORIDAD_SUJETO;
                          if ($scope.invitado.IDENTIFICACION == "")
                          {
                            $scope.focus_identificacion_invitado = true;
                          }
                        }
                      }
                      $scope.selectedGenero = function (item)
                      { 
                        if ($scope.formularioRepresentante)
                        {
                          descripciones_hombre();
                          $scope.representante.ID_GENERO = item.ID_GENERO;
                          // $scope.representante.GENERO = item.GENERO;
                          $scope.representante.SEXO_MUJER = false;
                          if (item.ID_GENERO == $scope.CONSTANTES.SEXO_MUJER)
                          {
                            descripciones_mujer();
                            $scope.representante.SEXO_MUJER = true;
                          }
                          else
                          {
                            $scope.representante.APELLIDO_CASADA="";
                          }
                        }
                        else if ($scope.formulario_solicitante)
                        {
                          descripciones_hombre();
                          $scope.solicitante.ID_GENERO = item.ID_GENERO;
                          // $scope.solicitante.GENERO = item.GENERO;
                          $scope.solicitante.SEXO_MUJER = false;
                          if (item.ID_GENERO == $scope.CONSTANTES.SEXO_MUJER)
                          { 
                            descripciones_mujer();
                            $scope.solicitante.SEXO_MUJER = true;
                          }
                          else
                          {
                            $scope.solicitante.APELLIDO_CASADA="";
                          }
                        }
                        else
                        { 
                          descripciones_hombre();
                          $scope.invitado.ID_GENERO = item.ID_GENERO;
                          // $scope.invitado.GENERO = item.GENERO;
                          $scope.invitado.SEXO_MUJER = false;
                          if (item.ID_GENERO == $scope.CONSTANTES.SEXO_MUJER)
                          { 
                            descripciones_mujer();
                            $scope.invitado.SEXO_MUJER = true;
                          }
                          else
                          {
                            $scope.invitado.APELLIDO_CASADA="";
                          }
                        }
                        getEstadoCivil(item.ID_GENERO,item.ID_ESTADO_CIVIL);
                        getProfesion(item.ID_GENERO,item.ID_PROFESION);
                      }
                      $scope.selectedEstadoCivil = function (item)
                      {
                        ID_ESTADO_CIVIL = item.ID_ESTADO_CIVIL;
                        if ($scope.formularioRepresentante)
                        {
                          $scope.representante.ID_ESTADO_CIVIL = item.ID_ESTADO_CIVIL;
                          // $scope.representante.ESTADO_CIVIL = item.ESTADO_CIVIL;
                        }
                        else if ($scope.formulario_solicitante)
                        {
                          $scope.solicitante.ID_ESTADO_CIVIL = item.ID_ESTADO_CIVIL;
                          // $scope.solicitante.ESTADO_CIVIL = item.ESTADO_CIVIL;
                        }
                        else
                        {
                          $scope.invitado.ID_ESTADO_CIVIL = item.ID_ESTADO_CIVIL;
                          // $scope.invitado.ESTADO_CIVIL = item.ESTADO_CIVIL;
                        }
                      }
                      selectedEstadoCivilTemporal = function (item)
                      {
                        if ($scope.formularioRepresentante)
                        {
                          $scope.representante.ID_ESTADO_CIVIL = item.ID_ESTADO_CIVIL;
                          // $scope.representante.ESTADO_CIVIL = item.ESTADO_CIVIL;
                        }
                        else if ($scope.formulario_solicitante)
                        {
                          $scope.solicitante.ID_ESTADO_CIVIL = item.ID_ESTADO_CIVIL;
                          // $scope.solicitante.ESTADO_CIVIL = item.ESTADO_CIVIL;
                        }
                        else
                        {
                          $scope.invitado.ID_ESTADO_CIVIL = item.ID_ESTADO_CIVIL;
                          // $scope.invitado.ESTADO_CIVIL = item.ESTADO_CIVIL;
                        }
                      }
                      $scope.selectedNivelEducativo = function (item)
                      {
                        if ($scope.formularioRepresentante)
                        {
                          $scope.representante.ID_NIVEL_EDUCATIVO = item.ID_NIVEL_EDUCATIVO;
                          // $scope.representante.NIVEL_EDUCATIVO = item.NIVEL_EDUCATIVO;
                        }
                        else if ($scope.formulario_solicitante)
                        {
                          $scope.solicitante.ID_NIVEL_EDUCATIVO = item.ID_NIVEL_EDUCATIVO;
                          // $scope.solicitante.NIVEL_EDUCATIVO = item.NIVEL_EDUCATIVO; 
                        }
                        else
                        {
                          $scope.invitado.ID_NIVEL_EDUCATIVO = item.ID_NIVEL_EDUCATIVO;
                          // $scope.invitado.NIVEL_EDUCATIVO = item.NIVEL_EDUCATIVO;
                        }
                      }
                      $scope.selectedProfesion = function (item)
                      {
                        ID_PROFESION = item.ID_PROFESION;
                        if ($scope.formularioRepresentante)
                        {
                          $scope.representante.ID_PROFESION = item.ID_PROFESION;
                          // $scope.representante.PROFESION = item.PROFESION;
                        }
                        else if ($scope.formulario_solicitante)
                        {
                          $scope.solicitante.ID_PROFESION = item.ID_PROFESION;
                          // $scope.solicitante.PROFESION = item.PROFESION; 
                        }
                        else
                        {
                          $scope.invitado.ID_PROFESION = item.ID_PROFESION;
                          // $scope.invitado.PROFESION = item.PROFESION;
                        }
                      }
                      selectedProfesionTemporal = function (item)
                      {
                        if ($scope.formularioRepresentante)
                        {
                          $scope.representante.ID_PROFESION = item.ID_PROFESION;
                          // $scope.representante.PROFESION = item.PROFESION;
                        }
                        else if ($scope.formulario_solicitante)
                        {
                          $scope.solicitante.ID_PROFESION = item.ID_PROFESION;
                          // $scope.solicitante.PROFESION = item.PROFESION; 
                        }
                        else
                        {
                          $scope.invitado.ID_PROFESION = item.ID_PROFESION;
                          // $scope.invitado.PROFESION = item.PROFESION;
                        }
                      }
                      $scope.selectedIdioma = function (item)
                      {
                        if ($scope.formularioRepresentante)
                        {
                          $scope.representante.ID_IDIOMA = item.ID_IDIOMA;
                          // $scope.representante.IDIOMA = item.IDIOMA;
                          $scope.representante.ID_CLASIFICACION_IDIOMA = item.ID_CLASIFICACION_IDIOMA;
                        }
                        else if ($scope.formulario_solicitante)
                        {
                          $scope.solicitante.ID_IDIOMA = item.ID_IDIOMA;
                          // $scope.solicitante.IDIOMA = item.IDIOMA;
                          $scope.solicitante.ID_CLASIFICACION_IDIOMA = item.ID_CLASIFICACION_IDIOMA; 
                        }
                        else
                        {
                          $scope.invitado.ID_IDIOMA = item.ID_IDIOMA;
                          // $scope.invitado.IDIOMA = item.IDIOMA;
                          $scope.invitado.ID_CLASIFICACION_IDIOMA = item.ID_CLASIFICACION_IDIOMA;
                        }
                      }
                      limpiarIdioma = function(limpiar)
                      {
                        if ($scope.formularioRepresentante) 
                        {
                          ((!$scope.editar_representante) || ($scope.representante.IDENTIFICACION == "") || (limpiar))
                          {
                            $scope.representante.ID_IDIOMA = "";
                            $scope.representante.ID_CLASIFICACION_IDIOMA = "";
                            $scope.idiomas = [];
                          }
                        }
                        else if ($scope.formulario_solicitante)
                        { 
                          if ((!$scope.editar_solicitante) || ($scope.solicitante.IDENTIFICACION == "") || (limpiar))
                          {
                            $scope.solicitante.ID_IDIOMA = "";
                            $scope.solicitante.ID_CLASIFICACION_IDIOMA = "";                              
                            $scope.idiomas = [];
                          }
                        }
                        else if ($scope.formulario_invitado)
                        {
                          ((!$scope.editar_invitado) || ($scope.invitado.IDENTIFICACION == "") || (limpiar))
                          {
                            $scope.invitado.ID_IDIOMA = "";
                            $scope.invitado.ID_CLASIFICACION_IDIOMA = "";                              
                            $scope.idiomas = [];
                          }
                        }
                      }
                      getIdioma = function (p_id_nacionalidad,p_id_tipo_poblacion,p_id_tipo_clasificacion_idioma,limpiar)
                      {
                        casosService.getIdioma(p_id_nacionalidad,p_id_tipo_poblacion,p_id_tipo_clasificacion_idioma).then(
                          function ( response ) 
                          {
                            limpiarIdioma(limpiar);     
                            $scope.idiomas = [];
                            $scope.idiomas = response.data;
                            if ($scope.idiomas.length == 1)
                            {
                              $scope.selectedIdioma(response.data[0]);
                            }
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                      }
                      limpiarNacionalidad = function()
                      {
                        if ($scope.formularioRepresentante)
                        {
                          $scope.representante.ID_NACIONALIDAD = "";
                          // $scope.representante.TIPO_POBLACION = "";
                        }
                        else if ($scope.formulario_solicitante)
                        {
                          $scope.solicitante.ID_NACIONALIDAD = "";
                          // $scope.solicitante.TIPO_POBLACION = ""; 
                        }
                        else 
                        {
                          $scope.invitado.ID_NACIONALIDAD = "";
                          // $scope.invitado.TIPO_POBLACION = "";                       
                        }
                        limpiarTipoPoblacion();
                      }
                      limpiarTipoPoblacion = function()
                      {
                        if ((($scope.formularioRepresentante) && (!$scope.editar_representante)) ||
                            (($scope.formularioRepresentante) && ($scope.representante.IDENTIFICACION == "")))
                        {
                          $scope.representante.ID_TIPO_POBLACION = "";
                        }
                        else if ((($scope.formulario_solicitante) && (!$scope.editar_solicitante)) ||
                                 (($scope.formulario_solicitante) && ($scope.solicitante.IDENTIFICACION == "")))
                        {
                          $scope.solicitante.ID_TIPO_POBLACION = "";
                        }
                        else if ((($scope.formulario_invitado) && (!$scope.editar_invitado)) ||
                                 (($scope.formulario_invitado) && ($scope.invitado.IDENTIFICACION == "")))
                        {
                          $scope.invitado.ID_TIPO_POBLACION = "";
                          // $scope.invitado.TIPO_POBLACION = "";                       
                        }
                        limpiarIdioma(!$scope.limpiar_combo); 
                      }
                      $scope.selectedTipoPoblacion = function (item,limpiar)
                      {
                        ID_NACIONALIDAD = "";
                        if ($scope.formularioRepresentante)
                        {
                          $scope.representante.ID_TIPO_POBLACION = item.ID_TIPO_POBLACION;
                          // $scope.representante.TIPO_POBLACION = item.TIPO_POBLACION;
                          ID_NACIONALIDAD = $scope.representante.ID_NACIONALIDAD;
                        }
                        else if ($scope.formulario_solicitante)
                        {
                          $scope.solicitante.ID_TIPO_POBLACION = item.ID_TIPO_POBLACION;
                          // $scope.solicitante.TIPO_POBLACION = item.TIPO_POBLACION;
                          ID_NACIONALIDAD = $scope.solicitante.ID_NACIONALIDAD;  
                        }
                        else
                        {
                          $scope.invitado.ID_TIPO_POBLACION = item.ID_TIPO_POBLACION;
                          // $scope.invitado.TIPO_POBLACION = item.TIPO_POBLACION;
                          ID_NACIONALIDAD = $scope.invitado.ID_NACIONALIDAD;
                        }
                        getIdioma(ID_NACIONALIDAD,item.ID_TIPO_POBLACION,$scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO,limpiar);
                      }
                      getTipoPoblacion = function (p_id_nacionalidad,p_id_tipo_clasificacion_idioma)
                      {
                        casosService.getTipoPoblacion(p_id_nacionalidad,p_id_tipo_clasificacion_idioma).then(
                          function ( response ) 
                          {    
                            limpiarTipoPoblacion();
                            $scope.tipoPoblacion = [];
                            $scope.tipoPoblacion = response.data;
                            if ($scope.tipoPoblacion.length == 1)
                            {
                              $scope.selectedTipoPoblacion(response.data[0],!$scope.limpiar_combo);
                            }
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                      }
                      $scope.selectedNacionalidad = function (item)
                      {
                        if ($scope.formularioRepresentante)
                        {
                          $scope.representante.ID_NACIONALIDAD = item.ID_NACIONALIDAD;
                          // $scope.representante.NACIONALIDAD = item.NACIONALIDAD;
                        }
                        else if ($scope.formulario_solicitante)
                        {
                          $scope.solicitante.ID_NACIONALIDAD = item.ID_NACIONALIDAD;
                          // $scope.solicitante.NACIONALIDAD = item.NACIONALIDAD;
                        }
                        else
                        {
                          $scope.invitado.ID_NACIONALIDAD = item.ID_NACIONALIDAD;
                          // $scope.invitado.NACIONALIDAD = item.NACIONALIDAD;
                        }
                        getTipoPoblacion(item.ID_NACIONALIDAD,$scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO);
                      }
                      //se obtiene el arreglo inicial para el tipo de identificacion de los sujetos
                      buscarNacionalidad = function(valor, arreglo){
                        for (var i=0; i < arreglo.length; i++) {
                            if (arreglo[i].ID_NACIONALIDAD === valor) {
                                return arreglo[i];
                            }
                        }
                      }
                      getNacionalidad = function(p_id_tipo_clasificacion_idioma,p_id_tipo_identificacion)
                      {
                        casosService.getNacionalidad(p_id_tipo_clasificacion_idioma,p_id_tipo_identificacion).then(
                          function ( response ) 
                          {
                            limpiarNacionalidad();                           
                            $scope.nacionalidades = [];   
                            $scope.nacionalidades = response.data;
                            if ($scope.nacionalidades.length == 1)
                            {
                              $scope.selectedNacionalidad(response.data[0]);
                            }
                            //itemNacionalidad = buscarNacionalidad($scope.CONSTANTES.NACIONALIDAD_GUATEMALTECA,$scope.nacionalidades);
                            //$scope.selectedNacionalidad(itemNacionalidad);
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                      }
                      //getNacionalidad($scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO,$scope.CONSTANTES.TIPO_IDENTIFICACION_DPI);
                      getPoblacionIdioma = function(item)
                      {
                        if ((item.ID_NACIONALIDAD != undefined) && (item.ID_NACIONALIDAD != ""))
                        {
                          $scope.tipoPoblacion = [];
                          casosService.getTipoPoblacion(item.ID_NACIONALIDAD,$scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO).then(
                            function ( response ) 
                            {    
                              $scope.tipoPoblacion = response.data;
                            },
                            function ( error ) 
                            {
                                toastr.error( error );
                            });
                          if ((item.ID_TIPO_POBLACION != undefined) && (item.ID_TIPO_POBLACION != ""))
                          {
                            $scope.idiomas = [];
                            casosService.getIdioma(item.ID_NACIONALIDAD,item.ID_TIPO_POBLACION,$scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO).then(
                            function ( response ) 
                            {
                              $scope.idiomas = response.data;
                            },
                            function ( error ) 
                            {
                                toastr.error( error );
                            });
                          }
                        }
                      }
                      $scope.reinicio_contado_mensajes_invalidos = function()
                      {
                        contador_mensajes_invalidos = 0;
                      }

                      $scope.verificar_identificacion_invitado = function()
                      {
                        if (($scope.invitado.IDENTIFICACION != "") && ($scope.invitado.IDENTIFICACION != undefined))
                        {
                          if ($scope.invitado.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI)
                          {
                            $scope.valida_identificacion($scope.invitado.IDENTIFICACION);
                          }
                          if ($scope.UBICACION_CORRECTA)
                          {
                            $scope.campo_requerido_invitado = true;
                            $scope.deshabilitar_datos_sujeto = true;
                          }
                        }
                        else
                        {
                          $scope.UBICACION_CORRECTA = true;
                        }
                      }

                      $scope.verificar_identificacion_solicitante = function()
                      {
                        if ($scope.caso.REQUIERE_EXPEDIENTE== $scope.CONSTANTES.REGISTRO_VERDADERO)
                        {
                          if (($scope.solicitante.IDENTIFICACION != "") && ($scope.solicitante.IDENTIFICACION != undefined))
                          {
                            if ($scope.solicitante.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI)
                            {
                              $scope.valida_identificacion($scope.solicitante.IDENTIFICACION);
                            }
                            if ($scope.UBICACION_CORRECTA)
                            {
                              $scope.campo_requerido_solicitante = true;
                              $scope.deshabilitar_datos_sujeto = true;
                            }
                          }
                          else
                          {
                            $scope.UBICACION_CORRECTA = true;
                          }  
                        } 
                      }
                      
                      $scope.verificar_identificacion_representante = function()
                      {
                        if ($scope.caso.REQUIERE_EXPEDIENTE== $scope.CONSTANTES.REGISTRO_VERDADERO)
                        {
                          if (($scope.representante.IDENTIFICACION != "") && ($scope.representante.IDENTIFICACION != undefined))
                          {
                            if ($scope.representante.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI)
                            {
                              $scope.valida_identificacion($scope.representante.IDENTIFICACION);
                            }
                            if ($scope.UBICACION_CORRECTA)
                            {
                              $scope.campo_requerido = true;
                              $scope.deshabilitar_datos_sujeto_representante = true;
                            }
                          }
                          else
                          {
                            $scope.UBICACION_CORRECTA = true;
                          }  
                        } 
                      }

                      $scope.reinicio_contado_mensajes_invalidos();
                      $scope.valida_identificacion = function(IDENTIFICACION)
                      {
                        if (IDENTIFICACION != undefined)
                        {
                          if (contador_mensajes_invalidos < 100) 
                          {
                            validaUbicacionNacimiento();
                          }
                          contador_mensajes_invalidos++;
                        }
                      }
                      //verificar si se usa para obtener el lugar de nacimiento de los sujetos o se obtiene desde la base
                      getUbicacionNacimiento = function(IDENTIFICACION)
                      {
                        IDENTIFICACION = IDENTIFICACION.replace(/\s/g, "");
                        IDENTIFICACION = IDENTIFICACION.substring(IDENTIFICACION.length-4, IDENTIFICACION.length);                      
                        casosService.getUbicacionNacimiento(IDENTIFICACION).then(
                          function ( response ) 
                          { 
                            if (response.data.id == 0)
                            {
                              toastr.warning(response.data.msj);
                              $scope.mensaje_ubicacion_incorrecta = response.data.msj
                              $scope.UBICACION_CORRECTA = false;
                            }
                            else
                            {
                              $scope.UBICACION_CORRECTA = true;
                            }
                          },
                          function ( error ) 
                          {
                            toastr.error( error );
                          });  
                      }
                      validaUbicacionNacimiento = function()
                      {
                        if (($scope.formularioRepresentante) &&
                            ($scope.representante.IDENTIFICACION != undefined) && 
                            ($scope.representante.IDENTIFICACION != "") &&
                            ($scope.representante.ID_TIPO_IDENTIFICACION == $scope.caso.IDENTIFICACION_DPI))
                          {
                            getUbicacionNacimiento($scope.representante.IDENTIFICACION);
                          }
                        else if (($scope.formulario_solicitante) &&
                                 ($scope.solicitante.IDENTIFICACION != undefined) && 
                                 ($scope.solicitante.IDENTIFICACION != "") &&
                                 ($scope.solicitante.ID_TIPO_IDENTIFICACION == $scope.caso.IDENTIFICACION_DPI))
                          {
                            getUbicacionNacimiento($scope.solicitante.IDENTIFICACION);
                          }
                        else if (($scope.formulario_invitado) &&
                                 ($scope.invitado.IDENTIFICACION != undefined) && 
                                 ($scope.invitado.IDENTIFICACION != "") &&
                                 ($scope.invitado.ID_TIPO_IDENTIFICACION == $scope.caso.IDENTIFICACION_DPI))
                          {
                            getUbicacionNacimiento($scope.invitado.IDENTIFICACION);
                          }
                      }
                      desplegar_mensaje_fecha_invalida = true;
                      $scope.valida_fecha_nacimiento = function(FECHA_NACIMIENTO)
                      {
                        if (FECHA_NACIMIENTO != undefined) 
                        {
                          contador_mensajes_invalidos++;
                          if (FECHA_NACIMIENTO >= $scope.dateOptions.minDate)
                          {
                            if (FECHA_NACIMIENTO <= $scope.dateOptions.maxDate)
                            {
                              $scope.FECHA_NACIMIENTO_VALIDA = true;
                              contador_mensajes_invalidos = 0;
                            }
                            else
                            {
                              if ((desplegar_mensaje_fecha_invalida) && (contador_mensajes_invalidos < 2))
                              {
                                toastr.warning('Fecha de nacimiento invalida, no se pueden registrar menores de edad');
                              }
                              desplegar_mensaje_fecha_invalida = !desplegar_mensaje_fecha_invalida;
                              $scope.FECHA_NACIMIENTO_VALIDA = false;
                            }
                          }
                          else
                          { 
                            if ((desplegar_mensaje_fecha_invalida) && (contador_mensajes_invalidos < 2))
                            {
                              toastr.warning('Fecha de nacimiento invalida');
                            }
                            desplegar_mensaje_fecha_invalida = !desplegar_mensaje_fecha_invalida;
                            $scope.FECHA_NACIMIENTO_VALIDA = false;
                          }
                        }
                        else
                        {
                          contador_mensajes_invalidos = 0;
                        }
                      }
                      validaSujetos = function()
                      {
                        // if ($scope.formulario_solicitante)
                          $scope.SOLICITANTES_AGREGADOS = false;
                          //$scope.formulario_solicitante_completo = false;
                          if ($scope.solicitantes.seleccion.length > 0)
                          {
                            $scope.SOLICITANTES_AGREGADOS = true;
                            //$scope.formulario_solicitante_completo = true;
                          }
                          $scope.SOLICITANTE_PRINCIPAL_AGREGADO = false;
                          BreakException = {};
                          try 
                          {
                            $scope.solicitantes.seleccion.forEach(function(solicitantes) 
                            {
                              if (solicitantes.ID_PRIORIDAD_SUJETO == $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL)                  
                              {
                                throw BreakException;
                              }
                            });
                          } catch (e) 
                          {
                            $scope.SOLICITANTE_PRINCIPAL_AGREGADO = true;
                          }  
                        // }
                        // else if ($scope.formulario_invitado)
                          $scope.INVITADOS_AGREGADOS = false;
                          // $scope.formulario_invitado_completo = false;
                          if ($scope.invitados.seleccion.length > 0)
                          {
                            $scope.INVITADOS_AGREGADOS = true;
                            // $scope.formulario_invitado_completo = true;
                          }
                          $scope.INVITADO_PRINCIPAL_AGREGADO = false;
                          BreakException = {};
                          try 
                          {
                            $scope.invitados.seleccion.forEach(function(invitados) 
                            {
                              if (invitados.ID_PRIORIDAD_SUJETO == $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL)                  
                              {
                                throw BreakException;
                              }
                            });
                          } catch (e) 
                          {
                            $scope.INVITADO_PRINCIPAL_AGREGADO = true;
                          }  
                        // }
                        // else
                        // {
                        //   if ($scope.solicitantes.seleccion.length > 0)
                        //   {
                        //     $scope.SOLICITANTES_AGREGADOS = true;
                        //   }
                        //   if ($scope.invitados.seleccion.length > 0)
                        //   {
                        //     $scope.INVITADOS_AGREGADOS = true;
                        //   }
                        // }
                      }
                      ordenarSujeto = function()
                      {
                        if ($scope.formulario_solicitante)
                        {
                          var filtered = [];
                          angular.forEach($scope.solicitantes.seleccion, function(item)
                          {
                            filtered.push(item);
                          });
                          filtered.sort(function (a, b) 
                          {  
                            a_ID_TIPO_SUJETO = a.ID_TIPO_SUJETO;
                            b_ID_TIPO_SUJETO = b.ID_TIPO_SUJETO;
                            a_ID_PRIORIDAD_SUJETO = a.ID_PRIORIDAD_SUJETO;
                            b_ID_PRIORIDAD_SUJETO = b.ID_PRIORIDAD_SUJETO;
                            if(a_ID_TIPO_SUJETO == b_ID_TIPO_SUJETO)
                            {
                                return (a_ID_PRIORIDAD_SUJETO < b_ID_PRIORIDAD_SUJETO) ? -1 : (a_ID_PRIORIDAD_SUJETO > b_ID_PRIORIDAD_SUJETO) ? 1 : 0;
                            }
                            else
                            {
                                return (a_ID_TIPO_SUJETO < b_ID_TIPO_SUJETO) ? -1 : 1;
                            }
                          });
                          $scope.solicitantes.seleccion =  filtered;  
                        }
                        else
                        {
                          var filtered = [];
                          angular.forEach($scope.invitados.seleccion, function(item)
                          {
                            filtered.push(item);
                          });
                          filtered.sort(function (a, b) 
                          {  
                            a_ID_TIPO_SUJETO = a.ID_TIPO_SUJETO;
                            b_ID_TIPO_SUJETO = b.ID_TIPO_SUJETO;
                            a_ID_PRIORIDAD_SUJETO = a.ID_PRIORIDAD_SUJETO;
                            b_ID_PRIORIDAD_SUJETO = b.ID_PRIORIDAD_SUJETO;
                            if(a_ID_TIPO_SUJETO == b_ID_TIPO_SUJETO)
                            {
                                return (a_ID_PRIORIDAD_SUJETO < b_ID_PRIORIDAD_SUJETO) ? -1 : (a_ID_PRIORIDAD_SUJETO > b_ID_PRIORIDAD_SUJETO) ? 1 : 0;
                            }
                            else
                            {
                                return (a_ID_TIPO_SUJETO < b_ID_TIPO_SUJETO) ? -1 : 1;
                            }
                          });
                          $scope.invitados.seleccion =  filtered;  
                        }
                      }
                      validaSujetoPrincipal = function()
                      {
                        cambiar_prioridad = false;  
                        if ($scope.formulario_solicitante)
                        {
                          longitud = $scope.solicitantes.seleccion.length;
                          if (longitud > 1)
                          {
                            if (($scope.editar_solicitante) && 
                                ($scope.solicitantes.seleccion[$scope.index].ID_PRIORIDAD_SUJETO == $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL))
                            {
                              index = $scope.index;
                              cambiar_prioridad = true;  
                              descripcion_sujeto_principal = $scope.solicitantes.seleccion[$scope.index].PRIORIDAD_SUJETO;
                            }
                            else if ($scope.solicitantes.seleccion[longitud-1].ID_PRIORIDAD_SUJETO == $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL)
                            {
                              index = $scope.solicitantes.seleccion.length-1;
                              cambiar_prioridad = true;
                              descripcion_sujeto_principal = $scope.solicitantes.seleccion[index].PRIORIDAD_SUJETO;
                            }
                            if (cambiar_prioridad)
                            {
                              itemPrioridadSujeto = buscarPrioridadSujeto($scope.CONSTANTES.PRIORIDAD_SUJETO_SECUNDARIO, $scope.prioridadSujetos);
                              for (i=0; i<longitud; i++)
                              {
                                if (i==index)
                                {
                                  $scope.deshabilitar_prioridad_solicitante = true;
                                  $scope.solicitantes.seleccion[i].ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL;
                                  $scope.solicitantes.seleccion[i].PRIORIDAD_SUJETO = descripcion_sujeto_principal;  
                                }
                                else
                                {
                                  $scope.solicitantes.seleccion[i].ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_SECUNDARIO;
                                  $scope.solicitantes.seleccion[i].PRIORIDAD_SUJETO = itemPrioridadSujeto.PRIORIDAD_SUJETO;
                                }
                              }
                            }
                          }
                        }
                        else if ($scope.formulario_invitado)
                        {
                          longitud = $scope.invitados.seleccion.length;
                          if (longitud > 1)
                          {
                            if (($scope.editar_invitado) && 
                                ($scope.invitados.seleccion[$scope.index].ID_PRIORIDAD_SUJETO == $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL))
                            {
                              index = $scope.index;
                              cambiar_prioridad = true;  
                              descripcion_sujeto_principal = $scope.invitados.seleccion[$scope.index].PRIORIDAD_SUJETO;
                            }
                            else if ($scope.invitados.seleccion[longitud-1].ID_PRIORIDAD_SUJETO == $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL)
                            {
                              index = $scope.invitados.seleccion.length-1;
                              cambiar_prioridad = true;
                              descripcion_sujeto_principal = $scope.invitados.seleccion[index].PRIORIDAD_SUJETO;
                            }
                            if (cambiar_prioridad)
                            {
                              itemPrioridadSujeto = buscarPrioridadSujeto($scope.CONSTANTES.PRIORIDAD_SUJETO_SECUNDARIO, $scope.prioridadSujetos);
                              for (i=0; i<longitud; i++)
                              {
                                if (i==index)
                                {
                                  $scope.deshabilitar_prioridad_invitado = true;
                                  $scope.invitados.seleccion[i].ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL;
                                  $scope.invitados.seleccion[i].PRIORIDAD_SUJETO = descripcion_sujeto_principal;  
                                }
                                else
                                {
                                  $scope.invitados.seleccion[i].ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_SECUNDARIO;
                                  $scope.invitados.seleccion[i].PRIORIDAD_SUJETO = itemPrioridadSujeto.PRIORIDAD_SUJETO;
                                }
                              }
                            }
                          }
                        }
                      }
                      funcionesSujeto = function()
                      {
                        validaSujetoPrincipal();
                        $scope.cambiarBotones();
                        validaSujetos();
                        $scope.limpiarSujeto();
                        $scope.restaurarValoresSujeto();
                        ordenarSujeto();
                      }
                      validaSexo = function()
                      { 
                        $scope.validacionSexoSujeto = false;
                        if ($scope.formularioRepresentante)
                        {
                          if (($scope.representante.ID_GENERO != undefined) && ($scope.representante.ID_GENERO != ""))
                          {
                            $scope.validacionSexoSujeto = true;
                          }
                        }
                        else if (($scope.formulario_solicitante) && 
                                 ($scope.solicitante.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL))
                        {
                          if (($scope.solicitante.ID_GENERO != undefined) && ($scope.solicitante.ID_GENERO != ""))
                          {
                            $scope.validacionSexoSujeto = true;
                          }
                        }
                        else if (($scope.formulario_invitado) && 
                                 ($scope.invitado.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL))
                        {
                          if (($scope.invitado.ID_GENERO != undefined) && ($scope.invitado.ID_GENERO != ""))
                          {
                            $scope.validacionSexoSujeto = true;
                          }
                        }
                        else
                        {
                          $scope.validacionSexoSujeto = true;
                        }
                      }
                      $scope.agregarSujeto = function(isValid,accion)
                      {
                        validaDireccion();
                        validaRepresentante();
                        validaSexo();
                        nombre_sujeto = "";
                        espacio_nombre=" ";
                        if ($scope.formulario_solicitante)
                        {
                          if((isValid) && 
                             ($scope.solicitante.DIRECCION) && 
                             ($scope.UBICACION_CORRECTA) &&
                             ($scope.REPRESENTANTES_AGREGADOS) &&
                             ($scope.validacionSexoSujeto))
                          {
                            mensaje_operacion = "Solicitante agregado correctamente";
                            if ($scope.solicitante.SUJETO_NATURAL)
                            {
                              nombre_sujeto = $scope.solicitante.PRIMER_NOMBRE;
                              if ($scope.solicitante.SEGUNDO_NOMBRE != undefined && $scope.solicitante.SEGUNDO_NOMBRE != "")
                              {
                                nombre_sujeto = nombre_sujeto+espacio_nombre+$scope.solicitante.SEGUNDO_NOMBRE;
                              }
                              if ($scope.solicitante.TERCER_NOMBRE != undefined && $scope.solicitante.TERCER_NOMBRE != "")
                              {
                                nombre_sujeto = nombre_sujeto+espacio_nombre+$scope.solicitante.TERCER_NOMBRE;
                              }
                              nombre_sujeto = nombre_sujeto+espacio_nombre+$scope.solicitante.PRIMER_APELLIDO;
                              if ($scope.solicitante.SEGUNDO_APELLIDO != undefined && $scope.solicitante.SEGUNDO_APELLIDO != "")
                              {
                                nombre_sujeto = nombre_sujeto+espacio_nombre+$scope.solicitante.SEGUNDO_APELLIDO;
                              }
                              if ($scope.solicitante.APELLIDO_CASADA != undefined && $scope.solicitante.APELLIDO_CASADA != "")
                              {
                                nombre_sujeto = nombre_sujeto+espacio_nombre+'DE'+espacio_nombre+$scope.solicitante.APELLIDO_CASADA;
                              }
                            }
                            else
                            {
                              nombre_sujeto = $scope.solicitante.SUJETO_JURIDICO;
                              if ($scope.solicitante.MARCA_COMERCIAL != undefined && $scope.solicitante.MARCA_COMERCIAL != "")
                              {
                                nombre_sujeto = nombre_sujeto+espacio_nombre+"("+$scope.solicitante.MARCA_COMERCIAL+")";
                              }
                            }
                            $scope.solicitante.SUJETO=nombre_sujeto;  
                            if ($scope.editar_solicitante)
                            {
                              if ($scope.solicitante.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                              {
                                $scope.solicitantes.seleccion[$scope.index].APELLIDO_CASADA = $scope.solicitante.APELLIDO_CASADA;
                                $scope.solicitantes.seleccion[$scope.index].contactos = $scope.datosContacto.seleccion;
                                $scope.solicitantes.seleccion[$scope.index].contactoseliminacion = $scope.datosContacto.eliminacion;
                                //$scope.solicitantes.seleccion[$scope.index].FECHA_NACIMIENTO = fechaFormatoYYYYMMDD($scope.solicitante.FECHA_NACIMIENTO);
                                $scope.solicitantes.seleccion[$scope.index].FECHA_NACIMIENTO = $scope.solicitante.FECHA_NACIMIENTO;
                                $scope.solicitantes.seleccion[$scope.index].ICONO_TIPO_SUJETO = $scope.solicitante.ICONO_TIPO_SUJETO;
                                $scope.solicitantes.seleccion[$scope.index].IDENTIFICACION = $scope.solicitante.IDENTIFICACION;
                                $scope.solicitantes.seleccion[$scope.index].ID_CLASIFICACION_IDIOMA = $scope.solicitante.ID_CLASIFICACION_IDIOMA;
                                $scope.solicitantes.seleccion[$scope.index].ID_ESTADO_CIVIL = $scope.solicitante.ID_ESTADO_CIVIL;
                                $scope.solicitantes.seleccion[$scope.index].ID_GENERO = $scope.solicitante.ID_GENERO;
                                $scope.solicitantes.seleccion[$scope.index].ID_IDIOMA = $scope.solicitante.ID_IDIOMA;
                                $scope.solicitantes.seleccion[$scope.index].ID_NACIONALIDAD = $scope.solicitante.ID_NACIONALIDAD;
                                $scope.solicitantes.seleccion[$scope.index].ID_NIVEL_EDUCATIVO = $scope.solicitante.ID_NIVEL_EDUCATIVO;
                                $scope.solicitantes.seleccion[$scope.index].ID_PRIORIDAD_SUJETO = $scope.solicitante.ID_PRIORIDAD_SUJETO;
                                $scope.solicitantes.seleccion[$scope.index].ID_PROFESION = $scope.solicitante.ID_PROFESION;
                                $scope.solicitantes.seleccion[$scope.index].ID_SUJETO = $scope.solicitante.ID_SUJETO;
                                $scope.solicitantes.seleccion[$scope.index].ID_SUJETO_NATURAL = $scope.solicitante.ID_SUJETO_NATURAL;
                                $scope.solicitantes.seleccion[$scope.index].ID_SUJETO_NAT_IDENTIFICACION = $scope.solicitante.ID_SUJETO_NAT_IDENTIFICACION;
                                $scope.solicitantes.seleccion[$scope.index].ID_TIPO_IDENTIFICACION = $scope.solicitante.ID_TIPO_IDENTIFICACION;
                                $scope.solicitantes.seleccion[$scope.index].ID_TIPO_POBLACION = $scope.solicitante.ID_TIPO_POBLACION;
                                $scope.solicitantes.seleccion[$scope.index].ID_TIPO_SUJETO = $scope.solicitante.ID_TIPO_SUJETO;
                                $scope.solicitantes.seleccion[$scope.index].MASCARA_IDENTIFICACION = $scope.solicitante.MASCARA_IDENTIFICACION;
                                $scope.solicitantes.seleccion[$scope.index].PRIMER_APELLIDO = $scope.solicitante.PRIMER_APELLIDO;
                                $scope.solicitantes.seleccion[$scope.index].PRIMER_NOMBRE = $scope.solicitante.PRIMER_NOMBRE;
                                $scope.solicitantes.seleccion[$scope.index].PRIORIDAD_SUJETO = $scope.solicitante.PRIORIDAD_SUJETO;
                                $scope.solicitantes.seleccion[$scope.index].SEGUNDO_APELLIDO = $scope.solicitante.SEGUNDO_APELLIDO;
                                $scope.solicitantes.seleccion[$scope.index].SEGUNDO_NOMBRE = $scope.solicitante.SEGUNDO_NOMBRE;
                                $scope.solicitantes.seleccion[$scope.index].SUJETO = $scope.solicitante.SUJETO;
                                $scope.solicitantes.seleccion[$scope.index].TERCER_NOMBRE = $scope.solicitante.TERCER_NOMBRE;
                                $scope.solicitantes.seleccion[$scope.index].ID_DISCAPACIDAD = $scope.solicitante.ID_DISCAPACIDAD;
                              }
                              else
                              {
                                $scope.solicitantes.seleccion[$scope.index].contactos = $scope.datosContacto.seleccion;
                                $scope.solicitantes.seleccion[$scope.index].contactoseliminacion = $scope.datosContacto.eliminacion;
                                $scope.solicitantes.seleccion[$scope.index].ICONO_TIPO_SUJETO = $scope.solicitante.ICONO_TIPO_SUJETO;
                                $scope.solicitantes.seleccion[$scope.index].IDENTIFICACION = $scope.solicitante.IDENTIFICACION;
                                $scope.solicitantes.seleccion[$scope.index].ID_PRIORIDAD_SUJETO = $scope.solicitante.ID_PRIORIDAD_SUJETO;
                                $scope.solicitantes.seleccion[$scope.index].ID_SUJETO = $scope.solicitante.ID_SUJETO;
                                $scope.solicitantes.seleccion[$scope.index].ID_SUJETO_JURIDICO = $scope.solicitante.ID_SUJETO_JURIDICO;
                                $scope.solicitantes.seleccion[$scope.index].ID_SUJETO_JUR_IDENTIFICACION = $scope.solicitante.ID_SUJETO_JUR_IDENTIFICACION;
                                $scope.solicitantes.seleccion[$scope.index].ID_TIPO_IDENTIFICACION = $scope.solicitante.ID_TIPO_IDENTIFICACION;
                                $scope.solicitantes.seleccion[$scope.index].ID_TIPO_SUJETO = $scope.solicitante.ID_TIPO_SUJETO;
                                $scope.solicitantes.seleccion[$scope.index].MASCARA_IDENTIFICACION = $scope.solicitante.MASCARA_IDENTIFICACION;
                                $scope.solicitantes.seleccion[$scope.index].MARCA_COMERCIAL = $scope.solicitante.MARCA_COMERCIAL,
                                $scope.solicitantes.seleccion[$scope.index].PRIORIDAD_SUJETO = $scope.solicitante.PRIORIDAD_SUJETO;
                                //$scope.solicitantes.seleccion[$scope.index].representantes = $scope.representantes.seleccion;
                                $scope.solicitantes.seleccion[$scope.index].SUJETO_JURIDICO = $scope.solicitante.SUJETO_JURIDICO,
                                $scope.solicitantes.seleccion[$scope.index].SUJETO = $scope.solicitante.SUJETO;
                              }
                              mensaje_operacion = "Solicitante actualizado correctamente";
                            }
                            else
                            {
                              if ($scope.solicitante.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                              {
                                $scope.solicitantes.seleccion.push(
                                  {
                                    APELLIDO_CASADA:$scope.solicitante.APELLIDO_CASADA,
                                    contactos:$scope.datosContacto.seleccion,
                                    contactoseliminacion:$scope.datosContacto.eliminacion,
                                    //FECHA_NACIMIENTO:fechaFormatoYYYYMMDD($scope.solicitante.FECHA_NACIMIENTO),
                                    FECHA_NACIMIENTO:$scope.solicitante.FECHA_NACIMIENTO,
                                    ICONO_TIPO_SUJETO:$scope.solicitante.ICONO_TIPO_SUJETO,
                                    IDENTIFICACION:$scope.solicitante.IDENTIFICACION,
                                    ID_CLASIFICACION_IDIOMA:$scope.solicitante.ID_CLASIFICACION_IDIOMA,
                                    ID_ESTADO_CIVIL:$scope.solicitante.ID_ESTADO_CIVIL,
                                    ID_GENERO:$scope.solicitante.ID_GENERO,
                                    ID_IDIOMA:$scope.solicitante.ID_IDIOMA,
                                    ID_NACIONALIDAD:$scope.solicitante.ID_NACIONALIDAD,
                                    ID_NIVEL_EDUCATIVO:$scope.solicitante.ID_NIVEL_EDUCATIVO,
                                    ID_PRIORIDAD_SUJETO:$scope.solicitante.ID_PRIORIDAD_SUJETO,
                                    ID_PROFESION:$scope.solicitante.ID_PROFESION,
                                    ID_SUJETO:$scope.solicitante.ID_SUJETO,
                                    ID_SUJETO_NATURAL:$scope.solicitante.ID_SUJETO_NATURAL,
                                    ID_SUJETO_NAT_IDENTIFICACION:$scope.solicitante.ID_SUJETO_NAT_IDENTIFICACION,
                                    ID_TIPO_IDENTIFICACION:$scope.solicitante.ID_TIPO_IDENTIFICACION,
                                    ID_TIPO_POBLACION:$scope.solicitante.ID_TIPO_POBLACION,
                                    ID_TIPO_SUJETO:$scope.solicitante.ID_TIPO_SUJETO,
                                    MASCARA_IDENTIFICACION:$scope.solicitante.MASCARA_IDENTIFICACION,
                                    PRIMER_APELLIDO:$scope.solicitante.PRIMER_APELLIDO,
                                    PRIMER_NOMBRE:$scope.solicitante.PRIMER_NOMBRE,
                                    PRIORIDAD_SUJETO:$scope.solicitante.PRIORIDAD_SUJETO,
                                    SEGUNDO_APELLIDO:$scope.solicitante.SEGUNDO_APELLIDO,
                                    SEGUNDO_NOMBRE:$scope.solicitante.SEGUNDO_NOMBRE,
                                    SUJETO:$scope.solicitante.SUJETO,
                                    TERCER_NOMBRE:$scope.solicitante.TERCER_NOMBRE,
                                    ID_DISCAPACIDAD:$scope.solicitante.ID_DISCAPACIDAD
                                  });
                              }
                              else
                              {
                                $scope.solicitantes.seleccion.push(
                                  {
                                    contactos:$scope.datosContacto.seleccion,
                                    contactoseliminacion:$scope.datosContacto.eliminacion,
                                    ICONO_TIPO_SUJETO:$scope.solicitante.ICONO_TIPO_SUJETO,
                                    IDENTIFICACION:$scope.solicitante.IDENTIFICACION,
                                    ID_PRIORIDAD_SUJETO:$scope.solicitante.ID_PRIORIDAD_SUJETO,
                                    ID_SUJETO:$scope.solicitante.ID_SUJETO,
                                    ID_SUJETO_JURIDICO:$scope.solicitante.ID_SUJETO_JURIDICO,
                                    ID_SUJETO_JUR_IDENTIFICACION:$scope.solicitante.ID_SUJETO_JUR_IDENTIFICACION,
                                    ID_TIPO_IDENTIFICACION:$scope.solicitante.ID_TIPO_IDENTIFICACION,
                                    ID_TIPO_SUJETO:$scope.solicitante.ID_TIPO_SUJETO,
                                    MASCARA_IDENTIFICACION:$scope.solicitante.MASCARA_IDENTIFICACION,
                                    MARCA_COMERCIAL:$scope.solicitante.MARCA_COMERCIAL,
                                    PRIORIDAD_SUJETO:$scope.solicitante.PRIORIDAD_SUJETO,
                                    SUJETO_JURIDICO:$scope.solicitante.SUJETO_JURIDICO,
                                    representantes:$scope.representantes.seleccion,
                                    SUJETO:$scope.solicitante.SUJETO
                                  });
                              }
                            }
                            if ($scope.solicitantes.seleccion.length == 1)
                            {
                              if (accion == "siguiente")
                              {
                                funcionesSujeto();
                                $scope.formularioInvitado()
                              }
                              else if ((accion == "guardar") || ($scope.icono_boton_editar_solicitante == "fa fa-refresh"))
                              { 
                                if (accion == "guardar")
                                {
                                  verificacionGuardadoCaso(true);
                                }
                              }
                              else
                              {
                                funcionesSujeto();
                              }
                            }
                            else if ($scope.icono_boton_editar_solicitante == "fa fa-user-plus")
                            {
                              funcionesSujeto();
                            }
                            else
                            {
                              validaSujetoPrincipal();
                              //ordenarSujeto();
                            }
                            toastr.success(mensaje_operacion);

                            // if ($scope.solicitante.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                            // {
                            //   completarAgregadoSujeto(accion);
                            // }
                            // else
                            // {
                            //   if ($scope.campo_requerido_solicitante) 
                            //   {
                            //     $scope.campo_requerido = $scope.campo_requerido_solicitante;
                            //     $scope.mensaje_operacion_agregado = "Debe agregar como mínimo un representante al solicitante";
                            //     if (accion == 'agregar')
                            //     {
                            //       toastr.warning($scope.mensaje_operacion_agregado);
                            //     }
                            //     if (accion == 'agregar_representante')
                            //     {
                            //       $scope.activarFormularioRepresentante();
                            //     }
                            //   }
                            //   else
                            //   {
                            //     completarAgregadoSujeto(accion);
                            //   }
                            // }
                          }
                          else 
                          {
                            mensaje="Faltan datos por ingresar";
                            if(isValid)
                            {
                              if (!$scope.solicitante.DIRECCION)
                              {
                                mensaje="Debe agregar como mínimo una dirección en los datos de contacto";
                              }
                              else if (!$scope.UBICACION_CORRECTA)
                              {
                                mensaje = $scope.mensaje_ubicacion_incorrecta;
                              }
                              else if (!$scope.REPRESENTANTES_AGREGADOS)
                              {
                                mensaje="Debe agregar como mínimo un representante al solicitante";
                              }
                            }
                            toastr.warning(mensaje);
                          }
                        }
                        else if($scope.formulario_invitado)
                        {
                          if((isValid) && 
                             ($scope.invitado.DIRECCION) && 
                             ($scope.UBICACION_CORRECTA) &&
                             ($scope.REPRESENTANTES_AGREGADOS) &&
                             ($scope.validacionSexoSujeto))
                          {   
                            mensaje_operacion = "Invitado agregado correctamente";
                            if ($scope.invitado.SUJETO_NATURAL)
                            {
                              nombre_sujeto = $scope.invitado.PRIMER_NOMBRE;
                              if ($scope.invitado.SEGUNDO_NOMBRE != undefined && $scope.invitado.SEGUNDO_NOMBRE != "")
                              {
                                nombre_sujeto = nombre_sujeto+espacio_nombre+$scope.invitado.SEGUNDO_NOMBRE;
                              }
                              if ($scope.invitado.TERCER_NOMBRE != undefined && $scope.invitado.TERCER_NOMBRE != "")
                              {
                                nombre_sujeto = nombre_sujeto+espacio_nombre+$scope.invitado.TERCER_NOMBRE;
                              }
                              nombre_sujeto = nombre_sujeto+espacio_nombre+$scope.invitado.PRIMER_APELLIDO;
                              if ($scope.invitado.SEGUNDO_APELLIDO != undefined && $scope.invitado.SEGUNDO_APELLIDO != "")
                              {
                                nombre_sujeto = nombre_sujeto+espacio_nombre+$scope.invitado.SEGUNDO_APELLIDO;
                              }
                              if ($scope.invitado.APELLIDO_CASADA != undefined && $scope.invitado.APELLIDO_CASADA != "")
                              {
                                nombre_sujeto = nombre_sujeto+espacio_nombre+'DE'+espacio_nombre+$scope.invitado.APELLIDO_CASADA;
                              }
                            }
                            else
                            {
                              nombre_sujeto = $scope.invitado.SUJETO_JURIDICO;
                              if ($scope.invitado.MARCA_COMERCIAL != undefined && $scope.invitado.MARCA_COMERCIAL != "")
                              {
                                nombre_sujeto = nombre_sujeto+espacio_nombre+"("+$scope.invitado.MARCA_COMERCIAL+")";
                              }
                            }
                            $scope.invitado.SUJETO=nombre_sujeto;  
                            if ($scope.editar_invitado)
                            {
                              if ($scope.invitado.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                              {
                                $scope.invitados.seleccion[$scope.index].APELLIDO_CASADA = $scope.invitado.APELLIDO_CASADA;
                                $scope.invitados.seleccion[$scope.index].contactos = $scope.datosContacto.seleccion;
                                $scope.invitados.seleccion[$scope.index].contactoseliminacion = $scope.datosContacto.seleccion.eliminacion;
                                //$scope.invitados.seleccion[$scope.index].FECHA_NACIMIENTO = fechaFormatoYYYYMMDD($scope.invitado.FECHA_NACIMIENTO);
                                $scope.invitados.seleccion[$scope.index].FECHA_NACIMIENTO = $scope.invitado.FECHA_NACIMIENTO;
                                $scope.invitados.seleccion[$scope.index].ICONO_TIPO_SUJETO = $scope.invitado.ICONO_TIPO_SUJETO;
                                $scope.invitados.seleccion[$scope.index].IDENTIFICACION = $scope.invitado.IDENTIFICACION;
                                $scope.invitados.seleccion[$scope.index].ID_CLASIFICACION_IDIOMA = $scope.invitado.ID_CLASIFICACION_IDIOMA;
                                $scope.invitados.seleccion[$scope.index].ID_ESTADO_CIVIL = $scope.invitado.ID_ESTADO_CIVIL;
                                $scope.invitados.seleccion[$scope.index].ID_GENERO = $scope.invitado.ID_GENERO;
                                $scope.invitados.seleccion[$scope.index].ID_IDIOMA = $scope.invitado.ID_IDIOMA;
                                $scope.invitados.seleccion[$scope.index].ID_NACIONALIDAD = $scope.invitado.ID_NACIONALIDAD;
                                $scope.invitados.seleccion[$scope.index].ID_NIVEL_EDUCATIVO = $scope.invitado.ID_NIVEL_EDUCATIVO;
                                $scope.invitados.seleccion[$scope.index].ID_PRIORIDAD_SUJETO = $scope.invitado.ID_PRIORIDAD_SUJETO;
                                $scope.invitados.seleccion[$scope.index].ID_PROFESION = $scope.invitado.ID_PROFESION;
                                $scope.invitados.seleccion[$scope.index].ID_SUJETO = $scope.invitado.ID_SUJETO;
                                $scope.invitados.seleccion[$scope.index].ID_SUJETO_NATURAL = $scope.invitado.ID_SUJETO_NATURAL;
                                $scope.invitados.seleccion[$scope.index].ID_SUJETO_NAT_IDENTIFICACION = $scope.invitado.ID_SUJETO_NAT_IDENTIFICACION;
                                $scope.invitados.seleccion[$scope.index].ID_TIPO_IDENTIFICACION = $scope.invitado.ID_TIPO_IDENTIFICACION;
                                $scope.invitados.seleccion[$scope.index].ID_TIPO_POBLACION = $scope.invitado.ID_TIPO_POBLACION;
                                $scope.invitados.seleccion[$scope.index].ID_TIPO_SUJETO = $scope.invitado.ID_TIPO_SUJETO;
                                $scope.invitados.seleccion[$scope.index].MASCARA_IDENTIFICACION = $scope.invitado.MASCARA_IDENTIFICACION;
                                $scope.invitados.seleccion[$scope.index].PRIMER_APELLIDO = $scope.invitado.PRIMER_APELLIDO;
                                $scope.invitados.seleccion[$scope.index].PRIMER_NOMBRE = $scope.invitado.PRIMER_NOMBRE;
                                $scope.invitados.seleccion[$scope.index].PRIORIDAD_SUJETO = $scope.invitado.PRIORIDAD_SUJETO;
                                $scope.invitados.seleccion[$scope.index].SEGUNDO_APELLIDO = $scope.invitado.SEGUNDO_APELLIDO;
                                $scope.invitados.seleccion[$scope.index].SEGUNDO_NOMBRE = $scope.invitado.SEGUNDO_NOMBRE;
                                $scope.invitados.seleccion[$scope.index].SUJETO = $scope.invitado.SUJETO;
                                $scope.invitados.seleccion[$scope.index].TERCER_NOMBRE = $scope.invitado.TERCER_NOMBRE;
                                $scope.invitados.seleccion[$scope.index].ID_DISCAPACIDAD = $scope.invitado.ID_DISCAPACIDAD;
                              }
                              else
                              {
                                $scope.invitados.seleccion[$scope.index].contactos = $scope.datosContacto.seleccion;
                                $scope.invitados.seleccion[$scope.index].contactoseliminacion = $scope.datosContacto.seleccion.eliminacion;
                                $scope.invitados.seleccion[$scope.index].ICONO_TIPO_SUJETO = $scope.invitado.ICONO_TIPO_SUJETO;
                                $scope.invitados.seleccion[$scope.index].IDENTIFICACION = $scope.invitado.IDENTIFICACION;
                                $scope.invitados.seleccion[$scope.index].ID_PRIORIDAD_SUJETO = $scope.invitado.ID_PRIORIDAD_SUJETO;
                                $scope.invitados.seleccion[$scope.index].ID_SUJETO = $scope.invitado.ID_SUJETO;
                                $scope.invitados.seleccion[$scope.index].ID_SUJETO_JURIDICO = $scope.invitado.ID_SUJETO_JURIDICO;
                                $scope.invitados.seleccion[$scope.index].ID_SUJETO_JUR_IDENTIFICACION = $scope.invitado.ID_SUJETO_JUR_IDENTIFICACION;
                                $scope.invitados.seleccion[$scope.index].ID_TIPO_IDENTIFICACION = $scope.invitado.ID_TIPO_IDENTIFICACION;
                                $scope.invitados.seleccion[$scope.index].ID_TIPO_SUJETO = $scope.invitado.ID_TIPO_SUJETO;
                                $scope.invitados.seleccion[$scope.index].MASCARA_IDENTIFICACION = $scope.invitado.MASCARA_IDENTIFICACION;
                                $scope.invitados.seleccion[$scope.index].MARCA_COMERCIAL = $scope.invitado.MARCA_COMERCIAL;
                                //$scope.invitados.seleccion[$scope.index].representantes = $scope.representantes.seleccion;
                                $scope.invitados.seleccion[$scope.index].PRIORIDAD_SUJETO = $scope.invitado.PRIORIDAD_SUJETO;
                                $scope.invitados.seleccion[$scope.index].SUJETO_JURIDICO = $scope.invitado.SUJETO_JURIDICO;
                                $scope.invitados.seleccion[$scope.index].SUJETO = $scope.invitado.SUJETO;
                              }
                              mensaje_operacion = "Invitado actualizado correctamente";
                            }
                            else
                            {
                              if ($scope.invitado.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                              {
                                $scope.invitados.seleccion.push(
                                {
                                  APELLIDO_CASADA:$scope.invitado.APELLIDO_CASADA,
                                  contactos:$scope.datosContacto.seleccion,
                                  contactoseliminacion:$scope.datosContacto.eliminacion,
                                  //FECHA_NACIMIENTO:fechaFormatoYYYYMMDD($scope.invitado.FECHA_NACIMIENTO),
                                  FECHA_NACIMIENTO:$scope.invitado.FECHA_NACIMIENTO,
                                  ICONO_TIPO_SUJETO:$scope.invitado.ICONO_TIPO_SUJETO,
                                  IDENTIFICACION:$scope.invitado.IDENTIFICACION,
                                  ID_CLASIFICACION_IDIOMA:$scope.invitado.ID_CLASIFICACION_IDIOMA,
                                  ID_ESTADO_CIVIL:$scope.invitado.ID_ESTADO_CIVIL,
                                  ID_GENERO:$scope.invitado.ID_GENERO,
                                  ID_IDIOMA:$scope.invitado.ID_IDIOMA,
                                  ID_NACIONALIDAD:$scope.invitado.ID_NACIONALIDAD,
                                  ID_NIVEL_EDUCATIVO:$scope.invitado.ID_NIVEL_EDUCATIVO,
                                  ID_PRIORIDAD_SUJETO:$scope.invitado.ID_PRIORIDAD_SUJETO,
                                  ID_PROFESION:$scope.invitado.ID_PROFESION,
                                  ID_SUJETO:$scope.invitado.ID_SUJETO,
                                  ID_SUJETO_NATURAL:$scope.invitado.ID_SUJETO_NATURAL,
                                  ID_SUJETO_NAT_IDENTIFICACION:$scope.invitado.ID_SUJETO_NAT_IDENTIFICACION,
                                  ID_TIPO_IDENTIFICACION:$scope.invitado.ID_TIPO_IDENTIFICACION,
                                  ID_TIPO_POBLACION:$scope.invitado.ID_TIPO_POBLACION,
                                  ID_TIPO_SUJETO:$scope.invitado.ID_TIPO_SUJETO,
                                  MASCARA_IDENTIFICACION:$scope.invitado.MASCARA_IDENTIFICACION,
                                  PRIMER_APELLIDO:$scope.invitado.PRIMER_APELLIDO,
                                  PRIMER_NOMBRE:$scope.invitado.PRIMER_NOMBRE,
                                  PRIORIDAD_SUJETO:$scope.invitado.PRIORIDAD_SUJETO,
                                  SEGUNDO_APELLIDO:$scope.invitado.SEGUNDO_APELLIDO,
                                  SEGUNDO_NOMBRE:$scope.invitado.SEGUNDO_NOMBRE,
                                  SUJETO:$scope.invitado.SUJETO,
                                  TERCER_NOMBRE:$scope.invitado.TERCER_NOMBRE,
                                  ID_DISCAPACIDAD:$scope.invitado.ID_DISCAPACIDAD
                                });
                              }
                              else
                              {
                                $scope.invitados.seleccion.push(
                                {
                                  contactos:$scope.datosContacto.seleccion,
                                  contactoseliminacion:$scope.datosContacto.eliminacion,
                                  ICONO_TIPO_SUJETO:$scope.invitado.ICONO_TIPO_SUJETO,
                                  IDENTIFICACION:$scope.invitado.IDENTIFICACION,
                                  ID_PRIORIDAD_SUJETO:$scope.invitado.ID_PRIORIDAD_SUJETO,
                                  ID_SUJETO:$scope.invitado.ID_SUJETO,
                                  ID_SUJETO_JURIDICO:$scope.invitado.ID_SUJETO_JURIDICO,
                                  ID_SUJETO_JUR_IDENTIFICACION:$scope.invitado.ID_SUJETO_JUR_IDENTIFICACION,
                                  ID_TIPO_IDENTIFICACION:$scope.invitado.ID_TIPO_IDENTIFICACION,
                                  ID_TIPO_SUJETO:$scope.invitado.ID_TIPO_SUJETO,
                                  MASCARA_IDENTIFICACION:$scope.invitado.MASCARA_IDENTIFICACION,
                                  MARCA_COMERCIAL:$scope.invitado.MARCA_COMERCIAL,
                                  PRIORIDAD_SUJETO:$scope.invitado.PRIORIDAD_SUJETO,
                                  SUJETO_JURIDICO:$scope.invitado.SUJETO_JURIDICO,
                                  representantes:$scope.representantes.seleccion,
                                  SUJETO:$scope.invitado.SUJETO
                                });
                              }
                            }
                            if ($scope.invitados.seleccion.length == 1)
                            {
                              if ((accion == "siguiente") || ($scope.icono_boton_editar_invitado == "fa fa-refresh"))
                              {
                                if (accion == "siguiente")
                                {
                                  funcionesSujeto();
                                  $scope.formularioSesion()
                                }
                              }
                              // else if ($scope.icono_boton_editar_invitado == "fa fa-refresh")
                              // {
                              //   $scope.editarSujeto($scope.invitados.seleccion[0]);
                              // }
                              else
                              {
                                funcionesSujeto();
                              }
                            }
                            else if ($scope.icono_boton_editar_invitado == "fa fa-user-plus")
                            {
                              funcionesSujeto();
                            }
                            else
                            {
                              validaSujetoPrincipal();
                              //ordenarSujeto();
                            }
                            toastr.success(mensaje_operacion);






                            // if ($scope.invitado.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                            // {
                            //   completarAgregadoSujeto(accion);
                            // }
                            // else
                            // {
                            //   if (($scope.campo_requerido_invitado) && ($scope.icono_boton_editar_invitado != "fa fa-refresh"))
                            //   {
                            //     $scope.campo_requerido = $scope.campo_requerido_invitado;
                            //     $scope.mensaje_operacion = "Debe agregar como mínimo un representante al invitado";
                            //     if (accion == 'agregar')
                            //     {
                            //       toastr.warning($scope.mensaje_operacion);
                            //     }
                            //     $scope.activarFormularioRepresentante();
                            //   }
                            //   else
                            //   {
                            //     completarAgregadoSujeto(accion);
                            //   }
                            // }
                          }
                          else
                          {
                            mensaje="Faltan datos por ingresar";
                            if(isValid)
                            {
                              if (!$scope.invitado.DIRECCION)
                              {
                                mensaje="Debe agregar como mínimo una dirección en los datos de contacto";
                              }
                              else if (!$scope.UBICACION_CORRECTA)
                              {
                                mensaje = $scope.mensaje_ubicacion_incorrecta;
                              }
                              else if (!$scope.REPRESENTANTES_AGREGADOS)
                              {
                                mensaje="Debe agregar como mínimo un representante al invitado";
                              }
                            }
                            toastr.warning(mensaje);
                          }
                        }
                      }
                      $scope.editarSujeto = function(item)
                      {
                        if ($scope.formulario_solicitante)
                        {
                          $scope.index = $scope.solicitantes.seleccion.indexOf(item);
                        }
                        else
                        {
                          $scope.index = $scope.invitados.seleccion.indexOf(item);
                        }
                        if ((item.ID_SUJETO_EXPEDIENTE != undefined) && (item.ID_SUJETO_EXPEDIENTE != ""))
                        {
                          $scope.SUJETO_BD = true;
                          getDatosSujeto(item, $scope.CONSTANTES.TIPO_SUJETO_NATURAL,false);  
                        }
                        else
                        {
                          $scope.SUJETO_BD = false;
                          editarSujetoLocal(item);
                        }
                      }
                      editarSujetoLocal = function(item)
                      {
                        $scope.LOCAL_ID_TIPO_SUJETO = item.ID_TIPO_SUJETO;
                        $scope.LOCAL_ID_PRIORIDAD_SUJETO = item.ID_PRIORIDAD_SUJETO;
                        casosService.getTipoIdentificacion(item.ID_TIPO_SUJETO).then(
                          function ( response ) 
                          {
                            $scope.tipoIdentificacion = [];
                            $scope.tipoIdentificacion = response.data;
                            if (!$scope.seleccionTipoIdentificacion)
                            {
                              itemTipoIdentificacion = buscarTipoIdentificacionSujeto(item.ID_TIPO_IDENTIFICACION, $scope.tipoIdentificacion);
                              $scope.selectedTipoIdentificacion(itemTipoIdentificacion,false);
                            }
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                        // $scope.tooltip_ver_representante = "Agregar representante";
                        if ($scope.formulario_solicitante)
                        {
                          $scope.editar_solicitante = true;
                          angular.extend($scope.solicitante,item);
                          $scope.datosContacto.seleccion = $scope.solicitante.contactos;
                          $scope.representantes.seleccion = $scope.solicitante.representantes;
                          $scope.solicitante.SUJETO_NATURAL = false;
                          //$scope.solicitante.REQUIERE_REPRESENTANTE = false;
                          if (item.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                          {
                            $scope.solicitante.SUJETO_NATURAL = true;
                            $scope.campo_identificacion_requerido = false;
                            // $scope.deshabilitar_datos_sujeto = false;
                          }
                          else
                          {
                            descripciones_hombre();
                          }
                          $scope.icono_boton_editar_solicitante = "fa fa-refresh";
                          $scope.icono_boton_limpiar_solicitante = "fa fa-close";
                          $scope.tooltip_boton_editar_solicitante = "Actualizar datos";
                          $scope.tooltip_boton_limpiar_solicitante = "Cancelar actualización de datos";
                          $scope.mostrar_solicitantes = false;
                          if ($scope.solicitantes.seleccion.length > 1)
                          {
                              $scope.mostrar_solicitantes = true; 
                          }
                          $scope.deshabilitar_prioridad_solicitante = false;
                          if (item.ID_PRIORIDAD_SUJETO == $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL)
                          {
                            $scope.deshabilitar_prioridad_solicitante = true;
                          }
                        }
                        else if ($scope.formulario_invitado)
                        {
                          $scope.editar_invitado = true;
                          angular.extend($scope.invitado,item);
                          $scope.datosContacto.seleccion = $scope.invitado.contactos;
                          $scope.representantes.seleccion = $scope.invitado.representantes;
                          $scope.invitado.SUJETO_NATURAL = false;
                          //$scope.invitado.REQUIERE_REPRESENTANTE = false;
                          if (item.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                          {
                            $scope.invitado.SUJETO_NATURAL = true;
                          }
                          else
                          {
                            descripciones_hombre();
                            $scope.campo_identificacion_requerido = false;
                            // $scope.deshabilitar_datos_sujeto = false;
                          }
                          $scope.icono_boton_editar_invitado = "fa fa-refresh";
                          $scope.icono_boton_limpiar_invitado = "fa fa-close";
                          $scope.tooltip_boton_editar_invitado = "Actualizar datos";
                          $scope.tooltip_boton_limpiar_invitado = "Cancelar actualización de datos";
                          $scope.mostrar_invitados = false;
                          if ($scope.invitados.seleccion.length > 1)
                          {
                              $scope.mostrar_invitados = true; 
                          }
                          $scope.deshabilitar_prioridad_invitado = false;
                          if (item.ID_PRIORIDAD_SUJETO == $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL)
                          {
                            $scope.deshabilitar_prioridad_invitado = true;
                          }
                        } 
                        if (item.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                        {
                          $scope.estadosCiviles = [];
                          $scope.profesiones = [];
                          ID_ESTADO_CIVIL = item.ID_ESTADO_CIVIL;
                          ID_PROFESION = item.ID_PROFESION;
                          $scope.selectedGenero(item);
                          getPoblacionIdioma(item);
                        }
                        // if (($scope.representantes.seleccion != undefined) &&
                        //     ($scope.representantes.seleccion.length > 0))
                        // {
                        //   // $scope.tooltip_ver_representante = "Ver representante";
                        //   // if ($scope.representantes.seleccion.length > 1)
                        //   // {
                        //   //   $scope.tooltip_ver_representante = "Ver representantes"
                        //   // }
                        //   $scope.REPRESENTANTES_AGREGADOS = true;
                        // }
                        $scope.seleccionTipoIdentificacion = false;
                        validaDireccion();
                        validaRepresentante();
                        $scope.habilitar_datos_identificacion();
                        
                      }
                      $scope.eliminarSujeto = function(item)
                      {
                        sujeto = "invitado";
                        if ($scope.formulario_solicitante)
                        {
                          sujeto = "solicitante";
                        }
                        swal({                            
                          title:'¿Eliminar '+sujeto+'?', 
                          html: ',',
                          text: '<i class="'+item.ICONO_TIPO_SUJETO+'"></i>'+' '+item.SUJETO,
                          type: "error",
                          showCancelButton: true,
                          confirmButtonClass: "btn-danger",
                          confirmButtonText: "Continuar",
                          cancelButtonClass: "btn-default",
                          cancelButtonText: "Cancelar",
                          closeOnConfirm: false,
                          closeOnCancel: false }, 
                          function(isConfirm){ 
                          if (isConfirm) 
                          {
                            ordenarSujeto();
                            if ($scope.formulario_solicitante)
                            {
                              if ($scope.solicitantes.seleccion.length == 0)
                              {
                                  $scope.mostrar_solicitantes = false; 
                              }
                            }
                            else
                            {
                              if ($scope.invitados.seleccion.length == 0)
                              {
                                  $scope.mostrar_invitados = false; 
                              }
                            }
                            swal.close();
                            $scope.$apply();
                          } 
                          else 
                          {
                            if ($scope.formulario_solicitante)
                            {
                              $scope.solicitantes.seleccion.push(item);
                              if ($scope.solicitantes.seleccion.length > 0)
                              {
                                  $scope.mostrar_solicitantes = true; 
                              }
                            }
                            else
                            {
                              $scope.invitados.seleccion.push(item);
                              if ($scope.invitados.seleccion.length > 0)
                              {
                                  $scope.mostrar_invitados = true; 
                              }
                            }
                            ordenarSujeto();
                            swal.close();
                            $scope.$apply();
                          }
                        });
                      }
          /*-------------------viewContacto------------------*/
                      $scope.editar_contacto = false;
                      $scope.boton_agregar_contacto = "Guardar";
                      $scope.seccion_datos = false;
                      $scope.seccion_datos_tipo = false;
                      $scope.icono_boton_editar_contacto = "fa fa-plus";
                      //se inicializa el arreglo de los tipos de contacto del sujeto
                      $scope.tipoContacto = [];
                      $scope.tipoContacto = dataTipoContacto.data;
                      $scope.editarContacto = function(item)
                      {
                        if ($scope.formularioRepresentante)
                        {
                          $scope.index_contacto = $scope.datosContactoRepresentante.seleccion.indexOf(item);
                        }
                        else
                        {
                          $scope.index_contacto = $scope.datosContacto.seleccion.indexOf(item); 
                        }
                        $scope.editar_contacto = true;
                        $scope.boton_agregar_contacto = "Actualizar";
                        $scope.icono_boton_editar_contacto = "fa fa-refresh";
                        $scope.focus_contacto = true;
                        cambiar_tipo_dato();
                        $scope.viewContacto(item,$scope.editar_contacto);
                      }

                      $scope.getHeight = function(selector)
                      {
                        var element = $(selector);
                        return element.css("height");
                      }
                      validaDireccion = function()
                      {
                        if ($scope.formularioRepresentante)
                        {
                          $scope.representante.DIRECCION=false;
                          var BreakException = {};
                          try 
                          {
                            $scope.datosContactoRepresentante.seleccion.forEach(function(contacto) 
                            {
                              if (contacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION) throw BreakException;
                            });
                          } catch (e) 
                          {
                            $scope.representante.DIRECCION=true;
                          }
                        }
                        if ($scope.formulario_solicitante)
                        {
                          $scope.solicitante.DIRECCION = false;
                          var BreakException = {};
                          try 
                          {
                            $scope.datosContacto.seleccion.forEach(function(contacto) 
                            {
                              if (contacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION) throw BreakException;
                            });
                          } catch (e) 
                          {
                            $scope.solicitante.DIRECCION = true;
                          }
                        }
                        else if ($scope.formulario_invitado)
                        {
                          $scope.invitado.DIRECCION = false;
                          var BreakException = {};
                          try 
                          {
                            $scope.datosContacto.seleccion.forEach(function(contacto) 
                            {
                              if (contacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION) throw BreakException;
                            });
                          } catch (e) 
                          {
                            $scope.invitado.DIRECCION = true;
                          }
                        }  
                      }
                      cambiar_tipo_dato = function()
                      {
                        if (($scope.seccion_datos == false) && ($scope.seccion_datos_tipo == false))
                        {
                          $scope.seccion_datos = true;
                        }
                        else if (($scope.seccion_datos == true) && ($scope.seccion_datos_tipo == false))
                        {
                          $scope.seccion_datos = false;
                          $scope.seccion_datos_tipo = true;
                        }
                        else
                        {
                          $scope.seccion_datos = true;
                          $scope.seccion_datos_tipo = false;
                        }       
                      }
                      limpiarContacto = function()
                      {
                        $scope.datosContacto.CONTACTO = "";
                        //$scope.datosContacto.ICONO = "";
                        $scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE = "";
                        $scope.datosContacto.ID_UBICACION_GEOGRAFICA = "";
                        $scope.datosContacto.UBICACION_GEOGRAFICA = "";
                        $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE = "";
                      }
                      limpiardatosContacto = function()
                      {
                        $scope.datoContactoDireccion = [];
                        $scope.datoContactoTelefono = [];
                        $scope.datoContactoCorreo = [];
                      }
                      $scope.eliminarContacto = function(item)
                      {
                        // validaDireccion();
                        /*if (($scope.formularioRepresentante) &&
                            ($scope.editar_representante) &&
                            (!$scope.representante.DIRECCION))
                        {                        
                          $scope.datosContactoRepresentante.seleccion.push(item);
                          validaDireccion();
                          ordenarContacto();
                          toastr.warning("No se puede realizar la eliminación, Debe registrar como mínimo una dirección en los datos de contacto");  
                        }
                        else if (($scope.formulario_solicitante) &&
                            ($scope.editar_solicitante) &&
                            (!$scope.solicitante.DIRECCION))
                        {                        
                          $scope.datosContacto.seleccion.push(item);
                          validaDireccion();
                          ordenarContacto();
                          toastr.warning("No se puede realizar la eliminación, Debe registrar como mínimo una dirección en los datos de contacto");  
                        }
                        else if (($scope.formulario_invitado) &&
                            ($scope.editar_invitado) &&
                            (!$scope.invitado.DIRECCION))
                        {                        
                          $scope.datosContacto.seleccion.push(item);
                          validaDireccion();
                          ordenarContacto();
                          toastr.warning("No se puede realizar la eliminación, Debe registrar como mínimo una dirección en los datos de contacto");  
                        }
                        else
                        {*/
                          swal({                            
                            title:'¿Eliminar contacto?', 
                            html: ',',
                            text: '<i class="'+item.ICONO+'"></i>'+' '+item.CONTACTO_TEMPORAL,
                            type: "error",
                            showCancelButton: true,
                            confirmButtonClass: "btn-danger",
                            confirmButtonText: "Continuar",
                            cancelButtonClass: "btn-default",
                            cancelButtonText: "Cancelar",
                            closeOnConfirm: false,
                            closeOnCancel: false }, 
                            function(isConfirm){ 
                            if (isConfirm) 
                            {
                              if ($scope.formularioRepresentante)
                              {
                                // $scope.representantes.seleccion[$scope.index_representante].contactos = $scope.datosContactoRepresentante.seleccion;
                                if ((item.ID_CONTACTO_SUJETO != undefined) && (item.ID_CONTACTO_SUJETO != ""))
                                {
                                  $scope.datosContactoRepresentante.eliminacion.push(item);
                                }
                              }
                              // else if (edicion)
                              //     {
                              //       $scope.sujeto.contactos = $scope.datosContacto.seleccion;
                              //       if ((item.ID_CONTACTO_SUJETO != undefined) && (item.ID_CONTACTO_SUJETO != ""))
                              //       {
                              //         $scope.datosContacto.eliminacion.push(item);
                              //       }
                              //     } 
                              else 
                              // if ($scope.formulario_solicitante)
                              {
                                // $scope.solicitantes.seleccion[$scope.index].contactos = $scope.datosContacto;
                                if ((item.ID_CONTACTO_SUJETO != undefined) && (item.ID_CONTACTO_SUJETO != ""))
                                {
                                  $scope.datosContacto.eliminacion.push(item);
                                }
                              }
                              // else if ($scope.formulario_invitado)
                              // {
                              //   // $scope.invitados.seleccion[$scope.index].contactos = $scope.datosContacto;
                              //   if ((item.ID_CONTACTO_SUJETO != undefined) && (item.ID_CONTACTO_SUJETO != ""))
                              //   {
                              //     $scope.datosContacto.eliminacion.push(item);
                              //   }
                              // } 
                              validaDireccion();
                              ordenarContacto();
                              $scope.$apply();
                              swal.close();
                            } 
                            else 
                            {
                              if ($scope.formularioRepresentante)
                              {
                                $scope.datosContactoRepresentante.seleccion.push(item);
                              }
                              else
                              {
                                $scope.datosContacto.seleccion.push(item);  
                              }
                              validaDireccion();
                              ordenarContacto();
                              $scope.$apply();
                              swal.close();
                            }
                          });
                        // }
                      }
                      $scope.viewContacto = function(item,edicion)
                      {
                        $scope.dialogShowContacto = ngDialog.open(
                        {
                          template: 'app/casos/casos.registro.contacto.view.tpl.html',
                          showClose:true,
                          closeByEscape: true,
                          preCloseCallback:function()
                          {
                            $scope.editar_contacto = false;
                            $scope.boton_agregar_contacto = "Guardar";
                            $scope.icono_boton_editar_contacto = "fa fa-plus";
                            $scope.datosContacto.ID_TIPO_CONTACTO="";
                            $scope.datosContacto.TIPO_CONTACTO = "";
                            $scope.focus_contacto = false;
                            $scope.seccion_datos = false;
                            $scope.seccion_datos_tipo = false;
                             
                            if (($scope.editar_representante) && (!$scope.REPRESENTANTE_BD))
                            {
                              $scope.representantes.seleccion[$scope.index_representante].contactos = $scope.datosContactoRepresentante.seleccion;
                              $scope.representantes.seleccion[$scope.index_representante].contactoseliminacion = $scope.datosContactoRepresentante.eliminacion;
                            }
                            else if (!$scope.SUJETO_BD)
                            {
                              if ($scope.editar_solicitante)
                              {
                                $scope.solicitantes.seleccion[$scope.index].contactos = $scope.datosContacto.seleccion;
                                $scope.solicitantes.seleccion[$scope.index].contactoseliminacion = $scope.datosContacto.eliminacion;
                              }
                              else if ($scope.editar_invitado)
                              {
                                $scope.invitados.seleccion[$scope.index].contactos = $scope.datosContacto;
                                $scope.invitados.seleccion[$scope.index].contactoseliminacion = $scope.datosContacto.eliminacion;
                              }
                            }
                              
                            
                            // if (($scope.formulario_solicitante) &&
                            //     ($scope.solicitante.ID_TIPO_SUJETO != $scope.CONSTANTES.TIPO_SUJETO_NATURAL) &&
                            //     (!$scope.editar_solicitante) && 
                            //     ($scope.representantes.seleccion.length == 0) && 
                            //     ($scope.solicitante.DIRECCION) &&
                            //     (!$scope.formularioRepresentante))
                            // {
                            //   $scope.viewContactoCloseId = $scope.dialogShowContacto.id;
                            //   $scope.vieneDeContacto = true;
                            //   $scope.agregarSujeto(true);
                            //   return false; 
                            // }
                            // else if (($scope.formulario_invitado) && 
                            //          ($scope.invitado.ID_TIPO_SUJETO != $scope.CONSTANTES.TIPO_SUJETO_NATURAL) && 
                            //          (!$scope.editar_invitado) && 
                            //          ($scope.representantes.seleccion.length == 0) &&
                            //          ($scope.invitado.DIRECCION) && 
                            //          (!$scope.formularioRepresentante)) 
                            // {
                            //   $scope.viewContactoCloseId = $scope.dialogShowContacto.id;
                            //   $scope.vieneDeContacto = true;
                            //   $scope.agregarSujeto(true);
                            //   return false; 
                            // }
                          },
                          className: 'ngdialog-theme-flat-custom custom-width',
                          scope:$scope,
                          controller: ['$scope', function($scope) 
                          {
                            $scope.datosContacto.ICONO = "";
                            limpiardatosContacto();
                            //se obtiene el arreglo inicial para el tipo de contacto de los sujetos
                            buscarTipoContacto = function(valor, arreglo){
                              for (var i=0; i < arreglo.length; i++) {
                                  if (arreglo[i].ID_TIPO_CONTACTO === valor) {
                                      return arreglo[i];
                                  }
                              }
                            }
                            $scope.ingreso_inicial_contacto = false;
                            $scope.tituloFormContacto = "Contacto";
                            if (($scope.datosContacto.seleccion.length == 0) || 
                                (($scope.formularioRepresentante) && 
                                 ($scope.datosContactoRepresentante.seleccion.length == 0)))
                            {
                              $scope.longitud_minima_caja_contacto = longitud_minima_caja_contacto;
                              $scope.focus_contacto = true;
                              itemTipocontacto = buscarTipoContacto($scope.CONSTANTES.TIPO_CONTACTO_DIRECCION, $scope.tipoContacto);
                              $scope.datoContactoDireccion.ID_TIPO_CONTACTO = itemTipocontacto.ID_TIPO_CONTACTO;
                              $scope.datoContactoDireccion.TIPO_CONTACTO = itemTipocontacto.TIPO_CONTACTO;
                              $scope.datoContactoDireccion.ICONO = itemTipocontacto.ICONO;
                              $scope.datoContactoDireccion.MASCARA = itemTipocontacto.MASCARA;
                              $scope.datoContactoDireccion.TIPO_DATO = itemTipocontacto.TIPO_DATO;
                              itemTipocontacto = buscarTipoContacto($scope.CONSTANTES.TIPO_CONTACTO_TELEFONO, $scope.tipoContacto);
                              $scope.datoContactoTelefono.ID_TIPO_CONTACTO = itemTipocontacto.ID_TIPO_CONTACTO;
                              $scope.datoContactoTelefono.TIPO_CONTACTO = itemTipocontacto.TIPO_CONTACTO;
                              $scope.datoContactoTelefono.ICONO = itemTipocontacto.ICONO;
                              $scope.datoContactoTelefono.MASCARA = itemTipocontacto.MASCARA;
                              $scope.datoContactoTelefono.TIPO_DATO = itemTipocontacto.TIPO_DATO;
                              itemTipocontacto = buscarTipoContacto($scope.CONSTANTES.TIPO_CONTACTO_CORREO, $scope.tipoContacto);
                              $scope.datoContactoCorreo.ID_TIPO_CONTACTO = itemTipocontacto.ID_TIPO_CONTACTO;
                              $scope.datoContactoCorreo.TIPO_CONTACTO = itemTipocontacto.TIPO_CONTACTO;
                              $scope.datoContactoCorreo.ICONO = itemTipocontacto.ICONO;
                              $scope.datoContactoCorreo.MASCARA = itemTipocontacto.MASCARA;
                              $scope.datoContactoCorreo.TIPO_DATO = itemTipocontacto.TIPO_DATO;
                              $scope.ingreso_inicial_contacto = true;
                              $scope.tituloFormContacto = "Contacto";
                            }
                            //limpiarContacto();
                            //funciones formulario contacto
                            $scope.cambiar_focus_contacto = function()
                            {
                              $scope.focus_contacto = false;
                            } 

                            buscarDepartamentoMunicipio = function(valor, arreglo)
                            {
                                for (var i=0; i < arreglo.length; i++) 
                                {
                                  if (arreglo[i].ID_UBICACION_GEOGRAFICA === valor) 
                                  {
                                      return arreglo[i];
                                  }
                                } 
                            }
                            selectDepto = false;
                            enlistarUbicacionesGeograficas = function(p_id_tipo_ubicacion,p_id_ubicacion_padre)
                            {
                              casosService.getUbicacionGeografica(p_id_tipo_ubicacion,p_id_ubicacion_padre).then(
                                function ( response ) 
                                {
                                  if (p_id_tipo_ubicacion > 0)
                                  {
                                    $scope.departamentos = [];
                                    $scope.departamentos = response.data;
                                    if ($scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA_PADRE == undefined)
                                    {
                                      selectDepto = true;
                                      itemDepartamento = buscarDepartamentoMunicipio($scope.ubicacionCentro.ID_DEPARTAMENTO, $scope.departamentos);
                                      $scope.selectedUbicacionGeografica(itemDepartamento,$scope.CONSTANTES.TIPO_UB_GEOGRAFICA_DEPTO);
                                    }
                                  }
                                  else
                                  {
                                    $scope.municipios = [];
                                    $scope.municipios = response.data;
                                    if (selectDepto)
                                    {
                                      selectDepto = false;
                                      itemMunicipio = buscarDepartamentoMunicipio($scope.ubicacionCentro.ID_MUNICIPIO, $scope.municipios);
                                      $scope.selectedUbicacionGeografica(itemMunicipio);
                                    }
                                  }
                                },
                                function ( error ) 
                                {
                                    toastr.error( error );
                                });
                            }
                            enlistarUbicacionesGeograficas($scope.CONSTANTES.TIPO_UB_GEOGRAFICA_DEPTO,0);
                            $scope.selectedUbicacionGeografica = function (item,ubicacion_padre)
                            {
                              if (ubicacion_padre != undefined)
                              {
                                $scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE = item.ID_UBICACION_GEOGRAFICA;   
                                $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE = item.UBICACION_GEOGRAFICA;
                                $scope.datosContacto.ID_UBICACION_GEOGRAFICA = "";
                                $scope.datosContacto.UBICACION_GEOGRAFICA = "";
                                $scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA_PADRE = item.ID_UBICACION_GEOGRAFICA;   
                                $scope.datoContactoDireccion.UBICACION_GEOGRAFICA_PADRE = item.UBICACION_GEOGRAFICA;
                                $scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA = "";
                                $scope.datoContactoDireccion.UBICACION_GEOGRAFICA = "";
                                enlistarUbicacionesGeograficas(0,item.ID_UBICACION_GEOGRAFICA);
                              }
                              else
                              {
                                $scope.datosContacto.ID_UBICACION_GEOGRAFICA = item.ID_UBICACION_GEOGRAFICA;
                                $scope.datosContacto.UBICACION_GEOGRAFICA = item.UBICACION_GEOGRAFICA;
                                $scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA = item.ID_UBICACION_GEOGRAFICA;
                                $scope.datoContactoDireccion.UBICACION_GEOGRAFICA = item.UBICACION_GEOGRAFICA;
                              }
                            }
                            
                            $scope.selectedTipoContacto = function (item)
                            {
                              limpiarContacto();
                              $scope.focus_contacto = true;
                              $scope.contacto_tipo_direccion = false;
                              $scope.datosContacto.ID_TIPO_CONTACTO = item.ID_TIPO_CONTACTO;
                              $scope.datosContacto.TIPO_CONTACTO = item.TIPO_CONTACTO;
                              $scope.datosContacto.ICONO = item.ICONO;
                              $scope.datosContacto.MASCARA = item.MASCARA;
                              $scope.datosContacto.TIPO_DATO = item.TIPO_DATO;
                              cambiar_tipo_dato();
                              $scope.longitud_minima_caja_contacto = 0;
                              if (edicion == true)
                              {
                                $scope.datosContacto.ICONO = item.ICONO;
                                $scope.datosContacto.MASCARA = item.MASCARA;
                                $scope.datosContacto.TIPO_DATO = item.TIPO_DATO;
                                $scope.datosContacto.CONTACTO = item.CONTACTO;
                                $scope.datosContacto.CONTACTO_TEMPORAL = item.CONTACTO_TEMPORAL;
                                if (item.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                                {
                                  $scope.longitud_minima_caja_contacto = longitud_minima_caja_contacto;
                                  $scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE = item.ID_UBICACION_GEOGRAFICA_PADRE;
                                  $scope.datosContacto.ID_UBICACION_GEOGRAFICA = item.ID_UBICACION_GEOGRAFICA;
                                  $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE = item.UBICACION_GEOGRAFICA_PADRE;
                                  $scope.datosContacto.UBICACION_GEOGRAFICA = item.UBICACION_GEOGRAFICA;
                                  enlistarUbicacionesGeograficas(0,item.ID_UBICACION_GEOGRAFICA_PADRE);
                                }
                              }
                              else if ($scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA_PADRE != undefined)
                              {
                                selectDepto = true;
                                itemDepartamento = buscarDepartamentoMunicipio($scope.ubicacionCentro.ID_DEPARTAMENTO, $scope.departamentos);
                                $scope.selectedUbicacionGeografica(itemDepartamento,$scope.CONSTANTES.TIPO_UB_GEOGRAFICA_DEPTO);
                              }
                              
                              if (item.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                              {
                                $scope.longitud_minima_caja_contacto = longitud_minima_caja_contacto;
                                $scope.contacto_tipo_direccion = true;
                              }
                            }
                            if (edicion == true)
                            {
                              $scope.selectedTipoContacto(item);
                            }
                            $scope.formularioContacto = function(isValid)
                            {
                              if(isValid)
                              {
                                tipo_dato = $filter('lowercase')($scope.datosContacto.TIPO_CONTACTO) ;
                                mensaje_operacion="Contacto "+tipo_dato+" agregado correctamente";
                                espacio = " ";
                                if ($scope.datosContacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                                {
                                  coma = ", ";
                                }
                                if (edicion == true)
                                {
                                  if ($scope.formularioRepresentante)
                                  {
                                    if ($scope.datosContacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                                    {
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].ID_TIPO_CONTACTO = $scope.datosContacto.ID_TIPO_CONTACTO;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].TIPO_CONTACTO = $scope.datosContacto.TIPO_CONTACTO;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].ICONO = $scope.datosContacto.ICONO;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].MASCARA = $scope.datosContacto.MASCARA;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].TIPO_DATO = $scope.datosContacto.TIPO_DATO;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].CONTACTO = $scope.datosContacto.CONTACTO;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].ID_UBICACION_GEOGRAFICA = $scope.datosContacto.ID_UBICACION_GEOGRAFICA;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].ID_UBICACION_GEOGRAFICA_PADRE = $scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].UBICACION_GEOGRAFICA = $scope.datosContacto.UBICACION_GEOGRAFICA;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].UBICACION_GEOGRAFICA_PADRE = $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].CONTACTO_TEMPORAL = $scope.datosContacto.CONTACTO+espacio+$scope.datosContacto.UBICACION_GEOGRAFICA+coma+$scope.datosContacto.UBICACION_GEOGRAFICA_PADRE;    
                                    }
                                    else
                                    {
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].ID_TIPO_CONTACTO = $scope.datosContacto.ID_TIPO_CONTACTO;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].TIPO_CONTACTO = $scope.datosContacto.TIPO_CONTACTO;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].ICONO = $scope.datosContacto.ICONO;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].MASCARA = $scope.datosContacto.MASCARA;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].TIPO_DATO = $scope.datosContacto.TIPO_DATO;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].CONTACTO = $scope.datosContacto.CONTACTO;
                                      $scope.datosContactoRepresentante.seleccion[$scope.index_contacto].CONTACTO_TEMPORAL = $scope.datosContacto.CONTACTO;  
                                    }
                                  }
                                  else
                                  {
                                    if ($scope.datosContacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                                    {
                                      $scope.datosContacto.seleccion[$scope.index_contacto].ID_TIPO_CONTACTO = $scope.datosContacto.ID_TIPO_CONTACTO;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].TIPO_CONTACTO = $scope.datosContacto.TIPO_CONTACTO;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].ICONO = $scope.datosContacto.ICONO;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].MASCARA = $scope.datosContacto.MASCARA;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].TIPO_DATO = $scope.datosContacto.TIPO_DATO;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].CONTACTO = $scope.datosContacto.CONTACTO;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].ID_UBICACION_GEOGRAFICA = $scope.datosContacto.ID_UBICACION_GEOGRAFICA;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].ID_UBICACION_GEOGRAFICA_PADRE = $scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].UBICACION_GEOGRAFICA = $scope.datosContacto.UBICACION_GEOGRAFICA;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].UBICACION_GEOGRAFICA_PADRE = $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].CONTACTO_TEMPORAL = $scope.datosContacto.CONTACTO+espacio+$scope.datosContacto.UBICACION_GEOGRAFICA+coma+$scope.datosContacto.UBICACION_GEOGRAFICA_PADRE;
                                    }
                                    else
                                    {
                                      $scope.datosContacto.seleccion[$scope.index_contacto].ID_TIPO_CONTACTO = $scope.datosContacto.ID_TIPO_CONTACTO;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].TIPO_CONTACTO = $scope.datosContacto.TIPO_CONTACTO;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].ICONO = $scope.datosContacto.ICONO;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].MASCARA = $scope.datosContacto.MASCARA;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].TIPO_DATO = $scope.datosContacto.TIPO_DATO;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].CONTACTO = $scope.datosContacto.CONTACTO;
                                      $scope.datosContacto.seleccion[$scope.index_contacto].CONTACTO_TEMPORAL = $scope.datosContacto.CONTACTO;
                                    }
                                    
                                  }
                                  mensaje_operacion="Contacto "+tipo_dato+" actualizado correctamente";
                                  ngDialog.close($scope.dialogShowContacto.id);
                                }
                                else
                                {
                                  if ($scope.formularioRepresentante)
                                  {
                                    if ($scope.datosContacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                                    {
                                      $scope.datosContactoRepresentante.seleccion.push(
                                      {
                                        ID_TIPO_CONTACTO:$scope.datosContacto.ID_TIPO_CONTACTO,
                                        TIPO_CONTACTO:$scope.datosContacto.TIPO_CONTACTO,
                                        ICONO:$scope.datosContacto.ICONO,
                                        MASCARA:$scope.datosContacto.MASCARA,
                                        TIPO_DATO:$scope.datosContacto.TIPO_DATO,
                                        CONTACTO:$scope.datosContacto.CONTACTO,
                                        ID_UBICACION_GEOGRAFICA:$scope.datosContacto.ID_UBICACION_GEOGRAFICA,
                                        ID_UBICACION_GEOGRAFICA_PADRE:$scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE,
                                        UBICACION_GEOGRAFICA:$scope.datosContacto.UBICACION_GEOGRAFICA,
                                        UBICACION_GEOGRAFICA_PADRE:$scope.datosContacto.UBICACION_GEOGRAFICA_PADRE,
                                        CONTACTO_TEMPORAL:$scope.datosContacto.CONTACTO+espacio+
                                                          $scope.datosContacto.UBICACION_GEOGRAFICA+coma+
                                                          $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE
                                      });
                                    }
                                    else
                                    {
                                      $scope.datosContactoRepresentante.seleccion.push(
                                      {
                                        ID_TIPO_CONTACTO:$scope.datosContacto.ID_TIPO_CONTACTO,
                                        TIPO_CONTACTO:$scope.datosContacto.TIPO_CONTACTO,
                                        ICONO:$scope.datosContacto.ICONO,
                                        MASCARA:$scope.datosContacto.MASCARA,
                                        TIPO_DATO:$scope.datosContacto.TIPO_DATO,
                                        CONTACTO:$scope.datosContacto.CONTACTO,
                                        CONTACTO_TEMPORAL:$scope.datosContacto.CONTACTO
                                      });
                                    } 
                                  }
                                  else
                                  {
                                    if ($scope.datosContacto.ID_TIPO_CONTACTO == $scope.CONSTANTES.TIPO_CONTACTO_DIRECCION)
                                    {
                                      $scope.datosContacto.seleccion.push(
                                      {
                                        ID_TIPO_CONTACTO:$scope.datosContacto.ID_TIPO_CONTACTO,
                                        TIPO_CONTACTO:$scope.datosContacto.TIPO_CONTACTO,
                                        ICONO:$scope.datosContacto.ICONO,
                                        MASCARA:$scope.datosContacto.MASCARA,
                                        TIPO_DATO:$scope.datosContacto.TIPO_DATO,
                                        CONTACTO:$scope.datosContacto.CONTACTO,
                                        ID_UBICACION_GEOGRAFICA:$scope.datosContacto.ID_UBICACION_GEOGRAFICA,
                                        ID_UBICACION_GEOGRAFICA_PADRE:$scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE,
                                        UBICACION_GEOGRAFICA:$scope.datosContacto.UBICACION_GEOGRAFICA,
                                        UBICACION_GEOGRAFICA_PADRE:$scope.datosContacto.UBICACION_GEOGRAFICA_PADRE,
                                        CONTACTO_TEMPORAL:$scope.datosContacto.CONTACTO+espacio+
                                                          $scope.datosContacto.UBICACION_GEOGRAFICA+coma+
                                                          $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE
                                      });
                                    }
                                    else
                                    {
                                      $scope.datosContacto.seleccion.push(
                                      {
                                        ID_TIPO_CONTACTO:$scope.datosContacto.ID_TIPO_CONTACTO,
                                        TIPO_CONTACTO:$scope.datosContacto.TIPO_CONTACTO,
                                        ICONO:$scope.datosContacto.ICONO,
                                        MASCARA:$scope.datosContacto.MASCARA,
                                        TIPO_DATO:$scope.datosContacto.TIPO_DATO,
                                        CONTACTO:$scope.datosContacto.CONTACTO,
                                        CONTACTO_TEMPORAL:$scope.datosContacto.CONTACTO
                                      });
                                    }
                                  }
                                }
                                limpiarContacto();
                                ordenarContacto();
                                validaDireccion();
                                toastr.success(mensaje_operacion);
                              }
                              else
                              {
                                toastr.warning("Faltan datos por ingresar");
                              }
                            }
                            $scope.guardarContactosInicial = function(isValid)
                            {
                              if (isValid)
                              {
                                $scope.datosContacto.CONTACTO = $scope.datoContactoDireccion.CONTACTO
                                $scope.datosContacto.ICONO = $scope.datoContactoDireccion.ICONO
                                $scope.datosContacto.ID_TIPO_CONTACTO = $scope.datoContactoDireccion.ID_TIPO_CONTACTO
                                $scope.datosContacto.ID_UBICACION_GEOGRAFICA = $scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA
                                $scope.datosContacto.ID_UBICACION_GEOGRAFICA_PADRE = $scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA_PADRE
                                $scope.datosContacto.MASCARA = $scope.datoContactoDireccion.MASCARA
                                $scope.datosContacto.TIPO_CONTACTO = $scope.datoContactoDireccion.TIPO_CONTACTO
                                $scope.datosContacto.TIPO_DATO = $scope.datoContactoDireccion.TIPO_DATO
                                $scope.datosContacto.UBICACION_GEOGRAFICA = $scope.datoContactoDireccion.UBICACION_GEOGRAFICA
                                $scope.datosContacto.UBICACION_GEOGRAFICA_PADRE = $scope.datoContactoDireccion.UBICACION_GEOGRAFICA_PADRE
                                $scope.formularioContacto(true);
                                if (($scope.datoContactoTelefono.CONTACTO != undefined) && 
                                    ($scope.datoContactoTelefono.CONTACTO != ""))
                                {
                                  $scope.datosContacto.CONTACTO = $scope.datoContactoTelefono.CONTACTO
                                  $scope.datosContacto.ICONO = $scope.datoContactoTelefono.ICONO
                                  $scope.datosContacto.ID_TIPO_CONTACTO = $scope.datoContactoTelefono.ID_TIPO_CONTACTO
                                  $scope.datosContacto.MASCARA = $scope.datoContactoTelefono.MASCARA
                                  $scope.datosContacto.TIPO_CONTACTO = $scope.datoContactoTelefono.TIPO_CONTACTO
                                  $scope.datosContacto.TIPO_DATO = $scope.datoContactoTelefono.TIPO_DATO
                                  $scope.formularioContacto(true);
                                }
                                if (($scope.datoContactoCorreo.CONTACTO != undefined) && 
                                    ($scope.datoContactoCorreo.CONTACTO != ""))
                                {
                                  $scope.datosContacto.CONTACTO = $scope.datoContactoCorreo.CONTACTO
                                  $scope.datosContacto.ICONO = $scope.datoContactoCorreo.ICONO
                                  $scope.datosContacto.ID_TIPO_CONTACTO = $scope.datoContactoCorreo.ID_TIPO_CONTACTO
                                  $scope.datosContacto.MASCARA = $scope.datoContactoCorreo.MASCARA
                                  $scope.datosContacto.TIPO_CONTACTO = $scope.datoContactoCorreo.TIPO_CONTACTO
                                  $scope.datosContacto.TIPO_DATO = $scope.datoContactoCorreo.TIPO_DATO
                                  $scope.formularioContacto(true);
                                }
                                ngDialog.close($scope.dialogShowContacto.id);  
                              }
                              else
                              {
                                mensaje = "Faltan datos por ingresar";
                                if (($scope.datoContactoDireccion.CONTACTO != undefined) && 
                                    ($scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA != "") && 
                                    ($scope.datoContactoDireccion.ID_UBICACION_GEOGRAFICA_PADRE != ""))
                                {
                                  mensaje = "Formato inválido en el contacto correo electrónico";
                                }
                                toastr.warning(mensaje);  
                              }
                            }
                          }] 
                        });  
                      }
                      // $scope.validacionFormulario = function(isValid)
                      // {
                      //   limpiarContacto();
                      //   if ($scope.formulario_solicitante)
                      //   {
                      //     if ($scope.solicitante.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                      //     {
                      //       $scope.viewContacto()
                      //     }
                      //     else
                      //     {
                      //       if (isValid)
                      //       {
                      //         $scope.viewContacto()
                      //       }
                      //       else
                      //       {
                      //         toastr.warning('Faltan datos por ingresar, complete formulario antes de agregar datos de contacto');
                      //       }
                      //     }
                      //   }
                      //   else if ($scope.formulario_invitado)
                      //   {
                      //     if ($scope.invitado.ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL)
                      //     {
                      //       $scope.viewContacto()
                      //     }
                      //     else
                      //     {
                      //       if (isValid)
                      //       {
                      //         $scope.viewContacto()
                      //       }
                      //       else
                      //       {
                      //         toastr.warning('Faltan datos por ingresar, complete formulario antes de agregar datos de contacto');
                      //       }
                      //     }
                      //   }
                      // }
          /*-------------------viewContacto------------------*/
          /*----------------viewRepresentante----------------*/
                      
                      // $scope.deshabilitar_datos_representante = false;
                      $scope.tipoIdentificacionRepresentante = [];
                      // $scope.tooltip_boton_guardar_representante = "Guardar representante";
                      // $scope.cerrarDialog = false;
                      $scope.cambiar_focus_identificacion_representante = function()
                      {
                        $scope.focus_identificacion_representante = false;
                        //$scope.UBICACION_NACIMIENTO = true;
                      }
                      $scope.combo_tipo_identificacion_representante = true;
                      cambiar_tipo_identificacion_representante = function()
                      {
                        $scope.combo_tipo_identificacion_representante = !$scope.combo_tipo_identificacion_representante;
                      }
                      $scope.selectedTipoIdentificacionRepresentante = function (item)
                      {
                        cambiar_tipo_identificacion_representante();
                        $scope.representante.ID_TIPO_IDENTIFICACION = item.ID_TIPO_IDENTIFICACION;
                        // $scope.representante.TIPO_IDENTIFICACION = item.TIPO_IDENTIFICACION;
                        $scope.representante.MASCARA_IDENTIFICACION = item.MASCARA;
                        $scope.representante.IDENTIFICACION=""; 
                        $scope.focus_identificacion_representante = true;
                        if (item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_PASAPORTE)
                        { 
                          getNacionalidad($scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO,item.ID_TIPO_IDENTIFICACION);
                        }
                        else if (item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI)
                        { 
                          getNacionalidad($scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO,item.ID_TIPO_IDENTIFICACION);
                        }
                        else if (item.ID_TIPO_IDENTIFICACION == $scope.CONSTANTES.TIPO_IDENTIFICACION_DPI_EXT)
                        { 
                          getNacionalidad($scope.CONSTANTES.TIPO_CLS_IDIOMA_MATERNO,item.ID_TIPO_IDENTIFICACION);
                        }
                      }
                      casosService.getTipoIdentificacion($scope.CONSTANTES.TIPO_SUJETO_NATURAL).then(
                        function ( response ) 
                        {
                          $scope.tipoIdentificacionRepresentante = response.data;
                        },
                        function ( error ) 
                        {
                            toastr.error( error );
                        });
                      $scope.limpiarRepresentante = function()
                      {
                        $scope.cambiarBotones();
                        $scope.representante = {};
                        $scope.representante.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                        $scope.datosContactoRepresentante = [];
                        $scope.datosContactoRepresentante.seleccion = [];
                        $scope.datosContactoRepresentante.eliminacion = [];
                        $scope.focus_identificacion_representante = false;
                        $scope.UBICACION_CORRECTA = true;
                        descripciones_generales();
                        // if ($scope.nacionalidades != undefined)
                        // {
                        //   // (($scope.nacionalidades != undefined) && ($scope.representantes.seleccion.length != 1))
                        //   if ($scope.nacionalidades.length = 1)
                        //   {
                        //     $scope.selectedNacionalidad($scope.nacionalidades[0]);
                        //   }
                        //   else
                        //   {
                        //     $scope.tipoPoblacion = [];
                        //     $scope.idiomas = [];
                        //   }
                        // }
                        itemTipoIdentificacion = buscarTipoIdentificacionSujeto($scope.CONSTANTES.TIPO_IDENTIFICACION_DPI, $scope.tipoIdentificacionRepresentante);
                        $scope.selectedTipoIdentificacionRepresentante(itemTipoIdentificacion);
                      }
                      $scope.limpiarSeleccionRepresentante = function()
                      {
                        $scope.representante = {};
                        $scope.representante.ID_DISCAPACIDAD = $scope.CONSTANTES.NINGUNA_DISCAPACIDAD;
                        $scope.representantes.seleccion = [];
                      }
                      validaRepresentante = function()
                      {
                        if ($scope.formulario_solicitante)
                        {
                          ID_TIPO_SUJETO = $scope.solicitante.ID_TIPO_SUJETO;
                        }
                        else if ($scope.formulario_invitado)
                        {
                          ID_TIPO_SUJETO = $scope.invitado.ID_TIPO_SUJETO;
                        }
                        // $scope.tooltip_boton_guardar_representante = "Guardar representante";
                        // $scope.mensaje_validacion="Representante guardado correctamente";
                        $scope.REPRESENTANTES_AGREGADOS = false;
                        if ((ID_TIPO_SUJETO == $scope.CONSTANTES.TIPO_SUJETO_NATURAL) ||
                          ($scope.representantes.seleccion | $scope.representantes.seleccion.length > 0) || (!$scope.campo_requerido))
                        {
                          $scope.REPRESENTANTES_AGREGADOS = true;
                        }
                      }

                      $scope.agregarRepresentante = function(isValid)
                      {
                        validaDireccion();
                        validaSexo();
                        if((isValid) && 
                           ($scope.representante.DIRECCION) && 
                           ($scope.UBICACION_CORRECTA) &&
                           ($scope.validacionSexoSujeto))
                        {
                          nombre_representante = "";
                          espacio_nombre=" ";
                          mensaje_operacion = "Representante agregado correctamente";
                          nombre_representante = $scope.representante.PRIMER_NOMBRE;
                          if ($scope.representante.SEGUNDO_NOMBRE != undefined && $scope.representante.SEGUNDO_NOMBRE != "")
                          {
                            nombre_representante = nombre_representante+espacio_nombre+$scope.representante.SEGUNDO_NOMBRE;
                          }
                          if ($scope.representante.TERCER_NOMBRE != undefined && $scope.representante.TERCER_NOMBRE != "")
                          {
                            nombre_representante = nombre_representante+espacio_nombre+$scope.representante.TERCER_NOMBRE;
                          }
                          nombre_representante = nombre_representante+espacio_nombre+$scope.representante.PRIMER_APELLIDO;
                          if ($scope.representante.SEGUNDO_APELLIDO != undefined && $scope.representante.SEGUNDO_APELLIDO != "")
                          {
                            nombre_representante = nombre_representante+espacio_nombre+$scope.representante.SEGUNDO_APELLIDO;
                          }
                          if ($scope.representante.APELLIDO_CASADA != undefined && $scope.representante.APELLIDO_CASADA != "")
                          {
                            nombre_representante = nombre_representante+espacio_nombre+'DE'+espacio_nombre+$scope.representante.APELLIDO_CASADA;
                          }
                          $scope.representante.SUJETO=nombre_representante;  

                          if ($scope.editar_representante)
                          {
                            $scope.representantes.seleccion[$scope.index_representante].APELLIDO_CASADA = $scope.representante.APELLIDO_CASADA;
                            $scope.representantes.seleccion[$scope.index_representante].contactos = $scope.datosContactoRepresentante.seleccion;
                            $scope.representantes.seleccion[$scope.index_representante].contactoseliminacion = $scope.datosContactoRepresentante.eliminacion;
                            //$scope.representantes.seleccion[$scope.index_representante].FECHA_NACIMIENTO = fechaFormatoYYYYMMDD($scope.representante.FECHA_NACIMIENTO);
                            $scope.representantes.seleccion[$scope.index_representante].FECHA_NACIMIENTO = $scope.representante.FECHA_NACIMIENTO;
                            $scope.representantes.seleccion[$scope.index_representante].IDENTIFICACION = $scope.representante.IDENTIFICACION;
                            $scope.representantes.seleccion[$scope.index_representante].ID_CLASIFICACION_IDIOMA = $scope.representante.ID_CLASIFICACION_IDIOMA;
                            $scope.representantes.seleccion[$scope.index_representante].ID_ESTADO_CIVIL = $scope.representante.ID_ESTADO_CIVIL;
                            $scope.representantes.seleccion[$scope.index_representante].ID_GENERO = $scope.representante.ID_GENERO;
                            $scope.representantes.seleccion[$scope.index_representante].ID_IDIOMA = $scope.representante.ID_IDIOMA;
                            $scope.representantes.seleccion[$scope.index_representante].ID_NACIONALIDAD = $scope.representante.ID_NACIONALIDAD;
                            $scope.representantes.seleccion[$scope.index_representante].ID_NIVEL_EDUCATIVO = $scope.representante.ID_NIVEL_EDUCATIVO;
                            $scope.representantes.seleccion[$scope.index_representante].ID_PROFESION = $scope.representante.ID_PROFESION;
                            $scope.representantes.seleccion[$scope.index_representante].ID_SUJETO = $scope.representante.ID_SUJETO;
                            $scope.representantes.seleccion[$scope.index_representante].ID_SUJETO_NATURAL = $scope.representante.ID_SUJETO_NATURAL;
                            $scope.representantes.seleccion[$scope.index_representante].ID_SUJETO_NAT_IDENTIFICACION = $scope.representante.ID_SUJETO_NAT_IDENTIFICACION;
                            $scope.representantes.seleccion[$scope.index_representante].ID_TIPO_IDENTIFICACION = $scope.representante.ID_TIPO_IDENTIFICACION;
                            $scope.representantes.seleccion[$scope.index_representante].ID_TIPO_POBLACION = $scope.representante.ID_TIPO_POBLACION;
                            $scope.representantes.seleccion[$scope.index_representante].MASCARA_IDENTIFICACION = $scope.representante.MASCARA_IDENTIFICACION;
                            $scope.representantes.seleccion[$scope.index_representante].PRIMER_APELLIDO = $scope.representante.PRIMER_APELLIDO;
                            $scope.representantes.seleccion[$scope.index_representante].PRIMER_NOMBRE = $scope.representante.PRIMER_NOMBRE;
                            $scope.representantes.seleccion[$scope.index_representante].SEGUNDO_APELLIDO = $scope.representante.SEGUNDO_APELLIDO;
                            $scope.representantes.seleccion[$scope.index_representante].SEGUNDO_NOMBRE = $scope.representante.SEGUNDO_NOMBRE;
                            $scope.representantes.seleccion[$scope.index_representante].SUJETO = $scope.representante.SUJETO;
                            $scope.representantes.seleccion[$scope.index_representante].TERCER_NOMBRE = $scope.representante.TERCER_NOMBRE;
                            $scope.representantes.seleccion[$scope.index_representante].ID_DISCAPACIDAD = $scope.representante.ID_DISCAPACIDAD;
                            mensaje_operacion = "Representante actualizado correctamente";
                          }
                          else
                          {
                            $scope.representantes.seleccion.push(
                            {
                              APELLIDO_CASADA:$scope.representante.APELLIDO_CASADA,
                              contactos:$scope.datosContactoRepresentante.seleccion,
                              contactoseliminacion:$scope.datosContactoRepresentante.eliminacion,
                              //FECHA_NACIMIENTO:fechaFormatoYYYYMMDD($scope.representante.FECHA_NACIMIENTO),
                              FECHA_NACIMIENTO:$scope.representante.FECHA_NACIMIENTO,
                              IDENTIFICACION:$scope.representante.IDENTIFICACION,
                              ID_CLASIFICACION_IDIOMA:$scope.representante.ID_CLASIFICACION_IDIOMA,
                              ID_ESTADO_CIVIL:$scope.representante.ID_ESTADO_CIVIL,
                              ID_GENERO:$scope.representante.ID_GENERO,
                              ID_IDIOMA:$scope.representante.ID_IDIOMA,
                              ID_NACIONALIDAD:$scope.representante.ID_NACIONALIDAD,
                              ID_NIVEL_EDUCATIVO:$scope.representante.ID_NIVEL_EDUCATIVO,
                              ID_PROFESION:$scope.representante.ID_PROFESION,
                              ID_SUJETO:$scope.representante.ID_SUJETO,
                              ID_SUJETO_NATURAL:$scope.representante.ID_SUJETO_NATURAL,
                              ID_SUJETO_NAT_IDENTIFICACION:$scope.representante.ID_SUJETO_NAT_IDENTIFICACION,
                              ID_TIPO_IDENTIFICACION:$scope.representante.ID_TIPO_IDENTIFICACION,
                              ID_TIPO_POBLACION:$scope.representante.ID_TIPO_POBLACION,
                              MASCARA_IDENTIFICACION:$scope.representante.MASCARA_IDENTIFICACION,
                              PRIMER_APELLIDO:$scope.representante.PRIMER_APELLIDO,
                              PRIMER_NOMBRE:$scope.representante.PRIMER_NOMBRE,
                              SEGUNDO_APELLIDO:$scope.representante.SEGUNDO_APELLIDO,
                              SEGUNDO_NOMBRE:$scope.representante.SEGUNDO_NOMBRE,
                              SUJETO:$scope.representante.SUJETO,
                              TERCER_NOMBRE:$scope.representante.TERCER_NOMBRE,
                              ID_DISCAPACIDAD:$scope.representante.ID_DISCAPACIDAD
                            });
                          }
                          if ($scope.icono_boton_editar_representante == "fa fa-plus")
                          {
                            $scope.cambiarBotones();
                            validaRepresentante();
                            $scope.limpiarRepresentante();
                          }
                          toastr.success(mensaje_operacion);
                          $scope.habilitar_datos_identificacion_representante();
                        }
                        else
                        {
                          mensaje="Faltan datos por ingresar";
                          if(isValid)
                          {
                            if (!$scope.representante.DIRECCION)
                            {
                              mensaje="Debe agregar como mínimo una dirección en los datos de contacto";
                            }
                            else if (!$scope.UBICACION_CORRECTA)
                            {
                              mensaje = $scope.mensaje_ubicacion_incorrecta;
                            }
                          }
                          toastr.warning(mensaje);
                        }
                      }
                      /*$scope.editarRepresentante = function(item)
                      {
                        $scope.index_representante = $scope.representantes.seleccion.indexOf(item);
                        if ((item.ID_SUJETO != undefined) && (item.ID_SUJETO != ""))
                        {
                          $scope.REPRESENTANTE_BD = true;
                          item.ID_TIPO_SUJETO = $scope.CONSTANTES.TIPO_SUJETO_NATURAL;
                          getDatosSujeto(item,$scope.CONSTANTES.TIPO_SUJETO_NATURAL,true);  
                        }
                        else
                        {
                          $scope.REPRESENTANTE_BD = false;
                          editarRepresentanteLocal(item);
                        }
                      }*/
                      $scope.editarRepresentante = function(item)
                      {
                        $scope.index_representante = $scope.representantes.seleccion.indexOf(item);
                        $scope.activarFormularioRepresentante();
                        $scope.editar_representante = true;
                        $scope.editar_representante_registro = true;
                        itemTipoIdentificacion = buscarTipoIdentificacionSujeto(item.ID_TIPO_IDENTIFICACION, $scope.tipoIdentificacionRepresentante);
                        $scope.selectedTipoIdentificacionRepresentante(itemTipoIdentificacion);
                        angular.extend($scope.representante,item);
                        $scope.selectedGenero(item);
                        getPoblacionIdioma(item);
                        $scope.representante.ID_CLASIFICACION_IDIOMA = item.ID_CLASIFICACION_IDIOMA;
                        $scope.representante.ID_TIPO_POBLACION = item.ID_TIPO_POBLACION;
                        $scope.representante.ID_IDIOMA = item.ID_IDIOMA;
                        $scope.datosContactoRepresentante.seleccion=$scope.representante.contactos;
                        $scope.icono_boton_editar_representante = "fa fa-refresh";
                        // $scope.icono_boton_limpiar_representante = "fa fa-close";
                        $scope.tooltip_boton_editar_representante = "Actualizar datos";
                        // $scope.tooltip_boton_limpiar_representante = "Cancelar actualización de datos";
                        $scope.formularioRepresentante = true;
                        

                        // if ($scope.representantes.seleccion.length > 1)
                        // {
                        //     $scope.mostrar_representantes = true; 
                        // }
                        // else
                        // {
                        //   $scope.mostrar_representantes = false;
                        // }


                        $scope.focus_identificacion_representante = false;
                        validaDireccion();
                        $scope.habilitar_datos_identificacion_representante();
                      }
                      $scope.eliminarRepresentante = function(item)
                      {
                        /*if (($scope.representantes.seleccion.length == 0) && 
                            ($scope.index >= 0) && 
                            ($scope.campo_requerido))
                        {
                          $scope.representantes.seleccion.push(item);
                          toastr.warning("No se puede realizar la eliminación, debe asignar como mínimo un representante");
                        }
                        else
                        {*/
                          swal({                            
                            title:'¿Eliminar representante?', 
                            text: item.SUJETO,
                            type: "error",
                            showCancelButton: true,
                            confirmButtonClass: "btn-danger",
                            confirmButtonText: "Continuar",
                            cancelButtonClass: "btn-default",
                            cancelButtonText: "Cancelar",
                            closeOnConfirm: false,
                            closeOnCancel: false }, 
                            function(isConfirm){ 
                            if (isConfirm) 
                            {  
                              /*if ($scope.editar_solicitante)
                              {
                                //$scope.solicitantes.seleccion[$scope.index].representantes = $scope.representantes.seleccion;
                                if ((item.ID_REPRESENTANTE != undefined) && (item.ID_REPRESENTANTE != ""))
                                {
                                  $scope.representantes.eliminacion.push(item);
                                }
                              }
                              else if ($scope.editar_invitado)
                              {
                                //$scope.invitados.seleccion[$scope.index].representantes = $scope.representantes.seleccion;
                                if ((item.ID_REPRESENTANTE != undefined) && (item.ID_REPRESENTANTE != ""))
                                {
                                  $scope.representantes.eliminacion.push(item);
                                }
                              }*/
                              //$scope.representantes.eliminacion.push(item);
                              validaRepresentante();
                              $scope.$apply();
                              swal.close();
                              
                            } 
                            else 
                            {
                              $scope.representantes.seleccion.push(item);
                              validaRepresentante();
                              $scope.$apply();
                              swal.close();
                            }
                          });
                        // }
                        
                      }
                      $scope.viewRepresentante = function()
                      {
                        $scope.dialogShowRepresentante = ngDialog.open(
                        {
                          template: 'app/casos/casos.registro.representante.view.tpl.html',
                          showClose: true,
                          closeByEscape: true,
                          closeByNavigation: true,
                          preCloseCallback:function()
                          {
                          //   validaRepresentantes();
                          //   if ($scope.REPRESENTANTES_AGREGADOS == true)
                          //   {
                          //     // $scope.representantes_guardados = true;
                          //     //toastr.success($scope.mensaje_validacion);
                          $scope.limpiarRepresentante();
                          //     // $scope.cerrarDialog = true;
                          //     //ngDialog.close();
                          $scope.formularioRepresentante = false;
                          $scope.focus_identificacion_valida_representante = false;   
                          /*if (!$scope.REPRESENTANTE_BD)
                          {
                            if ($scope.editar_solicitante)
                            {
                              $scope.solicitantes.seleccion[$scope.index].representantes = $scope.representantes.seleccion;
                            }
                            else if ($scope.editar_invitado)
                            {
                              $scope.invitados.seleccion[$scope.index].representantes = $scope.representantes.seleccion;
                            }*/
                          //       // else
                          //       // {
                          //       //   completarAgregadoSujeto(accion,true);
                          //       // }
                          //       // $scope.tooltip_ver_representante = "Ver representante";
                          //       // if ($scope.representantes.seleccion.length > 1)
                          //       // {
                          //       //   $scope.tooltip_ver_representante = "Ver representantes"
                          //       // }
                          //       $scope.REPRESENTANTES_AGREGADOS = true;
                          //     }
                              
                          //     // $scope.cerrarDialog = false;
                          //     // if ($scope.vieneDeContacto)
                          //     // {
                          //     //   $scope.vieneDeContacto = false;
                          //     //   ngDialog.close($scope.viewContactoCloseId);
                          //     // }
                          //   }
                          //   else
                          //   {
                          //   // if (!$scope.cerrarDialog)
                          //   // {
                          //     mensaje="No se agregó ningún representante al solicitante";
                          //     if ($scope.formulario_invitado)
                          //     {
                          //       mensaje="No se agregó ningún representante al invitado";
                          //     }
                          //     // if (($scope.editar_solicitante) || ($scope.editar_invitado))
                          //     // {
                          //     //   mensaje="No se actualizó ningún representante del invitado";
                          //     //   if ($scope.editar_solicitante)
                          //     //   {
                          //     //     mensaje="No se actualizó ningún representante del solicitante";
                          //     //   }
                          //     //   if ($scope.representantes.seleccion.length == 0)
                          //     //   {
                          //     //     $scope.restaurarValoresSujeto();
                          //     //     $scope.cambiarBotones();  
                          //     //   }
                          //     // }
                          //     if ($scope.deshabilitar_datos_representante)
                          //     {
                          //       return false;
                          //     }
                          //     else
                          //     {
                          //       $scope.UBICACION_CORRECTA = true;
                          //       // if ($scope.vieneDeContacto)
                          //       // {
                          //       //   $scope.vieneDeContacto = false;
                          //       //   ngDialog.close($scope.viewContactoCloseId);
                          //       // }
                          //       $scope.formularioRepresentante = false;
                          //     }
                          //     toastr.warning(mensaje);
                          //   } 
                            // }
                          },
                          className: 'ngdialog-theme-flat-custom',
                          // resolve:
                          // {
                            // dataTipoContacto: ['casosService',
                            // function(casosService)
                            // {
                            //   return casosService.getTipoContacto();
                            // }]
                          // },
                          scope:$scope,
                          controller: ['$scope', function($scope) 
                          {
                            // if ($scope.representantes.seleccion.length == 1)
                            // { 
                            //   $scope.editarRepresentante($scope.representantes.seleccion[0]);
                            // }
                            if (!$scope.editar_representante)
                            {
                              $scope.limpiarRepresentante();
                              itemTipoIdentificacion = buscarTipoIdentificacionSujeto($scope.CONSTANTES.TIPO_IDENTIFICACION_DPI, $scope.tipoIdentificacionRepresentante);
                              $scope.selectedTipoIdentificacionRepresentante(itemTipoIdentificacion);
                            } 
                          }] 
                        });  
                      }
                      $scope.activarFormularioRepresentante = function()
                      {
                        // if ((isValid) && (($scope.solicitante.DIRECCION) || ($scope.invitado.DIRECCION)))
                        // {
                          //se activa el indicador que las operaciones son en el formulario de representantes
                          $scope.formularioRepresentante = true;
                          //se deshabilita la seccion para visualizar los representantes del sujeto
                          //$scope.mostrar_representantes = false;
                          //se inicializa el indicador de representante guardado en base de datos
                          // if ($scope.campo_requerido)
                          // {
                            $scope.habilitar_datos_identificacion_representante();
                          // }
                          $scope.REPRESENTANTE_BD = false;
                          $scope.FECHA_NACIMIENTO_VALIDA = true;
                          // $scope.limpiarRepresentante();
                          $scope.viewRepresentante();
                        // }
                        // else
                        // {
                        //   toastr.warning("Faltan datos por ingresar");
                        // }
                      }
          /*----------------viewRepresentante----------------*/        
/*datos comunes solicitante invitados representantes contactos*/

/*formulario solicitante*/
                      //funciones solicitante
                      $scope.formularioSolicitante = function(isValid)
                      {
                        if(isValid)
                        {
                          $scope.box_ngDdialog = "box-primary";
                          $scope.btn_sujeto = "btn-primary"
                          // $scope.combo_tipo_identificacion_solicitante = true;
                          // $scope.formulario_caso_completo = true;
                          formulariocompleto();
                          $scope.deshabilitar_item_solicitante = false;
                          if ($scope.formulario_solicitante == false)
                          {
                            tooltipItems("formulario_solicitante");
                            if ($scope.formulario_caso == true)
                            {
                              $scope.animacion_formulario_solicitante = entrada_derecha;
                            }
                            else
                            {
                              $scope.animacion_formulario_solicitante = entrada_izquiera;
                            }
                            $scope.formulario_caso = false;    
                            $scope.formulario_solicitante = true;
                            $scope.formulario_invitado = false;
                            $scope.formulario_sesion = false;
                            $scope.formulario_homologacion = false;
                            $scope.formulario_seguimiento = false;
                          }
                          $scope.cambiarBotones();
                          if ($scope.solicitantes.seleccion.length != 1)
                          {
                            $scope.LOCAL_ID_TIPO_SUJETO = $scope.CONSTANTES.TIPO_SUJETO_NATURAL;
                            if ($scope.SOLICITANTE_PRINCIPAL_AGREGADO)
                            {
                              $scope.deshabilitar_prioridad_solicitante = false;
                              $scope.LOCAL_ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_SECUNDARIO;  
                            }
                            else
                            {
                              $scope.deshabilitar_prioridad_solicitante = true;
                              $scope.LOCAL_ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL;  
                            }
                            $scope.restaurarValoresSujeto();
                            ordenarSujeto();
                          }
                          $scope.mostrar_solicitantes = false;
                          if ($scope.solicitantes.seleccion.length == 1)
                          {
                            limpiarEstadoCivilProfesion();
                            $scope.editarSujeto($scope.solicitantes.seleccion[0]);
                          }
                          if ($scope.solicitantes.seleccion.length > 1)
                          {
                            $scope.mostrar_solicitantes = true; 
                          }
                          $scope.editar_invitado = false;
                          $scope.seleccionTipoIdentificacion = true;
                          $scope.campo_requerido = $scope.campo_requerido_solicitante;
                          descripciones_generales();
                          $scope.habilitar_datos_identificacion();
                        }
                        else
                        {
                          toastr.warning("Faltan datos por ingresar");
                        }
                      } 
                      $scope.agregarSolicitante = function(isValid,accion)
                      { 
                        if (accion == "siguiente")
                        {
                          if ($scope.solicitantes.seleccion.length == 0)
                          {
                            $scope.agregarSujeto(isValid,accion);
                          }
                          else
                          {
                            $scope.formularioInvitado();
                          }
                        }
                        else if (accion == "guardar")
                        {
                          if ($scope.solicitantes.seleccion.length == 0)
                          {
                            $scope.agregarSujeto(isValid,accion);
                          }
                          else
                          {
                            verificacionGuardadoCaso(true);
                          }
                        }
                        // $scope.mensaje_operacion_agregado = "Faltan datos por ingresar";
                        // if ((isValid) && ($scope.solicitantes.seleccion.length == 0))
                        //   validaDireccion();
                        //   if ($scope.solicitante.DIRECCION)
                        //   {
                        //     $scope.agregarSujeto(isValid,accion);
                        //   }
                        //   else
                        //   {
                        //     $scope.mensaje_operacion_agregado = "Debe agregar como mínimo una dirección en los datos de contacto";
                        //   }
                        // }
                        // else if ($scope.solicitantes.seleccion.length > 0)
                        // {
                        //   $scope.mensaje_operacion_agregado = "Debe agregar como mínimo un solicitante principal";
                        // }
                      }
/*formulario solicitante*/
/*formulario invitado*/
                      //funciones invitado
                      $scope.formularioInvitado = function()
                      {
                        validaSujetos();
                        if(($scope.SOLICITANTES_AGREGADOS) && ($scope.SOLICITANTE_PRINCIPAL_AGREGADO))
                        {
                          $scope.box_ngDdialog = "box-warning";
                          $scope.btn_sujeto = "btn-warning"
                          // $scope.combo_tipo_identificacion_invitado = true;
                          //$scope.formulario_solicitante_completo = true;
                          formulariocompleto();
                          $scope.deshabilitar_item_invitado = false;
                          if ($scope.formulario_invitado == false)
                          {
                            tooltipItems("formulario_invitado");
                            if (($scope.formulario_solicitante == true) || ($scope.formulario_caso == true)) 
                            {
                              $scope.animacion_formulario_invitado = entrada_derecha;
                            }
                            else
                            {
                              $scope.animacion_formulario_invitado = entrada_izquiera;
                            }
                            $scope.formulario_caso = false;    
                            $scope.formulario_solicitante = false;
                            $scope.formulario_invitado = true;
                            $scope.formulario_sesion = false;
                            $scope.formulario_homologacion = false;
                            $scope.formulario_seguimiento = false;
                          }
                          $scope.cambiarBotones();
                          if ($scope.invitados.seleccion.length != 1)
                          {
                            $scope.LOCAL_ID_TIPO_SUJETO = $scope.CONSTANTES.TIPO_SUJETO_NATURAL;
                            if ($scope.INVITADO_PRINCIPAL_AGREGADO)
                            {
                              $scope.deshabilitar_prioridad_invitado = false;
                              $scope.LOCAL_ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_SECUNDARIO;  
                            }
                            else
                            {
                              $scope.deshabilitar_prioridad_invitado = true;
                              $scope.LOCAL_ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL;  
                            }
                            $scope.LOCAL_ID_PRIORIDAD_SUJETO = $scope.CONSTANTES.PRIORIDAD_SUJETO_PRINCIPAL;
                            $scope.restaurarValoresSujeto();
                            ordenarSujeto();
                          }
                          $scope.mostrar_invitados = false;
                          if ($scope.invitados.seleccion.length == 1)
                          {
                            limpiarEstadoCivilProfesion();
                            $scope.editarSujeto($scope.invitados.seleccion[0]);
                          }
                          if ($scope.invitados.seleccion.length > 1)
                          {
                            $scope.mostrar_invitados = true; 
                          }
                          $scope.editar_solicitante = false;
                          $scope.seleccionTipoIdentificacion = true;
                          $scope.campo_requerido = $scope.campo_requerido_invitado;
                          descripciones_generales();
                          $scope.habilitar_datos_identificacion();
                        }
                        else
                        {
                          toastr.warning("Debe agregar como mínimo un solicitante principal");
                        }
                      }
                      $scope.agregarInvitado = function(isValid,accion)
                      { 
                        if ($scope.invitados.seleccion.length == 0)
                        {
                          $scope.agregarSujeto(isValid,accion);
                        }
                        else
                        {
                          $scope.formularioSesion();
                        }
                        
                        // $scope.mensaje_operacion_agregado = "Faltan datos por ingresar";
                        // if ((isValid) && ($scope.invitados.seleccion.length == 0))
                        // {
                        //   validaDireccion();
                        //   if ($scope.invitado.DIRECCION)
                        //   {
                        //     $scope.agregarSujeto(isValid,accion);
                        //   }
                        //   else
                        //   {
                        //     $scope.mensaje_operacion_agregado = "Debe agregar como mínimo una dirección en los datos de contacto";
                        //   }
                        // }
                        // else if ($scope.invitados.seleccion.length > 0)
                        // {
                        //   $scope.mensaje_operacion_agregado = "Debe agregar como mínimo un invitado principal";
                        // }
                      }
/*formulario invitado*/
/*formulario sesion*/
                      //se cambia la configuracion predeterminada para que al seleccionar semana salga en español el texto
                      calendarConfig.allDateFormats.angular.title.week = "Semana {week} de {year}"
                      //se utiliza para que el calendario inicie en lunes como primer dia de la semana
                      //moment.locale('en_gb', {week : {dow : 1 }});
                      //se declara el arreglo para datos de la sesion
                      $scope.btn_select_agenda = "btn-default";
                      //se inicializa el id de la sesion en 0 para ser cambiado segun la sesion seleccionada en la seccion de sesiones
                      //cambiar el 0 por el id que se seleccione en la seccion sesiones
                      $scope.sesion.ID_SESION = "0";
                      //se inicializa la etiqueta de la fecha y hora de la sesion
                      $scope.sesion.FECHA_HORA_SESION = "SESIÓN NO AGENDADA";
                      $scope.sesion.SESION_AGENDADA = false;
                      //se inicializa la bandera para mantener oculto el calendario
                      $scope.colapsado = true;
                      //se declara el arreglo para el calendario
                      $scope.vm = {};
                      //unidad con la que el calendario se visualizara incialmente, pueden ser dia, semana, mes y año                      
                      $scope.vm.calendarView = 'week';
                      //se verifica si hay alguna semana fija en la agendada
                      casosService.getFechaAgenda(CENTRO.ID_DESPACHO).then(
                        function ( response ) 
                        {
                          if ((response.data.FECHA_AGENDA == "") || (response.data.FECHA_AGENDA == undefined))
                          {
                            $scope.vm.viewDate = new Date();
                          }
                          else
                          {
                            $scope.vm.viewDate = new Date(response.data.FECHA_AGENDA);
                            $scope.btn_select_agenda = "btn-info";
                          }
                          $scope.vm.FECHA_AGENDA = $scope.vm.viewDate;
                          p_fecha_actual = fechaFormatoYYYYMMDD(new Date(new Date().setDate($scope.vm.viewDate.getDate())));
                          getMediadoresCentro();
                        },
                        function ( error ) 
                        {
                            toastr.error( error );
                        });
                      //se inicializa oculta la etiqueta de fecha y hora
                      $scope.mostrar_fecha_hora = false;
                      //se obtiene el dia actual para poder enviarla como fecha actual al llenar el calendario
                      // p_fecha_actual = fechaFormatoYYYYMMDD(new Date(new Date().setDate($scope.vm.viewDate.getDate())));
                      meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
                      dias = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
                      fechaDiaInicialFinalSemana = function (date)
                      {
                        d = new Date(date);
                        day = d.getDay();
                        diff = d.getDate() - day + (day == 0 ? -6 : 1);
                        lunes = new Date(d.setDate(diff));
                        p_fecha_inicial = fechaFormatoYYYYMMDD(lunes);

                        d = new Date(date);
                        day = d.getDay(),
                        diff = d.getDate() - day + (day == 0 ? -6 : 5);
                        viernes = new Date(d.setDate(diff));
                        p_fecha_final = fechaFormatoYYYYMMDD(viernes);
                      }
                      fechaTituloRangoDiasSemana = function(date)
                      {
                        d = new Date(date);
                        day = d.getDay(),
                        diff = d.getDate() - day;
                        domingo = new Date(d.setDate(diff));            
                        d = new Date(date);
                        day = d.getDay(),
                        diff = d.getDate() - day + (day == 0 ? -6 : 6);
                        sabado = new Date(d.setDate(diff));
                        diaInicial = domingo.getDate();
                        mesInicial = meses[domingo.getMonth()];
                        anioInicial= domingo.getFullYear();
                        diaFinal = sabado.getDate();
                        mesFinal = meses[sabado.getMonth()];
                        anioFinal= sabado.getFullYear();
                        tituloCalendario = diaInicial;
                        if (mesInicial != mesFinal)
                        {
                          tituloCalendario = tituloCalendario +' '+ mesInicial;
                        }
                        if (anioInicial != anioFinal)
                        {
                          tituloCalendario = tituloCalendario +' '+ anioInicial;
                        }
                        tituloCalendario = tituloCalendario +' - '+diaFinal+' '+mesFinal+', '+anioFinal;
                        return tituloCalendario;
                      }
                      fechaEtiquetaDiaMes = function(date)
                      {
                        today = new Date(date);
                        dd = today.getDate();
                        mm = today.getMonth()+1;
                        yyyy = today.getFullYear();
                        if(dd<10)
                        {
                          dd='0'+dd;
                        } 
                        if(mm<10)
                        {
                          mm='0'+mm;
                        }   
                        d = new Date(date);
                        return $filter('uppercase')(dias[d.getDay()])+', '+dd+' DE '+$filter('uppercase')(meses[today.getMonth()])+' DE '+yyyy;
                      }
                      $scope.fijarAgenda = function(item)
                      {
                        casosService.edtFijarAgenda({ID_DESPACHO:CENTRO.ID_DESPACHO,FECHA_AGENDA:fechaFormatoYYYYMMDD(item)}).then(
                          function (response)
                          {
                            if(response.data.result=='OK')
                            {
                              toastr.success(response.data.msj);
                              $scope.btn_select_agenda = "btn-info";
                            }
                            else
                            {
                              toastr.error(response.data.msj);
                            }                      
                          },
                          function (error) 
                          {
                            toastr.error( error );
                          });
                      }
                      $scope.colapsar = function()
                      {
                        $scope.colapsado = !$scope.colapsado;
                      }
                      limpiarEventoSeleccionado = function()
                      {
                        $scope.sesion.calendarEventId = undefined;
                        $scope.mostrar_fecha_hora = false;
                        $scope.sesion.FECHA_HORA_SESION = "SESIÓN NO AGENDADA"; 
                        $scope.sesion.SESION_AGENDADA = false;
                        $scope.sesion.ID_HORA = "";
                        $scope.sesion.FECHA_SESION = "";
                      }
                      armaCalendario = function(eventos){
                      $scope.vm.events=[];
                       eventos.forEach(function(evento) {
                            var evt ={
                              title: evento.HORA_INICIO+' - '+evento.ESTADO_SESION,
                              color: angular.fromJson(evento.COLORES),
                              startsAt: new Date(fechaFormatoYYYYMMDD(evento.FECHA_CALENDARIO)+' '+evento.HORA_INICIO),
                              endsAt: new Date(fechaFormatoYYYYMMDD(evento.FECHA_CALENDARIO)+' '+evento.HORA_FIN),
                              draggable: false,
                              resizable: false,
                              FECHA_CALENDARIO: evento.FECHA_CALENDARIO,
                              ID_HORA: evento.ID_HORA,
                              HORA_INICIO: evento.HORA_INICIO,
                              HORA_FIN: evento.HORA_FIN,
                              ID_SESION:evento.ID_SESION,
                              ESTADO_SESION: evento.ESTADO_SESION,
                              SESION_EDITABLE: evento.SESION_EDITABLE,
                              PROGRAMACION_FUTURA: evento.PROGRAMACION_FUTURA,
                              MEDIADORES_CENTRO: evento.MEDIADORES_CENTRO,
                              SESIONES_CENTRO: evento.SESIONES_CENTRO
                            };
                            /*if ((evento.ID_SESION > 0) && (evento.SESION_EDITABLE > 0))
                            {console.log('colapsado');
                              // $scope.sesion.ID_SESION = evento.ID_SESION;
                              $scope.sesion.SESION_EDITABLE = evento.SESION_EDITABLE;
                              $scope.mostrar_fecha_hora = true;
                              $scope.sesion.FECHA_HORA_SESION = fechaEtiquetaDiaMes(evento.FECHA_CALENDARIO)+', '+evento.HORA_INICIO+' HORAS';
                              // $scope.colapsado = true;
                            }*/
                            $scope.vm.events.push(evt);
                        });      
                      }
                      $scope.cargarEventos = function(colapsar)
                      {
                        if ($scope.sesion.ID_SESION == "0")
                        {
                          limpiarEventoSeleccionado();
                        }
                        fechaDiaInicialFinalSemana($scope.vm.viewDate);
                        if ($scope.vm.calendarView == 'week')
                        {
                          $scope.tituloCalendario = fechaTituloRangoDiasSemana($scope.vm.viewDate);  
                        }
                        else
                        {
                          $scope.tituloCalendario = $scope.vm.calendarTitle;
                        }
                        casosService.getAgendaSesionesMediador(CENTRO.ID_DESPACHO,$scope.sesion.ID_SESION,p_fecha_inicial,p_fecha_final,p_fecha_actual).then(
                          function ( response ) 
                          { 
                            $scope.colapsado = colapsar;
                            armaCalendario(response.data);
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                          $scope.btn_select_agenda = "btn-default";
                          if (fechaFormatoYYYYMMDD($scope.vm.FECHA_AGENDA) == fechaFormatoYYYYMMDD($scope.vm.viewDate))
                          {
                            $scope.btn_select_agenda = "btn-info";
                          }
                      }

                      $scope.selectedMediadorCentro = function (item)
                      {
                        $scope.sesion.ID_MEDIADOR_RECEPTOR = item.ID_MEDIADOR;
                        $scope.sesion.NOMBRE_MEDIADOR = item.NOMBRE_MEDIADOR;
                        //$scope.caso.FIRMA_DOCUMENTO = item.ESTADO_FIRMA;
                        //$scope.caso.FIRMA_USUARIO_INACTIVA = $scope.CONSTANTES.FIRMA_USUARIO_INACTIVA;
                        if (!$scope.sesion.SESION_AGENDADA)
                        {
                          $scope.colapsado = false;
                        }
                      }
                      //se inicializa el arreglo de los mediadores segun centro
                      getMediadoresCentro = function()
                      {
                        casosService.getMediadoresCentro(CENTRO.ID_DESPACHO,$scope.loginData.ID_USUARIO,$scope.CONSTANTES.CARGO_MEDIADOR).then(
                          function ( response ) 
                          {
                            $scope.mediadoresCentro = [];
                            $scope.mediadoresCentro = response.data;  
                            // colapsar = false;
                            
                            if ($scope.mediadoresCentro.length == 1)
                            {
                              $scope.selectedMediadorCentro(response.data[0]);
                              $scope.cargarEventos(false);
                              // colapsar = true;
                            }
                            else
                            {
                              $scope.cargarEventos(true);
                            }
                            // console.log(colapsar);
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                        }
                        $scope.vm.cellIsOpen = true;
                        $scope.vm.eventClicked = function(event) 
                        {  
                          /*if (($scope.sesion.ID_SESION > 0) && ($scope.sesion.SESION_EDITABLE > 0))
                          {
                            $scope.sesion.ID_HORA = event.ID_HORA;
                            $scope.sesion.SESION_AGENDADA = true;
                            $scope.colapsado = true;
                          }
                          else
                          {*/
                            if (event.SESION_EDITABLE == 0)
                            {
                              mensaje = 'Otra sesión ya ha sido agendada en este horario, por favor seleccione uno diferente';
                              if (event.MEDIADORES_CENTRO > 1)
                              {
                                mensaje = 'Otras sesiones ya han sido agendadas en este horario, por favor seleccione uno diferente';
                              }
                              toastr.warning(mensaje);
                            }
                            else
                            {
                              $scope.mostrar_fecha_hora = true;
                              $scope.sesion.FECHA_HORA_SESION = fechaEtiquetaDiaMes(event.FECHA_CALENDARIO)+', '+event.HORA_INICIO+' HORAS';  
                              $scope.sesion.ID_HORA = event.ID_HORA;
                              $scope.sesion.FECHA_SESION = event.FECHA_CALENDARIO;
                              eventTemp = $scope.vm.events[event.calendarEventId];
                              $scope.sesion.SESION_AGENDADA = true;
                              complemento_titulo = ' - Sesión agendada';
                              if (event.MEDIADORES_CENTRO > 1)
                              {
                                complemento_titulo = ' - ('+(parseInt(event.SESIONES_CENTRO)+1)+'/'+event.MEDIADORES_CENTRO+') Sesión agendada';
                              }
                              if ($scope.sesion.calendarEventId == undefined)
                              {
                                eventTemp.title = event.HORA_INICIO+complemento_titulo;
                                eventTemp.color.primary = '#ad2121';
                                eventTemp.color.secondary = '#fae3e3';
                                $scope.sesion.calendarEventId = event.calendarEventId;
                              }
                              else
                              {
                                if ($scope.sesion.calendarEventId != event.calendarEventId)
                                {
                                  eventRestore = $scope.vm.events[$scope.sesion.calendarEventId];
                                  eventRestore.title = eventRestore.HORA_INICIO+' - '+eventRestore.ESTADO_SESION;
                                  if (eventRestore.PROGRAMACION_FUTURA == $scope.CONSTANTES.REGISTRO_VERDADERO)
                                  {
                                    eventRestore.color.primary = '#006400';
                                    eventRestore.color.secondary = '#caffca';
                                  }
                                  else if (eventRestore.PROGRAMACION_FUTURA == $scope.CONSTANTES.REGISTRO_FALSO)
                                  {
                                    eventRestore.color.primary = '#e3bc08';
                                    eventRestore.color.secondary = '#fdf1ba';
                                  }
                                  else
                                  {
                                    eventRestore.color.primary = '#1e90ff';
                                    eventRestore.color.secondary = '#d1e8ff';
                                  }
                                  eventTemp.title = event.HORA_INICIO+complemento_titulo;
                                  eventTemp.color.primary = '#ad2121';
                                  eventTemp.color.secondary = '#fae3e3';
                                  $scope.sesion.calendarEventId = event.calendarEventId;
                                }
                              }
                              // toastr.success('Sesión agendada correctamente');
                              $scope.colapsado = true;
                            }
                          // }
                        };
                      $scope.formularioSesion = function()
                      {
                        validaSujetos();
                        if(($scope.INVITADOS_AGREGADOS) && ($scope.INVITADO_PRINCIPAL_AGREGADO))
                        {
                          // $scope.formulario_invitado_completo = true;
                          formulariocompleto();
                          $scope.deshabilitar_item_sesion = false;
                          if ($scope.formulario_sesion == false)
                          {
                            tooltipItems("formulario_sesion");
                            if (($scope.formulario_invitado == true) || ($scope.formulario_solicitante == true) || ($scope.formulario_caso == true)) 
                            {
                              $scope.animacion_formulario_sesion = entrada_derecha;
                            }
                            else
                            {
                              $scope.animacion_formulario_sesion = entrada_izquiera;
                            }
                            $scope.formulario_caso = false;    
                            $scope.formulario_solicitante = false;
                            $scope.formulario_invitado = false;
                            $scope.formulario_sesion = true;
                            $scope.formulario_homologacion = false;
                            $scope.formulario_seguimiento = false;
                          }
                          descripciones_generales();                          
                        }
                        else
                        {
                          toastr.warning("Debe agregar como mínimo un invitado principal");
                        }
                      }
                      
                      
/*formulario sesion*/
/*guardado caso*/    
                      getTime = function(date)
                      {
                        time = new Date(date);
                        horas = time.getHours();
                        if(horas<10)
                        {
                          horas='0'+horas;
                        }
                        minutos = time.getMinutes();
                        if(minutos<10)
                        {
                          minutos='0'+minutos;
                        }
                        // segundos = time.getSeconds(); // => 51
                        // if(segundos<10)
                        // {
                        //   segundos='0'+segundos;
                        // }
                        return (horas+':'+minutos);
                      }
                      // //se obtiene la fecha actual para mostrarla en el encabezado de los formularios
                      $scope.caso.FECHA_CREACION = $filter('lowercase')(fechaEtiquetaDiaMes(new Date()));
                      //funciones de guardado caso
                      getDatosSujeto = function(item,p_sujeto_natural,representante)
                      {
                        casosService.getDatosSujeto($scope.caso.ID_EXPEDIENTE,item.ID_SUJETO,item.ID_TIPO_SUJETO,p_sujeto_natural).then(
                          function ( response ) 
                          { 
                            datosSujeto = [];
                            datosSujeto = response.data;
                            angular.extend(datosSujeto,item);
                            if (representante)
                            {
                              editarRepresentante(datosSujeto);  
                            }
                            else
                            {
                              editarSujetoLocal(datosSujeto);
                            }
                          },
                          function ( error ) 
                          {
                            toastr.error( error );
                          });
                      }

                      getCaso = function(p_id_expediente, firma, datosFirma)
                      {
                        casosService.getCaso(p_id_expediente).then(
                          function ( response ) 
                          { 
                            $scope.caso.ENCABEZADO_CASO = "CASO";
                            $scope.caso.NUMERO_CASO = response.data[0].NUMERO_CASO;
                            $scope.caso.ID_SESION = response.data[0].ID_SESION;
                            $scope.caso.ID_EXPEDIENTE = p_id_expediente;
                            $scope.caso.archivoFirmado = false;
                            $scope.deshabilitar_nuevo_caso = false;
                            $scope.deshabilitar_datos_caso = true;
                            $scope.deshabilitar_datos_solicitante = true;
                            $scope.deshabilitar_datos_invitado = true;
                            $scope.deshabilitar_datos_sesion = true;
                            $scope.deshabilitar_imprimir_invitacion = false;
                            $scope.tooltip_imprimir_evolucion = "Imprimir carátula y evolución del caso";
                            $scope.deshabilitar_boton_guardar_caso_no_mediable = true;
                            $scope.deshabilitar_boton_guardar_caso_mediable = true;
                            $scope.tooltip_item_caso = true;
                            $scope.tooltip_item_solicitante = false;
                            if ($scope.caso.ID_TIPO_ASUNTO == $scope.CONSTANTES.ASUNTO_MEDIABLE)
                            {
                              $scope.tooltip_item_solicitante = true;
                              $scope.tooltip_item_sesion = false;
                              $scope.tooltip_imprimir_evolucion = "Imprimir invitaciones, carátula, evolución y registro del caso";
                            }
                            formulariocompleto();
                            if ((firma) && ($scope.loginData.CENTRO.FIRMA_DOCUMENTO == $scope.CONSTANTES.USUARIO_CON_FIRMA))
                            {
                              datosFirma.ARCHIVO = response.data[0].ARCHIVO;
                              datosFirma.ID_ARCHIVO = response.data[0].ID_ARCHIVO;
                              datosFirma.ID_ARCHIVO_EXPEDIENTE = response.data[0].ID_ARCHIVO_EXPEDIENTE;
                              datosFirma.ID_ARCHIVO_PADRE = response.data[0].ID_ARCHIVO;
                              datosFirma.ID_EXPEDIENTE = p_id_expediente.toString();
                              datosFirma.NUMERO_CASO = response.data[0].NUMERO_CASO;
                              datosFirma.ID_SESION = response.data[0].ID_SESION;
                              $scope.caso.ID_ARCHIVO = response.data[0].ID_ARCHIVO;
                              console.log("datosFirma en getCaso",datosFirma);
                              firmarArchivo(datosFirma);
                            }
                            else
                            {
                              $scope.imprimirInvitacion();
                            }
                        },
                        function ( error ) 
                        {
                          toastr.error( error );
                        });
                      }

                      firmarArchivo = function (item)
                      {
                        authService.firmarArchivo(item).then(
                          function (response)
                          {
                            if(response.data.result=='OK')
                            {
                              $scope.caso.archivoFirmado = true;
                              if ($scope.loginData.CENTRO.BUZON_ACHIVOS == $scope.CONSTANTES.MOSTRAR_BUZON_ARCHIO)
                              {
                                $scope.cantidadArchivosFirma($scope.loginData.ID_USUARIO,$scope.loginData.CENTRO.ID_DESPACHO,$scope.CONSTANTES.ESTADO_ARCHIVO_SOLICITUD,$scope.CONSTANTES.ARCHIVO_TIPO_INVITACION);
                              }
                              toastr.success(response.data.msj);
                              $scope.imprimirInvitacion();
                            }
                            else
                            {
                              toastr.error(response.data.msj);
                            }                    
                          },
                          function (error) 
                          {
                            toastr.error( error );
                          });
                      }

                      getCasoCompleto = function(p_id_expediente)
                      {
                        casosService.getCasoCompleto(p_id_expediente).then(
                          function ( response ) 
                          { 
                            //reasignacion de datos del caso
                            $scope.caso = response.data.CASO;
                            
                            $scope.caso.ENCABEZADO_CASO = "CASO";
                            $scope.caso.FECHA_CREACION;
                            // = ($filter('lowercase')(fechaEtiquetaDiaMes($scope.caso.FECHA_CREACION)))+', '+getTime($scope.caso.FECHA_CREACION);
                            $scope.selectedMateria(response.data.CASO);
                            $scope.selectedTipoProceso(response.data.CASO);
                            $scope.selectedTipoProcedencia(response.data.CASO,false);
                            $scope.selectedProcedencia(response.data.CASO,false);
                            $scope.deshabilitar_nuevo_caso = false;

                            $scope.deshabilitar_datos_caso = true;
                            $scope.deshabilitar_datos_solicitante = true;
                            $scope.deshabilitar_datos_invitado = true;
                            $scope.deshabilitar_datos_sesion = true;
                            $scope.deshabilitar_imprimir_invitacion = false;
                            $scope.tooltip_imprimir_evolucion = "Imprimir carátula y evolución del caso";
                            // if ($scope.caso.CIERRA_CASO == $scope.CONSTANTES.REGISTRO_VERDADERO)
                            // {
                            //   $scope.deshabilitar_datos_caso = true;
                            //   $scope.deshabilitar_datos_solicitante = true;
                            //   $scope.deshabilitar_datos_invitado = true;
                            //   $scope.deshabilitar_datos_representante = true;
                            //   $scope.deshabilitar_datos_sesion = true;
                            // }
                            // if ($scope.caso.CASO_EDITABLE == $scope.CONSTANTES.REGISTRO_FALSO)
                            // {
                            //   $scope.deshabilitar_datos_caso = true;
                            // }

                            //realizar la verificacion de la sesion para que sea actualizada o 


                            //reasignacion de datos del solicitante
                            $scope.solicitantes.seleccion = response.data.SOLICITANTES;
                            if ($scope.formulario_solicitante)
                            {
                              if (response.data.SOLICITANTES.length > 1)
                              {
                                $scope.mostrar_solicitantes = true;
                              }
                              else if (response.data.SOLICITANTES.length = 1)
                              {
                                getDatosSujeto($scope.solicitantes.seleccion[0],$scope.CONSTANTES.TIPO_SUJETO_NATURAL);
                              }
                            }
                            //verificar cuando se hagilitan estos botones
                            $scope.deshabilitar_boton_guardar_caso_no_mediable = true;
                            $scope.deshabilitar_boton_guardar_caso_mediable = true;
                            // $scope.LONGITUD_HOJA_EVOLUCION_SESION = true;
                            $scope.tooltip_item_caso = true;
                            $scope.tooltip_item_solicitante = false;
                            
                            //reasignacion de datos del invitado
                            if (response.data.INVITADOS != undefined)
                            {
                              $scope.invitados.seleccion = response.data.INVITADOS;
                              $scope.tooltip_item_solicitante = true;
                              //$scope.formulario_solicitante = false;
                              //$scope.formulario_sesion = true;
                            }
                            if (response.data.SESIONES != undefined)
                            {
                              $scope.sesion = response.data.SESIONES[0];
                              // if ($scope.sesion.FECHA_CREACION_SESION_EDITABLE == $scope.CONSTANTES.REGISTRO_FALSO)
                              // {
                              //   $scope.deshabilitar_datos_sesion = true;
                              // }
                              $scope.sesion.FECHA_HORA_SESION = $scope.sesion.FECHA_LARGA_HORA_SESION;
                              // fechaEtiquetaDiaMes($scope.sesion.FECHA_SESION)+', '+$scope.sesion.HORA_INICIO+' HORAS';
                              $scope.sesion.SESION_AGENDADA = true;
                              $scope.tooltip_item_sesion = false;
                              $scope.tooltip_imprimir_evolucion = "Imprimir invitaciones, carátula, evolución y registro del caso";
                              // $scope.vm.viewDate = new Date($scope.sesion.FECHA_SESION);                              
                              
                              // $scope.caso.ID_SESION = $scope.sesion.ID_SESION;
                              //$scope.cargarEventos(true);
                              //$scope.colapsar();
                            }
                            formulariocompleto();
                            $scope.habilitar_datos_identificacion();
                            $scope.imprimirInvitacion();
                          },
                          function ( error ) 
                          {
                            toastr.error( error );
                          });
                      }
                      
                      // getCasoCompleto(1217); //revisar 151 159 160

                      $scope.imprimirArchivo = function(ID_ARCHIVO,ID_TIPO_ARCHIVO)
                      {
                        authService.getArchivosImprimir(ID_ARCHIVO).then(
                          function ( response ) 
                          {
                            $scope.archivosImprimir = [];
                            $scope.archivosImprimir = response.data;
                            for (c=0;c<$scope.archivosImprimir.length;c++)
                            {
                              authService.getDocumento($scope.archivosImprimir[c].ID_ARCHIVO,ID_TIPO_ARCHIVO,$scope.CONSTANTES.ARCHIVO_TIPO_INVITACION);
                            }
                          },
                          function ( error ) 
                          {
                              toastr.error( error );
                          });
                      }

                      $scope.imprimirInvitacion = function()
                      {
                        if ($scope.caso.ID_TIPO_ASUNTO == $scope.CONSTANTES.ASUNTO_MEDIABLE)
                        {
                          casosService.getCaratulaCaso($scope.caso.ID_EXPEDIENTE);
                          casosService.getEvolucionCaso($scope.caso.ID_EXPEDIENTE);
                          casosService.getRegistroCaso($scope.caso.ID_EXPEDIENTE, $scope.caso.ID_SESION, 1);
                          if (($scope.loginData.CENTRO.FIRMA_DOCUMENTO == $scope.CONSTANTES.FIRMA_USUARIO_INACTIVA) ||
                              ($scope.caso.INVITACION_PARA_FIRMA == $scope.CONSTANTES.REGISTRO_FALSO))
                          {
                            casosService.getInvitacionCaso($scope.caso.ID_EXPEDIENTE, $scope.caso.ID_SESION, 1);  
                          }
                          /*else
                          {
                            if (($scope.loginData.CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_MEDIADOR) &&
                               ($scope.caso.archivoFirmado))
                            {
                              $scope.imprimirArchivo($scope.caso.ID_ARCHIVO,$scope.CONSTANTES.ARCHIVO_TIPO_INVITACION); 
                            }
                          }*/
                          else if ($scope.caso.INVITACION_PARA_FIRMA == $scope.CONSTANTES.REGISTRO_VERDADERO)
                          {
                            if ($scope.caso.ID_ESTADO_ARCHIVO == $scope.CONSTANTES.ESTADO_ARCHIVO_FIRMADO)
                            {
                              $scope.imprimirArchivo($scope.caso.ID_ARCHIVO,$scope.CONSTANTES.ARCHIVO_TIPO_INVITACION);
                            }
                            else
                            {
                              toastr.info("No se pudieron generar las invitaciones, antes deben firmarse");
                            }
                          }
                        }
                        else
                        {
                          casosService.getCaratulaCaso($scope.caso.ID_EXPEDIENTE);
                          casosService.getEvolucionCaso($scope.caso.ID_EXPEDIENTE);
                          casosService.getRegistroCaso($scope.caso.ID_EXPEDIENTE, 0, 0);
                        }
                      }
                      insCaso =  function(item,firma,datosFirma)
                      {
                        casosService.insCaso(item).then(
                          function (response)
                          {
                            if(response.data.result=='OK')
                            {
                              toastr.success(response.data.msj);
                              //limpiarCaso();
                              getCaso(response.data.id,firma,datosFirma);
                            }
                            else
                            {
                              toastr.error(response.data.msj);
                            }                      
                          },
                          function (error) 
                          {
                            toastr.error( error );
                          }); 
                      }
                      verificacionGuardadoCaso = function(no_mediable)
                      {
                        mensaje = $scope.caso.MATERIA+', '+$scope.caso.TIPO_PROCESO+', ';
                        if ($scope.caso.ID_TIPO_PROCEDENCIA == $scope.CONSTANTES.TIPO_PROCEDENCIA_DERIVADA)
                        {
                          mensaje = mensaje+$scope.caso.TIPO_PROCEDENCIA+' DE '+$scope.caso.PROCEDENCIA+' CON EXPEDIENTE '+$scope.caso.EXPEDIENTE;
                        }
                        else if ($scope.caso.ID_TIPO_PROCEDENCIA == $scope.CONSTANTES.TIPO_PROCEDENCIA_REFERIDA)
                        {
                          mensaje = mensaje+$scope.caso.TIPO_PROCEDENCIA+' POR '+$scope.caso.PROCEDENCIA;
                          if ($scope.caso.REQUIERE_EXPEDIENTE > 0)
                          {
                          mensaje = mensaje+' '+$scope.caso.EXPEDIENTE;
                          }
                        }
                        else
                        {
                          mensaje = mensaje+$scope.caso.TIPO_PROCEDENCIA;
                        }

                        if (no_mediable)
                        {
                          $scope.guardarCaso(true,true,false,null);
                        }
                        else
                        {
                          if //(($scope.loginData.CENTRO.ID_CARGO == $scope.CONSTANTES.CARGO_MEDIADOR) &&
                          ($scope.loginData.CENTRO.FIRMA_DOCUMENTO == $scope.CONSTANTES.USUARIO_CON_FIRMA)//)
                          {
                            swal({                            
                              title:'¿Guardar caso?', 
                              html: ',',
                              text: '<i class="fa fa-file-text-o"></i>'+' '+mensaje,
                              type: "input",
                              showCancelButton: true,
                              confirmButtonClass: "btn-warning",
                              confirmButtonText: "Continuar",
                              cancelButtonClass: "btn-default",
                              cancelButtonText: "Cancelar",
                              closeOnConfirm: false,
                              closeOnCancel: false,
                              inputPlaceholder: "Ingrese PIN definitivo"}, 
                              function(isConfirm){ 
                              if (isConfirm === "")
                              {
                                swal.showInputError("Para continuar necesita ingresar su PIN definitivo");
                              }
                              else if (isConfirm) 
                              {
                                  firma = {};
                                  firmantes = {};
                                  $scope.datosPin = {};
                                  item = {};
                                  $scope.datosPin.PIN = isConfirm;
                                  $scope.datosPin.usuario = $scope.loginData.USUARIO;
                                  $scope.datosPin.sistema = appSettings.sistemaIdRRHH;
                                  $scope.datosPin.contrasenia = $base64.encode($scope.datosPin.PIN);

                                  $scope.datosPin.cadena = 'SIGMA=>Generar invitación: Inicial'
                                  //+ item.ID_ARCHIVO
                                  + '=>Fecha:' + moment(new Date()).format('DD/MM/YYYY HH:mm:ss')
                                  + '=>Usuario:'+ $scope.loginData.USUARIO;
                                console.log('$scope.loginData',$scope.datosPin);
                                authService.validarPin($scope.datosPin)
                                  .then(function (response) {
                                    console.log('response validar PIN',response);
                                    if (response.data.status == "OK") 
                                    {
                                      console.log("response pasa", response);
                                      //$scope.datosPin.pinValido = true;  
                                      firmantes.FIRMA_INTERNA = response.data.data[0].contrasenia;
                                      authService.usuarioInterno($scope.datosPin.usuario)
                                        .then(function (response) {
                                          console.log("response usuarioInterno",response);
                                          if ((response.data.TIENE_FIRMA == $scope.CONSTANTES.REGISTRO_VERDADERO)
                                           //&&(response.data.TIENE_SELLO == $scope.CONSTANTES.REGISTRO_VERDADERO)
                                           &&(response.data.TIENE_RUBRICA == $scope.CONSTANTES.REGISTRO_VERDADERO))
                                          {
                                          //  $scope.datosPin.firmaInterna = true;
                                            
                                            firmantes.CARNET = response.data.EMPLEADO_ID;  
                                            firmantes.LLEVA_SELLO = "0";
                                            firmantes.NOMBRE_CARGO = response.data.CARGO.toUpperCase();
                                            firmantes.NOMBRE_DEPENDENCIA = $scope.loginData.CENTRO.DESPACHO.toUpperCase();
                                            firmantes.NOMBRE_FIRMANTE = response.data.NOMBRE_COMPLETO.toUpperCase();
                                            firmantes.PRIORIDAD = "1";
                                            firmantes.PROFESION = $scope.loginData.CENTRO.PROFESION.toUpperCase();
                                            firmantes.VISTO_BUENO = "0";
                                            
                                            firma.USUARIO = response.data.SAU_CUENTA;
                                            firma.ID_DEPENDENCIA = response.data.DEPENDENCIA_ID;
                                            firma.UBICACION = "";
                                            firma.OBSERVACIONES = "";
                                            firma.CODIGO = "";
                                            
                                            //se cierra el dialogo de verificacion de pin
                                            //ngDialog.close($scope.dialogShowPin.id);

                                            //se solicita la firma electronica
                                            //firmarArchivo(item);

                                            firma.ID_TIPO_DOCUMENTO = $scope.CONSTANTES.ARCHIVO_TIPO_INVITACION;
                                            firma.FIRMANTES = [];
                                            firma.FIRMANTES.push(firmantes);
                                            
                                            item.FIRMA = firma;
                                            item.RUTA = "";
                                            item.DATO_COMPLEMENTARIO = "";
                                            item.ARCHIVO_TIPO_INVITACION = $scope.CONSTANTES.ARCHIVO_TIPO_INVITACION;
                                            item.ID_ESTADO_ARCHIVO = $scope.CONSTANTES.ESTADO_ARCHIVO_FIRMADO;
                                            item.NUMERO_SESION = "1";
                                            item.ID_TIPO_ARCHIVO = $scope.CONSTANTES.ARCHIVO_TIPO_INVITACION;
                                            item.ID_TIPO_SESION = $scope.CONSTANTES.TIPO_SESION_MEDIACION;
                                            item.TIPO_SESION_MEDIACION = $scope.CONSTANTES.TIPO_SESION_MEDIACION;
                                            item.TIPO_SESION_REVISION = $scope.CONSTANTES.TIPO_SESION_REVISION;
                                            item.ARCHIVO = "";
                                            item.ID_ARCHIVO = "";
                                            item.ID_ARCHIVO_EXPEDIENTE = "";
                                            item.ID_ARCHIVO_PADRE = "";
                                            item.ID_EXPEDIENTE = "";
                                            item.NUMERO_CASO = "";
                                            item.ID_SESION = "";
                                            $scope.guardarCaso(true,false,true,item);    
                                            swal.close();
                                          }  
                                          else
                                          {
                                            limpiarDatosPin();
                                            toastr.warning("Usuario sin firma registrada");
                                          }
                                        }
                                        , function (error) {
                                          toastr.error(error);
                                        });
                                      
                                      //firmarArchivo(item,response);
                                    } 
                                    else 
                                    {
                                      //$scope.datosPin.pinValido = false;
                                      toastr.error(response.data.message);
                                    }
                                  }, function (error) {
                                    toastr.error(error);
                                  });
                                  $scope.$apply(); 
                              } 
                              else 
                              { 
                                swal.close();
                                $scope.$apply();
                              }
                           }); 
                          }
                          else if ($scope.loginData.CENTRO.FIRMA_DOCUMENTO != $scope.CONSTANTES.USUARIO_CON_FIRMA)
                          {
                            swal({                            
                              title:'¿Guardar caso?', 
                              html: ',',
                              text: '<i class="fa fa-file-text-o"></i>'+' '+mensaje,
                              type: "warning",
                              showCancelButton: true,
                              confirmButtonClass: "btn-warning",
                              confirmButtonText: "Continuar",
                              cancelButtonClass: "btn-default",
                              cancelButtonText: "Cancelar",
                              closeOnConfirm: false,
                              closeOnCancel: false,}, 
                              function(isConfirm){ 
                              if (isConfirm) 
                              {
                                $scope.guardarCaso(true,false,false,null);
                                swal.close();
                                $scope.$apply();
                              } 
                              else 
                              { 
                                swal.close();
                                $scope.$apply();
                              }
                           }); 
                          }
                        }
                      }
                      
                      //verificacionGuardadoCaso(false);

                      $scope.guardadoCasoMediable = function(isValid)
                      {
                        if ((isValid) && ($scope.sesion.SESION_AGENDADA))
                        {
                          verificacionGuardadoCaso(false);
                        }
                        else
                        {
                          toastr.warning("Faltan datos por ingresar");
                        }
                      }

                      $scope.guardarCaso = function(isValid,no_mediable,firma,item)
                      {
                        if (no_mediable)
                        {
                          if($scope.solicitantes.seleccion.length > 0)
                          {
                            $scope.caso.FECHA_REGISTRO = fechaFormatoYYYYMMDD($scope.caso.FECHA_REGISTRO)+ ' 00:00:00.0';
                            $scope.caso.solicitantes = $scope.solicitantes.seleccion;
                            insCaso($scope.caso, firma, item);
                          }
                          else
                          {
                            toastr.warning($scope.mensaje_operacion);
                          }
                        }
                        else if (isValid)
                        {
                          $scope.caso.FECHA_REGISTRO = fechaFormatoYYYYMMDD($scope.caso.FECHA_REGISTRO)+ ' 00:00:00.0';
                          $scope.caso.solicitantes = $scope.solicitantes.seleccion;
                          $scope.caso.invitados = $scope.invitados.seleccion;
                          $scope.caso.sesion = $scope.sesion;
                          $scope.caso.ID_TIPO_SESION = $scope.constantes.TIPO_SESION_MEDIACION;
                          $scope.caso.NUMERO_SESION = "1";
                          $scope.caso.ID_TIPO_ARCHIVO = $scope.constantes.ARCHIVO_TIPO_INVITACION;
                          $scope.caso.ID_ESTADO_ARCHIVO = $scope.constantes.ESTADO_ARCHIVO_SOLICITUD;
                          $scope.caso.ID_ARCHIVO_PADRE = "0";
                          $scope.caso.ARCHIVO = "";
                          $scope.caso.RUTA = "";
                          $scope.caso.DATO_COMPLEMENTARIO = "";
                          $scope.caso.FIRMA_DOCUMENTO = $scope.loginData.CENTRO.FIRMA_DOCUMENTO;
                          $scope.caso.FIRMA_USUARIO_INACTIVA = $scope.CONSTANTES.FIRMA_USUARIO_INACTIVA;
                          console.log("$scope.caso",$scope.caso);
                          insCaso($scope.caso, firma, item);
                        }
                        else
                        {
                          toastr.warning("Faltan datos por ingresar");
                        }
                      }
                      
/*guardado caso*/
                    }]
                  }
            }
        })
    }
  ]
);
